import React from 'react'
/*eslint max-len: 0*/

const SvgIcons = () => (
  <svg
    style={{ width: 0, height: 0, position: 'absolute', zIndex: -1 }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <symbol id="icn-parking" viewBox="0 0 35.578 35.578" fill="currentcolor">
      <path
        d="M45.335,30H42v6.671h3.335a3.335,3.335,0,0,0,0-6.671Zm0,5.559H43.112V31.112h2.224a2.224,2.224,0,0,1,0,4.447Z"
        transform="translate(-26.435 -18.882)"
        fill="#db0011"
      />
      <path
        d="M31.131,0H4.447A4.46,4.46,0,0,0,0,4.447V31.131a4.46,4.46,0,0,0,4.447,4.447H31.131a4.46,4.46,0,0,0,4.447-4.447V4.447A4.46,4.46,0,0,0,31.131,0Zm3.335,13.342V31.131a3.322,3.322,0,0,1-3.335,3.335H4.447a3.322,3.322,0,0,1-3.335-3.335V4.447A3.322,3.322,0,0,1,4.447,1.112H31.131a3.322,3.322,0,0,1,3.335,3.335Z"
        fill="currentcolor"
      ></path>
      <path
        d="M38.895,21H30.556a.57.57,0,0,0-.556.556v18.9a.57.57,0,0,0,.556.556H35a.57.57,0,0,0,.556-.556V34.342h3.335a6.671,6.671,0,0,0,0-13.342Zm0,12.23H34.447V39.9H31.112V22.112h7.783a5.559,5.559,0,0,1,0,11.118Z"
        transform="translate(-18.882 -13.217)"
        fill="#db0011"
      ></path>
    </symbol>

    <symbol
      id="icn-nonBlockedCard"
      viewBox="0 0 23.807 23.629"
      fill="currentcolor"
    >
      <g
        id="icn-nonBlockedCard"
        data-name="noun_blocked credit card_584320"
        transform="translate(0 0.8)"
      >
        <path
          id="Path_1086"
          data-name="Path 1086"
          d="M9.957,18.49H5.2a.6.6,0,1,1,0-1.19H9.957a.6.6,0,1,1,0,1.19Z"
          transform="translate(-1.862 -6.922)"
          fill="#db0011"
        />

        <path
          id="Path_1087"
          data-name="Path 1087"
          d="M23.807,2.283A2.07,2.07,0,0,0,21.724.2H2.083A2.07,2.07,0,0,0,0,2.283V13.651a2.109,2.109,0,0,0,2.083,2.083H8.333v.357a7.737,7.737,0,0,0,15.475,0,7.388,7.388,0,0,0-.179-1.607,1.9,1.9,0,0,0,.179-.833Zm-7.737,20.3a6.528,6.528,0,0,1-6.547-6.547v-.357a3.838,3.838,0,0,1,.179-1.19,6.558,6.558,0,0,1,12.677-.238,9.24,9.24,0,0,1,.238,1.25v.536A6.528,6.528,0,0,1,16.07,22.579Zm6.547-10.654A7.7,7.7,0,0,0,16.07,8.295a7.792,7.792,0,0,0-7.618,6.19H2.083a.915.915,0,0,1-.893-.893V5.616H22.617Zm0-7.5H1.19V2.283a.877.877,0,0,1,.893-.893H21.665a.915.915,0,0,1,.893.893V4.426Z"
          transform="translate(0 -1)"
          fill="#242424"
        />

        <path
          id="Path_5889"
          data-name="Path 5889"
          d="M12.389,13.016l6.987,4.031"
          transform="matrix(0.966, 0.259, -0.259, 0.966, 4.421, -3.686)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />

        <path
          id="Path_5890"
          data-name="Path 5890"
          d="M12.389,13.016l6.754,3.877"
          transform="matrix(-0.259, 0.966, -0.966, -0.259, 34.291, 3.557)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
    </symbol>

    <symbol id="icn-nonBlockedCard2" viewBox="0 0 26 19" fill="currentcolor">
      <g
        id="nonBlockedCard2"
        data-name="noun_blocked credit card_584320"
        transform="translate(-0.186 0.349)"
      >
        <path
          id="Path_1086"
          data-name="Path 1086"
          d="M9.957,18.49H5.2a.6.6,0,1,1,0-1.19H9.957a.6.6,0,1,1,0,1.19Z"
          transform="translate(-1.862 -6.922)"
          fill="#db0011"
        />

        <g
          id="Path_5914"
          data-name="Path 5914"
          transform="translate(0.186 -0.349)"
          fill="none"
        >
          <path
            d="M2,0H22a2,2,0,0,1,2,2V14a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
            stroke="none"
          />

          <path
            d="M 2 1 C 1.448600769042969 1 1 1.448599815368652 1 2 L 1 14 C 1 14.55140018463135 1.448600769042969 15 2 15 L 22 15 C 22.55139923095703 15 23 14.55140018463135 23 14 L 23 2 C 23 1.448599815368652 22.55139923095703 1 22 1 L 2 1 M 2 0 L 22 0 C 23.10457038879395
 0 24 0.8954296112060547 24 2 L 24 14 C 24 15.10457038879395 23.10457038879395 16 22 16 L 2 16 C 0.8954296112060547 16 0 15.10457038879395 0 14 L 0 2 C 0 0.8954296112060547 0.8954296112060547 0 2 0 Z"
            stroke="none"
            fill="#242424"
          />
        </g>

        <path
          id="Path_5913"
          data-name="Path 5913"
          d="M1.353,4.723H23.885"
          transform="translate(-0.561)"
          fill="none"
          stroke="#242424"
          strokeWidth="1"
        />

        <g
          id="Rectangle_898"
          data-name="Rectangle 898"
          transform="translate(9.186 12.651)"
          fill="#fff"
          stroke="#242424"
          strokeWidth="1"
        >
          <rect width="17" height="6" rx="1" stroke="none" />

          <rect x="0.5" y="0.5" width="16" height="5" rx="0.5" fill="none" />
        </g>

        <g
          id="Group_3161"
          data-name="Group 3161"
          transform="translate(11.76 14.643)"
        >
          <path
            id="Path_5909"
            data-name="Path 5909"
            d="M10.444,14.072v2.1"
            transform="translate(-9.394 -14.072)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="0.5"
          />

          <path
            id="Path_5910"
            data-name="Path 5910"
            d="M0,0V2.1"
            transform="translate(0.348 0.27) rotate(-42)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="0.5"
          />

          <path
            id="Path_5911"
            data-name="Path 5911"
            d="M0,2.1V0"
            transform="translate(1.753 0.27) rotate(42)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="0.5"
          />

          <path
            id="Path_5912"
            data-name="Path 5912"
            d="M0,2.1V0"
            transform="translate(2.101 1.05) rotate(90)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="0.5"
          />
        </g>

        <g
          id="Group_3162"
          data-name="Group 3162"
          transform="translate(15.073 14.643)"
        >
          <path
            id="Path_5909-2"
            data-name="Path 5909"
            d="M10.444,14.072v2.1"
            transform="translate(-9.394 -14.072)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="0.5"
          />

          <path
            id="Path_5910-2"
            data-name="Path 5910"
            d="M0,0V2.1"
            transform="translate(0.348 0.27) rotate(-42)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="0.5"
          />

          <path
            id="Path_5911-2"
            data-name="Path 5911"
            d="M0,2.1V0"
            transform="translate(1.753 0.27) rotate(42)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="0.5"
          />

          <path
            id="Path_5912-2"
            data-name="Path 5912"
            d="M0,2.1V0"
            transform="translate(2.101 1.05) rotate(90)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="0.5"
          />
        </g>

        <g
          id="Group_3163"
          data-name="Group 3163"
          transform="translate(18.558 14.643)"
        >
          <path
            id="Path_5909-3"
            data-name="Path 5909"
            d="M10.444,14.072v2.1"
            transform="translate(-9.394 -14.072)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="0.5"
          />

          <path
            id="Path_5910-3"
            data-name="Path 5910"
            d="M0,0V2.1"
            transform="translate(0.348 0.27) rotate(-42)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="0.5"
          />

          <path
            id="Path_5911-3"
            data-name="Path 5911"
            d="M0,2.1V0"
            transform="translate(1.753 0.27) rotate(42)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="0.5"
          />

          <path
            id="Path_5912-3"
            data-name="Path 5912"
            d="M0,2.1V0"
            transform="translate(2.101 1.05) rotate(90)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="0.5"
          />
        </g>

        <g
          id="Group_3164"
          data-name="Group 3164"
          transform="translate(22.043 14.643)"
        >
          <path
            id="Path_5909-4"
            data-name="Path 5909"
            d="M10.444,14.072v2.1"
            transform="translate(-9.394 -14.072)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="0.5"
          />

          <path
            id="Path_5910-4"
            data-name="Path 5910"
            d="M0,0V2.1"
            transform="translate(0.348 0.27) rotate(-42)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="0.5"
          />

          <path
            id="Path_5911-4"
            data-name="Path 5911"
            d="M0,2.1V0"
            transform="translate(1.753 0.27) rotate(42)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="0.5"
          />

          <path
            id="Path_5912-4"
            data-name="Path 5912"
            d="M0,2.1V0"
            transform="translate(2.101 1.05) rotate(90)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="0.5"
          />
        </g>
      </g>
    </symbol>

    <symbol
      id="icn-parking-alert"
      viewBox="0 0 20.924 17.449"
      fill="currentcolor"
    >
      <g id="icn-parking-alert" transform="translate(0.007 -3.961)">
        <path
          id="Path_1164"
          data-name="Path 1164"
          d="M12.059,4.849a1.891,1.891,0,0,0-3.207,0L.3,18.455a1.9,1.9,0,0,0-.057,1.97,1.87,1.87,0,0,0,1.66.985H19.01a1.87,1.87,0,0,0,1.66-.985,1.9,1.9,0,0,0-.057-1.97ZM19.9,19.984a1.011,1.011,0,0,1-.893.553H1.9A1.011,1.011,0,0,1,1,20a1.046,1.046,0,0,1,.031-1.081L9.583,5.333a1.02,1.02,0,0,1,1.743,0l8.55,13.588A1.046,1.046,0,0,1,19.907,20Z"
          transform="translate(0)"
          fill="#242424"
        />
        <path
          id="Path_1165"
          data-name="Path 1165"
          d="M15.445,24.275l1.178,1.216"
          transform="translate(-8.596 -11.335)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="0.5"
        />
        <path
          id="Path_1168"
          data-name="Path 1168"
          d="M15.445,24.275l1.178,1.216"
          transform="translate(-2.495 -11.335)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="0.5"
        />
        <path
          id="Path_1166"
          data-name="Path 1166"
          d="M0,0,1.178,1.216"
          transform="translate(8.015 12.928) rotate(87)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="0.5"
        />
        <path
          id="Path_1167"
          data-name="Path 1167"
          d="M0,0,1.178,1.216"
          transform="translate(14.116 12.928) rotate(87)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="0.5"
        />
        <path
          id="Path_1169"
          data-name="Path 1169"
          d="M18.429,36.211a5.539,5.539,0,0,1,2.43-.732,7.217,7.217,0,0,1,1.916.732"
          transform="translate(-10.203 -17.775)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="0.5"
        />
      </g>
    </symbol>

    <symbol id="icn-order" viewBox="0 0 25.041 33.388" fill="currentcolor">
      <g transform="translate(-20.5 11)">
        <path
          d="M42.746,8H19.295a.8.8,0,0,0-.795.795V40a.888.888,0,0,0,.4.715.812.812,0,0,0,.795-.04l5.127-3.3,5.565,2.186a.775.775,0,0,0,.6,0l1.294-.536,2.641-1.094,7.512,3.379a.935.935,0,0,0,.318.079.8.8,0,0,0,.437-.119.781.781,0,0,0,.358-.676V8.795A.773.773,0,0,0,42.746,8Zm-.318,32-7.194-3.149a.936.936,0,0,0-.318-.079.478.478,0,0,0-.318.079l-3.882,1.669-5.756-2.256a.761.761,0,0,0-.715.079l-4.552,2.684L19.624,9.265H42.417Z"
          transform="translate(2 -19)"
        ></path>
        <path
          d="M24.25,13.025h13.8"
          transform="translate(2 -18)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        ></path>
        <path
          d="M24.25,13.025h13.8"
          transform="translate(2 -13)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        ></path>
        <path
          d="M24.25,13.025h13.8"
          transform="translate(2 -7)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        ></path>
        <path
          d="M24.25,13.228h6.9"
          transform="translate(2 -1.203)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        ></path>
      </g>
    </symbol>

    <symbol id="icn-info2" viewBox="0 0 29.412 29.412" fill="currentcolor">
      <g transform="translate(-1262.5 -544.883)">
        <g transform="translate(1262.5 544.883)" fill="none">
          <path
            d="M14.706,0A14.706,14.706,0,0,1,29.412,14.706a14.969,14.969,0,0,1-1.117,5.633A14.707,14.707,0,1,1,14.706,0Z"
            stroke="none"
          ></path>
          <path
            d="M 14.70580959320068 1.5 C 11.17840957641602 1.5 7.862138748168945 2.873640060424805 5.367889404296875 5.367889404296875 C 2.873640060424805 7.862138748168945 1.5 11.17840957641602 1.5 14.70580959320068 C 1.5 18.23320960998535 2.873640060424805 21.54948043823242 5.367889404296875 24.04372978210449 C 7.862138748168945 26.53797912597656 11.17840957641602 27.91161918640137 14.70580959320068 27.91161918640137 C 20.07942962646484 27.91161918640137 24.97956848144531 24.64674949645996 26.89995956420898 19.78549003601074 C 27.59016036987305 18.04528999328613 27.91161918640137 16.43119049072266 27.91161918640137 14.70580959320068 C 27.91161918640137 11.17840957641602 26.53797912597656 7.862138748168945 24.04372978210449 5.367889404296875 C 21.54948043823242 2.873640060424805 18.23320960998535 1.5 14.70580959320068 1.5 M 14.70580959320068 0 C 22.82759857177734 0 29.41161918640137 6.584018707275391 29.41161918640137 14.70580959320068 C 29.41161918640137 16.61442947387695 29.04801940917969 18.43814086914063 28.29428863525391 20.33850860595703 C 26.23220062255859 25.5584888458252 20.91897964477539 29.41161918640137 14.70580959320068 29.41161918640137 C 6.584018707275391 29.41161918640137 0 22.82759857177734 0 14.70580959320068 C 0 6.584018707275391 6.584018707275391 0 14.70580959320068 0 Z"
            stroke="none"
            fill="currentcolor"
          ></path>
        </g>
        <path
          d="M5244.171,555.234v9.2"
          transform="translate(-3967 2.139)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="2"
        ></path>
        <path
          d="M5244.171,555.234v.879"
          transform="translate(-3967 -2)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="2"
        ></path>
      </g>
    </symbol>

    <symbol id="icn-car-parking" viewBox="0 0 62.152 38.86" fill="currentcolor">
      <g id="car" transform="translate(-338.551 -357.739)">
        <path
          id="Path_1258"
          data-name="Path 1258"
          d="M21092.348,1762.329s.441,11.128,1.139,11.238,54.465,0,54.465,0"
          transform="translate(-20748 -1378)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeWidth="1.5"
        ></path>
        <path
          id="Path_1259"
          data-name="Path 1259"
          d="M21097.885,1757.54v-5.586s5.824-5.968,5.824-6.111,41.012,0,41.012,0l5.887,6.111s-.395,18.524-.873,19.193a7.289,7.289,0,0,1-1.863,1.432"
          transform="translate(-20754 -1377)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></path>
        <path
          id="Path_1260"
          data-name="Path 1260"
          d="M21103.8,1745.78s3.2-9.342,4.631-9.819,30.316-.764,31.271,0,5.014,9.819,5.014,9.819"
          transform="translate(-20754 -1377)"
          fill="none"
          stroke="#242424"
          strokeWidth="1.5"
        ></path>
        <path
          id="Path_1261"
          data-name="Path 1261"
          d="M21093.3,1772.58h6.207"
          transform="translate(-20754 -1377)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeWidth="1.5"
        ></path>
        <path
          id="Path_1262"
          data-name="Path 1262"
          d="M21106.969,1762.267h-5.646s-.322,2.1,0,2.533l.48.6.775.512a8.637,8.637,0,0,0,2.348.2"
          transform="translate(-20754 -1377)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.5"
        ></path>
        <path
          id="Path_1263"
          data-name="Path 1263"
          d="M21101.18,1762.267h5.646s.322,2.1,0,2.533l-.48.6-.775.512a8.637,8.637,0,0,1-2.348.2"
          transform="translate(-20713 -1377)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.5"
        ></path>
        <rect
          id="Rectangle_775"
          data-name="Rectangle 775"
          width="16"
          height="4"
          rx="1"
          transform="translate(363 385)"
          fill="#db0011"
        ></rect>
        <path
          id="Path_1264"
          data-name="Path 1264"
          d="M21100.674,1754.284s-1.131,2.656.875,3.447,9.238.593,9.238.593a2.192,2.192,0,0,0-.715-2.541c-1.342-.911-.979-.793-4.652-1.1S21100.674,1754.284,21100.674,1754.284Z"
          transform="translate(-20754 -1377)"
          fill="#db0011"
        ></path>
        <path
          id="Path_1265"
          data-name="Path 1265"
          d="M21110.467,1754.284s1.131,2.656-.875,3.447-9.238.593-9.238.593a3.855,3.855,0,0,1,1.484-2.639,12.421,12.421,0,0,1,1.613-.745s-.279-.045,2.27-.261C21109.395,1754.368,21110.467,1754.284,21110.467,1754.284Z"
          transform="translate(-20715.998 -1377)"
          fill="#db0011"
        ></path>
        <path
          id="Path_1266"
          data-name="Path 1266"
          d="M21104.064,1745.5l.2.7-6.455-.7c0-.372-1.262-1.978.941-2.529s2.533-1.138,3.3-.7,1.34,2.277,1.34,2.277"
          transform="translate(-20754 -1377)"
          fill="#242424"
        ></path>
        <path
          id="Path_1267"
          data-name="Path 1267"
          d="M21096.783,1745.5v.277l6.25-.277c0-.372,1.262-1.978-.941-2.529s-2.533-1.138-3.3-.7-1.34,2.277-1.34,2.277"
          transform="translate(-20707 -1377)"
          fill="#242424"
        ></path>
        <rect
          id="Rectangle_776"
          data-name="Rectangle 776"
          width="37"
          height="4"
          rx="1"
          transform="translate(352 392)"
          fill="#242424"
        ></rect>
      </g>
    </symbol>

    <symbol id="icn-add-circle" viewBox="0 0 24 24">
      <g className="a">
        <g strokeWidth="1.5">
          <circle fill="none" stroke="currentColor" cx="12" cy="12" r="11.25" />
        </g>
        <path d="M11 17v-4H7v-2h4V7h2v4h4v2h-4v4z" fill="currentColor" />
      </g>
    </symbol>

    <symbol id="icn-add" viewBox="0 0 13.5 13.5" fill="currentColor">
      <path
        className="a"
        d="M22,16.857H16.857V22H15.143V16.857H10V15.143h5.143V10h1.714v5.143H22Z"
        transform="translate(-9.249 -9.25)"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </symbol>
    <symbol id="icn-add-round" viewBox="0 0 10.2 10.2" fill="currentColor">
      <g transform="translate(-214.259 -113.552)">
        <path
          d="M6.979,5.923c-.769-.78-1.537-1.549-2.306-2.317L6.99,1.289A.755.755,0,0,0,5.923.222L3.606,2.54C2.838,1.771,2.069,1,1.289.234A.755.755,0,0,0,.222,1.3C1,2.069,1.771,2.838,2.54,3.606,1.771,4.375,1,5.143.234,5.923A.755.755,0,0,0,1.3,6.99c.769-.78,1.537-1.549,2.306-2.317L5.923,6.99C6.6,7.667,7.667,6.6,6.979,5.923Z"
          transform="translate(219.359 113.552) rotate(45)"
        />
      </g>
    </symbol>
    <symbol id="icn-arrow-down" viewBox="0 0 10.112 6" fill="currentColor">
      <path d="M.281 1.603L4.41 5.724c.046.046.092.069.138.115.023.023.046.023.069.046s.069.023.088.046a.138.138 0 0 0 .092.023c.023 0 .046.023.092.023s.115.026.161.026h.023a.4.4 0 0 0 .161-.023c.023 0 .046-.023.069-.023s.069-.023.092-.023c.023-.023.069-.023.088-.046s.046-.023.069-.046a.61.61 0 0 0 .138-.115h.023l4.125-4.155a.91.91 0 0 0 0-1.3.9.9 0 0 0-.64-.269.918.918 0 0 0-.64.272L5.644 3.203a.849.849 0 0 1-1.2 0L1.523.272A.879.879 0 0 0 .373.169a.95.95 0 0 0-.092 1.434z" />
    </symbol>
    <symbol id="icn-arrow-up" viewBox="0 0 11.372 6.77" fill="currentColor">
      <path
        d="M9.531.325,5.686,4.17,1.841.325a1.047,1.047,0,0,0-1.516,0,1.047,1.047,0,0,0,0,1.516l4.6,4.6a1.047,1.047,0,0,0,1.516,0l4.6-4.6a1.047,1.047,0,0,0,0-1.516A1.047,1.047,0,0,0,9.531.325Z"
        transform="translate(11.373 6.769) rotate(180)"
      />
    </symbol>
    <symbol id="icn-arr-right" viewBox="0 0 8.885 15.795" fill="currentColor">
      <path d="M.323 1.815L6.3 7.869.323 13.952a1.066 1.066 0 0 0 0 1.521 1.034 1.034 0 0 0 1.5 0l6.742-6.829a1.066 1.066 0 0 0 0-1.521L1.794.323a1.034 1.034 0 0 0-1.5 0 1.058 1.058 0 0 0 .029 1.492z" />
    </symbol>
    <symbol id="icn-arrow-left" viewBox="0 0 13.114 10" fill="currentColor">
      <path
        data-name="Path 1"
        d="M11.913 3.805H4.068L5.825 2.05A1.2 1.2 0 0 0 4.132.35L.338 4.15a.667.667 0 0 0-.15.193c-.021.021-.021.064-.043.086a.469.469 0 0 1-.064.107c-.021.043-.021.086-.043.129 0 .043-.021.064-.021.107a1.737 1.737 0 0 0 0 .472c0 .043.021.064.021.107.021.043.021.086.043.129a.469.469 0 0 0 .064.107c.021.021.021.064.043.086a1.178 1.178 0 0 0 .15.193l3.794 3.791a1.19 1.19 0 0 0 1.672 0 1.19 1.19 0 0 0 0-1.693l-1.736-1.78h7.846a1.19 1.19 0 1 0 0-2.379z"
      />
    </symbol>
    <symbol id="icn-arrow-right" viewBox="0 0 13.114 10" fill="currentColor">
      <path d="M1.201 6.195h7.845L7.289 7.95a1.2 1.2 0 0 0 1.693 1.7l3.794-3.8a.667.667 0 0 0 .15-.193c.021-.021.021-.064.043-.086a.469.469 0 0 1 .064-.107c.021-.043.021-.086.043-.129 0-.043.021-.064.021-.107a1.737 1.737 0 0 0 0-.472c0-.043-.021-.064-.021-.107-.021-.043-.021-.086-.043-.129a.469.469 0 0 0-.064-.107c-.021-.021-.021-.064-.043-.086a1.178 1.178 0 0 0-.15-.193L8.982.343a1.19 1.19 0 0 0-1.672 0 1.19 1.19 0 0 0 0 1.693l1.736 1.78H1.2a1.19 1.19 0 1 0 0 2.379z" />
    </symbol>
    <symbol id="icn-arrow-top" viewBox="0 0 7.609 10" fill="currentColor">
      <path d="M4.708 9.085V3.1l1.34 1.34A.913.913 0 0 0 7.34 3.151L4.446.257A.509.509 0 0 0 4.3.143C4.284.127 4.251.127 4.235.11a.357.357 0 0 1-.082-.049c-.033-.016-.065-.016-.1-.033-.033 0-.049-.016-.082-.016a1.325 1.325 0 0 0-.36 0c-.033 0-.049.016-.082.016-.033.016-.065.016-.1.033a.357.357 0 0 0-.082.049c-.016.016-.049.016-.065.033a.9.9 0 0 0-.147.114L.262 3.151A.927.927 0 0 0 0 3.8a.89.89 0 0 0 .262.638.908.908 0 0 0 1.291 0L2.893 3.1v5.985a.914.914 0 0 0 .916.915.9.9 0 0 0 .899-.915z" />
    </symbol>
    <symbol id="icn-arrow-bottom" viewBox="0 0 7.609 10" fill="currentColor">
      <path d="M2.901.915V6.9l-1.34-1.34A.913.913 0 0 0 .269 6.849l2.894 2.894a.509.509 0 0 0 .146.114c.016.016.049.016.065.033a.357.357 0 0 1 .082.049c.033.016.065.016.1.033.033 0 .049.016.082.016a1.325 1.325 0 0 0 .36 0c.033 0 .049-.016.082-.016.033-.016.065-.016.1-.033a.357.357 0 0 0 .082-.049c.016-.016.049-.016.065-.033a.9.9 0 0 0 .147-.114l2.873-2.894a.927.927 0 0 0 .262-.649.89.89 0 0 0-.262-.638.908.908 0 0 0-1.291 0L4.716 6.9V.915A.914.914 0 0 0 3.8 0a.9.9 0 0 0-.899.915z" />
    </symbol>
    <symbol id="icn-arrows-circle" viewBox="0 0 32 32">
      <g stroke="currentColor" strokeWidth="1.5" fill="none">
        <circle cx="16" cy="16" r="16" stroke="none" />
        <circle cx="16" cy="16" r="15.25" />
      </g>
      <path
        d="M16.975 16.302l3.488 3.488a.28.28 0 0 1 0 .36l-3.374 3.357a.4.4 0 0 1-.573 0l-.72-.72a.4.4 0 0 1 0-.573l1.032-1.032a.17.17 0 0 0-.115-.295H9.311a.405.405 0 0 1-.409-.409v-1.011a.405.405 0 0 1 .409-.409h7.4a.17.17 0 0 0 .115-.295l-1.03-1.036a.4.4 0 0 1 0-.573l.835-.835a.226.226 0 0 1 .344-.017zm-2.129.442l-3.471-3.487a.28.28 0 0 1 0-.36l3.356-3.357a.4.4 0 0 1 .573 0l.72.72a.4.4 0 0 1 0 .573l-1.047 1.048a.17.17 0 0 0 .115.295h7.4a.405.405 0 0 1 .41.409v1.016a.405.405 0 0 1-.409.409h-7.385a.17.17 0 0 0-.115.295l1.032 1.031a.4.4 0 0 1 0 .573l-.835.835a.237.237 0 0 1-.344 0z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="icn-circle-tick" viewBox="0 0 17.5 17.5">
      <g stroke="currentColor">
        <path
          d="M8.75.75A8.049 8.049 0 0 0 .768 8.212a6.494 6.494 0 0 0-.018.538 8 8 0 1 0 8-8z"
          fill="none"
          strokeWidth="1.5"
        />
        <path
          d="M11.6 6.473a.551.551 0 0 0-.425.182l-.193.2-.086.089-3.177 3.289L5.96 8.414a.551.551 0 0 0-.425-.182.652.652 0 0 0-.606.606.551.551 0 0 0 .182.425l2.183 2.244a.586.586 0 0 0 .849 0l3.594-3.751c.121-.121.469-.434.469-.616a.624.624 0 0 0-.606-.667z"
          fill="currentColor"
          strokeWidth=".5"
        />
      </g>
    </symbol>
    <symbol id="icn-download" viewBox="0 0 12.026 14" fill="currentColor">
      <path
        className="a"
        d="M10.469 2.528h-2.1a.523.523 0 1 0 0 1.047h2.1a.51.51 0 0 1 .511.511v8.356a.51.51 0 0 1-.511.511H1.558a.51.51 0 0 1-.511-.511V4.086a.51.51 0 0 1 .511-.511h2.027a.523.523 0 0 0 0-1.047H1.558A1.558 1.558 0 0 0 0 4.086v8.356A1.558 1.558 0 0 0 1.558 14h8.911a1.558 1.558 0 0 0 1.558-1.558V4.086a1.558 1.558 0 0 0-1.558-1.558z"
      />
      <path
        className="a"
        d="M3.702 8.134a.525.525 0 0 0 0 .739l1.942 1.942.038.035c.013.013.013.01.019.016s.016.01.022.016a.08.08 0 0 0 .022.013c.006 0 .013.01.019.013a.1.1 0 0 1 .025.013l.022.01.025.01.025.01.025.006.025.006a.088.088 0 0 0 .029 0h.022a.408.408 0 0 0 .1 0H6.113l.025-.006c.006 0 .016 0 .022-.006l.025-.01.022-.01.022-.01a.08.08 0 0 0 .022-.013l.022-.013.022-.013c.01-.006.016-.013.022-.016l.019-.013a.379.379 0 0 0 .038-.035l1.942-1.942a.523.523 0 1 0-.739-.739L6.53 9.184V.523a.523.523 0 1 0-1.047 0v8.658L4.436 8.134a.519.519 0 0 0-.734 0z"
      />
    </symbol>
    <symbol
      id="icn-download-new"
      viewBox="0 0 14.892 12.546"
      fill="currentColor"
    >
      <g transform="translate(84 43.329)">
        <g transform="translate(-84 -46.329)">
          <path
            className="a"
            fill="#db0011"
            d="M45.941,43.751a.451.451,0,0,0,.654,0l2.8-2.8a.462.462,0,0,0-.654-.654L46.735,42.3V35.967a.467.467,0,0,0-.934,0V42.3L43.794,40.3a.462.462,0,1,0-.654.654Z"
            transform="translate(-38.799 -32.5)"
          />
          <path
            className="b"
            fill="currentcolor"
            d="M48.425,45.9a.441.441,0,0,0-.467.467v7.889H34.934V46.367a.467.467,0,1,0-.934,0v8.356a.441.441,0,0,0,.467.467H48.425a.441.441,0,0,0,.467-.467V46.367A.468.468,0,0,0,48.425,45.9Z"
            transform="translate(-34 -39.644)"
          />
        </g>
      </g>
    </symbol>
    <symbol id="icn-error" viewBox="0 0 65 65">
      <g>
        <path
          d="M32.5.5C15.825.5 2.116 13.275.571 30.347.545 30.532.5 31.511.5 32.5a32 32 0 1 0 32-32zm0 61.44A29.61 29.61 0 0 1 3.06 32.5 29.61 29.61 0 0 1 32.5 3.06 29.61 29.61 0 0 1 61.94 32.5 29.61 29.61 0 0 1 32.5 61.94z"
          stroke="currentColor"
        />
        <path d="M40.796 26.964l-6.15 6 6.15 6a1.45 1.45 0 0 1 0 2.1l-.3.3a1.631 1.631 0 0 1-2.25 0l-6-5.85-6 5.85a1.631 1.631 0 0 1-2.25 0l-.3-.3a1.45 1.45 0 0 1 0-2.1l6.15-6-6.15-6a1.45 1.45 0 0 1 0-2.1l.3-.3a1.631 1.631 0 0 1 2.25 0l6 5.85 6-5.85a1.631 1.631 0 0 1 2.25 0l.3.3a1.45 1.45 0 0 1 0 2.1z" />
      </g>
    </symbol>
    <symbol id="icn-eye-slash" viewBox="0 0 23.354 19.006">
      <g transform="translate(-372.594 -508.696)">
        <g transform="translate(348 443.861)">
          <path
            className="a"
            d="M17.361,21c-2.108,0-6.387.79-11.141,6.213a2.169,2.169,0,0,0,0,2.856c4.753,5.423,9.033,6.213,11.141,6.213s6.387-.79,11.141-6.213a2.169,2.169,0,0,0,0-2.856C23.748,21.79,19.468,21,17.361,21Zm10.35,8.379c-1.549,1.757-5.655,5.85-10.35,5.85s-8.8-4.092-10.35-5.855a1.112,1.112,0,0,1,0-1.465c1.549-1.763,5.657-5.855,10.35-5.855s8.8,4.092,10.35,5.855a1.112,1.112,0,0,1,0,1.465Z"
            transform="translate(18.911 45.605)"
          />
          <path
            className="a"
            d="M36.485,31.6a4.848,4.848,0,1,0,4.861,4.848A4.848,4.848,0,0,0,36.485,31.6Zm0,8.643a3.794,3.794,0,1,1,3.807-3.794A3.794,3.794,0,0,1,36.485,40.243Z"
            transform="translate(-0.213 37.799)"
          />
        </g>
        <path
          className="a"
          d="M20.593,39.214a.621.621,0,0,0,.9,0L39.214,21.492a.636.636,0,0,0-.9-.9L35.808,23.1,20.593,38.315A.62.62,0,0,0,20.593,39.214Z"
          transform="translate(354.581 488.296)"
        />
      </g>
    </symbol>
    <symbol id="icn-eye" viewBox="0 0 23.354 15.283">
      <g transform="translate(-24.594 -66.605)">
        <path
          className="a"
          d="M17.361,21c-2.108,0-6.387.79-11.141,6.213a2.169,2.169,0,0,0,0,2.856c4.753,5.423,9.033,6.213,11.141,6.213s6.387-.79,11.141-6.213a2.169,2.169,0,0,0,0-2.856C23.748,21.79,19.468,21,17.361,21Zm10.35,8.379c-1.549,1.757-5.655,5.85-10.35,5.85s-8.8-4.092-10.35-5.855a1.112,1.112,0,0,1,0-1.465c1.549-1.763,5.657-5.855,10.35-5.855s8.8,4.092,10.35,5.855a1.112,1.112,0,0,1,0,1.465Z"
          transform="translate(18.911 45.605)"
        />
        <path
          className="a"
          d="M36.485,31.6a4.848,4.848,0,1,0,4.861,4.848A4.848,4.848,0,0,0,36.485,31.6Zm0,8.643a3.794,3.794,0,1,1,3.807-3.794A3.794,3.794,0,0,1,36.485,40.243Z"
          transform="translate(-0.213 37.799)"
        />
      </g>
    </symbol>
    <symbol id="icn-help" viewBox="0 0 20 12.537" fill="currentColor">
      <path d="M6.363 12.513c1.767 0 7.258.024 7.258.024a6.33 6.33 0 0 0 6.363-5.8A6.276 6.276 0 0 0 13.739 0H5.868C2.687 0 0 3.064 0 6.269a6.373 6.373 0 0 0 6.363 6.244zM5.891 7.47a1.258 1.258 0 1 1 .943-.943 1.248 1.248 0 0 1-.943.943zm4.383 0a1.258 1.258 0 1 1 .943-.943 1.278 1.278 0 0 1-.942.943zm4.383 0a1.258 1.258 0 1 1 .943-.943 1.278 1.278 0 0 1-.942.943z" />
    </symbol>
    <symbol id="icn-img-default" viewBox="0 0 44 44" fill="currentColor">
      <path
        className="a"
        d="M4.4 0v11H0v4.4h4.4v13.2H0V33h4.4v11H44V.012H4.4zm35.2 39.589H8.8V4.4h30.8z"
      />
      <path
        className="b"
        d="M22 28.188v4.809h4.4v-4.809a6.585 6.585 0 0 0 3.989-3.988H35.2v-4.4h-4.811a6.585 6.585 0 0 0-3.989-3.988v-4.809H22v4.809a6.585 6.585 0 0 0-3.989 3.988H13.2v4.4h4.811A6.585 6.585 0 0 0 22 28.188zm2.206-8.387A2.205 2.205 0 1 1 22 22.003a2.211 2.211 0 0 1 2.206-2.2z"
      />
    </symbol>
    <symbol id="icn-mail" viewBox="0 0 16.405 12" fill="currentColor">
      <path d="M15.92.543A2.008 2.008 0 0 0 14.593 0H1.809A1.814 1.814 0 0 0 0 1.809v8.382A1.814 1.814 0 0 0 1.809 12h12.784a1.814 1.814 0 0 0 1.807-1.809V1.809a1.721 1.721 0 0 0-.48-1.266zM8.2 6.246l-5.637-5.01h11.306zM1.236 1.809L8.2 7.754l7-5.945v8.231h-.03v.151a.593.593 0 0 1-.573.573H1.809a.593.593 0 0 1-.573-.573z" />
    </symbol>
    <symbol id="icn-phone-circle" viewBox="0 0 32 32">
      <g fill="none">
        <path d="M16 0A16 16 0 1 1 0 16 16 16 0 0 1 16 0z" />
        <path
          d="M16 30.5c3.873 0 7.514-1.508 10.253-4.247A14.405 14.405 0 0 0 30.5 16c0-3.873-1.508-7.514-4.247-10.253A14.405 14.405 0 0 0 16 1.5 14.405 14.405 0 0 0 5.747 5.747 14.405 14.405 0 0 0 1.5 16c0 3.873 1.508 7.514 4.247 10.253A14.405 14.405 0 0 0 16 30.5m0 1.5C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16z"
          fill="currentColor"
        />
      </g>
      <path
        d="M19.176 8h-6.33A1.846 1.846 0 0 0 11 9.846v12.308A1.846 1.846 0 0 0 12.846 24h6.33a1.846 1.846 0 0 0 1.846-1.846V9.846A1.846 1.846 0 0 0 19.176 8zm-6.945 13.89h7.56v.264a.6.6 0 0 1-.615.615h-6.33a.6.6 0 0 1-.615-.615zm7.56-9.9v8.67h-7.56v-8.671zm-5.945-2.759h4.33c.316 0 2.029-.1 1.615 1.527h-7.56c-.331-1.712 1.299-1.527 1.615-1.527z"
        fill="CurrentColor"
      />
    </symbol>
    <symbol id="icn-print" viewBox="0 0 17 16" fill="currentColor">
      <path
        className="a"
        d="M16.2 2.5h-2.5V.7A.684.684 0 0 0 13 0H3.8a.684.684 0 0 0-.7.7v1.8H.7a.669.669 0 0 0-.7.6v7a.684.684 0 0 0 .7.7h2.6v4.5a.684.684 0 0 0 .7.7h9a.684.684 0 0 0 .7-.7v-4.5h2.6a.684.684 0 0 0 .7-.7v-7a.871.871 0 0 0-.8-.6zM4.5 1.3h8v1.1h-8zm7.8 13.4H4.6V7.8h7.8l-.1 6.9zm3.3-5.2h-1.9V7.2a.684.684 0 0 0-.7-.7H3.9a.684.684 0 0 0-.7.7v2.3H1.3V3.8h14.2v5.7zm-9.4 1.2h4.6a.7.7 0 0 0 0-1.4H6.2a.7.7 0 0 0 0 1.4zm0 2.4h4.6a.7.7 0 0 0 0-1.4H6.2a.7.7 0 1 0 0 1.4z"
      />
    </symbol>
    <symbol id="icn-print-new" viewBox="0 0 20.44 20.114" fill="currentColor">
      <g transform="translate(0 -1)">
        <g transform="translate(0 -1)">
          <g
            className="a"
            fill="none"
            stroke="currentcolor"
            strokeWidth="0.8px"
            transform="translate(0 4.719)"
          >
            <rect
              className="c"
              stroke="none"
              width="20.44"
              height="11.981"
              rx="1"
            />
            <rect
              className="d"
              fill="none"
              x="0.4"
              y="0.4"
              width="19.64"
              height="11.181"
              rx="0.6"
            />
          </g>
          <g
            className="a"
            transform="translate(4.447 2)"
            fill="none"
            stroke="currentcolor"
            strokeWidth="0.8px"
          >
            <path
              className="c"
              stroke="none"
              d="M1,0H11a1,1,0,0,1,1,1V3.349a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1A1,1,0,0,1,1,0Z"
            />
            <path
              className="d"
              fill="none"
              d="M1,.4H11a.6.6,0,0,1,.6.6V2.549a.4.4,0,0,1-.4.4H.8a.4.4,0,0,1-.4-.4V1A.6.6,0,0,1,1,.4Z"
            />
          </g>
          <g
            className="a"
            transform="translate(4.447 13.655)"
            fill="none"
            stroke="currentcolor"
            strokeWidth="0.8px"
          >
            <rect className="c" fill="none" width="12" height="8.459" rx="1" />
            <rect
              className="d"
              x="0.4"
              y="0.4"
              width="11.2"
              height="7.659"
              rx="0.6"
              fill="none"
            />
          </g>
          <path
            className="b"
            d="M11.03,21.768h6.708"
            transform="translate(-3.945 -3.91)"
            fill="none"
            strokeWidth="0.8px"
            strokeLinecap="round"
            stroke="#db0011"
          />
          <path
            className="b"
            d="M11.03,21.768h6.708"
            transform="translate(-3.945 -1.91)"
            fill="none"
            strokeWidth="0.8px"
            strokeLinecap="round"
            stroke="#db0011"
          />
          <path
            className="b"
            d="M11.03,21.5h2.449"
            transform="translate(5.161 -13.993)"
            fill="none"
            strokeWidth="0.8px"
            strokeLinecap="round"
            stroke="#db0011"
          />
        </g>
      </g>
    </symbol>
    <symbol id="icn-search" viewBox="0 0 14 14" fill="currentColor">
      <path d="M13.677 12.168L10.8 9.277a5.742 5.742 0 0 0 1.045-3.355 5.8 5.8 0 0 0-.465-2.3A5.926 5.926 0 0 0 5.923 0a5.8 5.8 0 0 0-2.3.465A5.812 5.812 0 0 0 .465 3.626a5.91 5.91 0 0 0 0 4.594 5.926 5.926 0 0 0 5.458 3.626A5.742 5.742 0 0 0 9.277 10.8l2.877 2.877A1.084 1.084 0 0 0 14 12.916a.978.978 0 0 0-.323-.748zm-5.1-3.587A3.636 3.636 0 0 1 5.923 9.69a3.636 3.636 0 0 1-2.658-1.11 3.636 3.636 0 0 1-1.11-2.658 3.636 3.636 0 0 1 1.11-2.658 3.636 3.636 0 0 1 2.658-1.11 3.636 3.636 0 0 1 2.658 1.11A3.636 3.636 0 0 1 9.69 5.923a3.636 3.636 0 0 1-1.11 2.658zm0 0" />
    </symbol>
    <symbol id="icn-search-new" viewBox="0 0 24 24" fill="currentColor">
      <path d="M13.677 12.168L10.8 9.277a5.742 5.742 0 0 0 1.045-3.355 5.8 5.8 0 0 0-.465-2.3A5.926 5.926 0 0 0 5.923 0a5.8 5.8 0 0 0-2.3.465A5.812 5.812 0 0 0 .465 3.626a5.91 5.91 0 0 0 0 4.594 5.926 5.926 0 0 0 5.458 3.626A5.742 5.742 0 0 0 9.277 10.8l2.877 2.877A1.084 1.084 0 0 0 14 12.916a.978.978 0 0 0-.323-.748zm-5.1-3.587A3.636 3.636 0 0 1 5.923 9.69a3.636 3.636 0 0 1-2.658-1.11 3.636 3.636 0 0 1-1.11-2.658 3.636 3.636 0 0 1 1.11-2.658 3.636 3.636 0 0 1 2.658-1.11 3.636 3.636 0 0 1 2.658 1.11A3.636 3.636 0 0 1 9.69 5.923a3.636 3.636 0 0 1-1.11 2.658zm0 0" />
    </symbol>
    <symbol id="icn-search-new" viewBox="0 0 24 24" fill="currentColor">
      <path
        id="Path_6104"
        data-name="Path 6104"
        d="M21,20l-5.317-5.317a7.757,7.757,0,1,0-1,1L20,21ZM3.4,9.735a6.337,6.337,0,1,1,6.337,6.337A6.337,6.337,0,0,1,3.4,9.735Z"
        transform="translate(0 0)"
        fill="#b7b6b8"
      />
      <rect
        id="_Transparent_Rectangle_"
        data-name="&lt;Transparent Rectangle&gt;"
        width="24"
        height="24"
        fill="none"
      />
    </symbol>
    <symbol id="icn-settings" viewBox="0 0 16.2 16.1" fill="currentColor">
      <path
        className="a"
        d="M8 11.5A3.543 3.543 0 0 0 11.5 8 3.543 3.543 0 0 0 8 4.5 3.543 3.543 0 0 0 4.5 8 3.543 3.543 0 0 0 8 11.5zm0-5.7A2.2 2.2 0 1 1 5.8 8 2.22 2.22 0 0 1 8 5.8z"
      />
      <path
        className="a"
        d="M.6 9.8l1.8.1c.1.2.2.5.3.7L1.5 12a.746.746 0 0 0 0 .9l1.7 1.7a.746.746 0 0 0 .9 0l1.4-1.2a4.875 4.875 0 0 0 .7.3l.1 1.8a.645.645 0 0 0 .6.6h2.4a.645.645 0 0 0 .6-.6l.1-1.8a4.875 4.875 0 0 1 .7-.3l1.4 1.2a.746.746 0 0 0 .9 0l1.7-1.7a.746.746 0 0 0 0-.9l-1.2-1.4a4.875 4.875 0 0 0 .3-.7l1.8-.1a.645.645 0 0 0 .6-.6V6.8a.645.645 0 0 0-.6-.6l-1.8-.1a4.875 4.875 0 0 1-.3-.7l1-1.4a.746.746 0 0 0 0-.9l-1.7-1.7a.746.746 0 0 0-.9 0l-1.4 1.2a4.875 4.875 0 0 0-.7-.3V.6a.645.645 0 0 0-.6-.6H6.8a.645.645 0 0 0-.6.6l-.1 1.8c-.2.1-.5.2-.7.3L4 1.5a.746.746 0 0 0-.9 0L1.5 3.2a.608.608 0 0 0 0 .8l1.2 1.4c-.1.2-.2.5-.3.7l-1.8.1a.645.645 0 0 0-.6.6v2.4a.645.645 0 0 0 .6.6zm2.9-3A6.117 6.117 0 0 1 4 5.6a.616.616 0 0 0-.1-.7L2.8 3.7l.9-.9L5 3.9c.1.2.4.2.6.1a6.117 6.117 0 0 1 1.2-.5.634.634 0 0 0 .5-.6l.1-1.7h1.2l.1 1.7a.634.634 0 0 0 .5.6 6.117 6.117 0 0 1 1.2.5.616.616 0 0 0 .7-.1l1.3-1.1.9.9L12.2 5a.616.616 0 0 0-.1.7 6.117 6.117 0 0 1 .5 1.2.634.634 0 0 0 .6.5l1.7.1v1.2l-1.7.1a.634.634 0 0 0-.6.5 6.117 6.117 0 0 1-.5 1.2.616.616 0 0 0 .1.7l1.1 1.3-.9.9-1.3-1.1a.616.616 0 0 0-.7-.1 6.117 6.117 0 0 1-1.2.5.634.634 0 0 0-.5.6L8.6 15H7.4l-.1-1.7a.634.634 0 0 0-.5-.6 7.459 7.459 0 0 0-1.2-.7.616.616 0 0 0-.7.1l-1.3 1.1-.9-.9L3.8 11a.616.616 0 0 0 .1-.7c-.1-.3-.3-.7-.4-1.1a.634.634 0 0 0-.6-.5l-1.7-.1V7.4l1.7-.1a.634.634 0 0 0 .6-.5z"
      />
    </symbol>
    <symbol
      id="icn-tick"
      viewBox="0 0 13 9.6"
      fill="currentColor"
      stroke="currentColor"
    >
      <path
        className="a"
        d="M11.5.5a.908.908 0 0 0-.7.3L5.1 6.7l-2.9-3a.908.908 0 0 0-.7-.3 1.075 1.075 0 0 0-1 1 .908.908 0 0 0 .3.7l3.6 3.7a.967.967 0 0 0 1.4 0l6.4-6.5a.908.908 0 0 0 .3-.7 1.029 1.029 0 0 0-1-1.1z"
      />
    </symbol>
    <symbol id="icn-check" viewBox="0 0 54.606 54.606" fill="currentColor">
      <g transform="translate(0.5 0.5)">
        <path
          d="M26.8,0C12.837,0,1.354,10.7.06,25c-.022.155-.06.974-.06,1.8A26.8,26.8,0,1,0,26.8,0Zm0,51.462A24.8,24.8,0,0,1,2.144,26.8,24.8,24.8,0,0,1,26.8,2.144,24.8,24.8,0,0,1,51.462,26.8,24.8,24.8,0,0,1,26.8,51.462Z"
          fill="#289a23"
          stroke="#289a23"
          strokeWidth="1"
        />
        <path
          d="M27.478,8.3a1.731,1.731,0,0,0-1.335.572L15.272,20.124,9.742,14.4a1.731,1.731,0,0,0-1.335-.572A2.051,2.051,0,0,0,6.5,15.738a1.731,1.731,0,0,0,.572,1.335l6.865,7.056a1.844,1.844,0,0,0,2.67,0l12.205-12.4a1.731,1.731,0,0,0,.572-1.335A1.962,1.962,0,0,0,27.478,8.3Z"
          transform="translate(8.999 11.95)"
          fill="#289a23"
          stroke="#289a23"
          strokeWidth="1"
        />
      </g>
    </symbol>

    <symbol
      id="icn-tick-long"
      viewBox="0 0 39.209 26.504"
      fill="currentColor"
      stroke="currentColor"
    >
      <path
        id="Path_5840"
        data-name="Path 5840"
        d="M-2299.97,18844.756l11.781,10.885.692.711,21.081-21.674"
        transform="translate(2302.797 -18831.85)"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
    </symbol>
    <symbol id="user" viewBox="0 0 20 20" fill="currentColor">
      <path
        id="Path_2167"
        data-name="Path 2167"
        d="M13.235,3.21A3.025,3.025,0,1,1,10.21,6.235,3.025,3.025,0,0,1,13.235,3.21m0-1.21a4.235,4.235,0,1,0,4.235,4.235A4.235,4.235,0,0,0,13.235,2Z"
        transform="translate(-3.554 -0.79)"
      />
      <path
        id="Path_2168"
        data-name="Path 2168"
        d="M18.1,25.261h-1.21V22.235a3.025,3.025,0,0,0-3.025-3.025h-3.63A3.025,3.025,0,0,0,7.21,22.235v3.025H6V22.235A4.235,4.235,0,0,1,10.235,18h3.63A4.235,4.235,0,0,1,18.1,22.235Z"
        transform="translate(-2.37 -7.109)"
      />
      <rect
        id="_Transparent_Rectangle_"
        data-name="&lt;Transparent Rectangle&gt;"
        width="20"
        height="20"
        fill="none"
      />
    </symbol>
    <symbol id="return" viewBox="0 0 20 20" fill="currentColor">
      <path
        id="Path_2170"
        data-name="Path 2170"
        d="M8.657,22.655,6.407,20.4H19.082V19.142H6.407l2.25-2.256L7.771,16,4,19.771l3.771,3.771Z"
        transform="translate(-1.486 -5.945)"
      />
      <path
        id="Path_2171"
        data-name="Path 2171"
        d="M19.082,7.771,15.312,4l-.886.886,2.25,2.256H4V8.4H16.675l-2.25,2.256.886.886Z"
        transform="translate(-1.486 -1.486)"
      />
      <rect
        id="_Transparent_Rectangle_"
        data-name="&lt;Transparent Rectangle&gt;"
        width="20"
        height="20"
        transform="translate(20) rotate(90)"
        fill="none"
      />
    </symbol>
    <symbol id="icn-user-old" viewBox="0 0 51.546 51.493" fill="currentColor">
      <path
        className="a"
        d="M25.773 0a25.746 25.746 0 1 0 25.773 25.719A25.768 25.768 0 0 0 25.773 0zm13.209 43.653a19.792 19.792 0 0 1-26.525 0v-.161c.054-6.229 5.96-11.329 13.209-11.383h.107c7.249.054 13.209 5.155 13.209 11.383.054.054 0 .108 0 .161zm2.685-1.289c-.644-6.819-6.819-12.3-14.5-12.94v-.054h-2.79v.054c-7.732.644-13.907 6.121-14.551 12.94a23.042 23.042 0 1 1 38.982-16.645 22.9 22.9 0 0 1-7.141 16.646z"
      />
      <path
        className="a"
        d="M25.774 10.793a8.144 8.144 0 0 0-8.323 8.376 8.323 8.323 0 1 0 16.645 0 8.208 8.208 0 0 0-8.322-8.376zm0 14.122a5.487 5.487 0 0 1-5.638-5.692 5.638 5.638 0 1 1 11.276 0 5.55 5.55 0 0 1-5.638 5.692z"
      />
    </symbol>

    <symbol id="icn-user" viewBox="0 0 51 51" fill="none">
      <g transform="translate(-19.541 -13.064)">
        <g transform="translate(12.05 3.874)">
          <g transform="translate(21.292 19.87)">
            <path
              className="a"
              d="M26.661,53h-4.72A9.441,9.441,0,0,0,12.5,62.441v2.832a.944.944,0,0,0,1.888,0V62.441a7.553,7.553,0,0,1,7.553-7.553h4.72a7.553,7.553,0,0,1,7.553,7.553v2.832a.944.944,0,1,0,1.888,0V62.441A9.441,9.441,0,0,0,26.661,53Z"
              transform="translate(-12.5 -37.895)"
              fill="currentColor"
            />
            <path
              className="b"
              d="M35.609,18.217A6.609,6.609,0,1,0,29,11.609,6.609,6.609,0,0,0,35.609,18.217Zm0-11.329a4.72,4.72,0,1,1-4.72,4.72,4.72,4.72,0,0,1,4.72-4.72Z"
              transform="translate(-23.808 -5)"
              fill="currentColor"
            />
          </g>
        </g>
        <g
          className="c"
          transform="translate(19.541 13.064)"
          stroke="currentColor"
          strokeWidth="2"
        >
          <circle className="d" cx="25.5" cy="25.5" r="25.5" stroke="none" />
          <circle className="e" cx="25.5" cy="25.5" r="24.5" fill="none" />
        </g>
      </g>
    </symbol>

    <symbol id="icn-user-red-head" viewBox="0 0 51 51" fill="none">
      <g transform="translate(-19.541 -13.064)">
        <g transform="translate(12.05 3.874)">
          <g transform="translate(21.292 19.87)">
            <path
              className="a"
              d="M26.661,53h-4.72A9.441,9.441,0,0,0,12.5,62.441v2.832a.944.944,0,0,0,1.888,0V62.441a7.553,7.553,0,0,1,7.553-7.553h4.72a7.553,7.553,0,0,1,7.553,7.553v2.832a.944.944,0,1,0,1.888,0V62.441A9.441,9.441,0,0,0,26.661,53Z"
              transform="translate(-12.5 -37.895)"
              fill="currentColor"
            />
            <path
              className="b"
              d="M35.609,18.217A6.609,6.609,0,1,0,29,11.609,6.609,6.609,0,0,0,35.609,18.217Zm0-11.329a4.72,4.72,0,1,1-4.72,4.72,4.72,4.72,0,0,1,4.72-4.72Z"
              transform="translate(-23.808 -5)"
              fill="#e03126"
            />
          </g>
        </g>
        <g
          className="c"
          transform="translate(19.541 13.064)"
          stroke="currentColor"
          strokeWidth="2"
        >
          <circle className="d" cx="25.5" cy="25.5" r="25.5" stroke="none" />
          <circle className="e" cx="25.5" cy="25.5" r="24.5" fill="none" />
        </g>
      </g>
    </symbol>

    <symbol id="icn-user-new" viewBox="0 0 51 51" fill="none">
      <g transform="translate(-19.541 -13.064)">
        <g transform="translate(12.05 3.874)">
          <g transform="translate(21.292 19.87)">
            <path
              className="a"
              d="M26.661,53h-4.72A9.441,9.441,0,0,0,12.5,62.441v2.832a.944.944,0,0,0,1.888,0V62.441a7.553,7.553,0,0,1,7.553-7.553h4.72a7.553,7.553,0,0,1,7.553,7.553v2.832a.944.944,0,1,0,1.888,0V62.441A9.441,9.441,0,0,0,26.661,53Z"
              transform="translate(-12.5 -37.895)"
              fill="currentColor"
            />
            <path
              className="b"
              d="M35.609,18.217A6.609,6.609,0,1,0,29,11.609,6.609,6.609,0,0,0,35.609,18.217Zm0-11.329a4.72,4.72,0,1,1-4.72,4.72,4.72,4.72,0,0,1,4.72-4.72Z"
              transform="translate(-23.808 -5)"
              fill="#db0011"
            />
          </g>
        </g>
        <g
          className="c"
          transform="translate(19.541 13.064)"
          stroke="#fff"
          strokeWidth="2"
        >
          <circle className="d" cx="25.5" cy="25.5" r="25.5" stroke="none" />
          <circle className="e" cx="25.5" cy="25.5" r="24.5" fill="none" />
        </g>
      </g>
    </symbol>
    <symbol id="icn-users" viewBox="0 0 35 41" fill="currentColor">
      <g transform="translate(33.5 -77.5)">
        <g transform="translate(-66 48)">
          <path
            className="a"
            d="M67.5,69a1.5,1.5,0,0,1-3,0,14.5,14.5,0,0,0-29,0,1.5,1.5,0,0,1-3,0,17.5,17.5,0,0,1,35,0ZM50,50.5A10.5,10.5,0,1,1,60.5,40,10.5,10.5,0,0,1,50,50.5Zm0-3A7.5,7.5,0,1,0,42.5,40,7.5,7.5,0,0,0,50,47.5Z"
          />
        </g>
      </g>
    </symbol>
    <symbol
      id="icn-circle-user"
      viewBox="0 0 32.234 32.234"
      fill="currentColor"
    >
      <g transform="translate(-17.3 -9.064)">
        <g transform="translate(17.3 9.064)">
          <path
            d="M29.417,45.534A16.117,16.117,0,1,0,13.3,29.417,16.128,16.128,0,0,0,29.417,45.534Zm-9.749-5.621a12.524,12.524,0,0,1,9.749-5.094,12.524,12.524,0,0,1,9.749,5.094,14.349,14.349,0,0,1-19.5,0Zm9.749-24.856A14.335,14.335,0,0,1,40.4,38.639a14.242,14.242,0,0,0-10.979-5.577,14.242,14.242,0,0,0-10.979,5.577A14.335,14.335,0,0,1,29.417,15.057Z"
            transform="translate(-13.3 -13.3)"
            fill="currentColor"
          />
          <path
            d="M41.485,36.271A5.685,5.685,0,1,0,35.8,30.585,5.707,5.707,0,0,0,41.485,36.271Zm0-9.769A4.084,4.084,0,1,1,37.4,30.585,4.1,4.1,0,0,1,41.485,26.5Z"
            transform="translate(-25.49 -19.133)"
            fill="#db0011"
          />
        </g>
      </g>
    </symbol>

    <symbol id="icn-warning" viewBox="0 0 16 16" fill="currentColor">
      <path
        className="a"
        d="M8 0a8 8 0 1 0 8 8 7.989 7.989 0 0 0-8-8zm0 14.933A6.933 6.933 0 1 1 14.933 8 6.954 6.954 0 0 1 8 14.933z"
      />
      <circle
        className="a"
        cx="1.067"
        cy="1.067"
        r="1.067"
        transform="translate(6.933 9.813)"
      />
      <path
        className="a"
        d="M8 4.053A1.07 1.07 0 0 0 6.933 5.12S6.96 9.173 8 9.173 9.067 5.12 9.067 5.12A1.07 1.07 0 0 0 8 4.053z"
      />
    </symbol>
    <symbol id="icn-warning-new" viewBox="0 0 13 13" fill="currentColor">
      <g transform="translate(-11492 1029)">
        <g transform="translate(10870 -1282)">
          <g
            className="a"
            fill="none"
            stroke="currentcolor"
            transform="translate(622 253)"
          >
            <circle className="c" stroke="none" cx="6.5" cy="6.5" r="6.5" />
            <circle className="d" fill="none" cx="6.5" cy="6.5" r="6" />
          </g>
        </g>
        <path
          className="b"
          strokeLinecap="round"
          stroke="currentcolor"
          fill="none"
          d="M1705.566,128.849V131.9"
          transform="translate(9792.934 -1154.192)"
        />
        <path
          className="b"
          strokeLinecap="round"
          stroke="currentcolor"
          fill="none"
          d="M1705.566,142.5h0"
          transform="translate(9792.934 -1162.107)"
        />
      </g>
    </symbol>
    <symbol id="icn-calendar" fill="currentColor" viewBox="0 0 19.274 17.266">
      <g id="noun_Calendar_1987389" transform="translate(-10.989 -14.9)">
        <g id="Group" transform="translate(10.989 14.9)">
          <path
            id="Compound_Path"
            data-name="Compound Path"
            className="cls-1"
            d="M28.334,16.447H27.218v-1.04a.507.507,0,0,0-1.014,0v1.04H21.133v-1.04a.507.507,0,0,0-1.014,0v1.04H15.049v-1.04a.507.507,0,0,0-1.014,0v1.04H12.919a1.9,1.9,0,0,0-1.927,1.978V30.163a1.9,1.9,0,0,0,1.927,2H28.334a1.9,1.9,0,0,0,1.927-2V18.424a1.9,1.9,0,0,0-1.927-1.978Zm.913,13.716a.9.9,0,0,1-.913.989H12.919a.9.9,0,0,1-.913-.989V18.424a.887.887,0,0,1,.913-.963h1.116v.634a.507.507,0,1,0,1.014,0v-.634h5.071v.634a.507.507,0,1,0,1.014,0v-.634H26.2v.634a.507.507,0,1,0,1.014,0v-.634h1.116a.887.887,0,0,1,.913.963Z"
            transform="translate(-10.989 -14.9)"
          />
          <path
            id="Path"
            className="cls-1"
            d="M39.62,38h-.913a.507.507,0,1,0,0,1.014h.913a.507.507,0,1,0,0-1.014Z"
            transform="translate(-31.301 -32.143)"
          />
          <path
            id="Path-2"
            data-name="Path"
            className="cls-1"
            d="M53.494,38h-.887a.507.507,0,1,0,0,1.014h.887a.507.507,0,1,0,0-1.014Z"
            transform="translate(-41.677 -32.143)"
          />
          <path
            id="Path-3"
            data-name="Path"
            className="cls-1"
            d="M67.494,38h-.887a.507.507,0,1,0,0,1.014h.887a.507.507,0,1,0,0-1.014Z"
            transform="translate(-52.127 -32.143)"
          />
          <path
            id="Path-4"
            data-name="Path"
            className="cls-1"
            d="M39.62,51h-.913a.507.507,0,0,0,0,1.014h.913a.507.507,0,1,0,0-1.014Z"
            transform="translate(-31.301 -41.847)"
          />
          <path
            id="Path-5"
            data-name="Path"
            className="cls-1"
            d="M25.62,51h-.913a.507.507,0,0,0,0,1.014h.913a.507.507,0,1,0,0-1.014Z"
            transform="translate(-20.851 -41.847)"
          />
          <path
            id="Path-6"
            data-name="Path"
            className="cls-1"
            d="M53.494,51h-.887a.507.507,0,1,0,0,1.014h.887a.507.507,0,1,0,0-1.014Z"
            transform="translate(-41.677 -41.847)"
          />
          <path
            id="Path-7"
            data-name="Path"
            className="cls-1"
            d="M67.494,51h-.887a.507.507,0,0,0,0,1.014h.887a.507.507,0,1,0,0-1.014Z"
            transform="translate(-52.127 -41.847)"
          />
          <path
            id="Path-8"
            data-name="Path"
            className="cls-1"
            d="M39.62,65h-.913a.507.507,0,0,0,0,1.014h.913a.507.507,0,1,0,0-1.014Z"
            transform="translate(-31.301 -52.298)"
          />
          <path
            id="Path-9"
            data-name="Path"
            className="cls-1"
            d="M25.62,65h-.913a.507.507,0,0,0,0,1.014h.913a.507.507,0,0,0,0-1.014Z"
            transform="translate(-20.851 -52.298)"
          />
          <path
            id="Path-10"
            data-name="Path"
            className="cls-1"
            d="M53.494,65h-.887a.507.507,0,1,0,0,1.014h.887a.507.507,0,1,0,0-1.014Z"
            transform="translate(-41.677 -52.298)"
          />
        </g>
      </g>
    </symbol>
    <symbol id="calendar" width="15" height="16.25" viewBox="0 0 15 16.25">
      <path
        id="Fill"
        d="M13.75,1.25h-2.5V0H10V1.25H5V0H3.75V1.25H1.25A1.254,1.254,0,0,0,0,2.5V15a1.254,1.254,0,0,0,1.25,1.25h12.5A1.254,1.254,0,0,0,15,15V2.5A1.254,1.254,0,0,0,13.75,1.25Zm0,13.75H1.25V6.25h12.5Zm0-10H1.25V2.5h2.5V3.75H5V2.5h5V3.75h1.25V2.5h2.5Z"
        fillRule="evenodd"
      />
    </symbol>
    <symbol id="clock" width="17.5" height="17.5" viewBox="0 0 17.5 17.5">
      <path
        id="Fill"
        d="M8.75,17.5a8.75,8.75,0,1,1,6.187-2.563A8.75,8.75,0,0,1,8.75,17.5Zm0-16.25a7.5,7.5,0,1,0,7.5,7.5A7.5,7.5,0,0,0,8.75,1.25ZM11.619,12.5,8.125,9.006V3.125h1.25V8.488L12.5,11.619l-.881.881Z"
        fillRule="evenodd"
      />
    </symbol>
    <symbol id="icn-arrows" viewBox="0 0 18 15.131" fill="currentColor">
      <path
        className="a"
        d="M3.799 7.597a.681.681 0 0 0 .482-1.163L2.326 4.479h11.328a.681.681 0 0 0 0-1.362H2.326L4.28 1.162a.681.681 0 1 0-.963-.963L.2 3.316a.681.681 0 0 0 0 .963l3.117 3.118a.679.679 0 0 0 .482.2zM17.801 10.851l-3.117-3.118a.681.681 0 1 0-.963.963l1.954 1.955H4.347a.681.681 0 1 0 0 1.362h11.328l-1.954 1.955a.681.681 0 1 0 .963.963l3.117-3.118a.681.681 0 0 0 0-.962z"
      />
    </symbol>
    <symbol id="icn-budget" viewBox="0 0 18 17.951" fill="currentColor">
      <path
        className="a"
        d="M0 16.511h18v1.44H0zM2.462 9.13h1.44v5.94h-1.44zM14.096 9.13h1.44v5.94h-1.44zM10.218 9.13h1.44v5.94h-1.44zM6.341 9.13h1.44v5.94h-1.44zM9.416 0h-.833L0 6.088v1.539h18V6.088zm-7.9 6.433L9.027 1.2l7.357 5.236z"
      />
    </symbol>
    <symbol id="icn-budget2" viewBox="0 0 62.646 53.764">
      <g transform="translate(-15.662)">
        <path
          className="a"
          d="M37.789,0a.859.859,0,0,0-.7.234L10.674,16.6a1.786,1.786,0,0,0-.468,1.169v3.506a1.508,1.508,0,0,0,1.4,1.4h4.208V42.543H11.375a1.508,1.508,0,0,0-1.4,1.4v2.1H8.1a1.508,1.508,0,0,0-1.4,1.4v4.909a1.508,1.508,0,0,0,1.4,1.4H67.944a1.508,1.508,0,0,0,1.4-1.4V47.452a1.508,1.508,0,0,0-1.4-1.4h-2.1v-2.1a1.508,1.508,0,0,0-1.4-1.4H60.23V22.908h4.208a1.508,1.508,0,0,0,1.4-1.4v-3.74a1.285,1.285,0,0,0-.7-1.169L38.724.234C38.491,0,38.257,0,37.789,0Zm.234,3.039L63.035,18.467v1.4H13.011v-1.4Zm-19.4,19.869h2.805V42.777H18.622Zm5.844,0h9.35V42.777h-9.35Zm11.922,0h2.805V42.777H36.387Zm5.844,0h9.35V42.777h-9.35Zm12.155,0h2.805V42.777H54.386ZM13.011,45.582H62.8v2.1a1.508,1.508,0,0,0,1.4,1.4h2.1v2.1H9.505v-2.1h2.1a1.508,1.508,0,0,0,1.4-1.4v-2.1Z"
          transform="translate(8.961)"
          fill="currentColor"
        />
        <g
          className="b"
          transform="translate(42.355 9.204)"
          fill="currentColor"
        >
          <ellipse
            className="c"
            cx="4.09"
            cy="4.09"
            rx="4.09"
            ry="4.09"
            stroke="none"
          />
          <ellipse
            className="d"
            cx="4.09"
            cy="4.09"
            rx="3.09"
            ry="3.09"
            fill="none"
          />
        </g>
      </g>
    </symbol>
    <symbol id="icn-budget3" viewBox="0 0 62.646 53.764" fill="currentColor">
      <g transform="translate(-15.662)">
        <path
          className="a"
          d="M37.789,0a.859.859,0,0,0-.7.234L10.674,16.6a1.786,1.786,0,0,0-.468,1.169v3.506a1.508,1.508,0,0,0,1.4,1.4h4.208V42.543H11.375a1.508,1.508,0,0,0-1.4,1.4v2.1H8.1a1.508,1.508,0,0,0-1.4,1.4v4.909a1.508,1.508,0,0,0,1.4,1.4H67.944a1.508,1.508,0,0,0,1.4-1.4V47.452a1.508,1.508,0,0,0-1.4-1.4h-2.1v-2.1a1.508,1.508,0,0,0-1.4-1.4H60.23V22.908h4.208a1.508,1.508,0,0,0,1.4-1.4v-3.74a1.285,1.285,0,0,0-.7-1.169L38.724.234C38.491,0,38.257,0,37.789,0Zm.234,3.039L63.035,18.467v1.4H13.011v-1.4Zm-19.4,19.869h2.805V42.777H18.622Zm5.844,0h9.35V42.777h-9.35Zm11.922,0h2.805V42.777H36.387Zm5.844,0h9.35V42.777h-9.35Zm12.155,0h2.805V42.777H54.386ZM13.011,45.582H62.8v2.1a1.508,1.508,0,0,0,1.4,1.4h2.1v2.1H9.505v-2.1h2.1a1.508,1.508,0,0,0,1.4-1.4v-2.1Z"
          transform="translate(8.961)"
          fill="currentColor"
        />
        <g className="b" transform="translate(42.355 9.204)" fill="#db0011">
          <ellipse
            className="c"
            cx="4.09"
            cy="4.09"
            rx="4.09"
            ry="4.09"
            stroke="none"
          />
          <ellipse
            className="d"
            cx="4.09"
            cy="4.09"
            rx="3.09"
            ry="3.09"
            fill="none"
          />
        </g>
      </g>
    </symbol>

    <symbol
      id="icn-moneytrasnfer"
      viewBox="0 0 23.678 24.231"
      fill="currentColor"
    >
      <g transform="translate(-368 -589.413)">
        <g
          transform="translate(368 594.823)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        >
          <rect width="23.678" height="18.821" rx="3" stroke="none" />
          <rect
            x="0.5"
            y="0.5"
            width="22.678"
            height="17.821"
            rx="2.5"
            fill="none"
          />
        </g>
        <path
          d="M377.612,593.972h13.31"
          transform="translate(-4.383 -1.595)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          d="M377.612,593.972h9.7"
          transform="translate(-3.199 10.548)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          d="M377.612,594.031h8.048"
          transform="translate(-1.842 -4.118)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          d="M393.159,610.018l2.137,2.137-2.137,2.137"
          transform="translate(-10.976 -7.654)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </g>
    </symbol>

    <symbol id="icn-close" viewBox="0 0 12 12">
      <path
        d="M11.611 9.855C10.332 8.555 9.054 7.279 7.775 6l3.855-3.855A1.256 1.256 0 0 0 9.855.37L6 4.225C4.721 2.946 3.443 1.668 2.145.389A1.256 1.256 0 0 0 .37 2.164C1.67 3.443 2.946 4.721 4.225 6 2.946 7.279 1.668 8.557.389 9.855a1.256 1.256 0 0 0 1.775 1.775C3.443 10.33 4.721 9.054 6 7.775l3.855 3.855c1.126 1.126 2.901-.649 1.756-1.775z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="icn-coins" viewBox="0 0 44 42">
      <path
        d="M29.5 16H29V5.5C29 1.889 21.706 0 14.5 0S0 1.889 0 5.5v20C0 29.111 7.295 31 14.5 31c.169 0 .333-.007.5-.009V36.5c0 3.611 7.295 5.5 14.5 5.5S44 40.111 44 36.5v-15c0-3.611-7.294-5.5-14.5-5.5zm-15-14C22.131 2 27 4.073 27 5.5S22.131 9 14.5 9 2 6.927 2 5.5 6.87 2 14.5 2zM2 8.43C4.66 10.125 9.6 11 14.5 11s9.84-.875 12.5-2.57v2.07c0 1.427-4.87 3.5-12.5 3.5S2 11.927 2 10.5zm0 5C4.66 15.125 9.6 16 14.5 16s9.84-.875 12.5-2.57v2.07a.979.979 0 0 1-.289.595c-4.259.292-8.2 1.255-10.247 2.852A38.82 38.82 0 0 1 14.5 19C6.87 19 2 16.927 2 15.5zm0 5C4.66 20.125 9.6 21 14.5 21c.185 0 .37-.005.555-.008A2.587 2.587 0 0 0 15 21.5v2.49c-.168 0-.331.009-.5.009C6.87 24 2 21.927 2 20.5zM14.5 29C6.87 29 2 26.927 2 25.5v-2.07C4.66 25.13 9.6 26 14.5 26c.169 0 .333-.007.5-.01v3c-.167.003-.331.01-.5.01zm15 11C21.87 40 17 37.927 17 36.5v-2.07C19.66 36.125 24.6 37 29.5 37s9.84-.875 12.5-2.57v2.07c0 1.427-4.869 3.5-12.5 3.5zm0-5C21.87 35 17 32.927 17 31.5v-2.07C19.66 31.125 24.6 32 29.5 32s9.84-.875 12.5-2.57v2.07c0 1.427-4.869 3.5-12.5 3.5zm0-5C21.87 30 17 27.927 17 26.5v-2.07C19.66 26.125 24.6 27 29.5 27s9.84-.875 12.5-2.57v2.07c0 1.427-4.869 3.5-12.5 3.5zm0-5C21.87 25 17 22.927 17 21.5S21.87 18 29.5 18 42 20.073 42 21.5 37.131 25 29.5 25z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="icn-lamp" viewBox="0 0 12.002 18.576">
      <path
        d="M10.097 1.618a6.02 6.02 0 0 0-8.5.284 6.058 6.058 0 0 0-.507 7.566 8.047 8.047 0 0 1 1.482 3.912 1.389 1.389 0 0 0 .71 1.055v4.145h5.436v-4.163a1.371 1.371 0 0 0 .71-1.014v-.023a8.545 8.545 0 0 1 1.481-3.935 5.983 5.983 0 0 0-.811-7.83zm-2.6 15.74h-3v-.832h3v.832zm0-2.049h-3v-.75h3v.75zm2.434-6.572a9.62 9.62 0 0 0-1.7 4.483.13.13 0 0 1-.122.122h-1.5V7.825h1.46V6.608H3.931v1.217h1.46v5.517H3.87c-.041 0-.081-.041-.1-.1a9.407 9.407 0 0 0-1.7-4.483 4.848 4.848 0 0 1-.852-3.1A4.774 4.774 0 0 1 5.66 1.237c.122 0 .223-.02.345-.02A4.8 4.8 0 0 1 9.94 8.742z"
        fill="currentColor"
      />
    </symbol>

    <symbol id="icn-lock" viewBox="0 0 16 20.366" fill="currentColor">
      <path
        className="a"
        d="M8.124 0a5.2 5.2 0 0 0-5.176 5.221v1.305H2.7a2.694 2.694 0 0 0-2.7 2.7v8.439a2.694 2.694 0 0 0 2.7 2.7h10.6a2.694 2.694 0 0 0 2.7-2.7V9.226a2.694 2.694 0 0 0-2.7-2.7V5.221A5.186 5.186 0 0 0 8.124 0zM4.433 5.221a3.7 3.7 0 1 1 7.4 0v1.305h-7.4zm10.1 4.006v8.439A1.22 1.22 0 0 1 13.3 18.9H2.723a1.22 1.22 0 0 1-1.238-1.238V9.226a1.22 1.22 0 0 1 1.238-1.238h10.6a1.259 1.259 0 0 1 1.214 1.238z"
      />
      <path
        className="a"
        d="M8.012 12.94a.721.721 0 0 0-.743.743v1.463a.743.743 0 0 0 1.485 0V13.66a.73.73 0 0 0-.742-.72z"
      />
    </symbol>

    <symbol id="icn-locked-red-circle" viewBox="0 0 12 17" fill="currentColor">
      <g id="Group_3176" data-name="Group 3176" transform="translate(0 0.33)">
        <g
          id="Union_1"
          data-name="Union 1"
          transform="translate(0 -0.33)"
          fill="none"
        >
          <path
            d="M0,11.333a5.506,5.506,0,0,1,1.847-4.09A4.419,4.419,0,0,1,1,4.722,5.035,5.035,0,0,1,6,0a4.867,4.867,0,0,1,5,4.722,4.513,4.513,0,0,1-.8,2.563A5.5,5.5,0,0,1,12,11.333,5.84,5.84,0,0,1,6,17,5.841,5.841,0,0,1,0,11.333Z"
            stroke="none"
          />
          <path
            d="M 6.000589847564697 16 C 8.757269859313965 16 11 13.90635967254639 11 11.33292007446289 C 11 10.07929039001465 10.47445964813232 8.902529716491699 9.520190238952637 8.019390106201172 L 8.886079788208008 7.432549953460693 L 9.374650001525879 6.719970226287842 C 9.78363037109375 6.123489856719971 9.999799728393555 5.432640075683594 9.999799728393555 4.722109794616699 C 9.999799728393555 2.669729948043823 8.20576000213623 1 6.000589847564697 1 C 4.955850124359131 1 3.948570013046265 1.422659993171692 3.164309978485107 2.190129995346069 C 2.424870014190674 2.913729906082153 2.00078010559082 3.836600065231323 2.00078010559082 4.722109794616699 C 2.00078010559082 5.369190216064453 2.236560106277466 6.059869766235352 2.664680004119873 6.666930198669434 L 3.174710035324097 7.390130043029785 L 2.518889904022217 7.984320163726807 C 1.539420008659363 8.871769905090332 1 10.06099033355713 1 11.33292007446289 C 1 13.90635967254639 3.243259906768799 16 6.000589847564697 16 M 6.000589847564697 17 C 2.687700033187866 17 -8.881784197001252e-16 14.46327972412109 -8.881784197001252e-16 11.33292007446289 C -8.881784197001252e-16 9.725890159606934 0.7089800238609314 8.27476978302002 1.847460031509399 7.243259906768799 C 1.3125 6.484710216522217 1.000779986381531 5.603169918060303 1.000779986381531 4.722109794616699 C 1.000779986381531 2.360399961471558 3.238480091094971 0 6.000589847564697 0 C 8.761520385742188 0 10.99979972839355 2.114140033721924 10.99979972839355 4.722109794616699 C 10.99979972839355 5.667150020599365 10.70565986633301 6.547100067138672 10.1994104385376 7.285459995269775 C 11.31093978881836 8.314129829406738 12 9.747679710388184 12 11.33292007446289 C 12 14.46327972412109 9.314060211181641 17 6.000589847564697 17 Z"
            stroke="none"
            fill="#242424"
          />
        </g>
        <g
          id="Ellipse_90"
          data-name="Ellipse 90"
          transform="translate(4 8.67)"
          fill="none"
          stroke="#db0011"
          strokeWidth="1"
        >
          <circle cx="2" cy="2" r="2" stroke="none" />
          <circle cx="2" cy="2" r="1.5" fill="none" />
        </g>
      </g>
    </symbol>

    <symbol id="icn-locked" viewBox="0 0 12 17.999" fill="currentColor">
      <g transform="translate(-886 -684.001)">
        <g transform="translate(6354.458 1752.541)" fill="none">
          <path
            d="M-5468.458-1056.541a5.984,5.984,0,0,1,1.847-4.33,4.865,4.865,0,0,1-.847-2.669,5.175,5.175,0,0,1,5-5,5,5,0,0,1,5,5,4.975,4.975,0,0,1-.8,2.714,5.982,5.982,0,0,1,1.8,4.285,6,6,0,0,1-6,6A6,6,0,0,1-5468.458-1056.541Z"
            stroke="none"
          />
          <path
            d="M -5462.4580078125 -1051.540893554688 C -5459.701171875 -1051.540893554688 -5457.4580078125 -1053.783935546875 -5457.4580078125 -1056.541015625 C -5457.4580078125 -1057.8955078125 -5457.9912109375 -1059.163696289062 -5458.95849609375 -1060.112060546875 L -5459.54248046875 -1060.68408203125 L -5459.09814453125 -1061.369995117188 C -5458.6796875 -1062.015991210938 -5458.45849609375 -1062.766479492188 -5458.45849609375 -1063.540283203125 C -5458.45849609375 -1065.745727539062 -5460.25244140625 -1067.539916992188 -5462.4580078125 -1067.539916992188 C -5463.49169921875 -1067.539916992188 -5464.4921875 -1067.093627929688 -5465.27392578125 -1066.283325195312 C -5466.0263671875 -1065.50390625 -5466.4580078125 -1064.504028320312 -5466.4580078125 -1063.540283203125 C -5466.4580078125 -1062.834106445312 -5466.216796875 -1062.082885742188 -5465.77880859375 -1061.425170898438 L -5465.3154296875 -1060.728759765625 L -5465.9189453125 -1060.1494140625 C -5466.91162109375 -1059.19677734375 -5467.45849609375 -1057.915283203125 -5467.45849609375 -1056.541015625 C -5467.45849609375 -1053.783935546875 -5465.21533203125 -1051.540893554688 -5462.4580078125 -1051.540893554688 M -5462.4580078125 -1050.540893554688 C -5465.77099609375 -1050.540893554688 -5468.45849609375 -1053.226684570312 -5468.45849609375 -1056.541015625 C -5468.45849609375 -1058.242431640625 -5467.74951171875 -1059.77880859375 -5466.611328125 -1060.870971679688 C -5467.14599609375 -1061.674072265625 -5467.4580078125 -1062.607421875 -5467.4580078125 -1063.540283203125 C -5467.4580078125 -1066.040771484375 -5465.2197265625 -1068.539916992188 -5462.4580078125 -1068.539916992188 C -5459.69677734375 -1068.539916992188 -5457.45849609375 -1066.301513671875 -5457.45849609375 -1063.540283203125 C -5457.45849609375 -1062.539672851562 -5457.75244140625 -1061.608032226562 -5458.2587890625 -1060.826293945312 C -5457.1474609375 -1059.737182617188 -5456.4580078125 -1058.219360351562 -5456.4580078125 -1056.541015625 C -5456.4580078125 -1053.226684570312 -5459.14404296875 -1050.540893554688 -5462.4580078125 -1050.540893554688 Z"
            stroke="none"
            fill="#7b7b7b"
          />
        </g>
        <g
          transform="translate(890 694)"
          fill="none"
          stroke="#7b7b7b"
          strokeWidth="1"
        >
          <circle cx="2" cy="2" r="2" stroke="none" />
          <circle cx="2" cy="2" r="1.5" fill="none" />
        </g>
      </g>
    </symbol>
    <symbol
      id="icn-pen-transparent"
      viewBox="0 0 16.272 10.812"
      fill="currentColor"
    >
      <g transform="translate(-4.881 -5.478)">
        <g transform="translate(0)">
          {/* <rect
            id="_Transparent_Rectangle_"
            width="24"
            height="24"
            rx="12"
            fill="#eff1f4"
          /> */}
          <path
            id="Shape"
            className="a"
            d="M3.043,11H0V7.953L7.7.25a.884.884,0,0,1,1.234,0l1.816,1.816a.9.9,0,0,1,0,1.234L3.043,11ZM6.3,3.217l-5.2,5.2V9.9H2.586l5.2-5.193ZM8.322,1.192l-1.25,1.25,1.494,1.49L9.813,2.681Z"
            transform="translate(7 6)"
          />
        </g>
      </g>
    </symbol>

    <symbol id="icn-pen" viewBox="0 0 16.272 10.812" fill="currentColor">
      <g transform="translate(-4.881 -5.478)">
        <g transform="translate(0)">
          <path
            className="a"
            d="M21.154,10.576ZM15.605,7.611l-1,1L12.556,6.571l-.776.776,2.045,2.045L8.809,14.407,6.764,12.362l-.776.776,2.045,2.045-.5.5-.01-.01a.4.4,0,0,1-.253.182l-1.907.425a.4.4,0,0,1-.473-.473L5.317,13.9a.4.4,0,0,1,.182-.253l-.01-.01L13.56,5.566a.3.3,0,0,1,.429,0l1.616,1.616A.3.3,0,0,1,15.605,7.611Z"
            transform="translate(-0.001)"
          />
        </g>
      </g>
    </symbol>
    <symbol id="icn-phone" viewBox="0 0 12 20" fill="currentColor">
      <path
        className="a"
        d="M9.684 0H2.316A2.316 2.316 0 0 0 0 2.316v15.368A2.316 2.316 0 0 0 2.316 20h7.368A2.316 2.316 0 0 0 12 17.684V2.316A2.316 2.316 0 0 0 9.684 0zm1.053 17.684a1.053 1.053 0 0 1-1.053 1.053H2.316a1.053 1.053 0 0 1-1.053-1.053v-1.979h9.474zm0-3.242H1.263V4.358h9.474zm0-11.347H1.263v-.779a1.053 1.053 0 0 1 1.053-1.053h7.368a1.053 1.053 0 0 1 1.053 1.053z"
      />
      <path
        className="a"
        d="M6.232 18.063a.821.821 0 0 0 .589-.589.842.842 0 0 0-1.032-1.032.821.821 0 0 0-.589.589.842.842 0 0 0 1.032 1.032z"
      />
    </symbol>
    <symbol id="icn-wallet" viewBox="0 0 63.324 55.602">
      <path
        d="M6.178 0A6.2 6.2 0 0 0 0 6.178v44.018a5.428 5.428 0 0 0 5.406 5.406h52.512a5.428 5.428 0 0 0 5.406-5.406V14.673a5.428 5.428 0 0 0-5.406-5.406h-3.861V1.545A1.605 1.605 0 0 0 52.513 0zm0 3.089h44.79v6.178H6.178a3.089 3.089 0 0 1 0-6.178zm-3.089 8.422a6.129 6.129 0 0 0 3.089.845c17.394-.016 36.79 0 51.741 0a2.278 2.278 0 0 1 2.317 2.317v9.265H37.84a3.887 3.887 0 0 0-3.861 3.861v9.267a3.887 3.887 0 0 0 3.861 3.861h22.4v9.267a2.279 2.279 0 0 1-2.317 2.317H5.406a2.279 2.279 0 0 1-2.317-2.317zM37.84 27.029h22.4v10.809h-22.4a.739.739 0 0 1-.772-.772v-9.267a.739.739 0 0 1 .772-.77zm7.722 2.317a3.089 3.089 0 1 0 3.089 3.089 3.089 3.089 0 0 0-3.088-3.09z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="icn-wallet2" viewBox="0 0 63.324 55.602">
      <g transform="translate(0 0)">
        <path
          fill="currentColor"
          className="a"
          d="M15.178,966.362A6.2,6.2,0,0,0,9,972.54v44.018a5.428,5.428,0,0,0,5.406,5.406H66.918a5.428,5.428,0,0,0,5.406-5.406V981.035a5.428,5.428,0,0,0-5.406-5.406H63.057v-7.722a1.605,1.605,0,0,0-1.544-1.545Zm0,3.089h44.79v6.178H15.178a3.089,3.089,0,0,1,0-6.178Zm-3.089,8.422a6.129,6.129,0,0,0,3.089.845c17.394-.016,36.79,0,51.741,0a2.278,2.278,0,0,1,2.317,2.317V990.3H46.84a3.887,3.887,0,0,0-3.861,3.861v9.267a3.887,3.887,0,0,0,3.861,3.861h22.4v9.267a2.279,2.279,0,0,1-2.317,2.317H14.406a2.279,2.279,0,0,1-2.317-2.317ZM46.84,993.391h22.4V1004.2H46.84a.739.739,0,0,1-.772-.772v-9.267A.739.739,0,0,1,46.84,993.391Zm7.722,2.317a3.089,3.089,0,1,0,3.089,3.089A3.089,3.089,0,0,0,54.563,995.707Z"
          transform="translate(-9 -966.362)"
        />
        <circle
          className="b"
          fill="#db0011"
          cx="3.5"
          cy="3.5"
          r="3.5"
          transform="translate(42 28.602)"
        />
      </g>
    </symbol>
    <symbol id="icn-star-full" viewBox="0 0 14 13.29">
      <path
        d="M13.227 4.461l-3.95-.294-1.5-3.656a.842.842 0 0 0-1.549 0l-1.5 3.656-3.95.294a.828.828 0 0 0-.48 1.456L3.35 8.442l-.929 3.826a.808.808 0 0 0 .77 1.022.759.759 0 0 0 .434-.139l3.33-2.076 3.377 2.076a.8.8 0 0 0 .434.139.832.832 0 0 0 .79-1.022l-.929-3.826 3.082-2.525a.827.827 0 0 0-.482-1.456z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="icn-star" viewBox="0 0 14 13.29">
      <g fill="none">
        <path d="M13.227 4.461l-3.95-.294-1.5-3.656a.842.842 0 0 0-1.549 0l-1.5 3.656-3.95.294a.828.828 0 0 0-.48 1.456L3.35 8.442l-.929 3.826a.808.808 0 0 0 .77 1.022.759.759 0 0 0 .434-.139l3.33-2.076 3.377 2.076a.8.8 0 0 0 .434.139.832.832 0 0 0 .79-1.022l-.929-3.826 3.082-2.525a.827.827 0 0 0-.482-1.456z" />
        <path
          d="M9.704 11.005l-.537-2.209-.223-.917.73-.597 1.77-1.45-2.278-.17-.924-.068-.352-.857L7 2.573l-.89 2.164-.352.857-.923.069-2.29.17L4.3 7.286l.723.598-.222.912-.53 2.183L6.16 9.802l.788-.49.791.485 1.965 1.208m1.06 2.285a.797.797 0 0 1-.434-.14l-3.376-2.075-3.33 2.076a.76.76 0 0 1-.434.14c-.48 0-.93-.465-.775-1.023l.93-3.826L.293 5.917c-.573-.48-.248-1.41.48-1.456l3.95-.294L6.226.51A.829.829 0 0 1 7 0c.31 0 .635.17.775.511l1.502 3.656 3.95.294c.728.031 1.053.976.48 1.456l-3.082 2.525.93 3.826a.832.832 0 0 1-.79 1.022z"
          fill="currentColor"
        />
      </g>
    </symbol>
    <symbol id="icn-money" viewBox="0 0 36 27.09" fill="currentColor">
      <path
        id="Path_174"
        data-name="Path 174"
        d="M38.07,20.178a.634.634,0,0,0-.422-.59l-1.855-.675,1.939-.885a.7.7,0,0,0,.379-.632.634.634,0,0,0-.422-.59l-10.5-3.752a1.857,1.857,0,0,0-1.349.042L11.93,19.5a14.23,14.23,0,0,1-8.938.422.717.717,0,0,0-.843.422.677.677,0,0,0,.422.843L9.19,23.551,2.908,26.46a.7.7,0,0,0-.379.632.634.634,0,0,0,.422.59l1.9.675-1.939.928a.667.667,0,0,0,.042,1.223l1.9.675-1.939.928a.7.7,0,0,0-.379.632.634.634,0,0,0,.422.59l1.9.675-1.939.928a.7.7,0,0,0-.379.632.634.634,0,0,0,.422.59l10.456,3.752a1.692,1.692,0,0,0,.632.126,1.827,1.827,0,0,0,.8-.169L37.69,29.285a.7.7,0,0,0,.379-.632.634.634,0,0,0-.422-.59l-1.9-.675,1.939-.928a.7.7,0,0,0,.379-.632.634.634,0,0,0-.422-.59l-1.9-.675,1.939-.928A.7.7,0,0,0,38.07,23a.634.634,0,0,0-.422-.59l-1.9-.675,1.939-.928A.629.629,0,0,0,38.07,20.178Zm-2.361.084L29.891,23V21.7l4.258-1.982Zm-9.36-5.987a.466.466,0,0,1,.337,0h0l8.98,3.2-6.619,3.078L19.9,17.269ZM18.3,18.07l10.329,3.668V32.109L26.1,33.416V23.171c0-.3-.422-.548-.675-.632l-9.444-3.373ZM8.052,21.738a13.713,13.713,0,0,0,4.427-1.012l1.6-.759,9.149,3.289-.379.169a14.119,14.119,0,0,1-8.9.422Zm2.909,2.445,2.572.928a14.348,14.348,0,0,0,4.216.59,15.73,15.73,0,0,0,5.9-1.054l1.18-.422v1.307L14.544,30.17a.625.625,0,0,1-.548,0l-8.98-3.2Zm2.445,7.252a1.692,1.692,0,0,0,.632.126,3.064,3.064,0,0,0,1.054-.169l9.739-4.385v1.349L14.544,32.995a.625.625,0,0,1-.548,0l-8.98-3.2,1.686-.8Zm0,2.825a1.692,1.692,0,0,0,.632.126,3.064,3.064,0,0,0,1.054-.169l9.739-4.385v1.349L14.544,35.819a.625.625,0,0,1-.548,0l-8.98-3.2,1.686-.8Zm1.138,4.385a.625.625,0,0,1-.548,0l-8.98-3.2,1.686-.8,6.746,2.445a1.692,1.692,0,0,0,.632.126,3.064,3.064,0,0,0,1.054-.169l9.7-4.385v1.349Zm21.165-9.908-5.818,2.74V30.128l4.216-1.982Zm0-2.825-5.818,2.74V27.3l4.216-1.982Zm0-2.825-5.818,2.74V24.478L34.107,22.5Z"
        transform="translate(-2.112 -12.945)"
      />
    </symbol>
    <symbol id="icn-arrow-repeat" viewBox="0 0 12 13.216">
      <path
        d="M11.194 4.216L9.7 5.073a4.185 4.185 0 0 1 .583 2.143 4.286 4.286 0 1 1-4.54-4.286v.977c0 .377.274.531.6.343l.926-.531 1.182-.686.926-.531a.363.363 0 0 0 0-.686l-.926-.531L7.269.599 6.343.084c-.326-.191-.6-.051-.6.309v.823a6 6 0 1 0 6.257 6 5.949 5.949 0 0 0-.806-3z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="icn-pile-money" viewBox="0 0 59.631 44.873">
      <g transform="translate(-19.412 -24.405)">
        <path
          className="a"
          d="M61.674,24.925a1.05,1.05,0,0,0-.7-.978L57.9,22.83l3.212-1.467a1.152,1.152,0,0,0,.629-1.048,1.05,1.05,0,0,0-.7-.978L43.656,13.123a3.077,3.077,0,0,0-2.235.07L18.375,23.808c-3.282,1.536-9.568,2.235-14.805.7a1.187,1.187,0,0,0-1.4.7,1.122,1.122,0,0,0,.7,1.4l10.964,3.911L3.431,35.331A1.152,1.152,0,0,0,2.8,36.379a1.05,1.05,0,0,0,.7.978l3.143,1.117L3.431,40.01a1.1,1.1,0,0,0,.07,2.025l3.143,1.117L3.431,44.689A1.152,1.152,0,0,0,2.8,45.737a1.05,1.05,0,0,0,.7.978l3.143,1.117L3.431,49.368A1.152,1.152,0,0,0,2.8,50.416a1.05,1.05,0,0,0,.7.978L20.82,57.609a2.8,2.8,0,0,0,1.048.21,3.026,3.026,0,0,0,1.327-.279L61.045,40.01a1.152,1.152,0,0,0,.629-1.048,1.05,1.05,0,0,0-.7-.978l-3.143-1.117,3.212-1.536a1.152,1.152,0,0,0,.629-1.048,1.05,1.05,0,0,0-.7-.978l-3.143-1.117,3.212-1.536a1.152,1.152,0,0,0,.629-1.048,1.05,1.05,0,0,0-.7-.978l-3.143-1.117,3.212-1.536A1.041,1.041,0,0,0,61.674,24.925Zm-3.911.14L48.125,29.6V27.44l7.053-3.282Zm-15.5-9.917a.771.771,0,0,1,.559,0h0l14.875,5.308-10.964,5.1L31.574,20.107ZM28.634,20.692l17.9,6.159V44.689L41.219,47.6l-.5-17.578c0-.489.023-.14-.4-.279L23.9,23.414ZM11.95,27.509a22.715,22.715,0,0,0,7.333-1.676l2.654-1.257,15.154,5.447-.629.279c-3.282,1.536-9.568,2.235-14.735.7Zm4.819,4.05,4.26,1.536a23.767,23.767,0,0,0,6.984.978,26.056,26.056,0,0,0,9.777-1.746l1.955-.7v2.165l-17.04,7.682a1.036,1.036,0,0,1-.908,0L6.922,36.169Zm4.05,12.012a2.8,2.8,0,0,0,1.048.21,5.075,5.075,0,0,0,1.746-.279l16.132-7.263v2.235l-17.04,7.682a1.036,1.036,0,0,1-.908,0L6.922,40.848l2.793-1.327Zm0,4.679a2.8,2.8,0,0,0,1.048.209,5.075,5.075,0,0,0,1.746-.279l16.132-7.263v2.235l-17.04,7.682a1.036,1.036,0,0,1-.908,0L6.922,45.527,9.716,44.2Zm1.886,7.263a1.036,1.036,0,0,1-.908,0L6.922,50.206l2.793-1.327,11.174,4.05a2.8,2.8,0,0,0,1.048.21,5.075,5.075,0,0,0,1.746-.279L39.745,45.6v2.235ZM57.763,39.1l-9.637,4.539V41.407l6.984-3.282Zm0-4.679-9.637,4.539V36.728l6.984-3.282Zm0-4.679-9.637,4.539V32.049l6.984-3.282Z"
          transform="translate(17.299 11.459)"
          fill="currentColor"
        />
        <path
          className="b"
          d="M-11327.332,4565.155l-7.265,3.349,18.877,6.739.126,18.241,6.656-3.078.136-18.778Z"
          transform="translate(11373.411 -4533.595)"
          fill="none"
          stroke="currentColor"
        />
      </g>
    </symbol>
    <symbol
      id="icn-pile-money2"
      viewBox="0 0 59.631 44.873"
      fill="currentColor"
    >
      <g
        id="Group_1999"
        data-name="Group 1999"
        transform="translate(82.588 -34.405)"
      >
        <path
          id="Path_1047"
          data-name="Path 1047"
          className="cls-1"
          d="M61.674,24.925a1.05,1.05,0,0,0-.7-.978L57.9,22.83l3.212-1.467a1.152,1.152,0,0,0,.629-1.048,1.05,1.05,0,0,0-.7-.978L43.656,13.123a3.077,3.077,0,0,0-2.235.07L18.375,23.808c-3.282,1.536-9.568,2.235-14.805.7a1.187,1.187,0,0,0-1.4.7,1.122,1.122,0,0,0,.7,1.4l10.964,3.911L3.431,35.331A1.152,1.152,0,0,0,2.8,36.379a1.05,1.05,0,0,0,.7.978l3.143,1.117L3.431,40.01a1.1,1.1,0,0,0,.07,2.025l3.143,1.117L3.431,44.689A1.152,1.152,0,0,0,2.8,45.737a1.05,1.05,0,0,0,.7.978l3.143,1.117L3.431,49.368A1.152,1.152,0,0,0,2.8,50.416a1.05,1.05,0,0,0,.7.978L20.82,57.609a2.8,2.8,0,0,0,1.048.21,3.026,3.026,0,0,0,1.327-.279L61.045,40.01a1.152,1.152,0,0,0,.629-1.048,1.05,1.05,0,0,0-.7-.978l-3.143-1.117,3.212-1.536a1.152,1.152,0,0,0,.629-1.048,1.05,1.05,0,0,0-.7-.978l-3.143-1.117,3.212-1.536a1.152,1.152,0,0,0,.629-1.048,1.05,1.05,0,0,0-.7-.978l-3.143-1.117,3.212-1.536A1.041,1.041,0,0,0,61.674,24.925Zm-3.911.14L48.125,29.6V27.44l7.053-3.282Zm-15.5-9.917a.771.771,0,0,1,.559,0h0l14.875,5.308-10.964,5.1L31.574,20.107ZM28.634,20.692l17.9,6.159V44.689L41.219,47.6l-.093-17.578c0-.489-.051-.438-.47-.578L23.9,23.414ZM11.95,27.509a22.715,22.715,0,0,0,7.333-1.676l2.654-1.257,15.154,5.447-.629.279c-3.282,1.536-9.568,2.235-14.735.7Zm4.819,4.05,4.26,1.536a23.767,23.767,0,0,0,6.984.978,26.056,26.056,0,0,0,9.777-1.746l1.955-.7v2.165l-17.04,7.682a1.036,1.036,0,0,1-.908,0L6.922,36.169Zm4.05,12.012a2.8,2.8,0,0,0,1.048.21,5.075,5.075,0,0,0,1.746-.279l16.132-7.263v2.235l-17.04,7.682a1.036,1.036,0,0,1-.908,0L6.922,40.848l2.793-1.327Zm0,4.679a2.8,2.8,0,0,0,1.048.209,5.075,5.075,0,0,0,1.746-.279l16.132-7.263v2.235l-17.04,7.682a1.036,1.036,0,0,1-.908,0L6.922,45.527,9.716,44.2Zm1.886,7.263a1.036,1.036,0,0,1-.908,0L6.922,50.206l2.793-1.327,11.174,4.05a2.8,2.8,0,0,0,1.048.21,5.075,5.075,0,0,0,1.746-.279L39.745,45.6v2.235ZM57.763,39.1l-9.637,4.539V41.407l6.984-3.282Zm0-4.679-9.637,4.539V36.728l6.984-3.282Zm0-4.679-9.637,4.539V32.049l6.984-3.282Z"
          transform="translate(-84.701 21.459)"
        />
        <g
          id="Group_1998"
          data-name="Group 1998"
          transform="translate(-102 10)"
        >
          <path
            id="Path_1043"
            data-name="Path 1043"
            className="cls-2"
            fill="#DB0011"
            d="M37.316,230.525l-18.472,5.393L2.076,227.186a1.324,1.324,0,0,0-1.722.479A1.183,1.183,0,0,0,.8,229.279l16.634,8.781a2.988,2.988,0,0,0,.939.389,6.17,6.17,0,0,0,1.234-.31l17.34-4.982C36.935,232.9,37.316,230.525,37.316,230.525Z"
            transform="translate(-11.937 -177.996) rotate(-8)"
          />
          <path
            id="Path_1046"
            data-name="Path 1046"
            className="cls-2"
            fill="#DB0011"
            d="M358.411,156.114l-10.534,6.558c-.622.424-.089.719.3,1.392a1.309,1.309,0,0,0,1.128.673c.242,0,0-.2.217-.353l11.2-7.09C361.35,156.87,359.033,155.69,358.411,156.114Z"
            transform="translate(-304.798 -157.059) rotate(7)"
          />
        </g>
        <g
          id="Path_1048"
          data-name="Path 1048"
          className="cls-3"
          transform="matrix(0.921, 0.391, -0.391, 0.921, -71.079, 49.898)"
        >
          <path
            className="cls-4"
            stroke="none"
            d="M 0.2659526765346527 1.379828214645386 L 0.4200383424758911 0.5000029802322388 L 4.66905689239502 0.5000029802322388 L 4.929891109466553 1.114489674568176 L 0.2659526765346527 1.379828214645386 Z"
          />
          <path
            className="cls-5"
            stroke="none"
            d="M -9.5367431640625e-07 2.980232238769531e-06 L 4.999999046325684 2.980232238769531e-06 L 5.667829513549805 1.573312997817993 L -0.335350513458252 1.914842963218689 L -9.5367431640625e-07 2.980232238769531e-06 Z"
          />
        </g>
      </g>
    </symbol>
    <symbol id="icn-money-bag" viewBox="0 0 48.074 53.984" fill="currentColor">
      <path
        className="a"
        d="M26.345 28.125a7.052 7.052 0 0 1 2.024.864 6.788 6.788 0 0 1 1.647 1.4 7.27 7.27 0 0 1 1.161 1.916 8.342 8.342 0 0 1 .54 2.429H28.64a4.578 4.578 0 0 0-.675-2.375 4.019 4.019 0 0 0-1.62-1.458v3.914h-1.646v-4.4a1.427 1.427 0 0 0-.351-.027h-.621a.748.748 0 0 0-.243.027v4.4h-1.647v-4.022a3.183 3.183 0 0 0-1.08.729 3.9 3.9 0 0 0-.756 1 4.89 4.89 0 0 0-.459 1.242 6.283 6.283 0 0 0-.162 1.431 6.786 6.786 0 0 0 .351 2.213 4.678 4.678 0 0 0 1.026 1.674 4.451 4.451 0 0 0 1.566 1.053 5.878 5.878 0 0 0 2.051.378h5.318v2.672H16.574v-2.672h2.564a6.153 6.153 0 0 1-1.053-1 6.77 6.77 0 0 1-.864-1.3 7.986 7.986 0 0 1-.594-1.512 6.719 6.719 0 0 1-.216-1.647 7.062 7.062 0 0 1 .378-2.375 6.437 6.437 0 0 1 1.107-2.024 7.33 7.33 0 0 1 1.728-1.566 7.68 7.68 0 0 1 2.267-.972v-1.935h1.647v1.674l.3-.027h.621l.3.027v-1.674h1.647v1.943z"
      />
      <path
        className="a"
        d="M34.038 0c2.834 1.458 2.834 1.458 1.269 4.346-1.512 2.807-3.023 5.587-4.373 8.1 3.023 3.131 6.127 5.938 8.746 9.15a34.978 34.978 0 0 1 8.395 22.08c.081 5.183-2.834 8.854-7.909 10.1-.162.054-.324.162-.486.216H8.368c-.324-.108-.675-.243-1-.324A10 10 0 0 1 .001 44c.027-9.366 3.752-17.275 9.8-24.185 2.186-2.483 4.724-4.67 7.234-7.153-.783-1.188-1.674-2.564-2.591-3.914-.972-1.458-1.889-2.942-2.915-4.373a1.555 1.555 0 0 1 .486-2.483A8.44 8.44 0 0 1 19.462.648a26.056 26.056 0 0 1 3.212 1 6.229 6.229 0 0 0 4.967-.054C28.963 1.053 30.286.54 31.609 0zM23.376 51.744v-.162c5.075 0 10.149.027 15.224 0a6.846 6.846 0 0 0 6.991-5.857 26.669 26.669 0 0 0-.4-7.747c-1.598-8.286-6.29-14.765-12.26-20.487-2.186-2.105-4.481-3.482-7.639-2.915a3.6 3.6 0 0 1-.54 0c-6.91 0-6.937 0-11.742 5.048C6.749 26.21 2.592 33.795 2.241 43.08c-.216 5.479 2.834 8.638 8.314 8.638 4.264.026 8.529.026 12.821.026zM13.713 3.482c1.889 2.861 3.7 5.641 5.587 8.341a1.8 1.8 0 0 0 1.269.486c2.294.054 4.589.081 6.856-.027a2.083 2.083 0 0 0 1.431-.837c1-1.647 1.862-3.374 2.78-5.075.7-1.3 1.377-2.564 2.078-3.86-.081-.135-.189-.3-.27-.432a38.09 38.09 0 0 0-3.995 1.215c-2.672 1.161-5.291 1.539-8.044.27a10.338 10.338 0 0 0-2.7-.783 6.111 6.111 0 0 0-4.992.702z"
      />
    </symbol>
    <symbol id="icn-search2" viewBox="0 0 15.908 15.908">
      <path
        d="M2.082 15.541l3.284-3.27a6.525 6.525 0 0 0 3.812 1.188 6.59 6.59 0 0 0 2.61-.528 6.733 6.733 0 0 0 4.12-6.201 6.59 6.59 0 0 0-.528-2.61A6.6 6.6 0 0 0 11.788.528a6.716 6.716 0 0 0-5.219 0 6.733 6.733 0 0 0-4.12 6.2 6.525 6.525 0 0 0 1.188 3.812l-3.27 3.27a1.232 1.232 0 0 0 .865 2.1 1.111 1.111 0 0 0 .85-.367zM6.158 9.75a4.131 4.131 0 0 1-1.261-3.02 4.131 4.131 0 0 1 1.261-3.021 4.131 4.131 0 0 1 3.02-1.261 4.131 4.131 0 0 1 3.02 1.261A4.131 4.131 0 0 1 13.46 6.73a4.131 4.131 0 0 1-1.261 3.02 4.131 4.131 0 0 1-3.02 1.261A4.131 4.131 0 0 1 6.158 9.75zm0 0"
        fill="currentColor"
      />
    </symbol>

    <symbol id="icn-clip" viewBox="0 0 12.502 12.502">
      <path
        d="M10.04 5.494L5.682 9.851A2.143 2.143 0 0 1 2.652 6.82L7.39 2.082a1.34 1.34 0 0 1 1.894 1.895l-3.98 3.98a.536.536 0 0 1-.758-.758l3.599-3.6-.566-.565-3.6 3.6a1.34 1.34 0 0 0 1.895 1.894L9.852 4.55a2.143 2.143 0 0 0-3.03-3.031L2.084 6.256a2.947 2.947 0 0 0 4.167 4.167l4.359-4.358z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="icn-list" viewBox="0 0 29.729 34.443" fill="currentColor">
      <path
        className="a"
        d="M7.251 8.266h15.227v2.175H7.251V8.266zM7.251 15.844h15.227v2.175H7.251v-2.175zM7.251 23.077h15.227v2.175H7.251v-2.175z"
      />
      <path
        className="a"
        d="M28.28 0H1.45A1.334 1.334 0 0 0 0 1.45v31.543a1.334 1.334 0 0 0 1.45 1.45h26.83a1.334 1.334 0 0 0 1.45-1.45V1.45A1.333 1.333 0 0 0 28.28 0zm-.725 31.543a.667.667 0 0 1-.725.725H2.9a.667.667 0 0 1-.725-.725V2.9a.667.667 0 0 1 .725-.725h23.929a.667.667 0 0 1 .725.725v28.643z"
      />
    </symbol>
    <symbol id="icn-arrows2" viewBox="0 0 24.546 24.919">
      <path
        d="M14.154 12.072l6.115 6.115a.492.492 0 0 1 0 .632l-5.914 5.885a.694.694 0 0 1-1 0l-1.263-1.263a.694.694 0 0 1 0-1l1.808-1.813a.3.3 0 0 0-.2-.517H.718A.711.711 0 0 1 0 19.393v-1.78a.711.711 0 0 1 .718-.718h12.976a.3.3 0 0 0 .2-.517l-1.807-1.808a.694.694 0 0 1 0-1l1.464-1.464a.4.4 0 0 1 .603-.034zm-3.732.775L4.335 6.732a.492.492 0 0 1 0-.632L10.22.215a.694.694 0 0 1 1 0l1.263 1.263a.694.694 0 0 1 0 1l-1.832 1.843a.3.3 0 0 0 .2.517h12.978a.711.711 0 0 1 .718.718v1.78a.711.711 0 0 1-.718.714H10.881a.3.3 0 0 0-.2.517l1.809 1.809a.694.694 0 0 1 0 1l-1.466 1.474a.416.416 0 0 1-.603 0z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="icn-trash" viewBox="0 0 10.534 12.177" fill="currentColor">
      <path
        d="M8.285,12.177H2.25a1.066,1.066,0,0,1-1.069-1.029L.9,3.731H9.64l-.286,7.416A1.066,1.066,0,0,1,8.285,12.177Zm1.4-9.536H.854L.818,1.72H.286a.277.277,0,0,1-.2-.085.284.284,0,0,1,0-.4.279.279,0,0,1,.2-.084H3.56V.57A.569.569,0,0,1,4.128,0H6.407a.57.57,0,0,1,.569.57v.578h3.273a.286.286,0,0,1,0,.573H9.716l-.034.92Z"
        transform="translate(0 0)"
      />
    </symbol>
    <symbol id="icn-arr-left" viewBox="0 0 4.268 7.588">
      <path
        data-name="Path 115"
        d="M4.112 6.716L1.241 3.808 4.112.886a.512.512 0 0 0 0-.731.5.5 0 0 0-.721 0L.152 3.435a.512.512 0 0 0 0 .731l3.252 3.267a.5.5 0 0 0 .721 0 .508.508 0 0 0-.013-.717z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="icn-list-circle" viewBox="0 0 80 80">
      <g stroke="currentColor" strokeWidth="4" fill="none">
        <circle cx="40" cy="40" r="40" stroke="none" />
        <circle cx="40" cy="40" r="38" />
      </g>
      <path
        className="b"
        fill="currentColor"
        d="M32.251 31.266h15.227v2.175H32.251v-2.175zM32.251 38.844h15.227v2.175H32.251v-2.175zM32.251 46.077h15.227v2.175H32.251v-2.175z"
      />
      <path
        className="b"
        fill="currentColor"
        d="M53.28 23H26.45A1.334 1.334 0 0 0 25 24.45v31.543a1.334 1.334 0 0 0 1.45 1.45h26.83a1.334 1.334 0 0 0 1.45-1.45V24.45A1.333 1.333 0 0 0 53.28 23zm-.725 31.543a.667.667 0 0 1-.725.725H27.9a.667.667 0 0 1-.725-.725V25.9a.667.667 0 0 1 .725-.725h23.929a.667.667 0 0 1 .725.725v28.643z"
      />
    </symbol>
    <symbol id="icn-clock" viewBox="0 0 16.834 16.834" fill="currentColor">
      <path
        className="a"
        d="M8.417 0a8.417 8.417 0 1 0 8.417 8.417A8.427 8.427 0 0 0 8.417 0zm0 15.043a6.626 6.626 0 1 1 6.626-6.626 6.634 6.634 0 0 1-6.626 6.626z"
      />
      <path
        className="a"
        d="M12.804 8.157H9.021V3.609a.693.693 0 1 0-1.386 0V8.85a.693.693 0 0 0 .693.693h4.476a.693.693 0 1 0 0-1.386z"
      />
    </symbol>
    <symbol id="icn-exchange-arrow" viewBox="0 0 36.572 36.572">
      <path
        d="M10.672 16.762l-6.1 6.095 6.1 6.1v-4.576h10.662v-3.047H10.672zm21.329-3.043l-6.1-6.1v4.572H15.239v3.048h10.667v4.572z"
        fill="currentColor"
      />
      <path d="M0 0h36.572v36.572H0z" fill="none" />
    </symbol>
    <symbol id="icn-exchange-arrow-new" viewBox="0 0 23.976 23.268">
      <g transform="translate(-927.762 -270.554)">
        <path
          className="a"
          fill="none"
          strokeLinecap="round"
          strokeWidth="2px"
          stroke="#db0011"
          d="M0,30.35l12.245-.28"
          transform="translate(937.434 246.232)"
        />
        <path
          className="b"
          d="M0,.28,12.245,0"
          transform="translate(942.066 288.073) rotate(180)"
          stroke="currentcolor"
          fill="none"
          strokeLinecap="round"
          strokeWidth="2px"
        />
        <path
          className="a"
          stroke="#db0011"
          fill="none"
          strokeLinecap="round"
          strokeWidth="2px"
          d="M10.312,24.031l4.776,4.848L10.312,33.5"
          transform="translate(935.23 247.523)"
        />
        <path
          className="b"
          stroke="currentcolor"
          fill="none"
          strokeLinecap="round"
          strokeWidth="2px"
          d="M0,0,4.776,4.848,0,9.474"
          transform="translate(933.958 292.822) rotate(180)"
        />
      </g>
    </symbol>
    <symbol id="icn-payments" viewBox="0 0 45.44 45.476">
      <path
        data-name="Path 115"
        d="M33.643,10.968a1.166,1.166,0,0,0-.692.328L11.388,31.11a1.166,1.166,0,0,0,.783,2.021h4.662V52.946a3.515,3.515,0,0,0,3.5,3.5H47.138a3.515,3.515,0,0,0,3.5-3.5V33.132H55.3a1.166,1.166,0,0,0,.783-2.021L38.323,14.792A1.166,1.166,0,1,0,36.757,16.5L52.31,30.8H49.469A1.166,1.166,0,0,0,48.3,31.966v20.98a1.138,1.138,0,0,1-1.166,1.166H34.9V48.174a6.422,6.422,0,0,0,5.245-6.3V38.959a1.166,1.166,0,0,0-1.165-1.166H37.814V34.3a1.166,1.166,0,1,0-2.331,0v3.5h-3.5V34.3a1.166,1.166,0,1,0-2.331,0v3.5H28.489q-.055,0-.109,0a1.166,1.166,0,0,0-1.056,1.166v2.914a6.422,6.422,0,0,0,5.245,6.3v5.937H20.33a1.138,1.138,0,0,1-1.166-1.166V31.966A1.166,1.166,0,0,0,18,30.8H15.158L34.517,13.008a1.166,1.166,0,0,0-.765-2.04Q33.7,10.965,33.643,10.968ZM29.655,40.125h8.159v1.748a4.079,4.079,0,1,1-8.159,0Z"
        fill="currentColor"
      />
    </symbol>
    <symbol id="icn-communicate" viewBox="0 0 53.01 39.845">
      <g fill="none">
        <path
          className="a"
          d="M31.851,60.319a1.158,1.158,0,1,0,1.638,1.638,12.537,12.537,0,0,1,17.67,0,1.131,1.131,0,0,0,1.638,0,1.131,1.131,0,0,0,0-1.638A14.8,14.8,0,0,0,31.851,60.319Z"
          fill="CurrentColor"
          transform="translate(-15.819 -34.283)"
        />
        <path
          className="a"
          d="M18.627,44.979a1.738,1.738,0,0,0,2.457,2.457,22.177,22.177,0,0,1,31.361,0,1.7,1.7,0,0,0,2.457,0,1.7,1.7,0,0,0,0-2.457A25.673,25.673,0,0,0,18.627,44.979Z"
          fill="CurrentColor"
          transform="translate(-10.26 -26.607)"
        />
        <path
          className="a"
          d="M5.4,29.607a2.358,2.358,0,1,0,3.335,3.335,31.853,31.853,0,0,1,44.994,0,2.338,2.338,0,0,0,3.277-3.335A36.444,36.444,0,0,0,5.4,29.607Z"
          fill="CurrentColor"
          transform="translate(-4.7 -18.9)"
        />
        <path
          className="a"
          d="M45.932,69.8a5.032,5.032,0,1,0,5.032,5.032A5.031,5.031,0,0,0,45.932,69.8Zm0,8.893a3.862,3.862,0,1,1,3.862-3.862A3.858,3.858,0,0,1,45.932,78.693Z"
          fill="CurrentColor"
          transform="translate(-19.72 -40.019)"
        />
      </g>
    </symbol>
    <symbol id="icn-gambling" viewBox="0 0 48.485 48.485">
      <path
        d="M542.186,542.31a12.256,12.256,0,0,1-10.015-10.015,9.951,9.951,0,1,0,10.015,10.015Zm10.109-.52,4.264,5.8,4.2-5.8-4.2-5.742Zm-20.475,1.659a3.537,3.537,0,0,1-2.307,3.63c-1.034.371-1.329.169-1.367.552v.105h7.769c-.023-.415-.175-.318-.6-.415a6.623,6.623,0,0,1-.762-.216,3.564,3.564,0,0,1-2.375-3.7c.225.143,1.387,2.033,3.16,1.192a2.209,2.209,0,0,0,.739-3.19c-.9-1.484-2.86-2.363-3.733-4.4a6.848,6.848,0,0,0-.321-.847c-.383.394.035.961-1.8,2.854a16.17,16.17,0,0,0-2.275,2.372c-1.247,2.039.672,4.145,2.591,3.166a3.986,3.986,0,0,0,1.154-1.011c.117-.1-.05.009.131-.091Zm12.095-6.919a7.12,7.12,0,0,0,.4-1,8.93,8.93,0,0,1,.47-.946c1.1-1.9,2.664-3.441,3.525-5.085,2.167-4.136-3.4-5.763-4.326-2-.2-.07-.041.123-.283-.423-1.443-3.271-6.163-1.422-4.218,2.348.742,1.44,3.1,3.885,4.039,6.055.088.2.324.961.4,1.057Zm-1.7,16.117c-3.16-.847-4.5,1.691-3.192,3.677a2.728,2.728,0,0,0,4.171.313c.721-.663.654-.905.943-1.18a3.653,3.653,0,0,1-2.3,3.841,11.556,11.556,0,0,1-1.221.327c-.272.079-.207.152-.242.45l7.851.006c-.085-.561-.289-.359-1.484-.783a3.034,3.034,0,0,1-1.256-.824,4.2,4.2,0,0,1-1.052-3.1,3.8,3.8,0,0,0,2.141,1.945c3.926,1.349,4.752-5.847-.19-4.682a2.7,2.7,0,0,0,.161-2.734,2.629,2.629,0,0,0-4.5,0C541.313,551.148,542,552.03,542.213,552.646Zm1.966-12.457a12.256,12.256,0,0,1,10.015-10.015,9.951,9.951,0,1,0-10.015,10.015ZM556.481,530a12.24,12.24,0,0,1,0,24.476,12.24,12.24,0,0,1-24.476,0A12.24,12.24,0,0,1,532,530a12.24,12.24,0,0,1,24.476,0Zm-.169,22.189A9.951,9.951,0,1,0,546.3,542.178a12.256,12.256,0,0,1,10.015,10.015Zm-22.02,2.118A9.951,9.951,0,1,0,544.307,544.3a12.256,12.256,0,0,1-10.015,10.015Z"
        fill="CurrentColor"
        transform="translate(-520 -518)"
      />
    </symbol>
    <symbol id="icn-parcels" viewBox="0 0 51.096 43.832">
      <path
        d="M17.488,1022.926h0a.8.8,0,0,0-.259.066L.482,1030.265a.8.8,0,0,0-.153,1.378l7.185,5.224L.329,1042.09a.8.8,0,0,0,.153,1.378l7.5,3.259v11.7a1.633,1.633,0,0,0,.5,1.1l16.738,7.145a.735.735,0,0,0,.1.03h.022l.031.016.062.016h.022a.812.812,0,0,0,.156,0l.069-.016h.031l.059-.016q.038-.011.075-.025l.031-.016,16.741-7.145a1.647,1.647,0,0,0,.5-1.1v-11.77l7.5-3.259a.8.8,0,0,0,.153-1.375l-7.463-5.427-.006-.016-.006-.016,6.736-4.9a.8.8,0,0,0-.153-1.378l-16.744-7.273a.788.788,0,0,0-.789.085l-7.145,5.2-7.185-5.224a.8.8,0,0,0-.527-.153Zm-.041,1.715,6.521,4.743-15.135,6.472L2.4,1031.178l15.048-6.537Zm15.469.026,15.048,6.537-6.141,4.463L26.688,1029.2l6.228-4.528Zm-7.366,5.779,14.976,6.406-14.976,6.406-4.821-2.061-6.191-2.645-3.973-1.7,14.985-6.406Zm16.741,7.391L48.7,1042.5l-15.048,6.537-6.5-4.725Zm-33.423.026,5.043,2.155,6.191,2.648,3.9,1.668-6.552,4.765L2.4,1042.563l6.468-4.7Zm17.48,7.834,6.736,4.9a.8.8,0,0,0,.786.088l7.647-3.321v10.909l-15.169,6.474V1045.7Zm-1.6.062v18.983l-15.169-6.474v-10.844l7.647,3.321a.8.8,0,0,0,.786-.088l6.736-4.9Zm7.943,8.844h-.009a.8.8,0,0,0-.284.068l-4.248,1.815a.8.8,0,0,0,.63,1.469l4.245-1.815a.8.8,0,0,0-.334-1.541Zm4.245,1.089H36.93a.8.8,0,0,0-.284.068l-4.244,1.815-4.248,1.815a.8.8,0,1,0,.63,1.466l4.245-1.812,4.245-1.815a.8.8,0,0,0-.334-1.541Z"
        fill="CurrentColor"
        transform="translate(0 -1022.909)"
      />
    </symbol>
    <symbol id="icn-insurance" viewBox="0 0 47.665 56">
      <path
        d="M61.45,36.426a22.851,22.851,0,0,0-22.118-22.67V10.264a.709.709,0,0,0-1.418,0v3.492A22.851,22.851,0,0,0,15.8,36.566a.709.709,0,1,0,1.418,0,2.971,2.971,0,1,1,5.942,0,.709.709,0,1,0,1.418,0,2.971,2.971,0,1,1,5.942,0,.709.709,0,1,0,1.418,0,2.971,2.971,0,1,1,5.942,0,.682.682,0,0,0,.036.178V58.822a3.313,3.313,0,1,1-6.627,0,.709.709,0,0,0-1.418,0,4.732,4.732,0,1,0,9.464,0V36.211a2.963,2.963,0,0,1,5.906.314v.041a.673.673,0,0,0,.008.1.665.665,0,0,0,.2.389.71.71,0,0,0,1.22-.494.723.723,0,0,0-.011-.127,2.971,2.971,0,0,1,5.94.127.709.709,0,0,0,1.418,0,2.971,2.971,0,1,1,5.943,0,.709.709,0,0,0,.709.709h.084a.709.709,0,0,0,.709-.709A.535.535,0,0,0,61.45,36.426Zm-4.461-4.251a4.388,4.388,0,0,0-3.681,2,4.383,4.383,0,0,0-7.361.006,4.383,4.383,0,0,0-7.361-.006,4.387,4.387,0,0,0-7.361,0,4.387,4.387,0,0,0-7.361,0A4.384,4.384,0,0,0,17.492,33.1a21.412,21.412,0,0,1,42.269.065A4.367,4.367,0,0,0,56.989,32.175Z"
        fill="CurrentColor"
      />
    </symbol>
    <symbol id="icn-education" viewBox="0 0 52.013 36.392">
      <path
        d="M52.465,15.628l-23.4-10.4a2.6,2.6,0,0,0-2.106,0l-23.4,10.4a2.6,2.6,0,0,0,0,4.758l5.2,2.262-1.56.546V40.1a1.3,1.3,0,0,0,2.6,0V24.807L28,17.994l-3.172-1.4L12.135,21.349,4.595,17.994,28,7.593l23.4,10.4L28,28.4,18.48,24.183,15,25.483l11.935,5.2a2.6,2.6,0,0,0,2.106,0l11.935-5.2V33.6a20.256,20.256,0,0,1-13,5.2,20.256,20.256,0,0,1-13-5.2V25.483l-2.6.962v8.243l.78.754A22.83,22.83,0,0,0,28,41.4,22.83,22.83,0,0,0,42.818,35.52l.78-.754v-10.4l8.867-3.926a2.6,2.6,0,0,0,0-4.758Z"
        fill="CurrentColor"
        transform="translate(-2.004 -5.004)"
      />
    </symbol>
    <symbol id="icn-microfinance" viewBox="0 0 34.657 49.7" fill="currentColor">
      <g id="Group_637" data-name="Group 637">
        <path
          id="Rectangle_291"
          data-name="Rectangle 291"
          className="cls-1"
          transform="translate(0 26.616)"
          d="M0 0h4.098v23.084H0z"
        />
        <path
          id="Path_198"
          data-name="Path 198"
          className="cls-2"
          fillRule="evenodd"
          d="M37 159h4.153v19.632H37z"
          transform="translate(-30.016 -128.986)"
        />
        <path
          id="Path_199"
          data-name="Path 199"
          className="cls-2"
          d="M75 177h3.964v16.234H75z"
          transform="translate(-60.842 -143.588)"
        />
        <path
          id="Path_200"
          data-name="Path 200"
          className="cls-2"
          d="M112 195h3.964v12.836H112z"
          transform="translate(-90.858 -158.19)"
        />
        <path
          id="Rectangle_292"
          data-name="Rectangle 292"
          className="cls-1"
          transform="translate(28.126 40.396)"
          d="M0 0h4.098v9.289H0z"
        />
        <path
          id="Path_201"
          data-name="Path 201"
          className="cls-2"
          d="M0 67l9.061 4.342-2.832 1.887a64.959 64.959 0 0 0 27.183 14.347c2.265.566 1.133 3.775-.944 3.209-11.515-3.02-21.331-8.117-29.259-15.668L.189 77z"
          transform="translate(0 -54.353)"
        />
        <path
          id="Path_202"
          data-name="Path 202"
          className="cls-1"
          d="M64.382 0a10.421 10.421 0 0 0-7.362 3.02 10.482 10.482 0 0 0 0 14.724 10.482 10.482 0 0 0 14.724 0 10.482 10.482 0 0 0 0-14.724A10.421 10.421 0 0 0 64.382 0zm-6.04 4.342a9.091 9.091 0 0 1 6.041-2.454 8.4 8.4 0 0 1 6.041 2.454 8.4 8.4 0 0 1 2.454 6.041 8.732 8.732 0 0 1-2.454 6.041 8.4 8.4 0 0 1-6.041 2.454 9.091 9.091 0 0 1-6.041-2.454 8.732 8.732 0 0 1-2.454-6.041 8.4 8.4 0 0 1 2.454-6.041z"
          transform="translate(-43.807)"
        />
        <text
          id="_"
          data-name="₾"
          transform="translate(17.234 14.02)"
          fontSize="11"
          fontWeight="700"
          fill="currentColor"
        >
          <tspan x="0" y="0">
            ₾
          </tspan>
        </text>
      </g>
    </symbol>
    <symbol id="icn-charity" viewBox="0 0 48.485 48.485">
      <path
        d="M18.51,964.374a12.424,12.424,0,0,0-8.832,3.684,12.585,12.585,0,0,0,0,17.732L28.537,1004.8a1.615,1.615,0,0,0,2.288,0q9.444-9.491,18.893-18.977a12.6,12.6,0,0,0,0-17.749,12.474,12.474,0,0,0-17.682,0l-2.322,2.355-2.355-2.372a12.463,12.463,0,0,0-8.849-3.684Zm0,3.2a9.243,9.243,0,0,1,6.561,2.759l3.5,3.516a1.615,1.615,0,0,0,2.288,0l3.466-3.5a9.176,9.176,0,0,1,13.106,0,9.31,9.31,0,0,1,0,13.19q-8.873,8.918-17.749,17.85L11.966,983.519a9.312,9.312,0,0,1,0-13.19,9.2,9.2,0,0,1,6.544-2.759Z"
        fill="CurrentColor"
        transform="translate(-6.024 -964.374)"
      />
    </symbol>
    <symbol id="icn-different" viewBox="0 0 49.252 12.737">
      <g
        id="noun_1485285_cc"
        transform="translate(-5.3 -17.3)"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      >
        <circle
          id="Ellipse_10"
          data-name="Ellipse 10"
          className="cls-1"
          cx="4.869"
          cy="4.869"
          r="4.869"
          transform="translate(25.057 18.8)"
        />
        <circle
          id="Ellipse_11"
          data-name="Ellipse 11"
          className="cls-1"
          cx="4.869"
          cy="4.869"
          r="4.869"
          transform="translate(43.315 18.8)"
        />
        <circle
          id="Ellipse_12"
          data-name="Ellipse 12"
          className="cls-1"
          cx="4.869"
          cy="4.869"
          r="4.869"
          transform="translate(6.8 18.8)"
        />
      </g>
    </symbol>
    <symbol id="icn-basket" viewBox="0 0 199.881 158.798" fill="currentColor">
      <g className="a" transform="translate(-6.7 -15.6)">
        <path
          d="M110.384,87.142a20.542,20.542,0,1,0-20.542,20.542A20.542,20.542,0,0,0,110.384,87.142Zm-31.852,0a11.31,11.31,0,1,1,11.31,11.31A11.31,11.31,0,0,1,78.532,87.142Z"
          transform="translate(81.887 66.713)"
        />
        <path
          d="M58.384,46.528,51,15.6H20.3v9.232H43.843l23.543,98.556H169.865l18.926-76.86Zm104.326,67.627H74.771L60.692,55.761H177.02Z"
          transform="translate(17.79 0)"
        />
        <path
          d="M79.484,87.142a20.542,20.542,0,1,0-20.542,20.542A20.542,20.542,0,0,0,79.484,87.142Zm-31.852,0a11.31,11.31,0,1,1,11.31,11.31,11.31,11.31,0,0,1-11.31-11.31Z"
          transform="translate(41.467 66.713)"
        />
        <rect
          width="28.62"
          height="9.232"
          transform="translate(25.165 55.068)"
        />
        <rect width="54.009" height="9.232" transform="translate(6.7 85.074)" />
        <rect
          width="40.161"
          height="9.232"
          transform="translate(29.781 115.079)"
        />
      </g>
    </symbol>
    <symbol id="icn-warning2" viewBox="0 0 23 23" fill="currentColor">
      <path
        className="a"
        d="M21,23.71a1.739,1.739,0,1,0,1.227.507A1.75,1.75,0,0,0,21,23.71Zm-.827-1.728a.785.785,0,0,0,.827.826.824.824,0,0,0,.827-.826l.852-5.489A1.5,1.5,0,0,0,21,14.814a1.5,1.5,0,0,0-1.679,1.679ZM30.1,9.5H11.895A2.4,2.4,0,0,0,9.5,11.895v18.21A2.4,2.4,0,0,0,11.895,32.5h18.21A2.4,2.4,0,0,0,32.5,30.105V11.895A2.4,2.4,0,0,0,30.1,9.5Zm.407,20.6a.408.408,0,0,1-.407.407H11.895a.408.408,0,0,1-.407-.407V11.895a.408.408,0,0,1,.407-.407h18.21a.408.408,0,0,1,.407.407V30.1Z"
        transform="translate(-9.5 -9.5)"
      />
    </symbol>
    <symbol id="icn-warning-new2" viewBox="0 0 26.864 23.74">
      <g transform="translate(-979.437 -705.685)">
        <path
          className="a"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          d="M-1514.942,6623.788l-12.854,22.24h25.365Z"
          transform="translate(2507.983 -5917.353)"
        />
        <path
          className="b"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="1.5"
          d="M-1515.975,6632.6l.086,4.72"
          transform="translate(2508.906 -5916.816)"
        />
        <path
          className="b"
          strokeWidth="1.5"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          d="M-1515.881,6639.853v.657"
          transform="translate(2508.897 -5916.388)"
        />
      </g>
    </symbol>

    <symbol id="icn-warnings-red" viewBox="0 0 22.779 20.158">
      <g transform="translate(-979.437 -705.686)">
        <path
          d="M-1517.012,6623.787l-10.784,18.658h21.279Z"
          transform="translate(2507.982 -5917.352)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M-1515.975,6632.6l.072,3.959"
          transform="translate(2506.854 -5918.321)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1.5"
        />
        <path
          d="M-1515.881,6639.853v.551"
          transform="translate(2506.831 -5919.13)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1.5"
        />
      </g>
    </symbol>

    <symbol
      id="icn-warning-simple"
      viewBox="0 0 1.5 7.234"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.5px"
    >
      <g transform="translate(-322.75 -123.906)">
        <path
          d="M1705.566,128.849V131.9"
          transform="translate(-1382.066 -4.192)"
        />
        <path d="M1705.566,142.5h0" transform="translate(-1382.066 -12.107)" />
      </g>
    </symbol>
    <symbol id="icn-exit" viewBox="0 0 512 512" fill="currentColor">
      <path d="M505.664 243.739l-54.783-38.622c-9.926-6.997-23.645.128-23.645 12.26v23.622h-263.04c-8.284 0-15.001 6.716-15.001 15.001s6.717 15 15.001 15h263.038v23.621c0 12.212 13.792 19.204 23.644 12.26l54.783-38.622c8.366-5.894 8.535-18.492.003-24.52z" />
      <path d="M430.471 352.317c-7.169-4.146-16.347-1.698-20.496 5.474-35.236 60.916-101.103 101.811-176.372 101.811-112.266 0-203.602-91.336-203.602-203.602S121.337 52.398 233.603 52.398c75.319 0 141.156 40.933 176.371 101.809 4.148 7.172 13.328 9.619 20.496 5.474 7.171-4.148 9.621-13.325 5.474-20.496C395.418 69.127 319.729 22.397 233.603 22.397 104.49 22.397 0 126.876 0 256c0 129.113 104.479 233.603 233.603 233.603 86.163 0 161.833-46.763 202.342-116.79 4.147-7.171 1.697-16.347-5.474-20.496z" />
    </symbol>
    <symbol id="cash-error" viewBox="0 0 53.843 53.844" fill="currentColor">
      <path
        d="M30.564,48.964H51.288L40.926,31.017Zm11.483-2.487a1.122,1.122,0,1,1-2.244,0v-.4a1.122,1.122,0,1,1,2.244,0Zm0-8.893v4.334a1.122,1.122,0,1,1-2.244,0V37.585a1.122,1.122,0,1,1,2.244,0ZM66.5,27.226A14.928,14.928,0,0,0,54.585,15.32a72.109,72.109,0,0,0-27.423,0A14.793,14.793,0,0,0,15.306,27.166a72.735,72.735,0,0,0,0,27.4A14.786,14.786,0,0,0,27.162,66.473a66.881,66.881,0,0,0,13.771,1.375,70.567,70.567,0,0,0,13.711-1.316A14.857,14.857,0,0,0,66.5,54.627,70.33,70.33,0,0,0,66.5,27.226ZM53.246,51.208H28.62a1.122,1.122,0,0,1-.972-1.683L39.954,28.213a1.122,1.122,0,0,1,1.943,0L54.122,49.384a1.122,1.122,0,0,1-.876,1.823Z"
        transform="translate(-14.004 -14.003)"
      />
    </symbol>
    <symbol id="filter-arrow-down" viewBox="0 0 8.18 4.09" fill="currentColor">
      <path
        d="M14,23.09,18.09,19l4.09,4.09Z"
        transform="translate(22.18 23.09) rotate(180)"
      />
    </symbol>
    <symbol id="filter-arrow-up" viewBox="0 0 8.18 4.09" fill="currentColor">
      <path d="M14,23.09,18.09,19l4.09,4.09Z" transform="translate(-14 -19)" />
    </symbol>
    <symbol id="quick_add" viewBox="0 0 23.338 23.338" fill="currentColor">
      <g transform="translate(0 0)">
        <path
          className="a"
          d="M10.211,0a.729.729,0,0,0-.729.729V3.316a8.693,8.693,0,0,0-2.168.9L5.481,2.387a.729.729,0,0,0-1.031,0L2.387,4.45a.729.729,0,0,0,0,1.031L4.214,7.307a8.691,8.691,0,0,0-.9,2.174H.729A.729.729,0,0,0,0,10.211v2.917a.729.729,0,0,0,.729.729H3.313a8.7,8.7,0,0,0,.9,2.171L2.387,17.857a.729.729,0,0,0,0,1.031L4.45,20.951a.729.729,0,0,0,1.031,0L7.3,19.128a8.7,8.7,0,0,0,2.177.9v2.584a.729.729,0,0,0,.729.729h2.917a.729.729,0,0,0,.729-.729V20.025c.213-.057.744-.259.744-.259L14.6,18.344a13.561,13.561,0,0,1-1.6.5.729.729,0,0,0-.6.715V21.88H10.94V19.552a.729.729,0,0,0-.6-.715,7.293,7.293,0,0,1-2.806-1.16.729.729,0,0,0-.929.085L4.966,19.4,3.934,18.373l1.647-1.647a.729.729,0,0,0,.085-.929,7.3,7.3,0,0,1-1.165-2.8.729.729,0,0,0-.718-.6H1.459V10.94H3.786a.729.729,0,0,0,.718-.6A7.3,7.3,0,0,1,5.661,7.535a.729.729,0,0,0-.085-.929L3.934,4.966,4.966,3.934,6.612,5.581a.73.73,0,0,0,.929.085,7.3,7.3,0,0,1,2.8-1.165.729.729,0,0,0,.6-.718V1.459H12.4V3.786A.729.729,0,0,0,13,4.5,7.291,7.291,0,0,1,15.8,5.664a.73.73,0,0,0,.929-.085l1.641-1.641L19.4,4.969,17.757,6.615a.73.73,0,0,0-.085.932,7.286,7.286,0,0,1,1.165,2.8.729.729,0,0,0,.718.6H21.88V12.4H19.552a.729.729,0,0,0-.718.6c-.043.236-.239.829-.239.829l1.313.4s.084-.24.117-.365h2.584a.729.729,0,0,0,.729-.729V10.213a.729.729,0,0,0-.729-.729H20.025a8.694,8.694,0,0,0-.9-2.171l1.829-1.829a.729.729,0,0,0,0-1.031L18.888,2.39a.729.729,0,0,0-1.031,0L16.031,4.216a8.7,8.7,0,0,0-2.174-.9V.732A.729.729,0,0,0,13.128,0Zm1.459,5.835A5.835,5.835,0,1,0,17.5,11.669,5.846,5.846,0,0,0,11.669,5.835Zm0,1.459a4.376,4.376,0,1,1-4.376,4.376A4.365,4.365,0,0,1,11.669,7.293Zm6.564,8.023V17.5H16.045v1.459h2.188V21.15h1.459V18.962H21.88V17.5H19.692V15.316Z"
        />
      </g>
    </symbol>
    <symbol id="icn-circle-close" viewBox="0 0 20 20">
      <g transform="translate(-30.431 -15.995)">
        <g
          className="a"
          transform="translate(30.431 15.995)"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <circle className="c" cx="10" cy="10" r="10" stroke="none" />
          <circle className="d" cx="10" cy="10" r="9.25" fill="none" />
        </g>
        <path
          className="b"
          fill="currentColor"
          d="M24.367,23.489c-.639-.649-1.279-1.288-1.918-1.928l1.928-1.928a.628.628,0,0,0-.887-.887l-1.928,1.928c-.639-.639-1.279-1.279-1.928-1.918a.628.628,0,0,0-.887.887c.649.639,1.288,1.279,1.928,1.918-.639.639-1.279,1.279-1.918,1.928a.628.628,0,0,0,.887.887c.639-.649,1.279-1.288,1.918-1.928l1.928,1.928C24.052,24.94,24.94,24.052,24.367,23.489Z"
          transform="translate(18.87 4.433)"
        />
      </g>
    </symbol>
    <symbol id="icn-circle-clock" viewBox="0 0 20 20">
      <g transform="translate(-30.431 -15.995)">
        <g
          className="a"
          transform="translate(30.431 15.995)"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <circle className="c" cx="10" cy="10" r="10" stroke="none" />
          <circle className="d" cx="10" cy="10" r="9.25" fill="none" />
        </g>
        <path
          className="b"
          fill="currentColor"
          d="M49.235,22.071H45.452V17.523a.693.693,0,1,0-1.386,0v5.241a.693.693,0,0,0,.693.693h4.476a.693.693,0,1,0,0-1.386Z"
          transform="translate(-5 4.081)"
        />
      </g>
    </symbol>
    <symbol id="icn-timeout" viewBox="0 0 25.5 21.857" fill="currentColor">
      <path
        className="a"
        d="M16.571,6A10.922,10.922,0,0,0,5.643,16.929H2l4.736,4.736.061.182,4.918-4.918H8.071a8.5,8.5,0,1,1,2.489,6.011l-1.7,1.7a10.673,10.673,0,0,0,7.711,3.218A10.929,10.929,0,0,0,16.571,6Zm-1.214,6.071v6.071l5.221,3.1.85-1.457-4.25-2.489V12.071Z"
        transform="translate(-2 -6)"
      />
    </symbol>
    <symbol id="icn-fine" viewBox="0 0 62.472 71.026" fill="currentColor">
      <g
        id="noun_Traffic_fine_1411618"
        data-name="noun_Traffic fine_1411618"
        transform="translate(-32.024 -14.49)"
      >
        <path
          id="Path_1"
          data-name="Path 1"
          d="M94.49,79.87V18.23a3.75,3.75,0,0,0-3.75-3.74H35.92a3.75,3.75,0,0,0-3.75,3.74,20.54,20.54,0,0,0,0,4.611c.031,1.9-.043,3.993,0,6.561.1,6.187,0,13.159,0,19.006,0,17.989,0,31.431,0,31.462a1.5,1.5,0,0,0,.64,1.39l5.93,4a1.51,1.51,0,0,0,1.68,0l5.09-3.44,5.09,3.44a1.52,1.52,0,0,0,.84.25,1.5,1.5,0,0,0,.84-.25l5.09-3.44,5.09,3.44a1.51,1.51,0,0,0,1.68,0l5.1-3.44,5.09,3.44a1.49,1.49,0,0,0,1.67,0l5.1-3.44,5.1,3.44a1.51,1.51,0,0,0,1.68,0l5.94-4a1.51,1.51,0,0,0,.67-1.39Zm-7.47,2.34L82,78.77a1.51,1.51,0,0,0-1.68,0l-5.09,3.44L70.1,78.77a1.51,1.51,0,0,0-1.68,0l-5.1,3.44-5.09-3.44a1.51,1.51,0,0,0-1.68,0l-5.09,3.44-5.09-3.44a1.51,1.51,0,0,0-1.68,0L39.6,82.2l-4.43-3v-61a.76.76,0,0,1,.75-.74H90.75a.75.75,0,0,1,.75.74v61Z"
        />
        <path
          id="Path_2"
          data-name="Path 2"
          d="M41.38,27.91H85.31a1.5,1.5,0,0,0,0-3H41.38a1.5,1.5,0,0,0,0,3Z"
        />
        <path
          id="Path_3"
          data-name="Path 3"
          d="M64.9,57.68H41.38a1.5,1.5,0,0,0,0,3H64.9a1.5,1.5,0,1,0,0-3Z"
        />
        <path
          id="Path_4"
          data-name="Path 4"
          d="M64.9,68.6H41.38a1.5,1.5,0,0,0,0,3H64.9a1.5,1.5,0,1,0,0-3Z"
        />
        <path
          id="Path_5"
          data-name="Path 5"
          d="M85.39,35.83H67.28a1.5,1.5,0,0,0,0,3H85.39a1.5,1.5,0,0,0,0-3Z"
        />
        <path
          id="Path_6"
          data-name="Path 6"
          d="M40.57,38.83H58.68a1.5,1.5,0,1,0,0-3H40.57a1.5,1.5,0,0,0,0,3Z"
        />
        <path
          id="Path_7"
          data-name="Path 7"
          d="M85.31,46.75H40.57a1.5,1.5,0,0,0,0,3H85.31a1.5,1.5,0,0,0,0-3Z"
        />
        <text
          id="_"
          data-name="₾"
          className="cls-1"
          transform="translate(71 72.49)"
        >
          <tspan x="0" y="0">
            ₾
          </tspan>
        </text>
      </g>
    </symbol>

    <symbol id="icn-warning-new" viewBox="0 0 32 32" fill="currentColor">
      <g transform="translate(-1689 -121)">
        <g className="a" transform="translate(1689 121)" fill="none">
          <path
            className="d"
            d="M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z"
            stroke="none"
          />
          <path
            className="e"
            stroke="none"
            fill="currentColor"
            d="M 16 1.5 C 12.12690925598145 1.5 8.485639572143555 3.008260726928711 5.746950149536133 5.746950149536133 C 3.008260726928711 8.485639572143555 1.5 12.12690925598145 1.5 16 C 1.5 19.87308883666992 3.008260726928711 23.51436042785645 5.746950149536133 26.25304985046387 C 8.485639572143555 28.99173927307129 12.12690925598145 30.5 16 30.5 C 19.87308883666992 30.5 23.51436042785645 28.99173927307129 26.25304985046387 26.25304985046387 C 28.99173927307129 23.51436042785645 30.5 19.87308883666992 30.5 16 C 30.5 12.12690925598145 28.99173927307129 8.485639572143555 26.25304985046387 5.746950149536133 C 23.51436042785645 3.008260726928711 19.87308883666992 1.5 16 1.5 M 16 0 C 24.8365592956543 0 32 7.163440704345703 32 16 C 32 24.8365592956543 24.8365592956543 32 16 32 C 7.163440704345703 32 0 24.8365592956543 0 16 C 0 7.163440704345703 7.163440704345703 0 16 0 Z"
          />
        </g>
        <path
          className="b"
          d="M1705.566,128.849v8.92"
          transform="translate(-0.066 0.651)"
          stroke="currentColor"
          fill="none"
        />
        <path
          className="c"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          d="M1705.566,142.5v.726"
          transform="translate(-0.066 0.002)"
        />
      </g>
    </symbol>

    <symbol id="triangle" viewBox="0 0 9.523 4.987" fill="currentColor">
      <path d="M.001.001l4.762 4.987L9.525.001z" />
    </symbol>
    <symbol id="icn-question" viewBox="0 0 17 17" fill="none">
      <g transform="translate(-1504 -9)">
        <g transform="translate(1509.403 12.662)">
          <path
            className="a"
            fill="currentColor"
            d="M30.21,6.731a2.859,2.859,0,0,0-5.493,1.113.064.064,0,0,0,.064.064h1.24a.064.064,0,0,0,.064-.064,1.49,1.49,0,1,1,2.4,1.182,1.527,1.527,0,0,1-.157.105l-.019.011-.01.006h0A2.659,2.659,0,0,0,26.892,11.5v.491a.064.064,0,0,0,.064.064H28.2a.064.064,0,0,0,.064-.064V11.5a1.292,1.292,0,0,1,.691-1.145l.027-.015.008,0,.03-.017a2.848,2.848,0,0,0,.3-.2,2.886,2.886,0,0,0,.813-.983,2.864,2.864,0,0,0,.079-2.4Z"
            transform="translate(-24.717 -4.985)"
          />
          <path
            className="a"
            fill="currentColor"
            d="M41.753,76.4A1.052,1.052,0,1,0,42.8,77.451,1.053,1.053,0,0,0,41.753,76.4Z"
            transform="translate(-38.894 -68.324)"
          />
        </g>
        <g
          className="b"
          fill="none"
          stroke="currentColor"
          transform="translate(1504 9)"
        >
          <circle className="c" stroke="none" cx="8.5" cy="8.5" r="8.5" />
          <circle className="d" fill="none" cx="8.5" cy="8.5" r="8" />
        </g>
      </g>
    </symbol>
    <symbol id="circle" viewBox="0 0 32 32">
      <g fill="none">
        <path d="M16 0A16 16 0 1 1 0 16 16 16 0 0 1 16 0z" />
        <path
          d="M16 1C11.993 1 8.227 2.56 5.393 5.393A14.902 14.902 0 0 0 1 16c0 4.007 1.56 7.773 4.393 10.607A14.902 14.902 0 0 0 16 31c4.007 0 7.773-1.56 10.607-4.393A14.902 14.902 0 0 0 31 16c0-4.007-1.56-7.773-4.393-10.607A14.902 14.902 0 0 0 16 1m0-1c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0z"
          fill="currentColor"
        />
      </g>
    </symbol>
    <symbol id="circle-new" viewBox="0 0 32 32">
      <g id="Path_1065" data-name="Path 1065" className="cls-1" fill="none">
        <path
          className="cls-2"
          d="M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z"
          stroke="none"
        />
        <path
          className="cls-3"
          d="M 16 1.5 C 12.12690925598145 1.5 8.485639572143555 3.008260726928711 5.746950149536133 5.746950149536133 C 3.008260726928711 8.485639572143555 1.5 12.12690925598145 1.5 16 C 1.5 19.87308883666992 3.008260726928711 23.51436042785645 5.746950149536133 26.25304985046387 C 8.485639572143555 28.99173927307129 12.12690925598145 30.5 16 30.5 C 19.87308883666992 30.5 23.51436042785645 28.99173927307129 26.25304985046387 26.25304985046387 C 28.99173927307129 23.51436042785645 30.5 19.87308883666992 30.5 16 C 30.5 12.12690925598145 28.99173927307129 8.485639572143555 26.25304985046387 5.746950149536133 C 23.51436042785645 3.008260726928711 19.87308883666992 1.5 16 1.5 M 16 0 C 24.8365592956543 0 32 7.163440704345703 32 16 C 32 24.8365592956543 24.8365592956543 32 16 32 C 7.163440704345703 32 0 24.8365592956543 0 16 C 0 7.163440704345703 7.163440704345703 0 16 0 Z"
          stroke="none"
          fill="currentColor"
        />
      </g>
    </symbol>

    <symbol id="circle-avatar" viewBox="0 0 41.708 41.708">
      <g fill="none" stroke="currentColor" strokeWidth="1">
        <circle cx="20.854" cy="20.854" r="20.854" stroke="none" />
        <circle cx="20.854" cy="20.854" r="20.354" fill="none" />
      </g>
    </symbol>
    <symbol id="circle4" viewBox="0 0 80 80">
      <g stroke="currentColor" strokeWidth="4" fill="none">
        <circle cx="40" cy="40" r="40" stroke="none" />
        <circle cx="40" cy="40" r="38" />
      </g>
    </symbol>
    <symbol id="icn-exchange" viewBox="0 0 46 26">
      <g fill="#fff">
        <path
          stroke="none"
          d="M33 25.5c-3.339 0-6.478-1.3-8.839-3.661A12.418 12.418 0 0 1 20.5 13c0-3.339 1.3-6.478 3.661-8.839C26.522 1.801 29.661.5 33 .5c3.339 0 6.478 1.3 8.839 3.661C44.199 6.522 45.5 9.661 45.5 13c0 3.339-1.3 6.478-3.661 8.839A12.418 12.418 0 0 1 33 25.5z"
        />
        <path
          stroke="none"
          fill="#db0011"
          d="M33 1a11.921 11.921 0 0 0-8.485 3.515A11.921 11.921 0 0 0 21 13c0 3.205 1.248 6.219 3.515 8.485A11.921 11.921 0 0 0 33 25c3.205 0 6.219-1.248 8.485-3.515A11.921 11.921 0 0 0 45 13c0-3.205-1.248-6.219-3.515-8.485A11.921 11.921 0 0 0 33 1m0-1c7.18 0 13 5.82 13 13s-5.82 13-13 13-13-5.82-13-13S25.82 0 33 0z"
        />
      </g>
      <g fill="#fff">
        <path
          stroke="none"
          d="M13 25.5c-3.339 0-6.478-1.3-8.839-3.661A12.418 12.418 0 0 1 .5 13c0-3.339 1.3-6.478 3.661-8.839C6.522 1.801 9.661.5 13 .5c3.339 0 6.478 1.3 8.839 3.661C24.199 6.522 25.5 9.661 25.5 13c0 3.339-1.3 6.478-3.661 8.839A12.418 12.418 0 0 1 13 25.5z"
        />
        <path
          stroke="none"
          fill="#db0011"
          d="M13 1a11.921 11.921 0 0 0-8.485 3.515A11.921 11.921 0 0 0 1 13c0 3.205 1.248 6.219 3.515 8.485A11.921 11.921 0 0 0 13 25c3.205 0 6.219-1.248 8.485-3.515A11.921 11.921 0 0 0 25 13c0-3.205-1.248-6.219-3.515-8.485A11.921 11.921 0 0 0 13 1m0-1c7.18 0 13 5.82 13 13s-5.82 13-13 13S0 20.18 0 13 5.82 0 13 0z"
        />
      </g>
      <path
        fill="#db0011"
        d="M14.1 8.878a4.487 4.487 0 0 1 1.191.5 3.835 3.835 0 0 1 .959.822 4.172 4.172 0 0 1 .673 1.13 4.636 4.636 0 0 1 .314 1.418h-1.8a2.716 2.716 0 0 0-.392-1.4 2.353 2.353 0 0 0-.945-.848v2.31h-.963v-2.58q-.1-.012-.2-.019t-.2-.006h-.154q-.074 0-.142.009v2.596h-.963v-2.358a2.149 2.149 0 0 0-.633.42 2.412 2.412 0 0 0-.448.59 2.816 2.816 0 0 0-.269.728 3.8 3.8 0 0 0-.09.836 3.8 3.8 0 0 0 .21 1.306 2.774 2.774 0 0 0 .6.981 2.593 2.593 0 0 0 .926.62 3.224 3.224 0 0 0 1.207.216h3.08v1.568h-7.7V16.15h1.5a3.73 3.73 0 0 1-.62-.583 4.092 4.092 0 0 1-.512-.759 4.412 4.412 0 0 1-.349-.889 3.633 3.633 0 0 1-.13-.966 4.211 4.211 0 0 1 .216-1.393 4.078 4.078 0 0 1 .648-1.191 4.072 4.072 0 0 1 1.019-.917 4.5 4.5 0 0 1 1.333-.568V7.742h.963v.988l.182-.009h.355l.167.009v-.988h.967zM36.675 15.452a2.469 2.469 0 0 1-.728 1.848 3.187 3.187 0 0 1-1.9.852V19.3h-.871v-1.131a3.723 3.723 0 0 1-1.87-.611 2.943 2.943 0 0 1-1.118-1.443l1.547-.9a1.745 1.745 0 0 0 1.443 1.185v-2.248h-.013l-.026-.013q-.455-.169-.741-.3a5.415 5.415 0 0 1-.669-.377 2.49 2.49 0 0 1-.6-.513 2.583 2.583 0 0 1-.377-.683 2.48 2.48 0 0 1-.162-.91 2.373 2.373 0 0 1 .747-1.833 3.061 3.061 0 0 1 1.84-.793V7.6h.871v1.157a2.948 2.948 0 0 1 2.497 1.833l-1.508.884a1.437 1.437 0 0 0-.988-.949V12.7a9.486 9.486 0 0 1 1.625.767 2.307 2.307 0 0 1 1.001 1.985zm-4.3-4.082a.75.75 0 0 0 .182.5 2 2 0 0 0 .624.435v-1.82a1.046 1.046 0 0 0-.6.312.83.83 0 0 0-.209.573zm1.677 5.005q.832-.182.832-.91a.78.78 0 0 0-.2-.546 1.934 1.934 0 0 0-.63-.416z"
      />
    </symbol>
    <symbol id="icn-exchange-hover" viewBox="0 0 46 26">
      <g fill="#db0011">
        <path
          stroke="none"
          d="M33 25.5c-3.339 0-6.478-1.3-8.839-3.661A12.418 12.418 0 0 1 20.5 13c0-3.339 1.3-6.478 3.661-8.839C26.522 1.801 29.661.5 33 .5c3.339 0 6.478 1.3 8.839 3.661C44.199 6.522 45.5 9.661 45.5 13c0 3.339-1.3 6.478-3.661 8.839A12.418 12.418 0 0 1 33 25.5z"
        />
        <path
          stroke="none"
          fill="#db0011"
          d="M33 1a11.921 11.921 0 0 0-8.485 3.515A11.921 11.921 0 0 0 21 13c0 3.205 1.248 6.219 3.515 8.485A11.921 11.921 0 0 0 33 25c3.205 0 6.219-1.248 8.485-3.515A11.921 11.921 0 0 0 45 13c0-3.205-1.248-6.219-3.515-8.485A11.921 11.921 0 0 0 33 1m0-1c7.18 0 13 5.82 13 13s-5.82 13-13 13-13-5.82-13-13S25.82 0 33 0z"
        />
      </g>
      <g fill="#db0011">
        <path
          stroke="none"
          d="M13 25.5c-3.339 0-6.478-1.3-8.839-3.661A12.418 12.418 0 0 1 .5 13c0-3.339 1.3-6.478 3.661-8.839C6.522 1.801 9.661.5 13 .5c3.339 0 6.478 1.3 8.839 3.661C24.199 6.522 25.5 9.661 25.5 13c0 3.339-1.3 6.478-3.661 8.839A12.418 12.418 0 0 1 13 25.5z"
        />
        <path
          stroke="none"
          fill="#db0011"
          d="M13 1a11.921 11.921 0 0 0-8.485 3.515A11.921 11.921 0 0 0 1 13c0 3.205 1.248 6.219 3.515 8.485A11.921 11.921 0 0 0 13 25c3.205 0 6.219-1.248 8.485-3.515A11.921 11.921 0 0 0 25 13c0-3.205-1.248-6.219-3.515-8.485A11.921 11.921 0 0 0 13 1m0-1c7.18 0 13 5.82 13 13s-5.82 13-13 13S0 20.18 0 13 5.82 0 13 0z"
        />
      </g>
      <path
        fill="#fff"
        d="M14.1 8.878a4.487 4.487 0 0 1 1.191.5 3.835 3.835 0 0 1 .959.822 4.172 4.172 0 0 1 .673 1.13 4.636 4.636 0 0 1 .314 1.418h-1.8a2.716 2.716 0 0 0-.392-1.4 2.353 2.353 0 0 0-.945-.848v2.31h-.963v-2.58q-.1-.012-.2-.019t-.2-.006h-.154q-.074 0-.142.009v2.596h-.963v-2.358a2.149 2.149 0 0 0-.633.42 2.412 2.412 0 0 0-.448.59 2.816 2.816 0 0 0-.269.728 3.8 3.8 0 0 0-.09.836 3.8 3.8 0 0 0 .21 1.306 2.774 2.774 0 0 0 .6.981 2.593 2.593 0 0 0 .926.62 3.224 3.224 0 0 0 1.207.216h3.08v1.568h-7.7V16.15h1.5a3.73 3.73 0 0 1-.62-.583 4.092 4.092 0 0 1-.512-.759 4.412 4.412 0 0 1-.349-.889 3.633 3.633 0 0 1-.13-.966 4.211 4.211 0 0 1 .216-1.393 4.078 4.078 0 0 1 .648-1.191 4.072 4.072 0 0 1 1.019-.917 4.5 4.5 0 0 1 1.333-.568V7.742h.963v.988l.182-.009h.355l.167.009v-.988h.967zM36.675 15.452a2.469 2.469 0 0 1-.728 1.848 3.187 3.187 0 0 1-1.9.852V19.3h-.871v-1.131a3.723 3.723 0 0 1-1.87-.611 2.943 2.943 0 0 1-1.118-1.443l1.547-.9a1.745 1.745 0 0 0 1.443 1.185v-2.248h-.013l-.026-.013q-.455-.169-.741-.3a5.415 5.415 0 0 1-.669-.377 2.49 2.49 0 0 1-.6-.513 2.583 2.583 0 0 1-.377-.683 2.48 2.48 0 0 1-.162-.91 2.373 2.373 0 0 1 .747-1.833 3.061 3.061 0 0 1 1.84-.793V7.6h.871v1.157a2.948 2.948 0 0 1 2.497 1.833l-1.508.884a1.437 1.437 0 0 0-.988-.949V12.7a9.486 9.486 0 0 1 1.625.767 2.307 2.307 0 0 1 1.001 1.985zm-4.3-4.082a.75.75 0 0 0 .182.5 2 2 0 0 0 .624.435v-1.82a1.046 1.046 0 0 0-.6.312.83.83 0 0 0-.209.573zm1.677 5.005q.832-.182.832-.91a.78.78 0 0 0-.2-.546 1.934 1.934 0 0 0-.63-.416z"
      />
    </symbol>
    <symbol id="icn-light" viewBox="0 0 31.541 29.921">
      <g className="a" transform="translate(-416.235 -1145.907)">
        <path
          className="b"
          d="M2573.96-1186.051v3.654"
          transform="translate(-2142.013 2332.958)"
          fill="none"
          stroke="#DB0011"
          strokeLinecap="round"
          strokeWidth="2px"
        />
        <path
          className="b"
          d="M0,0V3.325"
          transform="translate(442.659 1151.138) rotate(48)"
          fill="none"
          stroke="#DB0011"
          strokeLinecap="round"
          strokeWidth="2px"
        />
        <path
          className="b"
          d="M0,0V3.082"
          transform="matrix(0.174, 0.985, -0.985, 0.174, 446.617, 1160.518)"
          fill="none"
          stroke="#DB0011"
          strokeLinecap="round"
          strokeWidth="2px"
        />
        <path
          className="b"
          d="M0,0V3.691"
          transform="matrix(-0.719, 0.695, -0.695, -0.719, 424.187, 1152.935)"
          fill="none"
          stroke="#DB0011"
          strokeLinecap="round"
          strokeWidth="2px"
        />
        <path
          className="b"
          d="M0,0V3.206"
          transform="translate(420.458 1160.815) rotate(91)"
          fill="none"
          stroke="#DB0011"
          strokeLinecap="round"
          strokeWidth="2px"
        />
        <g transform="translate(424.534 1155.026)">
          <g transform="translate(0 0)">
            <path
              className="c"
              d="M12.873,2.823A7.415,7.415,0,0,0,8.714,16.378a2.9,2.9,0,0,1,.371,1.088.73.73,0,1,0,1.442-.231,4.148,4.148,0,0,0-.7-1.818.708.708,0,0,0-.192-.18,5.956,5.956,0,1,1,9.195-5,6.851,6.851,0,0,1-2.72,5.088.757.757,0,0,0-.167.173,4.587,4.587,0,0,0-.809,1.7.731.731,0,0,0,.564.865.689.689,0,0,0,.151.016.732.732,0,0,0,.714-.58,2.971,2.971,0,0,1,.521-1.079,8.308,8.308,0,0,0,3.205-6.18A7.424,7.424,0,0,0,12.873,2.823Z"
              transform="translate(-5.456 -2.823)"
              fill="currentColor"
            />
            <path
              className="c"
              d="M8.694,18.26a.729.729,0,0,0,.73.73H12.41l.1-.006a1.366,1.366,0,0,1,.18,0l3.034.006a.73.73,0,1,0,0-1.46H12.849l-.069,0a3.106,3.106,0,0,0-.356,0l-3,0A.729.729,0,0,0,8.694,18.26Z"
              transform="translate(-5.024 -0.863)"
            />
            <path
              className="c"
              d="M15.462,20.62a.729.729,0,0,0-.73-.73h-2.06l-.027,0a1.763,1.763,0,0,0-.309,0l-2.127,0a.73.73,0,0,0,0,1.46h2.159c.029,0,.06,0,.091-.007l.029,0,.034,0c.032,0,.062.006.094.007h2.117A.73.73,0,0,0,15.462,20.62Z"
              transform="translate(-4.92 -0.548)"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="icn-wahter" viewBox="0 0 32.116 32.117">
      <g className="a" transform="translate(-876.128 -3678.85)">
        <g transform="translate(876.128 3678.85)">
          <g transform="translate(0 0)">
            <path
              className="b"
              d="M33.581,12.17H29.834a.535.535,0,0,0-.535.535v1.606H24.481v-.535a.535.535,0,0,0-.535-.535H21.8V10.564a.535.535,0,0,0-.535-.535H19.664V6.817c.013,0,.046-2.115,0-3.747V2.535A.535.535,0,0,0,19.129,2H16.988a.535.535,0,0,0-.535.535V3.606s.024,4.1,0,6.423H14.846a.535.535,0,0,0-.535.535v2.676H12.17a.535.535,0,0,0-.535.535v1.071H8.959A6.967,6.967,0,0,0,2,21.8v3.212a.535.535,0,0,0,.535.535H7.888a.535.535,0,0,0,.535-.535V21.8a.535.535,0,0,1,.535-.535h2.676V22.34a.535.535,0,0,0,.535.535H23.946a.535.535,0,0,0,.535-.535V21.8H29.3v1.606a.535.535,0,0,0,.535.535h3.747a.535.535,0,0,0,.535-.535V12.705A.535.535,0,0,0,33.581,12.17ZM18.593,5.747H17.523V4.676h1.071ZM17.523,3.071h1.071v.535H17.523ZM16.452,4.676Zm1.071,2.141h1.071v3.212H17.523ZM15.382,11.1h5.353v2.141H15.382ZM8.959,20.2A1.606,1.606,0,0,0,7.353,21.8v2.676H3.071V21.8a5.9,5.9,0,0,1,5.888-5.888h2.676V20.2ZM23.411,21.8H12.705V14.311H23.411Zm1.071-1.071V15.382H29.3v5.353Zm8.564,2.141H30.369V13.241h2.676Z"
              transform="translate(-2 -2)"
              fill="currentColor"
            />
            <path
              className="c"
              fill="#DB0011"
              d="M5.678,55.513a2.676,2.676,0,0,0,2.331-1.285,2.388,2.388,0,0,0,.054-2.377L6.149,48.3a.558.558,0,0,0-.943,0l-1.913,3.55a2.388,2.388,0,0,0,.054,2.377,2.676,2.676,0,0,0,2.331,1.285ZM4.237,52.358l1.441-2.676,1.441,2.676a1.31,1.31,0,0,1-.029,1.321,1.615,1.615,0,0,1-1.412.763,1.615,1.615,0,0,1-1.412-.763,1.31,1.31,0,0,1-.029-1.321Z"
              transform="translate(-2.466 -23.396)"
            />
          </g>
        </g>
        <g className="d" fill="none" transform="translate(884.613 3680.528)">
          <path
            className="e"
            stroke="none"
            d="M1.561,0H13.268a1.6,1.6,0,0,1,1.561,1.642,1.6,1.6,0,0,1-1.561,1.642H1.561A1.6,1.6,0,0,1,0,1.642,1.6,1.6,0,0,1,1.561,0Z"
          />
          <path
            className="f"
            fill="#DB0011"
            d="M 1.562005996704102 1.500001549720764 C 1.549454689025879 1.506452441215515 1.499995231628418 1.54899275302887 1.499995231628418 1.641851544380188 C 1.499995231628418 1.738411545753479 1.553474426269531 1.780561566352844 1.560914993286133 1.783701539039612 L 11.20711517333984 1.783701539039612 L 13.26540470123291 1.784301519393921 C 13.27524471282959 1.780561566352844 13.32872486114502 1.738411545753479 13.32872486114502 1.641851544380188 C 13.32872486114502 1.545291543006897 13.27524471282959 1.503141522407532 13.26781463623047 1.500001549720764 L 1.562005996704102 1.500001549720764 M 1.560914993286133 1.430511474609375e-06 L 13.26781463623047 1.430511474609375e-06 C 14.12988471984863 1.430511474609375e-06 14.82872486114502 0.7350814342498779 14.82872486114502 1.641851544380188 C 14.82872486114502 2.548621654510498 14.12988471984863 3.283701658248901 13.26781463623047 3.283701658248901 L 11.20711517333984 3.283701658248901 L 1.560914993286133 3.283701658248901 C 0.6988449096679688 3.283701658248901 -4.76837158203125e-06 2.548621654510498 -4.76837158203125e-06 1.641851544380188 C -4.76837158203125e-06 0.7350814342498779 0.6988449096679688 1.430511474609375e-06 1.560914993286133 1.430511474609375e-06 Z"
          />
        </g>
      </g>
    </symbol>
    <symbol id="icn-recycled" viewBox="0 0 23.722 29">
      <g className="a" transform="translate(-11.004 -5)">
        <g transform="translate(11.004 5)">
          <circle
            className="b"
            fill="#DB0011"
            cx="1.054"
            cy="1.054"
            r="1.054"
            transform="translate(15.814 24.778)"
          />
          <path
            className="c"
            fill="currentColor"
            d="M34.726,8.69a1.6,1.6,0,0,0-1.607-1.582H31.447L31.02,5.4a.527.527,0,0,0-.511-.4H15.822a5.76,5.76,0,0,0-4.1,1.7l-.564.564v0a.527.527,0,0,0-.1.149.5.5,0,0,0-.017.05.527.527,0,0,0-.028.14c0,.012-.006.021-.006.032V9.745a.527.527,0,0,0,.527.527h1.107l.474,4.745a2.639,2.639,0,0,0,1.614,2.429l1.553,13.971a.527.527,0,0,0,.522.47h8.092A3.163,3.163,0,1,0,28.282,27.7l1.139-10.252a2.6,2.6,0,0,0,1.614-2.378l.48-4.8h1.606A1.6,1.6,0,0,0,34.726,8.69Zm-18.9-2.636H30.1l.264,1.054H12.838a4.71,4.71,0,0,1,2.984-1.054ZM29.981,30.833a2.109,2.109,0,1,1-2.109-2.109A2.109,2.109,0,0,1,29.981,30.833Zm-2.764-3.094a3.168,3.168,0,0,0-2.508,3.094H17.276l-1.467-13.18H28.338Zm2.764-12.722A1.582,1.582,0,0,1,28.4,16.6H15.747a1.6,1.6,0,0,1-1.582-1.634L13.7,10.272h16.76Zm1.054-5.8H12.056V8.163H33.119a.527.527,0,1,1,0,1.054Z"
            transform="translate(-11.004 -5)"
          />
          <path
            className="b"
            fill="#DB0011"
            d="M34.29,38.692l1.034,1.9h-.166a.527.527,0,1,0,0,1.054h1.054a.527.527,0,0,0,.463-.78l-1.46-2.677a.527.527,0,1,0-.925.505Z"
            transform="translate(-21.98 -20.556)"
          />
          <path
            className="b"
            fill="#DB0011"
            d="M25.527,43.254h3.585a.527.527,0,1,0,0-1.054h-2.7l.061-.113a.527.527,0,1,0-.926-.5l-.487.892a.527.527,0,0,0,.463.78Z"
            transform="translate(-17.621 -22.166)"
          />
          <path
            className="b"
            fill="#DB0011"
            d="M27.582,36.559a.527.527,0,0,0,.715-.211l1.484-2.722.195.354a.527.527,0,0,0,.925-.508l-.658-1.2A.527.527,0,0,0,29.781,32h0a.527.527,0,0,0-.462.275l-1.947,3.569a.527.527,0,0,0,.21.715Z"
            transform="translate(-18.712 -17.766)"
          />
        </g>
      </g>
    </symbol>
    <symbol id="icn-gas" viewBox="0 0 17.526 28.037">
      <g className="a" transform="translate(-26.736 -18.752)">
        <g transform="translate(26.736 18.752)">
          <path
            className="b"
            fill="none"
            stroke="#DB0011"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8.348,30.814l-.23-.142L7.4,30.1a3.066,3.066,0,0,1-.99-2.679A7.2,7.2,0,0,1,7.1,24.656l.746,3.372s.487,2.03,1.856,1.756a3.407,3.407,0,0,0,1.695-1.051,8.912,8.912,0,0,0,1.341-2.408s1.122-3.257.328-4.734c-.475-.885.021-.425.629.231.185.2.493.563.493.563a5.665,5.665,0,0,1,1.231,3.558,6.814,6.814,0,0,1-1.126,3.539c.066-.1-.029.044-.105.155a5.065,5.065,0,0,1-2.706,1.177,16.143,16.143,0,0,1-2.358.037c-.353-.011-.771-.037-.771-.037Z"
            transform="translate(-2.361 -7.803)"
          />
          <path
            className="c"
            fill="#currentColor"
            d="M40.175,23.173c.866-6.416-4.94-13.409-7.41-16.392a1.291,1.291,0,0,0-.994-.481,1.054,1.054,0,0,0-.545.128,1.334,1.334,0,0,0-.738,1.444c.834,4.427.417,6.865-.257,7.7-.1.1-.192.225-.321.225a.8.8,0,0,1-.513-.353,2.493,2.493,0,0,1-.385-2.021.989.989,0,0,0,.032-.321,1.332,1.332,0,0,0-1.251-1.315h-.16a1.194,1.194,0,0,0-.642.225,1.607,1.607,0,0,0-.257.225l-.032.032c-3.015,3.657-4.395,7.8-3.849,11.388a8.732,8.732,0,0,0,2.919,5.357,2.664,2.664,0,0,0,.128,5.325H37.32a2.663,2.663,0,1,0,0-5.325h-.289A9.532,9.532,0,0,0,40.175,23.173ZM27.7,13.069c-.449,2.246.866,3.978,2.181,3.978,1.572,0,3.208-2.47,1.893-9.463,3.689,4.491,12.158,15.045,3.24,21.3,0,0-6.174.309-7.506-.192C22.66,25.547,22.949,18.843,27.7,13.069ZM38.636,31.642a1.355,1.355,0,0,1-1.347,1.347H25.868a1.347,1.347,0,1,1,0-2.695h11.42A1.355,1.355,0,0,1,38.636,31.642Zm-7.114-2.359c.449-.257-.032-.353,0,0Z"
            transform="translate(-22.736 -6.3)"
          />
          <circle
            className="d"
            fill="#DB0011"
            cx="1.059"
            cy="1.059"
            r="1.059"
            transform="translate(2.426 24.283)"
          />
          <circle
            className="d"
            cx="1.059"
            cy="1.059"
            r="1.059"
            transform="translate(5.987 24.283)"
          />
          <circle
            cx="1.059"
            cy="1.059"
            r="1.059"
            transform="translate(9.548 24.283)"
          />
          <circle
            className="d"
            cx="1.059"
            cy="1.059"
            r="1.059"
            transform="translate(13.109 24.283)"
          />
        </g>
      </g>
    </symbol>
    <symbol id="icn-wifi" viewBox="0 0 27.045 19.869">
      <g className="a" transform="translate(0.344 0.144)">
        <path
          className="b"
          fill="#DB0011"
          d="M31.671,58.094a.565.565,0,0,0,.8.8,6.114,6.114,0,0,1,8.617,0,.552.552,0,0,0,.8,0,.552.552,0,0,0,0-.8A7.216,7.216,0,0,0,31.671,58.094Z"
          transform="translate(-23.638 -45.102)"
        />
        <path
          className="b"
          fill="#DB0011"
          d="M18.357,41.134a.847.847,0,1,0,1.2,1.2,10.815,10.815,0,0,1,15.294,0,.827.827,0,0,0,1.2,0,.827.827,0,0,0,0-1.2A12.52,12.52,0,0,0,18.357,41.134Z"
          transform="translate(-14.061 -31.881)"
        />
        <path
          className="c"
          fill="currentColor"
          d="M43.354,69.8a2.454,2.454,0,1,0,2.454,2.454A2.454,2.454,0,0,0,43.354,69.8Zm0,4.337a1.883,1.883,0,1,1,1.883-1.883A1.881,1.881,0,0,1,43.354,74.137Z"
          transform="translate(-30.355 -54.982)"
        />
        <path
          className="d"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="2px"
          d="M.656,7.144S12.1-6.487,25.7,6.515"
          transform="translate(0 0)"
        />
      </g>
    </symbol>
    <symbol id="icn-charity-new" viewBox="0 0 22.1 19.091">
      <g className="a" transform="translate(-5.943 -12.012)">
        <g transform="translate(5.943 12.012)">
          <path
            className="b"
            fill="currentColor"
            d="M11.852,964.374a5.8,5.8,0,0,0-4.122,1.72,5.874,5.874,0,0,0,0,8.276l8.8,8.873a.754.754,0,0,0,1.068,0q4.408-4.43,8.818-8.857a5.881,5.881,0,0,0,0-8.284,5.822,5.822,0,0,0-8.253,0l-1.084,1.1-1.1-1.107a5.817,5.817,0,0,0-4.13-1.72Zm0,1.025a4.314,4.314,0,0,1,3.062,1.288l1.633,1.641a.754.754,0,0,0,1.068,0l1.618-1.633a4.283,4.283,0,0,1,6.117,0,5.174,5.174,0,0,1,.765,6.671c-2.761,2.775-6.273,6.483-9.034,9.258l-9.314-9.557a5.314,5.314,0,0,1,.677-6.6A4.62,4.62,0,0,1,11.852,965.4Z"
            transform="translate(-6.024 -964.374)"
          />
          <g transform="translate(3.414 3.174)">
            <path
              className="c"
              fill="none"
              stroke="#DB0011"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M-6.574-1.912s-.51-1.48.652-2.084a1.744,1.744,0,0,1,2.038.333"
              transform="translate(6.685 4.199)"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="icn-gambling-new" viewBox="0 0 22.1 19.091">
      <g className="a">
        <path
          className="b"
          fill="currentColor"
          d="M0,954.7H2.4V952.3H15.532v18.58h-2.4v2.4H0m0,.073H0m.944-.943H12.266v-1.452H2.4V955.639H.944Zm2.322-2.4H14.588V953.244H3.266Z"
          transform="translate(0 -952.3)"
        />
        <g transform="translate(4.5 1.887)">
          <path
            className="c"
            fill="#DB0011"
            d="M13.745,964.948l-1.161.653-1.161-.653-1.161.653L9.1,964.948l2.322-3.048Z"
            transform="translate(-6.995 -956.82)"
          />
          <path
            d="M12.126,966.2l.8,2.1H11.4Z"
            transform="translate(-7.626 -957.999)"
          />
          <path
            d="M7.652,974.271l-.363.218-.363-.218-.363.218-.363-.218.653-.871Z"
            transform="translate(-6.2 -959.973)"
          />
          <path
            d="M7.218,974.6l.218.653H7Z"
            transform="translate(-6.419 -960.302)"
          />
          <path
            d="M17.752,955.771l-.363.218-.363-.218-.363.218-.363-.218.653-.871Z"
            transform="translate(-8.97 -954.9)"
          />
          <path
            d="M17.29,956.1l.218.653H17Z"
            transform="translate(-9.162 -955.229)"
          />
        </g>
      </g>
    </symbol>
    <symbol id="icon-notfoundaccount" viewBox="0 0 51.374 37.037">
      <g transform="translate(-409.699 -793.234)">
        <g
          transform="translate(409.699 793.235)"
          fill="#fff"
          stroke="#000"
          strokeWidth="1.5"
        >
          <rect width="51.374" height="37.037" rx="4" stroke="none" />
          <rect
            x="0.75"
            y="0.75"
            width="49.874"
            height="35.537"
            rx="3.25"
            fill="none"
          />
        </g>
        <g transform="translate(415.859 810.17)">
          <g transform="translate(0 0)">
            <rect width="20.824" height="1.467" rx="0.733" fill="#db0000" />
            <rect
              width="13.772"
              height="1.467"
              rx="0.733"
              transform="translate(0 4.03)"
              fill="#db0000"
            />
            <g
              transform="translate(28.138 6.754)"
              fill="none"
              stroke="#db0000"
              strokeWidth="1.5"
            >
              <rect width="8.441" height="6.752" rx="0.5" stroke="none" />
              <rect
                x="0.75"
                y="0.75"
                width="6.941"
                height="5.252"
                rx="0.25"
                fill="none"
              />
            </g>
          </g>
        </g>
        <line
          x2="50.777"
          transform="translate(409.998 803.091)"
          fill="none"
          stroke="#000"
          strokeWidth="1.5"
        />
      </g>
    </symbol>
    <symbol id="icon-notfounddeposit" viewBox="0 0 56.757 42.525">
      <g transform="translate(-409.699 -787.475)">
        <g
          className="a"
          fill="none"
          stroke="currentcolor"
          strokeWidth="1.5px"
          transform="translate(415.459 787.475)"
        >
          <rect
            className="e"
            stroke="none"
            width="50.997"
            height="36.765"
            rx="4"
          />
          <rect
            className="f"
            fill="none"
            x="0.75"
            y="0.75"
            width="49.497"
            height="35.265"
            rx="3.25"
          />
        </g>
        <g
          className="b"
          stroke="currentcolor"
          fill="#fff"
          strokeWidth="1.5px"
          transform="translate(409.699 793.235)"
        >
          <rect
            className="e"
            stroke="none"
            width="50.997"
            height="36.765"
            rx="4"
          />
          <rect
            className="f"
            fill="none"
            x="0.75"
            y="0.75"
            width="49.497"
            height="35.265"
            rx="3.25"
          />
        </g>
        <g transform="translate(415.813 810.046)">
          <g transform="translate(0 0)">
            <rect
              className="c"
              fill="#DB0011"
              width="20.671"
              height="1.456"
              rx="0.728"
            />
            <rect
              className="c"
              fill="#DB0011"
              width="13.671"
              height="1.456"
              rx="0.728"
              transform="translate(0 4)"
            />
            <g
              className="d"
              stroke="currentcolor"
              fill="none"
              strokeWidth="1.5px"
              transform="translate(27.932 6.705)"
            >
              <rect
                className="e"
                stroke="none"
                width="8.38"
                height="6.703"
                rx="0.5"
              />
              <rect
                className="f"
                fill="none"
                stroke="#DB0011"
                x="0.75"
                y="0.75"
                width="6.88"
                height="5.203"
                rx="0.25"
              />
            </g>
          </g>
        </g>
        <line
          className="a"
          fill="none"
          stroke="currentcolor"
          strokeWidth="1.5px"
          x2="50.404"
          transform="translate(409.996 803.019)"
        />
      </g>
    </symbol>
    <symbol id="icon-notfoundcredit" viewBox="0 0 51.515 37.158">
      <g transform="translate(-415.041 -616.685)">
        <g className="a" fill="#fff" transform="translate(415.041 616.685)">
          <path
            className="e"
            stroke="none"
            d="M 46.51380157470703 36.40830230712891 L 4.99950122833252 36.40830230712891 C 2.656321048736572 36.40830230712891 0.750001072883606 34.50197982788086 0.750001072883606 32.1588020324707 L 0.750001072883606 5.000401020050049 C 0.750001072883606 2.656721115112305 2.656321048736572 0.7500011324882507 4.99950122833252 0.7500011324882507 L 46.51380157470703 0.7500011324882507 C 48.85748291015625 0.7500011324882507 50.76420211791992 2.656721115112305 50.76420211791992 5.000401020050049 L 50.76420211791992 12.76260089874268 L 46.02510070800781 12.76260089874268 C 43.05034255981445 12.76260089874268 40.63019943237305 15.18274116516113 40.63019943237305 18.15750122070313 C 40.63019943237305 21.13176155090332 43.05034255981445 23.55150032043457 46.02510070800781 23.55150032043457 L 50.76420211791992 23.55150032043457 L 50.76420211791992 32.1588020324707 C 50.76420211791992 34.50197982788086 48.85748291015625 36.40830230712891 46.51380157470703 36.40830230712891 Z"
          />
          <path
            className="f"
            stroke="none"
            fill="currentcolor"
            d="M 46.51380157470703 35.65830230712891 C 48.44393157958984 35.65830230712891 50.01420211791992 34.08843231201172 50.01420211791992 32.1588020324707 L 50.01420211791992 24.30150032043457 L 46.02510070800781 24.30150032043457 C 42.63679122924805 24.30150032043457 39.88019943237305 21.54531097412109 39.88019943237305 18.15750122070313 C 39.88019943237305 14.76919078826904 42.63679122924805 12.01260089874268 46.02510070800781 12.01260089874268 L 50.01420211791992 12.01260089874268 L 50.01420211791992 5.000401020050049 C 50.01420211791992 3.070271253585815 48.44393157958984 1.500001192092896 46.51380157470703 1.500001192092896 L 4.99950122833252 1.500001192092896 C 3.069870948791504 1.500001192092896 1.500001072883606 3.070271253585815 1.500001072883606 5.000401020050049 L 1.500001072883606 32.1588020324707 C 1.500001072883606 34.08843231201172 3.069870948791504 35.65830230712891 4.99950122833252 35.65830230712891 L 46.51380157470703 35.65830230712891 M 46.51380157470703 37.15830230712891 L 4.99950122833252 37.15830230712891 C 2.242771148681641 37.15830230712891 1.058959924193914e-06 34.91553115844727 1.058959924193914e-06 32.1588020324707 L 1.058959924193914e-06 5.000401020050049 C 1.058959924193914e-06 2.243171215057373 2.242771148681641 1.153564426203957e-06 4.99950122833252 1.153564426203957e-06 L 46.51380157470703 1.153564426203957e-06 C 49.27103042602539 1.153564426203957e-06 51.51420211791992 2.243171215057373 51.51420211791992 5.000401020050049 L 51.51420211791992 13.51260089874268 L 46.02510070800781 13.51260089874268 C 43.46389007568359 13.51260089874268 41.38019943237305 15.59629154205322 41.38019943237305 18.15750122070313 C 41.38019943237305 20.71821022033691 43.46389007568359 22.80150032043457 46.02510070800781 22.80150032043457 L 51.51420211791992 22.80150032043457 L 51.51420211791992 32.1588020324707 C 51.51420211791992 34.91553115844727 49.27103042602539 37.15830230712891 46.51380157470703 37.15830230712891 Z"
          />
        </g>
        <g
          className="b"
          fill="#fff"
          stroke="#DB0011"
          strokeWidth="1.5px"
          transform="translate(459.11 631.886)"
        >
          <ellipse
            className="e"
            stroke="none"
            cx="2.956"
            cy="2.956"
            rx="2.956"
            ry="2.956"
          />
          <ellipse
            className="g"
            fill="none"
            cx="2.956"
            cy="2.956"
            rx="2.206"
            ry="2.206"
          />
        </g>
        <path
          className="c"
          stroke="#DB0011"
          fill="none"
          strokeLinecap="round"
          d="M419.9,682.687h23.259"
          transform="translate(1.812 -56.977)"
        />
        <path
          className="c"
          stroke="#DB0011"
          fill="none"
          strokeLinecap="round"
          d="M419.9,682.687h14.145"
          transform="translate(1.812 -51.065)"
        />
        <path
          className="d"
          strokeWidth="1.5px"
          fill="none"
          strokeLinecap="round"
          stroke="currentcolor"
          d="M419.9,682.707h3.755"
          transform="translate(39.064 -34.947)"
        />
      </g>
    </symbol>
    <symbol id="icn-notfoundloan" viewBox="0 0 45.237 49">
      <g transform="translate(-404 -531)">
        <g
          className="a"
          transform="translate(404 531)"
          fill="#fff"
          stroke="currentcolor"
          strokeWidth="1.5px"
        >
          <rect
            className="d"
            width="45.237"
            height="48.125"
            rx="4"
            stroke="none"
          />
          <rect
            className="e"
            x="0.75"
            y="0.75"
            width="43.737"
            height="46.625"
            rx="3.25"
            fill="none"
          />
        </g>
        <path
          className="b"
          d="M10365.944,1879.406h32.295"
          transform="translate(-9956.221 -1337.428)"
          stroke="currentcolor"
          strokeWidth="1.5px"
          fill="none"
          strokeLinecap="round"
        />
        <path
          className="b"
          d="M10365.944,1879.406h32.295"
          transform="translate(-9956.221 -1329.728)"
          stroke="currentcolor"
          strokeWidth="1.5px"
          fill="none"
          strokeLinecap="round"
        />
        <path
          className="b"
          d="M10365.943,1879.417h14.854"
          transform="translate(-9956.221 -1322.038)"
          stroke="currentcolor"
          strokeWidth="1.5px"
          fill="none"
          strokeLinecap="round"
        />
        <path
          className="b"
          d="M10365.944,1879.406h11.157"
          transform="translate(-9956.221 -1314.328)"
          stroke="currentcolor"
          strokeWidth="1.5px"
          fill="none"
          strokeLinecap="round"
        />
        <path
          className="b"
          d="M10365.944,1879.406h14.854"
          transform="translate(-9956.221 -1306.628)"
          stroke="currentcolor"
          strokeWidth="1.5px"
          fill="none"
          strokeLinecap="round"
        />
        <text
          className="c"
          transform="translate(427.541 574)"
          fill="#DB0011"
          fontSize="26"
          fontWeight="500"
          fontStyle="normal"
        >
          <tspan x="0" y="0">
            %
          </tspan>
        </text>
      </g>
    </symbol>
    <symbol id="icon-notfoundrecord" viewBox="0 0 27.28 32.585">
      <g transform="translate(-14 -7)">
        <path
          d="M29.379,40.758h3.789a.379.379,0,0,0,0-.758H29.379a.379.379,0,1,0,0,.758Z"
          transform="translate(-9.317 -20.497)"
          fill="#db0011"
        />
        <path d="M21.2,39.585H37.87a3.41,3.41,0,0,0,3.41-3.41V14.2a3.41,3.41,0,0,0-3.41-3.41H36.734V10.41A3.41,3.41,0,0,0,33.324,7H21.153a.379.379,0,0,0-.269.114L14.11,14.028a.379.379,0,0,0-.11.265V31.628a3.41,3.41,0,0,0,3.41,3.41h.379v1.137A3.41,3.41,0,0,0,21.2,39.585ZM37.87,11.547A2.652,2.652,0,0,1,40.522,14.2V36.175a2.652,2.652,0,0,1-2.652,2.652H21.2a2.652,2.652,0,0,1-2.652-2.652V35.038H33.324a3.41,3.41,0,0,0,3.41-3.41V11.547ZM20.82,8.258v4.8A1.137,1.137,0,0,1,19.683,14.2H15Zm-6.062,23.37V14.957h4.926a1.894,1.894,0,0,0,1.894-1.894v-5.3H33.324a2.652,2.652,0,0,1,2.652,2.652V31.628a2.652,2.652,0,0,1-2.652,2.652H17.41a2.652,2.652,0,0,1-2.652-2.652Z" />
        <path
          d="M29.379,64.758H39.988a.379.379,0,1,0,0-.758H29.379a.379.379,0,1,0,0,.758Z"
          transform="translate(-9.317 -35.403)"
        />
        <path
          d="M29.379,64.758H39.988a.379.379,0,1,0,0-.758H29.379a.379.379,0,1,0,0,.758Z"
          transform="translate(-9.317 -40.403)"
        />
      </g>
    </symbol>

    <symbol id="icon-swift" viewBox="0 0 20.299 21.594">
      <g id="swift" transform="translate(-404 -531)">
        <g
          id="Rectangle_718"
          data-name="Rectangle 718"
          className="cls-1"
          fill="#fff"
          stroke="currentcolor"
          strokeWidth="1.5px"
          transform="translate(404 531)"
        >
          <rect
            className="cls-3"
            width="20.299"
            height="21.594"
            rx="2"
            stroke="none"
          />
          <rect
            className="cls-4"
            x="0.25"
            y="0.25"
            width="19.799"
            height="21.094"
            rx="1.75"
            fill="none"
          />
        </g>
        <path
          id="Path_1094"
          data-name="Path 1094"
          className="cls-2"
          d="M10365.944,1879.406h14.491"
          transform="translate(-9959.376 -1337.48)"
          stroke="currentcolor"
          strokeWidth="1.5px"
          fill="none"
        />
        <path
          id="Path_1095"
          data-name="Path 1095"
          className="cls-2"
          d="M10365.944,1879.406h14.491"
          transform="translate(-9959.376 -1334.025)"
          stroke="currentcolor"
          strokeWidth="1.5px"
          fill="none"
        />
        <path
          id="Path_1096"
          data-name="Path 1096"
          className="cls-2"
          d="M10365.944,1879.406h14.491"
          transform="translate(-9959.376 -1330.57)"
          stroke="currentcolor"
          strokeWidth="1.5px"
          fill="none"
        />
        <path
          id="Path_1097"
          data-name="Path 1097"
          className="cls-2"
          d="M10365.944,1879.406h10.923"
          transform="translate(-9959.376 -1344.115)"
          stroke="currentcolor"
          strokeWidth="1.5px"
          fill="none"
        />
        <path
          id="Path_1098"
          data-name="Path 1098"
          className="cls-2"
          d="M10365.944,1879.406h10.923"
          transform="translate(-9959.376 -1340.659)"
          stroke="currentcolor"
          strokeWidth="1.5px"
          fill="none"
        />
      </g>

      {/* corporate */}
      <symbol id="corp-filter" viewBox="0 0 17 16">
        <path
          stroke="#242424"
          strokeLinecap="round"
          fill="none"
          d="M15.943 8.232H.643M15.943 14.232H.643"
        />
        <g fill="#fff" stroke="#db0011" transform="rotate(180 8.5 8)">
          <circle stroke="none" cx="2" cy="2" r="2" />
          <circle fill="none" cx="2" cy="2" r="1.5" />
        </g>
        <path
          stroke="#242424"
          strokeLinecap="round"
          fill="none"
          d="M15.943 2.232H.643"
        />
        <g fill="#fff" stroke="#db0011" transform="rotate(180 5 5)">
          <circle stroke="none" cx="2" cy="2" r="2" />
          <circle fill="none" cx="2" cy="2" r="1.5" />
        </g>
        <g fill="#fff" stroke="#db0011" transform="rotate(180 2 2)">
          <circle stroke="none" cx="2" cy="2" r="2" />
          <circle fill="none" cx="2" cy="2" r="1.5" />
        </g>
      </symbol>
      <symbol id="corp-settings" viewBox="0 0 17.592 17.578">
        <g transform="translate(-.551 -.55)">
          <path
            d="M10.32 18.129H8.364a1.341 1.341 0 0 1-1.342-1.339v-.869a10.145 10.145 0 0 1-.69-.279l-.626.606a1.344 1.344 0 0 1-1.9 0l-1.4-1.4a1.339 1.339 0 0 1 0-1.9l.612-.612a6.369 6.369 0 0 1-.279-.69h-.85A1.341 1.341 0 0 1 .55 10.309V8.353a1.341 1.341 0 0 1 1.339-1.342h.869c.084-.235.179-.464.279-.69l-.606-.615a1.339 1.339 0 0 1 0-1.9l1.4-1.4a1.339 1.339 0 0 1 1.9 0l.612.612a6.369 6.369 0 0 1 .69-.279v-.85A1.341 1.341 0 0 1 8.358.55h1.956a1.341 1.341 0 0 1 1.341 1.339v.869c.235.084.464.179.69.279l.626-.606a1.344 1.344 0 0 1 1.9 0l1.4 1.4a1.339 1.339 0 0 1 0 1.9l-.612.612a6.369 6.369 0 0 1 .279.69h.862a1.341 1.341 0 0 1 1.343 1.337v1.956a1.341 1.341 0 0 1-1.343 1.341h-.883c-.084.235-.179.464-.279.69l.606.615a1.341 1.341 0 0 1 0 1.895l-1.4 1.4a1.341 1.341 0 0 1-1.895 0l-.615-.612a6.369 6.369 0 0 1-.69.279v.866a1.344 1.344 0 0 1-1.33 1.327zm-4.086-3.58a.492.492 0 0 1 .232.059 6.011 6.011 0 0 0 1.177.489.489.489 0 0 1 .352.47v1.223a.363.363 0 0 0 .363.374h1.956a.363.363 0 0 0 .363-.361v-1.237a.489.489 0 0 1 .349-.47 5.964 5.964 0 0 0 1.179-.489.486.486 0 0 1 .578.084l.866.866a.366.366 0 0 0 .514 0l1.4-1.4a.366.366 0 0 0 0-.514l-.863-.863a.486.486 0 0 1-.084-.578 6.011 6.011 0 0 0 .489-1.177.489.489 0 0 1 .47-.352H16.8a.363.363 0 0 0 .369-.352V8.364A.363.363 0 0 0 16.8 8h-1.234a.489.489 0 0 1-.47-.352 6.011 6.011 0 0 0-.489-1.177.486.486 0 0 1 .084-.578l.866-.866a.361.361 0 0 0 0-.511l-1.4-1.4a.369.369 0 0 0-.514 0l-.866.866a.486.486 0 0 1-.578.084 6.081 6.081 0 0 0-1.177-.489.486.486 0 0 1-.352-.47V1.889a.363.363 0 0 0-.363-.361H8.353a.363.363 0 0 0-.363.361v1.224a.486.486 0 0 1-.352.47 6.081 6.081 0 0 0-1.177.489.486.486 0 0 1-.578-.084l-.866-.866a.361.361 0 0 0-.511 0l-1.4 1.4a.361.361 0 0 0 0 .511l.866.866a.486.486 0 0 1 .084.578 6.081 6.081 0 0 0-.489 1.177A.489.489 0 0 1 3.1 8H1.889a.363.363 0 0 0-.361.363v1.956a.363.363 0 0 0 .361.363h1.224a.489.489 0 0 1 .47.352 6.011 6.011 0 0 0 .489 1.177.486.486 0 0 1-.084.578l-.866.866a.369.369 0 0 0-.106.257.374.374 0 0 0 .106.257l1.4 1.4a.361.361 0 0 0 .511 0l.866-.866a.478.478 0 0 1 .338-.157z"
            fill="#242424"
          />
          <path
            fill="#db0011"
            d="M9.339 5.005a.651.651 0 0 1-.654-.651.654.654 0 1 1 .654.651zM5.727 6.385a.651.651 0 1 1 .463-.191.654.654 0 0 1-.463.191z"
          />
          <circle
            fill="#db0011"
            cx=".654"
            cy=".654"
            r=".654"
            transform="translate(3.7 8.685)"
          />
          <path
            fill="#db0011"
            d="M5.727 13.601a.651.651 0 1 1 .463-.191.654.654 0 0 1-.463.191zM9.339 14.979a.654.654 0 1 1 .654-.654.654.654 0 0 1-.654.654z"
          />
          <path d="M9.339 12.771a3.435 3.435 0 1 1 2.426-1.006 3.435 3.435 0 0 1-2.426 1.006zm0-5.886a2.451 2.451 0 1 0 1.735.718 2.451 2.451 0 0 0-1.735-.717z" />
          <path
            fill="#db0011"
            d="M12.948 13.601a.654.654 0 1 1 .651-.654.654.654 0 0 1-.651.654zM12.948 6.385a.654.654 0 1 1 .651-.654.654.654 0 0 1-.651.654zM14.325 9.993a.651.651 0 1 1 .463-.191.654.654 0 0 1-.463.191z"
          />
        </g>
      </symbol>
      <symbol id="icn-future-date" viewBox="0 0 14.258 13.061">
        <g transform="translate(-60.792 -36.933)">
          <g transform="translate(59.81 31.836)">
            <path
              className="a"
              fill="currentcolor"
              d="M1.272,9.638a6.607,6.607,0,0,0,3.359,7.886,6.646,6.646,0,0,0,8.48-2.507c.258-.409-.395-.778-.652-.37a5.852,5.852,0,0,1-7.644,2.131A5.8,5.8,0,0,1,8.493,5.931a5.879,5.879,0,0,1,4.79,5.4h-.826a.379.379,0,0,0-.259.621l.011.013,0,0,1.2,1.2a.378.378,0,0,0,.53,0l1.2-1.2a.378.378,0,0,0-.265-.639h-.835A6.625,6.625,0,0,0,8.471,5.173,6.587,6.587,0,0,0,1.272,9.638Z"
              transform="translate(0 0)"
            />
            <path
              className="b"
              fill="#DB0011"
              d="M43.045,17.855v4.322a.346.346,0,0,0,.1.254l.009.01.011.01a.347.347,0,0,0,.254.1h2.675a.375.375,0,0,0,0-.749h-2.3V17.854A.375.375,0,0,0,43.045,17.855Z"
              transform="translate(-35.945 -10.593)"
            />
          </g>
        </g>
      </symbol>
      <symbol id="corp-drag" viewBox="0 0 46.285 46.071">
        <path
          fill="#9f9f9f"
          d="M4.183.505a1.757 1.757 0 0 1-.317.053A4.938 4.938 0 0 0 2.579.98 4.628 4.628 0 0 0 .31 3.644a5.619 5.619 0 0 0-.218 2.153l.033 1.007 3.023-.052.01-1.007a4.312 4.312 0 0 1 .096-1.202 1.994 1.994 0 0 1 .713-.792c.226-.142.29-.148 1.09-.188l.848-.04-.01-1.554L5.877.423 5.1.44a7.416 7.416 0 0 0-.916.064z"
        />
        <path
          fill="#db0011"
          d="M8.885.406c-.021.016-.025.695-.012 1.5a6.534 6.534 0 0 0 .09 1.526 40.65 40.65 0 0 0 4.254-.05c.015-.027.02-.727.005-1.555L13.208.32l-2.143.02c-1.184.02-2.16.046-2.18.066zM16.15.285c-.02.017-.025.712-.011 1.533l.025 1.506.123.024c.064.015 1.034.003 2.158-.02l2.042-.052-.01-1.554L20.46.174 18.324.21c-1.178.021-2.159.054-2.174.075z"
        />
        <path
          fill="#9f9f9f"
          d="M23.456 1.652c.023 1.352.037 1.542.112 1.568a6.71 6.71 0 0 0 .817.018 2.271 2.271 0 0 1 .967.084 1.458 1.458 0 0 1 .765.698l.192.326.032.97a9.601 9.601 0 0 0 .06 1.022 10.912 10.912 0 0 0 1.543.01l1.506-.041-.018-1.061a4.9 4.9 0 0 0-.505-2.592A4.59 4.59 0 0 0 26.273.375a5.193 5.193 0 0 0-1.95-.253L23.43.114z"
        />
        <path
          fill="#db0011"
          d="M.197 11.907l.052 2.163 1.5-.01 1.5-.014.026-.118c.015-.07.003-1.04-.02-2.164l-.052-2.042-1.527.01-1.527.017z"
        />
        <path
          fill="#9f9f9f"
          d="M26.43 9.344c-.031.059.035 3.978.07 4.163l.035.143 1.517-.037 1.521-.042-.073-4.3-1.522.01a13.843 13.843 0 0 0-1.548.063z"
        />
        <path
          fill="#db0011"
          d="M.322 17.071c-.027.017-.027.918 0 2.175l.052 2.142 1.453-.01a7.139 7.139 0 0 0 1.521-.073 29.727 29.727 0 0 0-.062-4.29c-.727-.008-2.928.035-2.964.056z"
        />
        <path
          fill="#9f9f9f"
          d="M35.632 16.47a1.933 1.933 0 0 0 .324.659c.943 1.543 1.156 1.9 1.266 2.105.071.137.163.236.237.25s1.035.015 2.159.001c1.978-.018 2.047-.014 2.256.095a1.964 1.964 0 0 1 .74.745l.126.237.177 10.393c.165 9.7.172 10.41.09 10.597a1.742 1.742 0 0 1-.765.83l-.298.153-10.34.176c-8.686.148-10.383.165-10.596.106a1.787 1.787 0 0 1-.926-.79l-.158-.279-.052-3.691c-.035-2.026-.069-3.744-.086-3.818s-.125-.198-.306-.318c-.756-.5-1.63-1.102-1.733-1.19a.37.37 0 0 0-.15-.098 4.672 4.672 0 0 1-.692-.45.6.6 0 0 0-.202-.118c-.074.001.1 9.588.18 9.99a4.75 4.75 0 0 0 .41 1.324 4.768 4.768 0 0 0 1.917 2.015 6.363 6.363 0 0 0 1.74.586c.148.018 4.932-.047 10.632-.144 10.616-.18 10.8-.188 11.318-.392a2.175 2.175 0 0 1 .275-.09 2.866 2.866 0 0 0 .448-.188 4.913 4.913 0 0 0 1.251-.907 6.638 6.638 0 0 0 .825-1.106.66.66 0 0 1 .066-.177 4.475 4.475 0 0 0 .285-.905c.034-.16.078-.362.103-.447.07-.24-.295-21.132-.375-21.438a6.2 6.2 0 0 0-.318-1.045 4.649 4.649 0 0 0-2.049-2.225 4.892 4.892 0 0 0-1.409-.496c-.31-.063-6.276-.009-6.37.05z"
        />
        <path
          fill="#9f9f9f"
          d="M30.74 16.703a1.417 1.417 0 0 0-.47.46.872.872 0 0 0-.2.714c.012.44-.01.4.602 1.406a2.075 2.075 0 0 1 .253.542.658.658 0 0 1-.383.548c-.198.093-.21.093-.419-.014s-.284-.196-.683-.874a18.866 18.866 0 0 0-1.264-1.98 1.4 1.4 0 0 0-1.9.017 1.46 1.46 0 0 0-.396 1.083 3.742 3.742 0 0 0 .562 1.227 5.21 5.21 0 0 1 .63 1.19.72.72 0 0 1-.164.332c-.364.425-.76.283-1.159-.426-.12-.215-.426-.725-.677-1.129a2.606 2.606 0 0 0-.704-.895 1.431 1.431 0 0 0-1.976.49 1.094 1.094 0 0 0-.098.718l.029.476.371.604c1.15 1.853 1.106 1.764.974 2.047a.644.644 0 0 1-.308.298.356.356 0 0 1-.387.022c-.234-.096-.288-.159-.698-.847-.6-1.02-.79-1.26-1.074-1.393a1.4 1.4 0 0 0-1.858.583 1.041 1.041 0 0 0-.148.66c.007.366.018.392.334.907.18.297.327.545.327.556a1.34 1.34 0 0 0 .137.242c.126.184.53.861 1.392 2.305.13.215.377.62.545.89.372.595.427.726.314.77-.085.033-.347-.1-.541-.272a2.408 2.408 0 0 0-.322-.223c-.118-.067-.405-.253-.633-.408l-.767-.523c-.193-.133-.49-.33-.66-.45a2.976 2.976 0 0 0-.695-.327.94.94 0 0 0-.737-.009 1.513 1.513 0 0 0-1.242 1.21 1.217 1.217 0 0 0 .03.853c.147.498.405.742 1.728 1.62 1.62 1.073 2.327 1.546 2.53 1.703.101.078.483.337.843.575.72.476 1.02.678 2.27 1.52 1.282.864 1.873 1.263 2.994 2.007.246.166.573.368.733.45a4.87 4.87 0 0 0 2.02.495 4.419 4.419 0 0 0 1.097-.183.458.458 0 0 1 .174-.05 10.101 10.101 0 0 0 1.824-.976.209.209 0 0 1 .105-.066 3.047 3.047 0 0 0 .426-.246 4.06 4.06 0 0 1 .42-.246c.016 0 .278-.153.583-.344l1.407-.858c1.45-.878 1.974-1.524 2.224-2.738a7.42 7.42 0 0 0-.074-1.855 18.168 18.168 0 0 0-.741-2.428c-.094-.247-.283-.758-.42-1.133a39.702 39.702 0 0 0-1.1-2.676 44.94 44.94 0 0 0-2.579-4.581 37.647 37.647 0 0 1-.404-.683 1.607 1.607 0 0 0-.664-.705 1 1 0 0 0-.675-.142 1.1 1.1 0 0 0-.659.16zm1.731 7.752c.177.082.226.155.447.672a15.47 15.47 0 0 1 .509 1.502.257.257 0 0 0 .05.143c.026.025.266.658.533 1.407.525 1.481.541 1.591.291 1.84a.473.473 0 0 1-.373.134c-.2.003-.26-.023-.364-.148a1.65 1.65 0 0 1-.219-.396c-.05-.133-.127-.327-.166-.428s-.167-.469-.284-.817-.24-.707-.279-.796-.183-.497-.329-.922-.273-.802-.29-.845a4.047 4.047 0 0 1-.296-.88.82.82 0 0 1 .431-.516.665.665 0 0 0 .133-.035 1.191 1.191 0 0 1 .208.085zm-2.801 1.83a6.3 6.3 0 0 1 .691 1.08 1.1 1.1 0 0 0 .131.226c.163.23.741 1.188.742 1.23a3.629 3.629 0 0 0 .235.382c.261.388.617.99.835 1.413.126.257.132.283.06.434a.7.7 0 0 1-.486.384c-.27.005-.422-.136-.77-.713-.186-.31-.382-.625-.437-.698s-.147-.252-.223-.396a2.948 2.948 0 0 0-.247-.42c-.136-.184-.925-1.496-1.235-2.064-.24-.436-.243-.563.002-.811a.518.518 0 0 1 .704-.044zm-3.033 1.685a2.393 2.393 0 0 1 .407.38c.125.152.244.282.26.296s.195.214.408.444.519.575.702.762.53.575.784.857.6.663.772.846c.275.304.307.366.31.568a.5.5 0 0 1-.543.51c-.28.005-.28.005-1.81-1.693-.282-.313-.672-.737-.865-.946-1.129-1.206-1.19-1.28-1.193-1.528a.494.494 0 0 1 .272-.492.355.355 0 0 1 .5-.004zM.435 24.365a7.435 7.435 0 0 0 .037 1.532c.028.085.085.299.125.47a4.686 4.686 0 0 0 3.567 3.319 10.221 10.221 0 0 0 1.258.047l.928-.016-.051-3.023-.77-.019c-.917-.021-1.179-.097-1.524-.425a1.561 1.561 0 0 1-.516-1.311l-.043-.636-1.49.01c-.816.011-1.499.033-1.521.052zM9.322 26.737c-.014.07-.008.753.01 1.527l.04 1.405 2.159-.02 2.158-.026-.008-1.417c-.003-.785-.014-1.474-.027-1.543l-.014-.116-4.29.072z"
        />
      </symbol>
      <symbol id="icn-create-copy" viewBox="0 0 13.58 9.263">
        <g transform="translate(-6.019 -14.953)">
          <g transform="translate(6.019 14.953)">
            <path
              className="a"
              fill="currentcolor"
              d="M11.053,967.318a.463.463,0,0,0-.236.106l-4.632,3.86a.463.463,0,0,0,0,.709l4.632,3.861a.463.463,0,0,0,.757-.352v-1.539a11.719,11.719,0,0,1,7.261,2.5.463.463,0,0,0,.743-.492c-1.3-4-5.2-5.765-8-6.533v-1.66a.463.463,0,0,0-.521-.463Zm-.405,1.447v1.023a.463.463,0,0,0,.347.449c2.269.575,5.346,1.861,6.967,4.477a13.548,13.548,0,0,0-6.875-1.684.463.463,0,0,0-.439.463v1.018L7.2,971.641Z"
              transform="translate(-6.019 -967.315)"
            />
          </g>
        </g>
      </symbol>
      <symbol id="repeat" viewBox="0 0 20 20">
        <g id="rotate--360" transform="translate(0.055)">
          <path
            id="Path_1358"
            data-name="Path 1358"
            d="M4.9,5.91l0,0c.057-.068.123-.129.182-.2.115-.128.229-.257.351-.377.086-.085.178-.164.268-.245.114-.1.228-.206.348-.3.1-.08.2-.154.305-.23.12-.088.24-.173.365-.254.109-.071.22-.137.332-.2q.192-.112.39-.213c.115-.059.231-.116.349-.169.139-.063.28-.12.423-.175.118-.045.236-.091.356-.131.154-.051.311-.094.468-.135.115-.031.229-.064.346-.09.181-.04.366-.067.551-.094.1-.014.2-.035.3-.046a8.053,8.053,0,0,1,7.113,2.895V3.626h1.248V8.633H13.6V7.381H16.84a6.831,6.831,0,0,0-5.731-3.13,6.907,6.907,0,0,0-.742.042c-.085.009-.167.026-.251.038-.157.023-.313.046-.466.08-.1.022-.2.05-.294.076-.133.035-.266.071-.4.114-.1.034-.2.073-.3.112-.12.046-.239.094-.356.147-.1.046-.2.094-.3.144s-.221.117-.328.179-.19.113-.283.173-.206.14-.307.214-.176.128-.26.2c-.1.081-.2.167-.293.254-.076.069-.155.136-.228.208-.1.1-.2.212-.3.32A6.868,6.868,0,1,0,17.97,11.137h1.248A8.114,8.114,0,1,1,4.9,5.91Z"
            transform="translate(-1.61 -1.122)"
          />
          <rect
            id="_Transparent_Rectangle_"
            data-name="&lt;Transparent Rectangle&gt;"
            width="20"
            height="20"
            transform="translate(-0.055)"
            fill="none"
          />
        </g>
      </symbol>
    </symbol>
    <symbol id="icon-404" viewBox="0 0 63.904 53.291">
      <g id="noun_Error_1765803" transform="translate(0.007 -3.961)">
        <path
          id="Path_1164"
          data-name="Path 1164"
          fill="currentcolor"
          className="cls-1"
          d="M36.843,6.675a5.776,5.776,0,0,0-9.8,0L.921,48.227a5.816,5.816,0,0,0-.173,6.016,5.71,5.71,0,0,0,5.071,3.008H58.072a5.71,5.71,0,0,0,5.071-3.008,5.816,5.816,0,0,0-.173-6.016ZM60.8,52.9a3.088,3.088,0,0,1-2.728,1.69H5.819a3.088,3.088,0,0,1-2.742-1.637,3.194,3.194,0,0,1,.093-3.3l26.113-41.5a3.114,3.114,0,0,1,5.324,0l26.113,41.5a3.194,3.194,0,0,1,.093,3.3Z"
          transform="translate(0)"
        />
        <path
          id="Path_1165"
          data-name="Path 1165"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1.7px"
          className="cls-2"
          d="M15.445,24.275l3.6,3.713"
          transform="translate(5.489 7.11)"
        />
        <path
          id="Path_1168"
          data-name="Path 1168"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1.7px"
          className="cls-2"
          d="M15.445,24.275l3.6,3.713"
          transform="translate(24.122 7.11)"
        />
        <path
          id="Path_1166"
          data-name="Path 1166"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1.7px"
          className="cls-2"
          d="M0,0,3.6,3.713"
          transform="translate(24.492 31.348) rotate(87)"
        />
        <path
          id="Path_1167"
          data-name="Path 1167"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1.7px"
          className="cls-2"
          d="M0,0,3.6,3.713"
          transform="translate(43.125 31.348) rotate(87)"
        />
        <path
          id="Path_1169"
          data-name="Path 1169"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1.7px"
          className="cls-2"
          d="M18.429,37.744s4.835-2.645,7.422-2.235A22.043,22.043,0,0,1,31.7,37.744"
          transform="translate(6.71 10.427)"
        />
      </g>
    </symbol>
    <symbol id="icn-file" viewBox="0 0 26.266 31.373">
      <g transform="translate(-14 -7)">
        <path
          className="a"
          fill="#db0011"
          d="M29.365,40.73h3.648a.365.365,0,0,0,0-.73H29.365a.365.365,0,1,0,0,.73Z"
          transform="translate(-9.528 -20.962)"
        />
        <path d="M20.931,38.373H36.982a3.283,3.283,0,0,0,3.283-3.283V13.931a3.283,3.283,0,0,0-3.283-3.283H35.888v-.365A3.283,3.283,0,0,0,32.6,7H20.887a.365.365,0,0,0-.259.109l-6.523,6.658a.365.365,0,0,0-.106.255V30.712a3.283,3.283,0,0,0,3.283,3.283h.365v1.094A3.283,3.283,0,0,0,20.931,38.373ZM36.982,11.378a2.554,2.554,0,0,1,2.554,2.554V35.089a2.554,2.554,0,0,1-2.554,2.554H20.931a2.554,2.554,0,0,1-2.554-2.554V33.995H32.6a3.283,3.283,0,0,0,3.283-3.283V11.378ZM20.566,8.211v4.626a1.094,1.094,0,0,1-1.094,1.094H14.963Zm-5.837,22.5V14.661h4.742A1.824,1.824,0,0,0,21.3,12.837V7.73H32.6a2.554,2.554,0,0,1,2.554,2.554V30.712A2.554,2.554,0,0,1,32.6,33.265H17.283a2.554,2.554,0,0,1-2.554-2.554Z" />
        <path
          className="a"
          fill="#db0011"
          d="M29.365,52.73H39.579a.365.365,0,0,0,0-.73H29.365a.365.365,0,1,0,0,.73Z"
          transform="translate(-9.528 -28.584)"
        />
        <path
          d="M29.365,64.73H39.579a.365.365,0,1,0,0-.73H29.365a.365.365,0,1,0,0,.73Z"
          transform="translate(-9.528 -36.207)"
        />
      </g>
    </symbol>
    <symbol id="icn-upload" viewBox="0 0 18.365 17">
      <g transform="translate(412 -10.19)">
        <g transform="translate(-412 10.19)">
          <path
            className="a"
            fill="currentcolor"
            d="M15.877,17.605H13.1a.306.306,0,1,1,0-.611h2.775a3.854,3.854,0,0,0,.471-7.666l-.269-.034V8.989A4.184,4.184,0,0,0,11.9,4.8h-.33A4.166,4.166,0,0,0,7.71,7.378L7.6,7.653l-.278-.107a2.308,2.308,0,0,0-3.139,2.14v.972l-.134.092a3.252,3.252,0,0,0-1.434,2.7v.306A3.252,3.252,0,0,0,5.86,16.991H9.2a.306.306,0,1,1,0,.611H5.86A3.863,3.863,0,0,1,2,13.742v-.306a3.863,3.863,0,0,1,1.568-3.093V9.692A2.919,2.919,0,0,1,7.26,6.883,4.774,4.774,0,0,1,11.567,4.19h.33a4.8,4.8,0,0,1,4.774,4.557,4.466,4.466,0,0,1-.807,8.864Z"
            transform="translate(-2 -4.19)"
          />
          <path
            className="b"
            fill="#db0011"
            d="M31.306,35.73A.306.306,0,0,1,31,35.424V25.436a.306.306,0,1,1,.611,0v9.989A.306.306,0,0,1,31.306,35.73Z"
            transform="translate(-22.136 -18.73)"
          />
          <path
            className="b"
            fill="#db0011"
            d="M27.617,28.3a.306.306,0,0,1-.214-.086l-2.687-2.619-2.687,2.619a.306.306,0,1,1-.428-.437l3.115-3.035,3.115,3.035a.306.306,0,0,1-.214.526Z"
            transform="translate(-15.546 -18.459)"
          />
        </g>
      </g>
    </symbol>
    <symbol id="icn-xls" viewBox="0 0 16.176 19.992">
      <path
        className="a"
        fill="currentcolor"
        d="M27.8,5H26.492a1.125,1.125,0,0,0-.732.288l-.311.311c-.022,0-.067-.022-.089-.022H16.507A1.042,1.042,0,0,0,15.464,6.62v.222h-.178a1.042,1.042,0,0,0-1.043,1.043V16.56l-.355.355a1.026,1.026,0,0,0-.288.71v5.392a1.979,1.979,0,0,0,1.975,1.975H27.8a1.979,1.979,0,0,0,1.975-1.975V6.975A1.994,1.994,0,0,0,27.8,5ZM16,6.62a.5.5,0,0,1,.51-.51h8.432l-.754.732H16Zm-1.22,1.243a.5.5,0,0,1,.51-.51h8.365l-8.876,8.676ZM29.243,23A1.439,1.439,0,0,1,27.8,24.438H15.553A1.439,1.439,0,0,1,14.11,23V17.6a.452.452,0,0,1,.133-.333l11.871-11.6a.524.524,0,0,1,.355-.155h1.309a1.439,1.439,0,0,1,1.442,1.442V23Z"
        transform="translate(-13.6 -5)"
      />
      <path
        className="b"
        fill="#db0011"
        d="M58.927,72.8H55.066a.266.266,0,1,0,0,.533h3.883a.256.256,0,0,0,.266-.266A.275.275,0,0,0,58.927,72.8Z"
        transform="translate(-45.658 -57.756)"
      />
      <path
        className="b"
        fill="#db0011"
        d="M58.927,77.6H55.066a.266.266,0,1,0,0,.533h3.883a.256.256,0,0,0,.266-.266A.275.275,0,0,0,58.927,77.6Z"
        transform="translate(-45.658 -61.491)"
      />
      <path
        className="b"
        fill="#db0011"
        d="M57.662,82.4h-2.6a.266.266,0,1,0,0,.533h2.618a.256.256,0,0,0,.266-.266A.29.29,0,0,0,57.662,82.4Z"
        transform="translate(-45.658 -65.226)"
      />
      <path
        className="b"
        fill="#db0011"
        d="M24.02,20.3h-.444l-.355.555-.355-.555h-.444l.577.843-.6.865h.422l.4-.6.377.6h.444l-.6-.888Z"
        transform="translate(-20.447 -16.905)"
      />
      <path
        className="b"
        fill="#db0011"
        d="M31.377,20.3H31v1.709h1.243v-.355h-.865Z"
        transform="translate(-27.139 -16.905)"
      />
      <path
        className="b"
        fill="#db0011"
        d="M38.2,20.91c-.288-.067-.377-.111-.377-.222h0c0-.089.067-.155.222-.155a.756.756,0,0,1,.444.178l.2-.288a1.025,1.025,0,0,0-.643-.222.529.529,0,0,0-.6.51h0c0,.333.222.444.577.533.288.067.355.111.355.222h0c0,.111-.089.155-.244.155a.86.86,0,0,1-.51-.2l-.222.266a1.1,1.1,0,0,0,.732.266c.377,0,.621-.2.621-.533h0C38.731,21.11,38.532,21,38.2,20.91Z"
        transform="translate(-32.119 -16.827)"
      />
    </symbol>
    <symbol id="icn-batchtransfer" viewBox="0 0 20.803 18.519">
      <g transform="translate(0)">
        <path
          className="a"
          fill="currentcolor"
          d="M164.064,234.7H150.639a.339.339,0,0,0-.339.339v6.079a.339.339,0,0,0,.339.339H164.06a.339.339,0,0,0,.339-.339v-6.079A.332.332,0,0,0,164.064,234.7Zm-.339,6.079H150.978v-5.4h12.748v5.4Z"
          transform="translate(-143.596 -224.232)"
        />
        <path
          className="a"
          fill="currentcolor"
          d="M14.1,35.418V29.339A.339.339,0,0,0,13.76,29H.339A.339.339,0,0,0,0,29.339v6.079a.339.339,0,0,0,.339.339H13.76A.345.345,0,0,0,14.1,35.418Zm-.678-.339H.674v-5.4H13.421Z"
          transform="translate(0 -27.706)"
        />
        <path
          className="b"
          fill="#db0011"
          d="M29.271,204.07H27.737a.944.944,0,0,1-.941-.941v-1.347h.843a.282.282,0,0,0,.236-.433l-1.182-1.82a.281.281,0,0,0-.473,0l-1.178,1.82a.274.274,0,0,0-.009.285.282.282,0,0,0,.245.147h.843v1.347a1.617,1.617,0,0,0,1.615,1.615h1.534a.337.337,0,1,0,0-.673Z"
          transform="translate(-23.883 -190.506)"
        />
        <path
          className="b"
          fill="#db0011"
          d="M338.339,97.874h1.534a.944.944,0,0,1,.941.941v1.356h-.834a.282.282,0,0,0-.236.433l1.178,1.824a.281.281,0,0,0,.473,0l1.178-1.824a.265.265,0,0,0,.009-.285.282.282,0,0,0-.245-.147h-.848V98.815a1.617,1.617,0,0,0-1.615-1.615h-1.534a.339.339,0,0,0-.339.339A.335.335,0,0,0,338.339,97.874Z"
          transform="translate(-322.924 -92.865)"
        />
        <path
          className="a"
          fill="currentcolor"
          d="M204.051,400h-1.512a.339.339,0,1,0,0,.678h1.512a.339.339,0,0,0,0-.678Z"
          transform="translate(-193.181 -382.159)"
        />
        <path
          className="a"
          fill="currentcolor"
          d="M262.9,400h-.558a.339.339,0,1,0,0,.678h.558a.339.339,0,0,0,0-.678Z"
          transform="translate(-250.314 -382.159)"
        />
        <path
          className="a"
          fill="currentcolor"
          d="M306.5,400h-4.362a.339.339,0,0,0,0,.678H306.5a.339.339,0,0,0,0-.678Z"
          transform="translate(-288.339 -382.159)"
        />
        <path
          className="a"
          fill="currentcolor"
          d="M52.039.674h1.512a.337.337,0,1,0,0-.674H52.039A.339.339,0,0,0,51.7.339.335.335,0,0,0,52.039.674Z"
          transform="translate(-49.394)"
        />
        <path
          className="a"
          fill="currentcolor"
          d="M111.743.674h.558a.339.339,0,0,0,.339-.339A.339.339,0,0,0,112.3,0h-.558a.339.339,0,0,0-.339.339A.339.339,0,0,0,111.743.674Z"
          transform="translate(-106.431)"
        />
        <path
          className="a"
          fill="currentcolor"
          d="M151.543.674h4.362a.339.339,0,0,0,.339-.339A.339.339,0,0,0,155.9,0h-4.362a.339.339,0,0,0-.339.339A.339.339,0,0,0,151.543.674Z"
          transform="translate(-144.456)"
        />
      </g>
    </symbol>
    <symbol id="icn-currenttasks" viewBox="0 0 18.582 17">
      <g transform="translate(0)">
        <path
          className="a"
          fill="currentcolor"
          d="M21.581,9.372A2.372,2.372,0,0,0,19.209,7H5.372A2.372,2.372,0,0,0,3,9.372V21.628A2.372,2.372,0,0,0,5.372,24H19.209a2.372,2.372,0,0,0,2.372-2.372ZM5.372,7.791H19.209a1.581,1.581,0,0,1,1.581,1.581v.3h-17v-.3A1.581,1.581,0,0,1,5.372,7.791ZM19.209,23.209H5.372a1.581,1.581,0,0,1-1.581-1.581V10.459h17V21.628A1.581,1.581,0,0,1,19.209,23.209Z"
          transform="translate(-3 -7)"
        />
        <path
          className="a"
          fill="currentcolor"
          d="M54.424,35.5h-5.14a1.285,1.285,0,1,0,0,2.57h5.14a1.285,1.285,0,0,0,0-2.57Zm0,1.779h-5.14a.494.494,0,0,1,0-.988h5.14a.494.494,0,0,1,0,.988Z"
          transform="translate(-39.105 -29.866)"
        />
        <path
          className="b"
          fill="#db0011"
          d="M20.253,33.225l-2.1,2.319L17,34.753a.4.4,0,0,0-.445.652l1.433.977a.4.4,0,0,0,.506-.051l2.331-2.57a.4.4,0,1,0-.593-.53Z"
          transform="translate(-13.755 -27.94)"
        />
        <path
          className="b"
          fill="#db0011"
          d="M20.253,33.225l-2.1,2.319L17,34.753a.4.4,0,0,0-.445.652l1.433.977a.4.4,0,0,0,.506-.051l2.331-2.57a.4.4,0,1,0-.593-.53Z"
          transform="translate(-13.755 -22.852)"
        />
        <path
          className="a"
          fill="currentcolor"
          d="M54.424,63.5h-5.14a1.285,1.285,0,1,0,0,2.57h5.14a1.285,1.285,0,0,0,0-2.57Zm0,1.779h-5.14a.494.494,0,0,1,0-.988h5.14a.494.494,0,0,1,0,.988Z"
          transform="translate(-39.105 -52.331)"
        />
      </g>
    </symbol>
    <symbol id="icn-statment" viewBox="0 0 15.209 18.201">
      <g transform="translate(0)">
        <path
          className="a"
          fill="currentcolor"
          d="M70.8,40.538a1.443,1.443,0,0,0,.379-.022.348.348,0,0,1,.335.107l3.151,3.147a.344.344,0,1,1-.486.488l-2.733-2.73q0,1.554,0,3.109h3.292c.082,0,.161.031.243.028a.339.339,0,0,1,.325.219.743.743,0,0,1,.022.26q0,6.463,0,12.925c.012.1-.071.187-.057.29a.341.341,0,0,1-.334.347h-14.1c-.1,0-.191,0-.286,0a.332.332,0,0,1-.243-.124.756.756,0,0,1-.164-.224.907.907,0,0,1-.018-.266V41.028a.679.679,0,0,1,.033-.3.34.34,0,0,1,.257-.19q5.193.006,10.387,0m-9.99.688q0,8.4,0,16.792H74.645q0-6.347,0-12.694H71.27a.656.656,0,0,1-.283-.032.337.337,0,0,1-.2-.3c0-.084-.029-.163-.029-.246q0-1.759,0-3.517Z"
          transform="translate(-60.125 -40.506)"
        />
        <path
          className="b"
          fill="#db0011"
          d="M169.075,97.248a1,1,0,0,1,.236-.013h2.113a.344.344,0,1,1,0,.688h-2.2a.39.39,0,0,1-.259-.07.344.344,0,0,1,.11-.6Z"
          transform="translate(-166.271 -93.667)"
        />
        <path
          className="a"
          fill="currentcolor"
          d="M169.587,116.7c.3-.016.606,0,.908-.007.46,0,.919,0,1.379,0a.384.384,0,0,1,.249.064.344.344,0,0,1-.2.624h-2.136a.559.559,0,0,1-.306-.047.343.343,0,0,1,.111-.634Z"
          transform="translate(-166.719 -111.906)"
        />
        <path
          className="a"
          fill="currentcolor"
          d="M170.11,136.158a1.21,1.21,0,0,1,.26-.013h5.293a.344.344,0,1,1,0,.688h-5.385a.409.409,0,0,1-.293-.079.344.344,0,0,1,.124-.6Z"
          transform="translate(-167.239 -130.131)"
        />
        <path
          className="b"
          fill="#db0011"
          d="M95.573,160.244c.312-.014.625,0,.938-.006h8.875a.329.329,0,0,1,.293.184.356.356,0,0,1-.053.4.331.331,0,0,1-.261.107H95.63a.327.327,0,0,1-.293-.18A.348.348,0,0,1,95.573,160.244Z"
          transform="translate(-92.693 -152.709)"
        />
        <path
          className="a"
          fill="currentcolor"
          d="M95.3,181.244c.3-.015.608,0,.911-.006h8.77a.541.541,0,0,1,.328.054.354.354,0,0,1,.11.46.329.329,0,0,1-.288.174H95.5a.53.53,0,0,1-.335-.058.354.354,0,0,1-.1-.464A.328.328,0,0,1,95.3,181.244Z"
          transform="translate(-92.438 -172.388)"
        />
        <path
          className="a"
          fill="currentcolor"
          d="M111.945,206.678c3.245-.006,6.49,0,9.735,0a.346.346,0,1,1,0,.688H112.01a.382.382,0,0,1-.323-.145.329.329,0,0,1,0-.4A.365.365,0,0,1,111.945,206.678Z"
          transform="translate(-108.998 -196.226)"
        />
        <path
          className="a"
          fill="currentcolor"
          d="M95.518,227.728a.825.825,0,0,1,.271-.021h9.556a.471.471,0,0,1,.33.068.355.355,0,0,1,.066.484.327.327,0,0,1-.265.136H95.658a.336.336,0,0,1-.32-.193A.351.351,0,0,1,95.518,227.728Z"
          transform="translate(-92.69 -215.934)"
        />
        <path
          className="b"
          fill="#db0011"
          d="M94.672,251.525a1.012,1.012,0,0,1,.229-.012h9.754a.336.336,0,0,1,.332.309.347.347,0,0,1-.192.347.679.679,0,0,1-.29.031H94.772a.337.337,0,0,1-.342-.308A.345.345,0,0,1,94.672,251.525Z"
          transform="translate(-91.871 -238.244)"
        />
        <path
          className="a"
          fill="currentcolor"
          d="M98.278,275.748c1.039-.009,2.079,0,3.118,0h6.85a.344.344,0,0,1,0,.687h-9.78a.552.552,0,0,1-.329-.055.349.349,0,0,1-.106-.465A.333.333,0,0,1,98.278,275.748Z"
          transform="translate(-95.424 -260.951)"
        />
      </g>
    </symbol>
    <symbol id="icn-admin" viewBox="0 0 21.996 17.838" fill="currentcolor">
      <g transform="translate(11995 1458)">
        <path
          d="M11.442,1.071A4.308,4.308,0,0,1,12.624,4.5,4.629,4.629,0,0,1,11.3,7.219,3.789,3.789,0,0,1,8.629,8.735H8.616a3.807,3.807,0,0,1-2.7-1.516A4.628,4.628,0,0,1,4.6,4.5,4.319,4.319,0,0,1,5.78,1.071,4.123,4.123,0,0,1,8.611,0,4.119,4.119,0,0,1,11.442,1.071Zm-.32,3.281a2.824,2.824,0,0,0-.717-2.183,2.618,2.618,0,0,0-1.794-.659,2.62,2.62,0,0,0-1.8.659A2.829,2.829,0,0,0,6.1,4.351,3.141,3.141,0,0,0,7.029,6.2c.5.543,1,1.029,1.587,1.029.634,0,1.178-.595,1.576-1.027A3.162,3.162,0,0,0,11.122,4.351Zm-.681,11.09a.755.755,0,0,1,0,1.509H.614A.653.653,0,0,1,.1,16.689a.6.6,0,0,1-.1-.356A8.555,8.555,0,0,1,5.7,9.182a.492.492,0,0,1,.162-.028.464.464,0,0,1,.257.079,4.519,4.519,0,0,0,2.42.76h.075a3.777,3.777,0,0,0,.459-.028.752.752,0,0,1,.216,1.489,5.858,5.858,0,0,1-.675.048h-.1a5.972,5.972,0,0,1-2.752-.725A7.019,7.019,0,0,0,1.7,15.442Z"
          transform="translate(-11995 -1458.001)"
          fill="currentcolor"
          fillRule="evenodd"
        />
        <path
          d="M21.671,13.857l-.315.578a2.226,2.226,0,0,0-2.921,1.745h0l-.8-.012a2.208,2.208,0,0,0-2.847-1.75l-.327-.594A2.208,2.208,0,0,0,14.4,10.5l.38-.661a2.193,2.193,0,0,0,.706.125,2.234,2.234,0,0,0,2.186-1.777l.733,0A2.233,2.233,0,0,0,20.6,9.963a2.2,2.2,0,0,0,.752-.139l.37.645a2.206,2.206,0,0,0-.048,3.387m1.723-.471a.873.873,0,0,1-.075.637l-.881,1.587a.824.824,0,0,1-.167.215.872.872,0,0,1-.46.217.853.853,0,0,1-.282-.009l-.7-.184a.126.126,0,0,0-.07.009l-.154.092-.688.432-.037.06-.129.552a.826.826,0,0,1-.253.472.87.87,0,0,1-.59.233l-1.824-.032a.846.846,0,0,1-.674-.351.813.813,0,0,1-.125-.255l-.165-.7a.129.129,0,0,0-.04-.056l-.464-.315-.213-.11h0l-.072,0-.542.166a1,1,0,0,1-.537.019.869.869,0,0,1-.5-.4l-.884-1.583a.834.834,0,0,1-.093-.257.844.844,0,0,1,.214-.739l.525-.5a.136.136,0,0,0,.028-.064l0-.076L13.5,11.7l-.035-.062-.419-.381a.828.828,0,0,1-.289-.453.862.862,0,0,1,.09-.638L13.76,8.6a.849.849,0,0,1,.923-.4l.688.2a.133.133,0,0,0,.069-.009l.5-.251.2-.135.037-.061.119-.555a.828.828,0,0,1,.246-.478.863.863,0,0,1,.6-.242h1.815a.839.839,0,0,1,.265.042.852.852,0,0,1,.543.55l.176.7a.117.117,0,0,0,.042.056l.3.2.462.2.539-.194a.951.951,0,0,1,.538-.033.866.866,0,0,1,.511.384l.93,1.561a.811.811,0,0,1,.1.253.845.845,0,0,1-.2.748l-.507.506a.141.141,0,0,0-.026.064C23.16,12.983,23.325,13.132,23.394,13.386Zm-5.315-2.416a1.144,1.144,0,1,0,1.144,1.144A1.144,1.144,0,0,0,18.079,10.971Z"
          transform="translate(-11996.428 -1457.86)"
          fill="#db0011"
          fillRule="evenodd"
        />
      </g>
    </symbol>
    <symbol id="icn-trash-box" viewBox="0 0 10.112 12.641" fill="currentcolor">
      <g transform="translate(-2.528 -1.264)">
        <path
          d="M13.446,3.9l-.531,9.551h0a1.264,1.264,0,0,1-1.262,1.194H6.46A1.264,1.264,0,0,1,5.2,13.447L4.667,3.9H4.316a.316.316,0,1,1,0-.632H13.8a.316.316,0,1,1,0,.632Zm-8.181,0,.489,9.394a.758.758,0,0,0,.757.719H11.6a.758.758,0,0,0,.757-.719h0L12.849,3.9ZM8.108,2H10a.948.948,0,0,1,.948.948v.316H7.16V2.948h0A.948.948,0,0,1,8.108,2Zm0,.632a.316.316,0,0,0-.316.316v.316H10.32V2.948A.316.316,0,0,0,10,2.632Z"
          transform="translate(-1.472 -0.736)"
          fillRule="evenodd"
        />
        <path
          d="M0,0V7.689"
          transform="translate(9.229 4.466) rotate(3)"
          fill="none"
          stroke="#db0011"
          strokeWidth="0.5"
        />
        <path
          d="M0,0V7.689"
          transform="matrix(0.996, -0.087, 0.087, 0.996, 5.753, 4.476)"
          fill="none"
          stroke="#db0011"
          strokeWidth="0.5"
        />
      </g>
    </symbol>
    <symbol
      id="icn-new-profile"
      viewBox="0 0 17.906 16.852"
      fill="currentcolor"
    >
      <g transform="translate(-804 -433)">
        <g
          transform="translate(808.213 433)"
          fill="#fff"
          stroke="#242424"
          strokeWidth="0.8"
        >
          <rect width="13.693" height="12.639" rx="2" stroke="none" />
          <rect
            x="0.4"
            y="0.4"
            width="12.893"
            height="11.839"
            rx="1.6"
            fill="none"
          />
        </g>
        <g
          transform="translate(804 437.213)"
          fill="#fff"
          stroke="#242424"
          strokeWidth="0.8"
        >
          <rect width="13.693" height="12.639" rx="2" stroke="none" />
          <rect
            x="0.4"
            y="0.4"
            width="12.893"
            height="11.839"
            rx="1.6"
            fill="none"
          />
        </g>
        <path
          d="M5558.243,717.741v5.383"
          transform="translate(-4747.667 -276.588)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          d="M0,0V5.383"
          transform="translate(813.267 443.845) rotate(90)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
    </symbol>
    <symbol id="icn-rights" viewBox="0 0 18.581 17" fill="currentcolor">
      <path
        d="M21.581,9.372A2.372,2.372,0,0,0,19.209,7H5.372A2.372,2.372,0,0,0,3,9.372V21.628A2.372,2.372,0,0,0,5.372,24H19.209a2.372,2.372,0,0,0,2.372-2.372ZM5.372,7.791H19.209a1.581,1.581,0,0,1,1.581,1.581v.3h-17v-.3A1.581,1.581,0,0,1,5.372,7.791ZM19.209,23.209H5.372a1.581,1.581,0,0,1-1.581-1.581V10.459h17V21.628A1.581,1.581,0,0,1,19.209,23.209Z"
        transform="translate(-3 -7)"
        fill="currentcolor"
      />
      <path
        d="M54.424,35.5h-5.14a1.285,1.285,0,1,0,0,2.57h5.14a1.285,1.285,0,0,0,0-2.57Zm0,1.779h-5.14a.494.494,0,0,1,0-.988h5.14a.494.494,0,0,1,0,.988Z"
        transform="translate(-39.105 -29.866)"
        fill="currentcolor"
      />
      <path
        d="M20.253,33.225l-2.1,2.319L17,34.753a.4.4,0,0,0-.445.652l1.433.977a.4.4,0,0,0,.506-.051l2.331-2.57a.4.4,0,1,0-.593-.53Z"
        transform="translate(-13.755 -27.94)"
        fill="#db0011"
      />
      <path
        d="M20.253,33.225l-2.1,2.319L17,34.753a.4.4,0,0,0-.445.652l1.433.977a.4.4,0,0,0,.506-.051l2.331-2.57a.4.4,0,1,0-.593-.53Z"
        transform="translate(-13.755 -22.852)"
        fill="#db0011"
      />
      <path
        d="M54.424,63.5h-5.14a1.285,1.285,0,1,0,0,2.57h5.14a1.285,1.285,0,0,0,0-2.57Zm0,1.779h-5.14a.494.494,0,0,1,0-.988h5.14a.494.494,0,0,1,0,.988Z"
        transform="translate(-39.105 -52.331)"
        fill="currentcolor"
      />
    </symbol>
    <symbol id="icn-eye-border" viewBox="0 0 15.07 15.07" fill="currentcolor">
      <g transform="translate(0 0)">
        <path
          d="M7.651,11.535A6.216,6.216,0,0,1,2.044,7.967a.471.471,0,0,1,0-.4,6.19,6.19,0,0,1,11.214,0,.471.471,0,0,1,0,.4,6.216,6.216,0,0,1-5.607,3.568ZM3,7.767a5.247,5.247,0,0,0,9.31,0,5.247,5.247,0,0,0-9.31,0Z"
          transform="translate(-0.116 -0.233)"
          fill="#db0011"
        />
        <path
          d="M7.884,9.767A1.884,1.884,0,1,1,9.767,7.884,1.884,1.884,0,0,1,7.884,9.767Zm0-2.826a.942.942,0,1,0,.942.942A.942.942,0,0,0,7.884,6.942Z"
          transform="translate(-0.349 -0.349)"
          fill="#db0011"
        />
        <path
          d="M.471,5.651A.471.471,0,0,1,0,5.18V.471A.471.471,0,0,1,.471,0H5.18a.471.471,0,0,1,0,.942H.942V5.18a.471.471,0,0,1-.471.471Z"
          transform="translate(0 0)"
          fill="currentcolor"
        />
        <path
          d="M15.18,5.651a.471.471,0,0,1-.471-.471V.942H10.471a.471.471,0,1,1,0-.942H15.18a.471.471,0,0,1,.471.471V5.18A.471.471,0,0,1,15.18,5.651Z"
          transform="translate(-0.581 0)"
          fill="currentcolor"
        />
        <path
          d="M5.18,15.651H.471A.471.471,0,0,1,0,15.18V10.471a.471.471,0,1,1,.942,0v4.238H5.18a.471.471,0,1,1,0,.942Z"
          transform="translate(0 -0.581)"
          fill="currentcolor"
        />
        <path
          d="M15.18,15.651H10.471a.471.471,0,1,1,0-.942h4.238V10.471a.471.471,0,1,1,.942,0V15.18A.471.471,0,0,1,15.18,15.651Z"
          transform="translate(-0.581 -0.581)"
          fill="currentcolor"
        />
      </g>
    </symbol>
    <symbol id="icn-minus" viewBox="0 0 14.46.21" fill="currentcolor">
      <g transform="translate(-1533.609 -528.769)">
        <path
          d="M10963.109-879.5h13.462"
          transform="translate(-9429 1408.769)"
          fill="none"
          stroke="currentcolor"
          strokeLinecap="round"
          strokeWidth="2"
        />
      </g>
    </symbol>
    <symbol id="icn-pluse" viewBox="0 0 14.462 14.462" fill="currentcolor">
      <g transform="translate(-1533.609 -522.038)">
        <path
          d="M10963.109-879.5h13.462"
          transform="translate(-9429 1408.769)"
          fill="none"
          stroke="currentcolor"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          d="M0,0H13.462"
          transform="translate(1540.84 522.538) rotate(90)"
          fill="none"
          stroke="currentcolor"
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
    </symbol>
    <symbol id="icn-scrolltop" viewBox="0 0 12.519 7.042" fill="currentcolor">
      <g transform="translate(-790.166 -430.66)">
        <g transform="translate(790.166 437.702) rotate(-90)">
          <path
            d="M.255,1.438.233,6.159l.022,4.9a.845.845,0,0,0,0,1.205.82.82,0,0,0,1.19,0L6.789,6.851a.845.845,0,0,0,0-1.205L1.423.256a.82.82,0,0,0-1.19,0A.838.838,0,0,0,.255,1.438Z"
            transform="translate(0)"
            fill="currentcolor"
          />
        </g>
      </g>
    </symbol>
    <symbol id="logout" viewBox="0 0 23.07 20.58" fill="currentcolor">
      <path
        className="cls-1"
        d="M-15,14a9.05,9.05,0,0,1-8.17,4.75,9.39,9.39,0,0,1-9.39-9.39A9.39,9.39,0,0,1-23.2,0,9.75,9.75,0,0,1-15,4.72"
        transform="translate(33.49 0.9)"
        fill="none"
        stroke="currentcolor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8px"
      />
      <path
        className="cls-2"
        d="M-10.66,8.93l-2.07-1.46a.57.57,0,0,0-.79.14.6.6,0,0,0-.1.32v.89h-10a.57.57,0,0,0-.56.57.57.57,0,0,0,.56.57h10v.89a.57.57,0,0,0,.57.57.52.52,0,0,0,.32-.11l2.07-1.46a.56.56,0,0,0,.14-.79A.44.44,0,0,0-10.66,8.93Z"
        transform="translate(33.49 0.9)"
        fill="currentcolor"
      />
    </symbol>

    <symbol id="icn-step" viewBox="0 0 16 16" fill="currentcolor">
      <g transform="translate(-458 -240)">
        <g
          transform="translate(458 240)"
          fill="#fff"
          stroke="currentcolor"
          strokeWidth="1"
        >
          <circle cx="8" cy="8" r="8" stroke="none" />
          <circle cx="8" cy="8" r="7.5" fill="none" />
        </g>
        <circle
          cx="5"
          cy="5"
          r="5"
          transform="translate(461 243)"
          fill="currentcolor"
        />
      </g>
    </symbol>
    <symbol id="icn-cog" width="17.729" height="17.714">
      <path
        d="M9.85 17.714H7.874a1.352 1.352 0 0 1-1.352-1.349v-.875a10.23 10.23 0 0 1-.7-.282l-.631.611a1.355 1.355 0 0 1-1.912 0l-1.403-1.408a1.349 1.349 0 0 1 0-1.912l.617-.617a6.418 6.418 0 0 1-.282-.7H1.35A1.352 1.352 0 0 1 0 9.834V7.863a1.352 1.352 0 0 1 1.35-1.352h.876c.084-.237.18-.468.282-.7l-.611-.62a1.349 1.349 0 0 1 0-1.912l1.407-1.403a1.349 1.349 0 0 1 1.912 0l.617.617a6.418 6.418 0 0 1 .7-.282V1.35A1.352 1.352 0 0 1 7.869 0H9.84a1.352 1.352 0 0 1 1.352 1.35v.876c.237.084.468.18.7.282l.631-.611a1.355 1.355 0 0 1 1.912 0l1.408 1.408a1.349 1.349 0 0 1 0 1.912l-.617.617a6.418 6.418 0 0 1 .282.7h.876a1.352 1.352 0 0 1 1.345 1.346v1.97a1.352 1.352 0 0 1-1.349 1.352h-.89c-.084.237-.18.468-.282.7l.611.62a1.352 1.352 0 0 1 0 1.909l-1.408 1.408a1.352 1.352 0 0 1-1.909 0l-.62-.617a6.418 6.418 0 0 1-.7.282v.876a1.355 1.355 0 0 1-1.332 1.334zm-4.122-3.607a.5.5 0 0 1 .234.059 6.058 6.058 0 0 0 1.186.493.493.493 0 0 1 .355.473v1.234a.366.366 0 0 0 .366.377H9.84a.366.366 0 0 0 .366-.363v-1.248a.493.493 0 0 1 .352-.473 6.01 6.01 0 0 0 1.188-.493.49.49 0 0 1 .583.084l.873.873a.369.369 0 0 0 .518 0l1.408-1.408a.369.369 0 0 0 0-.518l-.873-.873a.49.49 0 0 1-.084-.583 6.058 6.058 0 0 0 .493-1.186.493.493 0 0 1 .473-.355h1.234a.366.366 0 0 0 .372-.355V7.874a.366.366 0 0 0-.363-.366h-1.248a.493.493 0 0 1-.473-.355 6.058 6.058 0 0 0-.493-1.186.49.49 0 0 1 .084-.583l.873-.873a.363.363 0 0 0 0-.515l-1.408-1.408a.372.372 0 0 0-.518 0l-.873.873a.49.49 0 0 1-.583.084 6.128 6.128 0 0 0-1.186-.495.49.49 0 0 1-.355-.473V1.35a.366.366 0 0 0-.366-.363H7.863a.366.366 0 0 0-.366.363v1.233a.49.49 0 0 1-.355.473 6.128 6.128 0 0 0-1.186.494.49.49 0 0 1-.583-.084L4.5 2.591a.363.363 0 0 0-.515 0L2.577 3.999a.363.363 0 0 0 0 .515l.873.874a.49.49 0 0 1 .084.583 6.128 6.128 0 0 0-.493 1.186.493.493 0 0 1-.473.355H1.35a.366.366 0 0 0-.363.366V9.85a.366.366 0 0 0 .363.366h1.233a.493.493 0 0 1 .473.355 6.058 6.058 0 0 0 .494 1.184.49.49 0 0 1-.084.583l-.873.873a.372.372 0 0 0-.107.259.377.377 0 0 0 .107.259l1.408 1.408a.363.363 0 0 0 .515 0l.873-.873a.482.482 0 0 1 .339-.157z"
        fill="#242424"
      />
      <g
        transform="translate(4.642 4.715)"
        fill="none"
        stroke="#000"
        strokeWidth=".5"
      >
        <circle cx="4.281" cy="4.281" r="4.281" stroke="none" />
        <circle cx="4.281" cy="4.281" r="4.031" />
      </g>
    </symbol>
    <symbol id="icn-credits" viewBox="0 0 26.184 25.018">
      <g transform="translate(-14766.604 -600.244)">
        <g
          transform="matrix(0.799, 0.602, -0.602, 0.799, 14775.821, 600.245)"
          fill="none"
          stroke="currentcolor"
          strokeWidth="0.8"
        >
          <rect width="21.244" height="15.316" rx="2" stroke="none" />
          <rect
            x="0.4"
            y="0.4"
            width="20.444"
            height="14.516"
            rx="1.6"
            fill="none"
          />
        </g>
        <g transform="matrix(0.799, 0.602, -0.602, 0.799, 14774.246, 606.571)">
          <g transform="translate(0 1.001)">
            <rect
              width="11.574"
              height="0.19"
              rx="0.095"
              transform="translate(0)"
              fill="#db0000"
            />
            <rect
              width="7.214"
              height="0.19"
              rx="0.095"
              transform="translate(0 2.384)"
              fill="#db0000"
            />
            <circle
              cx="1"
              cy="1"
              r="1"
              transform="matrix(0.799, -0.602, 0.602, 0.799, 13.892, 4.251)"
              fill="#db0011"
            />
            <circle
              cx="1"
              cy="1"
              r="1"
              transform="matrix(0.799, -0.602, 0.602, 0.799, 12.492, 4.055)"
              fill="#db0011"
            />
          </g>
        </g>
        <line
          x2="20.997"
          transform="matrix(0.799, 0.602, -0.602, 0.799, 14773.47, 603.575)"
          fill="none"
          stroke="currentcolor"
          strokeWidth="0.8"
        />
      </g>
    </symbol>
    <symbol id="icn-loans" viewBox="0 0 26.356 13.285">
      <g transform="translate(-14240.646 -562.553)">
        <path
          d="M14249.552,567.952l-6.258,4.259h18.08l6.661-4.114Z"
          transform="translate(-2.01 -5)"
          fill="none"
          stroke="currentcolor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.8"
        />
        <path
          d="M14243.053,574.163l18.484.37,6.791-4.333"
          transform="translate(-2 -5.094)"
          fill="none"
          stroke="currentcolor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.8"
        />
        <path
          d="M14243.046,574.63l18.554.162,6.89-4.418"
          transform="translate(-1.999 -3.184)"
          fill="none"
          stroke="currentcolor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.8"
        />
        <path
          d="M14243.053,574.147l18.6.256,6.951-4.577"
          transform="translate(-2 -0.286)"
          fill="none"
          stroke="currentcolor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.8"
        />
        <path
          d="M14261.561,567.123l-5.527,4.193.109,8.157h-8.285l.109-8.4,5.327-4.025Z"
          transform="translate(-2.199 -4.035)"
          fill="#fff"
          stroke="currentcolor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.8"
        />

        <text
          id="_"
          data-name="₾"
          transform="translate(14248 572.457)"
          fontSize="5"
          fontWeight="700"
          fill="#db0011"
        >
          <tspan x="0" y="0">
            ₾
          </tspan>
        </text>
      </g>
    </symbol>
    <symbol id="icn-deposit" viewBox="0 0 20.669 21.529">
      <g transform="translate(-15142.138 -598.717)">
        <g
          transform="translate(15142.138 600.439)"
          fill="none"
          stroke="currentcolor"
          strokeWidth="0.8"
        >
          <rect width="18.086" height="17.225" rx="2" stroke="none" />
          <rect
            x="0.4"
            y="0.4"
            width="17.286"
            height="16.425"
            rx="1.6"
            fill="none"
          />
        </g>
        <path
          d="M15169.974,567.965h17.371"
          transform="translate(-27.487 36.75)"
          fill="none"
          stroke="currentcolor"
          strokeWidth="0.5"
        />
        <g
          transform="translate(15146.444 598.716)"
          fill="none"
          stroke="currentcolor"
          strokeWidth="0.8"
        >
          <rect width="2.584" height="4.306" rx="1.292" stroke="none" />
          <rect
            x="0.4"
            y="0.4"
            width="1.784"
            height="3.506"
            rx="0.892"
            fill="none"
          />
        </g>
        <g
          transform="translate(15153.333 598.716)"
          fill="none"
          stroke="currentcolor"
          strokeWidth="0.8"
        >
          <rect width="2.584" height="4.306" rx="1.292" stroke="none" />
          <rect
            x="0.4"
            y="0.4"
            width="1.784"
            height="3.506"
            rx="0.892"
            fill="none"
          />
        </g>
        <g transform="translate(15152.472 609.912)" fill="#fff">
          <path
            d="M 5.167320251464844 9.934863090515137 C 2.538610219955444 9.934863090515137 0.4000002443790436 7.796203136444092 0.4000002443790436 5.167433261871338 C 0.4000002443790436 2.538663148880005 2.538610219955444 0.4000032544136047 5.167320251464844 0.4000032544136047 C 7.796030044555664 0.4000032544136047 9.934639930725098 2.538663148880005 9.934639930725098 5.167433261871338 C 9.934639930725098 7.796203136444092 7.796030044555664 9.934863090515137 5.167320251464844 9.934863090515137 Z"
            stroke="none"
          />
          <path
            d="M 5.167320251464844 0.8000030517578125 C 2.759170055389404 0.8000030517578125 0.8000001907348633 2.759223461151123 0.8000001907348633 5.167433261871338 C 0.8000001907348633 7.575643539428711 2.759170055389404 9.534863471984863 5.167320251464844 9.534863471984863 C 7.575469970703125 9.534863471984863 9.534640312194824 7.575643539428711 9.534640312194824 5.167433261871338 C 9.534640312194824 2.759223461151123 7.575469970703125 0.8000030517578125 5.167320251464844 0.8000030517578125 M 5.167320251464844 2.86102294921875e-06 C 8.021150588989258 2.86102294921875e-06 10.33464050292969 2.313543319702148 10.33464050292969 5.167433261871338 C 10.33464050292969 8.021323204040527 8.021150588989258 10.33486366271973 5.167320251464844 10.33486366271973 C 2.31348991394043 10.33486366271973 0 8.021323204040527 0 5.167433261871338 C 0 2.313543319702148 2.31348991394043 2.86102294921875e-06 5.167320251464844 2.86102294921875e-06 Z"
            stroke="none"
            fill="currentcolor"
          />
        </g>
        <path
          d="M-7605.769,520.391a.844.844,0,0,0-.6.248.839.839,0,0,0-.248.626.876.876,0,0,0,.256.618.875.875,0,0,0,.619.256.874.874,0,0,0,.875-.874.874.874,0,0,0-.875-.874h-.029Zm.307-2.115h0l-3.035,3.035a.217.217,0,0,0-.067.18.124.124,0,0,0,.067.1.219.219,0,0,0,.161.068.22.22,0,0,0,.161-.068l3.037-3.035a.225.225,0,0,0,.068-.161.226.226,0,0,0-.069-.161.287.287,0,0,0-.128-.031.283.283,0,0,0-.193.077Zm-2.666-.276a.872.872,0,0,0-.617.256.872.872,0,0,0-.256.618.872.872,0,0,0,.256.618.872.872,0,0,0,.617.256.872.872,0,0,0,.618-.256.872.872,0,0,0,.256-.618.87.87,0,0,0-.257-.619.873.873,0,0,0-.62-.255Zm2.392,3.681a.409.409,0,0,1-.292-.118.409.409,0,0,1-.121-.291.409.409,0,0,1,.408-.409.368.368,0,0,1,.071-.007.375.375,0,0,1,.261.137.373.373,0,0,1,.082.284.413.413,0,0,1-.414.414Zm-2.39-2.391h0a.409.409,0,0,1-.409-.409.409.409,0,0,1,.409-.409.415.415,0,0,1,.41.409.407.407,0,0,1-.122.293.409.409,0,0,1-.29.121Z"
          transform="translate(22764.508 95.288)"
          fill="#db0000"
        />
        <path
          d="M15145.4,527h1.022"
          transform="translate(0.031 80.186)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="0.5"
        />
        <path
          d="M15145.4,527h1.022"
          transform="translate(0.031 83.254)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="0.5"
        />
        <path
          d="M15145.4,527h1.022"
          transform="translate(0.031 86.321)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="0.5"
        />
        <path
          d="M15145.4,527h1.022"
          transform="translate(4.164 80.186)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="0.5"
        />
        <path
          d="M15145.4,527h1.022"
          transform="translate(4.164 83.254)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="0.5"
        />
        <path
          d="M15145.4,527h1.022"
          transform="translate(8.254 80.186)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="0.5"
        />
      </g>
    </symbol>

    <symbol id="icn-unblock" viewBox="0 0 34 33">
      <g transform="translate(-2959 -2422)">
        <path
          d="M2914.063,2428.717h32.028"
          transform="translate(45.886 -1)"
          fill="none"
          stroke="#db0011"
          strokeWidth="1"
        />
        <path
          d="M2914.063,2428.717h7.183"
          transform="translate(47.886 7)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <g
          transform="translate(2959 2422)"
          fill="none"
          stroke="#242424"
          strokeWidth="1"
        >
          <rect width="34" height="21" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="33" height="20" rx="1.5" fill="none" />
        </g>
        <g
          transform="translate(2970 2433)"
          fill="#fff"
          stroke="#242424"
          strokeWidth="1"
        >
          <circle cx="11" cy="11" r="11" stroke="none" />
          <circle cx="11" cy="11" r="10.5" fill="none" />
        </g>
        <path
          d="M-2949.7-2417.855h-7.96a.924.924,0,0,1-.923-.923v-6.69a.923.923,0,0,1,.923-.921h.061v-1a3.878,3.878,0,0,1,1.122-2.77,3.883,3.883,0,0,1,2.753-1.165h.03a3.9,3.9,0,0,1,2.524.926l-.344.543a3.287,3.287,0,0,0-2.18-.826,3.27,3.27,0,0,0-2.328.964,3.267,3.267,0,0,0-.964,2.327v1.005h5.779l0,.008h1.633a.925.925,0,0,1,.793.913v6.69A.923.923,0,0,1-2949.7-2417.855Zm-7.96-7.919a.308.308,0,0,0-.308.307v6.69a.308.308,0,0,0,.308.308h7.96a.308.308,0,0,0,.307-.308v-6.69a.307.307,0,0,0-.307-.307Z"
          transform="translate(5934.579 4867.603)"
          fill="#242424"
        />
        <path
          d="M43.324,59.85a1.487,1.487,0,1,0,1.491,1.482A1.487,1.487,0,0,0,43.324,59.85Zm0,2.249a.762.762,0,1,1,.542-.224A.76.76,0,0,1,43.324,62.1Z"
          transform="translate(2937.487 2384.15)"
          fill="#db0011"
        />
      </g>
    </symbol>
    <symbol id="icn-block" viewBox="0 0 34 33">
      <g transform="translate(-2913 -2423)">
        <path
          d="M2914.063,2428.717h32.028"
          transform="translate(-0.114)"
          fill="none"
          stroke="#db0011"
          strokeWidth="1"
        />
        <path
          d="M2914.063,2428.717h7.183"
          transform="translate(1.886 8)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <g
          transform="translate(2913 2423)"
          fill="none"
          stroke="#242424"
          strokeWidth="1"
        >
          <rect width="34" height="21" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="33" height="20" rx="1.5" fill="none" />
        </g>
        <g
          transform="translate(2924 2434)"
          fill="#fff"
          stroke="#242424"
          strokeWidth="1"
        >
          <circle cx="11" cy="11" r="11" stroke="none" />
          <circle cx="11" cy="11" r="10.5" fill="none" />
        </g>
        <path
          d="M27.395,11.242h-.077V10.129H27.3a4.086,4.086,0,0,0-8.172.063v1.05h-.064a.965.965,0,0,0-.965.965v7a.965.965,0,0,0,.965.965h8.33a.965.965,0,0,0,.965-.965v-7A.965.965,0,0,0,27.395,11.242Zm-7.622-1.05a3.444,3.444,0,1,1,6.888,0,.322.322,0,0,0,.012.087v.965h-6.9Zm7.944,9.015a.322.322,0,0,1-.322.322h-8.33a.322.322,0,0,1-.322-.322v-7a.322.322,0,0,1,.322-.322h8.33a.322.322,0,0,1,.322.322Z"
          transform="translate(2911.9 2431.263)"
          fill="#242424"
        />
        <path
          d="M43.242,59.85a1.4,1.4,0,1,0,1.408,1.4A1.4,1.4,0,0,0,43.242,59.85Zm0,2.125a.72.72,0,1,1,.512-.212A.718.718,0,0,1,43.242,61.975Z"
          transform="translate(2891.929 2385.553)"
          fill="#db0011"
        />
      </g>
    </symbol>
    <symbol id="business-card" viewBox="0 0 23.808 24">
      <path
        id="Path_1086"
        data-name="Path 1086"
        d="M9.957,18.49H5.2a.6.6,0,1,1,0-1.19H9.957a.6.6,0,1,1,0,1.19Z"
        transform="translate(-1.862 -5.938)"
        fill="#db0011"
      />
      <path
        id="Path_1087"
        data-name="Path 1087"
        d="M23.807,2.316A2.086,2.086,0,0,0,21.724.2H2.083A2.086,2.086,0,0,0,0,2.316V13.862a2.126,2.126,0,0,0,2.083,2.116H8.333v.363a7.738,7.738,0,1,0,15.475,0,7.617,7.617,0,0,0-.179-1.632,1.956,1.956,0,0,0,.179-.846ZM16.07,22.93a6.58,6.58,0,0,1-6.547-6.65v-.363A3.954,3.954,0,0,1,9.7,14.709a6.533,6.533,0,0,1,12.677-.242,9.517,9.517,0,0,1,.238,1.27v.544A6.58,6.58,0,0,1,16.07,22.93Zm6.547-10.821A7.672,7.672,0,0,0,16.07,8.422a7.823,7.823,0,0,0-7.618,6.287H2.083A.923.923,0,0,1,1.19,13.8V5.7H22.617Zm0-7.617H1.19V2.316a.883.883,0,0,1,.893-.907H21.665a.923.923,0,0,1,.893.907V4.492Z"
        transform="translate(0 -0.2)"
        fill="#242424"
      />
      <g id="renew" transform="translate(11 11)">
        <path
          id="Path_7324"
          data-name="Path 7324"
          d="M6.456,5.14h-1.6a3.378,3.378,0,0,1,6.209,1.842h.614A3.992,3.992,0,0,0,4.614,4.427V3.3H4V5.754H6.456Z"
          transform="translate(-2.685 -1.982)"
          fill="#242424"
          stroke="#242424"
          strokeWidth="0.4"
        />
        <path
          id="Path_7325"
          data-name="Path 7325"
          d="M8.22,17.842h1.6A3.378,3.378,0,0,1,3.614,16H3a3.992,3.992,0,0,0,7.062,2.555v1.13h.614V17.228H8.22Z"
          transform="translate(-1.992 -11)"
          fill="#db0011"
          stroke="#db0011"
          strokeWidth="0.4"
        />
        <g
          id="_Transparent_Rectangle_"
          data-name="&lt;Transparent Rectangle&gt;"
          transform="translate(0 0)"
        >
          <rect
            id="Rectangle_1581"
            data-name="Rectangle 1581"
            width="10"
            height="10"
            fill="none"
          />
        </g>
      </g>
    </symbol>
    <symbol id="icn-info" viewBox="0 0 13 13">
      <g transform="translate(-11492 1029)">
        <g transform="translate(10870 -1282)">
          <g
            transform="translate(622 253)"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
          >
            <circle cx="6.5" cy="6.5" r="6.5" stroke="none" />
            <circle cx="6.5" cy="6.5" r="6" fill="none" />
          </g>
        </g>
        <path
          d="M1705.566,128.849V131.9"
          transform="translate(9792.934 -1154.192)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          d="M1705.566,142.5h0"
          transform="translate(9792.934 -1162.107)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
    </symbol>
    <symbol id="icn-info-new" viewBox="0 0 20 20">
      <g id="information" transform="translate(0.268)">
        <path
          id="Path_5950"
          data-name="Path 5950"
          d="M15.133,19.013V14H12.627v1.253H13.88v3.76H12v1.253h5.013V19.013Z"
          transform="translate(-4.481 -5.279)"
          fill="currentColor"
        />
        <path
          id="Path_5951"
          data-name="Path 5951"
          d="M15.44,8a.94.94,0,1,0,.94.94A.94.94,0,0,0,15.44,8Z"
          transform="translate(-5.414 -3.039)"
          fill="currentColor"
        />
        <path
          id="Path_5952"
          data-name="Path 5952"
          d="M10.773,19.545a8.773,8.773,0,1,1,8.773-8.773,8.773,8.773,0,0,1-8.773,8.773Zm0-16.292a7.519,7.519,0,1,0,7.519,7.519A7.519,7.519,0,0,0,10.773,3.253Z"
          transform="translate(-0.747 -0.799)"
          fill="currentColor"
        />
        <rect
          id="_Transparent_Rectangle_"
          data-name="&lt;Transparent Rectangle&gt;"
          width="20"
          height="20"
          transform="translate(-0.268)"
          fill="none"
        />
      </g>
    </symbol>
    <symbol id="icn-info-newbg" viewBox="0 0 24 24">
      <title>Organization / Status / information--filled / 24@2x</title>
      <g
        id="Icons"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Organization-/-Status-/-information--filled-/-24">
          <rect
            fill="#000"
            opacity="0"
            x="0"
            y="0"
            width="24"
            height="24"
          ></rect>
          <path
            d="M12,1.5 C6.20101013,1.5 1.5,6.20101013 1.5,12 C1.5,17.7989899 6.20101013,22.5 12,22.5 C17.7989899,22.5 22.5,17.7989899 22.5,12 C22.5,9.21522686 21.3937532,6.54451077 19.4246212,4.5753788 C17.4554892,2.60624682 14.7847731,1.5 12,1.5 Z M12,6 C12.6213203,6 13.125,6.50367966 13.125,7.125 C13.125,7.74632034 12.6213203,8.25 12,8.25 C11.3786797,8.25 10.875,7.74632034 10.875,7.125 C10.875,6.50367966 11.3786797,6 12,6 Z M15,18.09375 L9,18.09375 L9,16.40625 L11.15625,16.40625 L11.15625,12.09375 L9.75,12.09375 L9.75,10.40625 L12.84375,10.40625 L12.84375,16.40625 L15,16.40625 L15,18.09375 Z"
            id="Fill"
            fill="#fff"
          ></path>
        </g>
      </g>
    </symbol>
    <symbol id="icn-info-fiiled" viewBox="0 0 24 24">
      <g
        id="Icons"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Organization-/-Status-/-information--filled-/-24">
          <rect
            fill="currentColor"
            opacity="0"
            x="0"
            y="0"
            width="24"
            height="24"
          ></rect>
          <path
            d="M12,1.5 C6.20101013,1.5 1.5,6.20101013 1.5,12 C1.5,17.7989899 6.20101013,22.5 12,22.5 C17.7989899,22.5 22.5,17.7989899 22.5,12 C22.5,9.21522686 21.3937532,6.54451077 19.4246212,4.5753788 C17.4554892,2.60624682 14.7847731,1.5 12,1.5 Z M12,6 C12.6213203,6 13.125,6.50367966 13.125,7.125 C13.125,7.74632034 12.6213203,8.25 12,8.25 C11.3786797,8.25 10.875,7.74632034 10.875,7.125 C10.875,6.50367966 11.3786797,6 12,6 Z M15,18.09375 L9,18.09375 L9,16.40625 L11.15625,16.40625 L11.15625,12.09375 L9.75,12.09375 L9.75,10.40625 L12.84375,10.40625 L12.84375,16.40625 L15,16.40625 L15,18.09375 Z"
            id="Fill"
            fill="currentColor"
          ></path>
        </g>
      </g>
    </symbol>
    <symbol id="icn-percent" viewBox="0 0 40.07 40.07">
      <g transform="translate(-1751 2161.07)">
        <circle
          cx="20.035"
          cy="20.035"
          r="20.035"
          transform="translate(1751 -2161.07)"
          fill="#242424"
        />
        <path
          d="M1776.184-2146.211l-10.49,10.49"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <circle
          cx="2.5"
          cy="2.5"
          r="2.5"
          transform="translate(1764 -2148)"
          fill="#fff"
        />
        <circle
          cx="2.5"
          cy="2.5"
          r="2.5"
          transform="translate(1774 -2139)"
          fill="#fff"
        />
      </g>
    </symbol>
    <symbol id="icn-lari" viewBox="0 0 39.339 39.339">
      <g transform="translate(-1874 2160.339)">
        <circle
          cx="19.67"
          cy="19.67"
          r="19.67"
          transform="translate(1874 -2160.339)"
          fill="#db0011"
        />
        <path
          d="M1.18,0H14.54V-1.36H8.04A5.8,5.8,0,0,1,2.2-7.12,5.712,5.712,0,0,1,5.94-12.5V-7h1.2v-5.82a6.8,6.8,0,0,1,.9-.06,6.8,6.8,0,0,1,.9.06V-7h1.2v-5.5A5.824,5.824,0,0,1,13.88-7h1.4a7.189,7.189,0,0,0-5.14-6.94V-16H8.94v1.82a6.8,6.8,0,0,0-.9-.06,6.8,6.8,0,0,0-.9.06V-16H5.94v2.06A7.157,7.157,0,0,0,.8-7.12,6.461,6.461,0,0,0,4.16-1.3H1.18Z"
          transform="translate(1885.5 -2134.5)"
          fill="#fff"
        />
      </g>
    </symbol>
    <symbol id="icn-lowlevel" viewBox="0 0 41.546 50.931">
      <g transform="translate(-798.21 -408.843)">
        <path
          d="M29.919,26.05V22.772a3.872,3.872,0,1,0-7.744,0v3.441c-.616.792,3.464-1.8,3.9-1.8l.051.007C26.52,24.411,30.535,26.93,29.919,26.05Zm-4.061-2.4a20.943,20.943,0,0,0-2.287.44V22.86a2.631,2.631,0,0,1,2.477-2.271,2.456,2.456,0,0,1,2.3,2.271v1.232a7.159,7.159,0,0,0-2.49-.44Z"
          transform="translate(800.731 408.426)"
          fill="#db0011"
        />
        <path
          d="M26.88,30.26a.871.871,0,0,1-.616-1.5.849.849,0,0,1,1.232,0,.88.88,0,0,1-.616,1.5Z"
          transform="translate(799.968 407.892)"
          fill="currentcolor"
        />
        <g
          transform="translate(821.532 431.956)"
          fill="none"
          stroke="#db0011"
          strokeWidth="2"
        >
          <ellipse cx="5.328" cy="5.328" rx="5.328" ry="5.328" stroke="none" />
          <ellipse cx="5.328" cy="5.328" rx="4.328" ry="4.328" fill="none" />
        </g>
        <g transform="translate(798.21 408.843)">
          <g transform="translate(0 0)">
            <g transform="translate(0 0)">
              <g transform="translate(0)">
                <g transform="translate(0)">
                  <ellipse
                    cx="1.756"
                    cy="1.756"
                    rx="1.756"
                    ry="1.756"
                    transform="translate(13.172 43.906)"
                    fill="currentcolor"
                  />
                  <path
                    d="M29.856,15.006a11.093,11.093,0,0,0-1.317-.078q-.221,0-.439.009V3.512a1.756,1.756,0,0,0-1.756-1.756H3.512A1.756,1.756,0,0,0,1.756,3.512V47.419a1.756,1.756,0,0,0,1.756,1.756H26.344A1.756,1.756,0,0,0,28.1,47.419V36.872q.219.009.439.009a11.092,11.092,0,0,0,1.317-.078V47.419a3.513,3.513,0,0,1-3.512,3.512H3.512A3.513,3.513,0,0,1,0,47.419V3.512A3.512,3.512,0,0,1,3.512,0H26.344a3.513,3.513,0,0,1,3.512,3.512Z"
                    transform="translate(0 0)"
                    fill="currentcolor"
                    fillRule="evenodd"
                  />
                  <path
                    d="M21.343,22.427a12.778,12.778,0,0,1,5.342-4.384,11.712,11.712,0,0,0,0,23.334,12.778,12.778,0,0,1-5.342-4.384,9.675,9.675,0,0,1,0-14.567Z"
                    transform="translate(-3.969 -3.851)"
                    fill="#242424"
                  />
                  <ellipse
                    cx="11.711"
                    cy="11.711"
                    rx="11.711"
                    ry="11.711"
                    transform="translate(17.123 14.148)"
                    fill="none"
                    stroke="currentcolor"
                    strokeWidth="2"
                  />
                </g>
                <rect
                  width="5.269"
                  height="1.756"
                  transform="translate(12.294 3.512)"
                  fill="currentcolor"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="icn-hightlevel" viewBox="0 0 59.057 53.013">
      <g transform="translate(-1152.943 -399.636)">
        <g transform="translate(1152.943 399.636)">
          <path
            d="M56.674,15.713,34.062,5.108a.913.913,0,0,0-.784,0L10.643,15.713a.89.89,0,0,0-.513.8c0,19.955,8.437,35.062,23.148,41.448a.925.925,0,0,0,.736,0c14.735-6.4,23.172-21.493,23.172-41.448A.89.89,0,0,0,56.674,15.713Zm-23.4,40.464C19.586,50.056,12.2,36.5,12.05,17.717L33.7,7.231l21.57,10.487c-.153,18.783-8.347,32.339-22.016,38.46Z"
            transform="translate(-10.13 -5.02)"
            fill="currentcolor"
          />
        </g>
        <path
          d="M33.764,29.571V24.679a5.779,5.779,0,1,0-11.558,0v5.135c-.919,1.182,5.171-2.689,5.827-2.689l.076.011C28.69,27.125,34.683,30.884,33.764,29.571ZM27.7,25.992a31.256,31.256,0,0,0-3.414.657V24.81c0-1.707,1.989-3.389,3.7-3.389a3.666,3.666,0,0,1,3.434,3.389v1.839a10.684,10.684,0,0,0-3.716-.657Z"
          transform="translate(1148.541 393.881)"
          fill="#db0011"
        />
        <path
          d="M27.313,31.127a1.3,1.3,0,0,1-.919-2.233,1.267,1.267,0,0,1,1.839,0,1.314,1.314,0,0,1-.919,2.233Z"
          transform="translate(1149.317 397.812)"
          fill="currentcolor"
        />
        <g
          transform="translate(1168.697 419.692)"
          fill="none"
          stroke="#db0011"
          strokeWidth="2"
        >
          <ellipse cx="7.952" cy="7.952" rx="7.952" ry="7.952" stroke="none" />
          <ellipse cx="7.952" cy="7.952" rx="6.952" ry="6.952" fill="none" />
        </g>
        <g transform="translate(1182 434)" fill="#fff">
          <path
            d="M 27 15.5 L 3 15.5 C 1.621500015258789 15.5 0.5 14.37849998474121 0.5 13 L 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 L 27 0.5 C 28.37849998474121 0.5 29.5 1.621500015258789 29.5 3 L 29.5 13 C 29.5 14.37849998474121 28.37849998474121 15.5 27 15.5 Z"
            stroke="none"
          />
          <path
            d="M 3 1 C 1.897199630737305 1 1 1.897199630737305 1 3 L 1 13 C 1 14.1028003692627 1.897199630737305 15 3 15 L 27 15 C 28.1028003692627 15 29 14.1028003692627 29 13 L 29 3 C 29 1.897199630737305 28.1028003692627 1 27 1 L 3 1 M 3 0 L 27 0 C 28.65685081481934 0 30 1.34315013885498 30 3 L 30 13 C 30 14.65684986114502 28.65685081481934 16 27 16 L 3 16 C 1.3431396484375 16 0 14.65684986114502 0 13 L 0 3 C 0 1.34315013885498 1.3431396484375 0 3 0 Z"
            stroke="none"
            fill="currentcolor"
          />
        </g>
        <g transform="translate(435 124)">
          <path
            d="M4.381-7.1V-7.93L3.2-7.865l.689-.962-.741-.442L2.561-8.2,1.976-9.269l-.728.442.676.962L.754-7.93V-7.1l1.17-.052L1.248-6.2l.728.442.585-1.066.585,1.066L3.887-6.2,3.2-7.15Zm5.382,0V-7.93L8.58-7.865l.689-.962-.741-.442L7.943-8.2,7.358-9.269l-.728.442.676.962L6.136-7.93V-7.1l1.17-.052L6.63-6.2l.728.442.585-1.066.585,1.066L9.269-6.2,8.58-7.15Zm5.382,0V-7.93l-1.183.065.689-.962-.741-.442L13.325-8.2,12.74-9.269l-.728.442.676.962-1.17-.065V-7.1l1.17-.052-.676.949.728.442.585-1.066.585,1.066.741-.442-.689-.949Zm5.382,0V-7.93l-1.183.065.689-.962-.741-.442L18.707-8.2l-.585-1.066-.728.442.676.962L16.9-7.93V-7.1l1.17-.052-.676.949.728.442.585-1.066.585,1.066.741-.442-.689-.949Z"
            transform="translate(751.619 325)"
            fill="#db0011"
          />
        </g>
      </g>
    </symbol>
    <symbol id="icn-check" viewBox="0 0 45.756 45.756">
      <g transform="translate(-793 -810.51)">
        <g
          transform="translate(793 810.51)"
          fill="none"
          stroke="currentcolor"
          strokeWidth="2"
        >
          <ellipse
            cx="22.878"
            cy="22.878"
            rx="22.878"
            ry="22.878"
            stroke="none"
          />
          <ellipse
            cx="22.878"
            cy="22.878"
            rx="21.878"
            ry="21.878"
            fill="none"
          />
        </g>
        <path
          d="M2793.626,322.95l7.522,7.523,11.553-11.552"
          transform="translate(-1986.863 509.516)"
          fill="none"
          stroke="currentcolor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </symbol>
    <symbol id="icn-delete" viewBox="0 0 9.543 11.929">
      <g transform="translate(-2.386 -1.193)">
        <path
          d="M12.913,3.789l-.5,9.013h0a1.193,1.193,0,0,1-1.191,1.127h-4.9A1.193,1.193,0,0,1,5.13,12.8l-.5-9.013H4.3a.3.3,0,0,1,0-.6h8.947a.3.3,0,1,1,0,.6Zm-7.721,0,.462,8.864a.716.716,0,0,0,.715.679h4.8a.716.716,0,0,0,.715-.679h0l.462-8.864ZM7.877,2H9.666a.9.9,0,0,1,.895.895v.3H6.982v-.3h0A.9.9,0,0,1,7.877,2Zm0,.6a.3.3,0,0,0-.3.3v.3H9.964v-.3a.3.3,0,0,0-.3-.3Z"
          transform="translate(-1.614 -0.807)"
          fill="currentColor"
          fillRule="evenodd"
        />
        <path
          d="M0,0V7.256"
          transform="translate(8.709 4.215) rotate(3)"
          fill="none"
          stroke="#db0011"
          strokeWidth="0.5"
        />
        <path
          d="M0,0V7.256"
          transform="matrix(0.996, -0.087, 0.087, 0.996, 5.428, 4.224)"
          fill="none"
          stroke="#db0011"
          strokeWidth="0.5"
        />
      </g>
    </symbol>
    <symbol id="icn-delete1" viewBox="0 0 9.543 11.929">
      <g transform="translate(-2.386 -1.193)">
        <path
          d="M12.913,3.789l-.5,9.013h0a1.193,1.193,0,0,1-1.191,1.127h-4.9A1.193,1.193,0,0,1,5.13,12.8l-.5-9.013H4.3a.3.3,0,0,1,0-.6h8.947a.3.3,0,1,1,0,.6Zm-7.721,0,.462,8.864a.716.716,0,0,0,.715.679h4.8a.716.716,0,0,0,.715-.679h0l.462-8.864ZM7.877,2H9.666a.9.9,0,0,1,.895.895v.3H6.982v-.3h0A.9.9,0,0,1,7.877,2Zm0,.6a.3.3,0,0,0-.3.3v.3H9.964v-.3a.3.3,0,0,0-.3-.3Z"
          transform="translate(-1.614 -0.807)"
          fill="currentColor"
          fillRule="evenodd"
        />
        <path
          d="M0,0V7.256"
          transform="translate(8.709 4.215) rotate(3)"
          fill="none"
          stroke="currentColor"
          strokeWidth="0.5"
        />
        <path
          d="M0,0V7.256"
          transform="matrix(0.996, -0.087, 0.087, 0.996, 5.428, 4.224)"
          fill="none"
          stroke="currentColor"
          strokeWidth="0.5"
        />
      </g>
    </symbol>
    <symbol id="icn-reply" viewBox="0 0 13.2 10.199">
      <g transform="translate(3.888 -15.3)">
        <g transform="translate(-3.888 15.3)">
          <path
            d="M11.059,15.987a.3.3,0,0,0-.164.075l-4.8,4.35a.3.3,0,0,0,0,.445l4.8,4.35a.3.3,0,0,0,.5-.22v-1.35a.3.3,0,1,0-.6,0v.67l-4.054-3.67L10.8,16.962v1.725a.3.3,0,0,0,.291.3,7.674,7.674,0,0,1,7.42,6.145,9.934,9.934,0,0,0-6.346-2.808.3.3,0,0,0-.042.6A9.563,9.563,0,0,1,18.685,26.1a.3.3,0,0,0,.511-.211c0-3.419-3.154-7.176-7.8-7.476V16.287a.3.3,0,0,0-.337-.3Z"
            transform="translate(-5.997 -15.984)"
            fill="currentColor"
          />
          <g transform="translate(3.591 4.218)" fill="#db0011">
            <path
              d="M 0.9365230202674866 1.3730388879776 C 0.695823073387146 1.3730388879776 0.5000030398368835 1.177218914031982 0.5000030398368835 0.9365189075469971 C 0.5000030398368835 0.6958189010620117 0.695823073387146 0.4999988973140717 0.9365230202674866 0.4999988973140717 C 1.239225745201111 0.4999988973140717 1.98494565486908 0.8656231760978699 2.228888988494873 1.109884738922119 C 1.97810423374176 1.242215275764465 1.366103053092957 1.3730388879776 0.9365230202674866 1.3730388879776 Z"
              stroke="none"
            />
            <path
              d="M 0.9365230798721313 -1.072883605957031e-06 C 1.453743100166321 -1.072883605957031e-06 2.790302991867065 0.6331288814544678 2.790302991867065 1.150348901748657 C 2.790302991867065 1.667578935623169 1.453743100166321 1.8730388879776 0.9365230798721313 1.8730388879776 C 0.4192929267883301 1.8730388879776 3.099441528320313e-06 1.453748941421509 3.099441528320313e-06 0.9365189075469971 C 3.099441528320313e-06 0.4192888736724854 0.4192929267883301 -1.072883605957031e-06 0.9365230798721313 -1.072883605957031e-06 Z"
              stroke="none"
              fill="#db0011"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="icn-attach" viewBox="0 0 20.459 19.016">
      <g transform="translate(-0.999 -4.455)">
        <path
          d="M20.543,6.028a3.718,3.718,0,0,0-5.209.336L12.562,9.136l-1.6,1.6L5.674,16.024a1.945,1.945,0,1,0,2.751,2.751l6.541-6.541a.49.49,0,0,0-.693-.693L7.731,18.081a.965.965,0,1,1-1.365-1.365l5.285-5.285,1.6-1.6,2.772-2.772A3.2,3.2,0,0,1,18.071,6.1a2.169,2.169,0,0,1,2.4,2.4,3.2,3.2,0,0,1-.957,2.044l-3.076,3.076-1.3,1.3L8.424,21.634a2.952,2.952,0,0,1-4.159,0L2.836,20.2a2.952,2.952,0,0,1,0-4.159L13.591,5.291a.49.49,0,0,0,0-.692h0a.49.49,0,0,0-.692,0L2.143,15.352a3.932,3.932,0,0,0,0,5.545l1.43,1.43a3.932,3.932,0,0,0,5.545,0l6.715-6.715,1.3-1.3,3.076-3.076A3.717,3.717,0,0,0,20.543,6.028Z"
          fill="currentcolor"
        />
      </g>
    </symbol>
    <symbol id="icn-remove" viewBox="0 0 12.519 12.144" fill="currentcolor">
      <g transform="translate(0.75 0.75)">
        <path
          d="M726.5,745.015l10.481,10.527"
          transform="translate(-725.961 -745.015)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1.5"
        />
        <path
          d="M736.6,745.015l-10.644,10.644"
          transform="translate(-725.961 -745.015)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1.5"
        />
      </g>
    </symbol>

    <symbol id="icn-notnotifi" viewBox="0 0 32.77 13.498" fill="currentcolor">
      <g transform="translate(140.158 22.161) rotate(180)">
        <g transform="translate(147.658 40.161) rotate(-180)" opacity="0.42">
          <path
            d="M9.082,31.5H23.845a1.593,1.593,0,0,0,1.582-1.582V19.582A1.593,1.593,0,0,0,23.845,18H9.082A1.593,1.593,0,0,0,7.5,19.582V29.916A1.593,1.593,0,0,0,9.082,31.5Zm0-12.655H23.845a.846.846,0,0,1,.316.063l-6.918,6.918a1.121,1.121,0,0,1-1.561,0L8.765,18.907A.846.846,0,0,1,9.082,18.844Zm-.738.844,6.749,6.749a1.935,1.935,0,0,0,2.742,0l6.749-6.749V29.916a.747.747,0,0,1-.738.738H9.082a.747.747,0,0,1-.738-.738Z"
            fill="#b2afb2"
          />
          <path
            d="M67.345,58.907a.477.477,0,0,0,.263.1.365.365,0,0,0,.3-.142.393.393,0,0,0-.041-.568l-3.4-3a.4.4,0,1,0-.527.608Z"
            transform="translate(-44.887 -29.658)"
            fill="#db0011"
          />
          <path
            d="M15.751,59.2a.427.427,0,0,0,.263-.1l3.364-2.959a.4.4,0,1,0-.527-.608l-3.385,2.959a.411.411,0,0,0-.041.568A.432.432,0,0,0,15.751,59.2Z"
            transform="translate(-6.245 -29.845)"
            fill="#db0011"
          />
        </g>
        <path
          d="M114.129,18.82h-6.255"
          transform="translate(5.803 -2.04)"
          fill="none"
          stroke="#d9d8d9"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          d="M117.735,18.82h-9.862"
          transform="translate(0.015 -5.988)"
          fill="none"
          stroke="#d9d8d9"
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
    </symbol>
    <symbol id="icn-parking" viewBox="0 0 35.578 35.578" fill="currentcolor">
      <path
        d="M45.335,30H42v6.671h3.335a3.335,3.335,0,0,0,0-6.671Zm0,5.559H43.112V31.112h2.224a2.224,2.224,0,0,1,0,4.447Z"
        transform="translate(-26.435 -18.882)"
        fill="#db0011"
      />
      <path
        d="M31.131,0H4.447A4.46,4.46,0,0,0,0,4.447V31.131a4.46,4.46,0,0,0,4.447,4.447H31.131a4.46,4.46,0,0,0,4.447-4.447V4.447A4.46,4.46,0,0,0,31.131,0Zm3.335,13.342V31.131a3.322,3.322,0,0,1-3.335,3.335H4.447a3.322,3.322,0,0,1-3.335-3.335V4.447A3.322,3.322,0,0,1,4.447,1.112H31.131a3.322,3.322,0,0,1,3.335,3.335Z"
        fill="currentcolor"
      />
      <path
        d="M38.895,21H30.556a.57.57,0,0,0-.556.556v18.9a.57.57,0,0,0,.556.556H35a.57.57,0,0,0,.556-.556V34.342h3.335a6.671,6.671,0,0,0,0-13.342Zm0,12.23H34.447V39.9H31.112V22.112h7.783a5.559,5.559,0,0,1,0,11.118Z"
        transform="translate(-18.882 -13.217)"
        fill="#db0011"
      />
    </symbol>
    <symbol id="icn-order" viewBox="0 0 25.041 33.388" fill="currentcolor">
      <g transform="translate(-20.5 11)">
        <path
          d="M42.746,8H19.295a.8.8,0,0,0-.795.795V40a.888.888,0,0,0,.4.715.812.812,0,0,0,.795-.04l5.127-3.3,5.565,2.186a.775.775,0,0,0,.6,0l1.294-.536,2.641-1.094,7.512,3.379a.935.935,0,0,0,.318.079.8.8,0,0,0,.437-.119.781.781,0,0,0,.358-.676V8.795A.773.773,0,0,0,42.746,8Zm-.318,32-7.194-3.149a.936.936,0,0,0-.318-.079.478.478,0,0,0-.318.079l-3.882,1.669-5.756-2.256a.761.761,0,0,0-.715.079l-4.552,2.684L19.624,9.265H42.417Z"
          transform="translate(2 -19)"
        />
        <path
          d="M24.25,13.025h13.8"
          transform="translate(2 -18)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          d="M24.25,13.025h13.8"
          transform="translate(2 -13)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          d="M24.25,13.025h13.8"
          transform="translate(2 -7)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          d="M24.25,13.228h6.9"
          transform="translate(2 -1.203)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
    </symbol>
    <symbol id="icn-info2" viewBox="0 0 29.412 29.412" fill="currentcolor">
      <g transform="translate(-1262.5 -544.883)">
        <g transform="translate(1262.5 544.883)" fill="none">
          <path
            d="M14.706,0A14.706,14.706,0,0,1,29.412,14.706a14.969,14.969,0,0,1-1.117,5.633A14.707,14.707,0,1,1,14.706,0Z"
            stroke="none"
          />
          <path
            d="M 14.70580959320068 1.5 C 11.17840957641602 1.5 7.862138748168945 2.873640060424805 5.367889404296875 5.367889404296875 C 2.873640060424805 7.862138748168945 1.5 11.17840957641602 1.5 14.70580959320068 C 1.5 18.23320960998535 2.873640060424805 21.54948043823242 5.367889404296875 24.04372978210449 C 7.862138748168945 26.53797912597656 11.17840957641602 27.91161918640137 14.70580959320068 27.91161918640137 C 20.07942962646484 27.91161918640137 24.97956848144531 24.64674949645996 26.89995956420898 19.78549003601074 C 27.59016036987305 18.04528999328613 27.91161918640137 16.43119049072266 27.91161918640137 14.70580959320068 C 27.91161918640137 11.17840957641602 26.53797912597656 7.862138748168945 24.04372978210449 5.367889404296875 C 21.54948043823242 2.873640060424805 18.23320960998535 1.5 14.70580959320068 1.5 M 14.70580959320068 0 C 22.82759857177734 0 29.41161918640137 6.584018707275391 29.41161918640137 14.70580959320068 C 29.41161918640137 16.61442947387695 29.04801940917969 18.43814086914063 28.29428863525391 20.33850860595703 C 26.23220062255859 25.5584888458252 20.91897964477539 29.41161918640137 14.70580959320068 29.41161918640137 C 6.584018707275391 29.41161918640137 0 22.82759857177734 0 14.70580959320068 C 0 6.584018707275391 6.584018707275391 0 14.70580959320068 0 Z"
            stroke="none"
            fill="currentcolor"
          />
        </g>
        <path
          d="M5244.171,555.234v9.2"
          transform="translate(-3967 2.139)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          d="M5244.171,555.234v.879"
          transform="translate(-3967 -2)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="2"
        />
      </g>
    </symbol>
    <symbol id="icn-car-parking" viewBox="0 0 62.152 38.86" fill="currentcolor">
      <g id="car" transform="translate(-338.551 -357.739)">
        <path
          id="Path_1258"
          data-name="Path 1258"
          d="M21092.348,1762.329s.441,11.128,1.139,11.238,54.465,0,54.465,0"
          transform="translate(-20748 -1378)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeWidth="1.5"
        />
        <path
          id="Path_1259"
          data-name="Path 1259"
          d="M21097.885,1757.54v-5.586s5.824-5.968,5.824-6.111,41.012,0,41.012,0l5.887,6.111s-.395,18.524-.873,19.193a7.289,7.289,0,0,1-1.863,1.432"
          transform="translate(-20754 -1377)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Path_1260"
          data-name="Path 1260"
          d="M21103.8,1745.78s3.2-9.342,4.631-9.819,30.316-.764,31.271,0,5.014,9.819,5.014,9.819"
          transform="translate(-20754 -1377)"
          fill="none"
          stroke="#242424"
          strokeWidth="1.5"
        />
        <path
          id="Path_1261"
          data-name="Path 1261"
          d="M21093.3,1772.58h6.207"
          transform="translate(-20754 -1377)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeWidth="1.5"
        />
        <path
          id="Path_1262"
          data-name="Path 1262"
          d="M21106.969,1762.267h-5.646s-.322,2.1,0,2.533l.48.6.775.512a8.637,8.637,0,0,0,2.348.2"
          transform="translate(-20754 -1377)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.5"
        />
        <path
          id="Path_1263"
          data-name="Path 1263"
          d="M21101.18,1762.267h5.646s.322,2.1,0,2.533l-.48.6-.775.512a8.637,8.637,0,0,1-2.348.2"
          transform="translate(-20713 -1377)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.5"
        />
        <rect
          id="Rectangle_775"
          data-name="Rectangle 775"
          width="16"
          height="4"
          rx="1"
          transform="translate(363 385)"
          fill="#db0011"
        />
        <path
          id="Path_1264"
          data-name="Path 1264"
          d="M21100.674,1754.284s-1.131,2.656.875,3.447,9.238.593,9.238.593a2.192,2.192,0,0,0-.715-2.541c-1.342-.911-.979-.793-4.652-1.1S21100.674,1754.284,21100.674,1754.284Z"
          transform="translate(-20754 -1377)"
          fill="#db0011"
        />
        <path
          id="Path_1265"
          data-name="Path 1265"
          d="M21110.467,1754.284s1.131,2.656-.875,3.447-9.238.593-9.238.593a3.855,3.855,0,0,1,1.484-2.639,12.421,12.421,0,0,1,1.613-.745s-.279-.045,2.27-.261C21109.395,1754.368,21110.467,1754.284,21110.467,1754.284Z"
          transform="translate(-20715.998 -1377)"
          fill="#db0011"
        />
        <path
          id="Path_1266"
          data-name="Path 1266"
          d="M21104.064,1745.5l.2.7-6.455-.7c0-.372-1.262-1.978.941-2.529s2.533-1.138,3.3-.7,1.34,2.277,1.34,2.277"
          transform="translate(-20754 -1377)"
          fill="#242424"
        />
        <path
          id="Path_1267"
          data-name="Path 1267"
          d="M21096.783,1745.5v.277l6.25-.277c0-.372,1.262-1.978-.941-2.529s-2.533-1.138-3.3-.7-1.34,2.277-1.34,2.277"
          transform="translate(-20707 -1377)"
          fill="#242424"
        />
        <rect
          id="Rectangle_776"
          data-name="Rectangle 776"
          width="37"
          height="4"
          rx="1"
          transform="translate(352 392)"
          fill="#242424"
        />
      </g>
    </symbol>
    <symbol id="icn-company" viewBox="0 0 36.755 34.844" fill="currentcolor">
      <g transform="translate(-1428.012 -227)">
        <g transform="translate(1664 243.013)">
          <path
            d="M46.794,19.251H38.371V17.34A2.378,2.378,0,0,0,37.1,15.3L35.3,14.425a4.9,4.9,0,0,0-1.9-.438H27.369a4.887,4.887,0,0,0-1.9.439l-1.791.876a2.378,2.378,0,0,0-1.273,2.039v1.91H13.984a1.975,1.975,0,0,0-1.972,1.972V33.65a2.027,2.027,0,0,0,.881,1.669V46.186a2.2,2.2,0,0,0,2.022,2.182c.061,0,6.24.463,15.474.463s15.412-.459,15.475-.463a2.2,2.2,0,0,0,2.022-2.182V35.321a2.034,2.034,0,0,0,.881-1.67V21.223A1.977,1.977,0,0,0,46.794,19.251Zm-23.261-2.9a.37.37,0,0,1,.094-.149l2.779-.87a2.894,2.894,0,0,1,.964-.224h6.036a2.865,2.865,0,0,1,.963.224l1.625.634,1.159,1.236a.409.409,0,0,1,.092.149v1.9H23.533Zm-3.489,4.2H40.735l.121,13.413c-1.837.061-5.19.067-7.5.094A2.015,2.015,0,0,0,31.576,32.1H29.2a2.124,2.124,0,0,0-1.9,1.966c-2.308-.027-5.539-.163-7.375-.225ZM31.7,33.01l.993,2L31.7,37.016a.124.124,0,0,1-.119.119H29.2a.125.125,0,0,1-.12-.119l-.865-2.009.865-2a.123.123,0,0,1,.12-.119h2.374A.121.121,0,0,1,31.7,33.01Zm-18.8.69V20.558H18.8V33.84C16.51,33.747,13.488,33.737,12.893,33.7ZM46.856,47.139a158.3,158.3,0,0,1-16.468.965A143.849,143.849,0,0,1,13.863,47.01V34.759c.844.047,3.413.1,4.938.166V38h0a1.121,1.121,0,0,0,2.242,0h0V35.008c1.84.06,3.953.113,6.255.141.068.991.895,2.777,1.9,2.777h2.374c1.008,0,1.835-1.786,1.9-2.777,2.3-.027,4.415-.079,6.255-.141V38h0a1.121,1.121,0,0,0,2.242,0h0V34.925c1.526-.06,4.036.047,4.88,0V47.139Zm1.03-13.246c-.595.037-3.618-.094-5.909,0V20.558h5.909Z"
            transform="translate(-248 -30)"
            fill="#242424"
          />
        </g>
        <path
          d="M7315.045,266.221h17.829"
          transform="translate(-5878 -9)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          d="M7315.045,266.221h6.553"
          transform="translate(-5872.447 -29)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
    </symbol>

    <symbol
      id="icn-avatar-retail"
      viewBox="0 0 17.722 22.327"
      fill="currentColor"
    >
      <g transform="translate(-21.445 -19.345)">
        <path
          className="a"
          d="M23.133,53H19.589A7.088,7.088,0,0,0,12.5,60.088v2.126c0,.391.027.695.419.695s.34-.3.34-.695V60.088c-.085-3.242,3.166-6.233,6.329-6.329h3.544a6.617,6.617,0,0,1,6.329,6.329v2.127c0,.391-.041.731.351.731s.409-.339.409-.731V60.088A7.088,7.088,0,0,0,23.133,53Z"
          transform="translate(8.945 -21.274)"
          fill="currentColor"
        />
        <g
          className="b"
          transform="translate(24.507 19.345)"
          stroke="#db0011"
          fill="none"
        >
          <ellipse
            className="c"
            cx="5.268"
            cy="5.268"
            rx="5.268"
            ry="5.268"
            stroke="none"
          />
          <ellipse
            className="d"
            cx="5.268"
            cy="5.268"
            rx="4.768"
            ry="4.768"
            fill="none"
          />
        </g>
      </g>
    </symbol>
    <symbol id="banker-avatar" viewBox="0 0 48 48" fill="currentColor">
      <g id="Group_5776" data-name="Group 5776" transform="translate(-137 -18)">
        <g id="Group_5776-2" data-name="Group 5776" transform="translate(-37)">
          <g id="Group_7928" data-name="Group 7928" transform="translate(43 2)">
            <rect
              id="magnet-me-zWkZwLUTlbw-unsplash"
              width="48"
              height="48"
              rx="24"
              transform="translate(131 16)"
              fill="#f1f1f4"
            />
            <g id="user" transform="translate(143.286 28.286)">
              <path
                id="Path_6055"
                data-name="Path 6055"
                d="M14.143,3.469a3.673,3.673,0,1,1-3.673,3.673,3.673,3.673,0,0,1,3.673-3.673m0-1.469a5.143,5.143,0,1,0,5.143,5.143A5.143,5.143,0,0,0,14.143,2Z"
                transform="translate(-2.429 -0.571)"
                fill="#afafb6"
              />
              <path
                id="Path_6056"
                data-name="Path 6056"
                d="M20.694,26.816H19.224V23.143a3.673,3.673,0,0,0-3.673-3.673H11.143a3.673,3.673,0,0,0-3.673,3.673v3.673H6V23.143A5.143,5.143,0,0,1,11.143,18h4.408a5.143,5.143,0,0,1,5.143,5.143Z"
                transform="translate(-1.633 -4.816)"
                fill="#afafb6"
              />
              <rect
                id="_Transparent_Rectangle_"
                data-name="&lt;Transparent Rectangle&gt;"
                width="24"
                height="24"
                transform="translate(-0.286 -0.286)"
                fill="none"
              />
            </g>
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="logo-pb" viewBox="0 0 54 54" fill="currentColor">
      <g
        id="Group_8512"
        data-name="Group 8512"
        transform="translate(-152 -389)"
      >
        <rect
          id="jason-goodman-ZJlfUi5rTDU-unsplash"
          width="54"
          height="54"
          rx="27"
          transform="translate(152 389)"
          fill="#f1f1f4"
        />
        <g
          id="Group_7924"
          data-name="Group 7924"
          transform="translate(159 412.4)"
        >
          <g id="Group_6014" data-name="Group 6014" transform="translate(0)">
            <path
              id="Path_814"
              data-name="Path 814"
              d="M450.044,7.575h-1.552V2.319a.544.544,0,0,0-.168-.44.689.689,0,0,0-.448-.152.568.568,0,0,0-.624.592V7.583H445.7V2.543a2.172,2.172,0,0,1,4.344-.008Z"
              transform="translate(-410.044 -0.359)"
              fill="#fff"
            />
            <path
              id="Path_815"
              data-name="Path 815"
              d="M350.4,5.724a.45.45,0,0,1-.472.44.48.48,0,0,1-.472-.44V2.076a.439.439,0,0,1,.472-.44.45.45,0,0,1,.472.44ZM352.42.3a2.112,2.112,0,0,0-1.248.4,2.042,2.042,0,0,0-1.248-.4A1.965,1.965,0,0,0,347.9,2.292V5.5a2.024,2.024,0,0,0,4.048,0V2.076a.45.45,0,0,1,.472-.44.444.444,0,0,1,.472.44V7.484h1.552V2.3a1.971,1.971,0,0,0-2.024-2"
              transform="translate(-320.068 -0.268)"
              fill="#242424"
            />
            <path
              id="Path_816"
              data-name="Path 816"
              d="M4.344,3.792V2.344A2.014,2.014,0,0,0,2.176.2,2.02,2.02,0,0,0,0,2.344v2.04C0,6.408,1.72,7.392,3.792,7.392V6.064c-1.248,0-2.24-.472-2.24-1.68V2.12A.583.583,0,0,1,2.176,1.5.583.583,0,0,1,2.8,2.12V3.784H4.344Z"
              transform="translate(0 -0.176)"
              fill="#242424"
            />
            <path
              id="Path_817"
              data-name="Path 817"
              d="M281.2,2.78a2.409,2.409,0,0,0-.84.3V2.9a1.213,1.213,0,0,1,1.5-1.208V.34C280.1.252,278.8,1.276,278.8,2.924v4.6h1.568v-2.1c0-.96.264-1.264.624-1.344.28-.064.624.152.624.728V7.524h1.552V4.484a1.571,1.571,0,0,0-1.968-1.7"
              transform="translate(-256.496 -0.3)"
              fill="#242424"
            />
            <path
              id="Path_818"
              data-name="Path 818"
              d="M447.16,1.92a.624.624,0,0,1,1.248,0V7.208h1.544V2.144a2.176,2.176,0,0,0-4.352,0V7.208h1.552V1.92Z"
              transform="translate(-409.952 0.008)"
              fill="#242424"
            />
            <path
              id="Path_819"
              data-name="Path 819"
              d="M70.252,2.12a.624.624,0,1,1,1.248,0V7.392h1.544V2.344a2.172,2.172,0,0,0-4.344,0V7.392h1.552Z"
              transform="translate(-63.204 -0.176)"
              fill="#242424"
            />
            <path
              id="Path_820"
              data-name="Path 820"
              d="M210.624.3a1.973,1.973,0,0,0-2.12,2.144v.68h1.544v-.9c0-.344.16-.624.568-.624a.549.549,0,0,1,.584.624V5.564a.624.624,0,1,1-1.248,0V4.452H208.4V5.34a2.176,2.176,0,0,0,4.352,0v-2.9A1.975,1.975,0,0,0,210.624.3"
              transform="translate(-191.728 -0.268)"
              fill="#242424"
            />
            <path
              id="Path_821"
              data-name="Path 821"
              d="M140.028,2.5a1.538,1.538,0,0,0,.472-1.08c0-.848-.48-1.368-1.64-1.368h-.288a1.418,1.418,0,0,1-.192-.008.246.246,0,0,1-.224-.144h-1.392a1.968,1.968,0,0,0,.4.736,1.767,1.767,0,0,0,1.408.64h.064c.392,0,.5.176.5.368.008.208-.152.424-.5.424h-.032a2.224,2.224,0,0,0-2.312,2.28v.384h1.552V4.124a.761.761,0,0,1,1.52,0v.928a.714.714,0,0,1-.76.736V7.116h0a2.224,2.224,0,0,0,2.312-2.28V4.348a2.292,2.292,0,0,0-.9-1.848"
              transform="translate(-125.396 0.1)"
              fill="#e03126"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="logo-pb-eng" viewBox="0 0 54 54" fill="currentColor">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="54"
        height="54"
        viewBox="0 0 54 54"
      >
        <g
          id="Group_8512"
          data-name="Group 8512"
          transform="translate(-152 -389)"
        >
          <rect
            id="jason-goodman-ZJlfUi5rTDU-unsplash"
            width="54"
            height="54"
            rx="27"
            transform="translate(152 389)"
            fill="#f1f1f4"
          />
          <g
            id="Group_8514"
            data-name="Group 8514"
            transform="translate(-7069 -11468.749)"
          >
            <g id="Page-1" transform="translate(7228 11880.999)">
              <g id="Group" transform="translate(0 0)">
                <path
                  id="Fill-1"
                  d="M4.372,5.85V7.5H0V0H1.706V5.85Z"
                  transform="translate(0 0)"
                  fill="#242424"
                  fillRule="evenodd"
                />
                <path
                  id="Fill-2"
                  d="M89.031,7.5h1.706V0H89.031Z"
                  transform="translate(-83.369)"
                  fill="#242424"
                  fillRule="evenodd"
                />
                <g id="Group-13" transform="translate(8.658 0)">
                  <path
                    id="Fill-3"
                    d="M3.9,3.611a1.881,1.881,0,0,0,.65-1.468A2.187,2.187,0,0,0,2.2,0H0V1.607H2.2a.626.626,0,0,1,.65.664.62.62,0,0,1-.177.472.643.643,0,0,1-.473.192H1.251V4.457h1.16a.676.676,0,0,1,.7.718.676.676,0,0,1-.7.718H1.251V7.5h1.16a2.237,2.237,0,0,0,2.41-2.2A1.938,1.938,0,0,0,3.9,3.611"
                    transform="translate(0 0)"
                    fill="#e03227"
                    fillRule="evenodd"
                  />
                  <path
                    id="Fill-5"
                    d="M101.137,5.85V7.5H96.445V0h4.639V1.65H98.152V2.893h2.666V4.521H98.152V5.85Z"
                    transform="translate(-90.326 0)"
                    fill="#242424"
                    fillRule="evenodd"
                  />
                  <path
                    id="Fill-7"
                    d="M289.5,1.65h-1.919V7.5h-1.706V1.65h-1.919V0H289.5Z"
                    transform="translate(-265.944 0)"
                    fill="#242424"
                    fillRule="evenodd"
                  />
                  <path
                    id="Fill-9"
                    d="M392.423,4.618V7.5h-1.706V4.618L388.211,0h1.941l1.418,2.893L392.988,0h1.941Z"
                    transform="translate(-363.587 0)"
                    fill="#242424"
                    fillRule="evenodd"
                  />
                  <path
                    id="Fill-11"
                    d="M192.332,4.746a2.473,2.473,0,0,0,1.376-2.175,2.515,2.515,0,0,0-.736-1.808A2.6,2.6,0,0,0,191.149,0h-2.2V1.607h2.2a.906.906,0,0,1,.853.964.907.907,0,0,1-.853.965h-1.094v1.5h.625L192.087,7.5h1.834Z"
                    transform="translate(-176.962 0)"
                    fill="#242424"
                    fillRule="evenodd"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </symbol>
    <symbol id="icn-phone-new-retail" viewBox="0 0 19.904 35.385">
      <g transform="translate(.001)">
        <path
          d="M17.139 0H2.764A2.764 2.764 0 0 0 0 2.764V32.62a2.764 2.764 0 0 0 2.764 2.764h14.375A2.764 2.764 0 0 0 19.9 32.62V2.764A2.764 2.764 0 0 0 17.139 0zM18.8 32.62a1.659 1.659 0 0 1-1.659 1.659H2.764a1.659 1.659 0 0 1-1.659-1.659v-1.659H18.8zm0-2.764H1.106V5.529H18.8zm0-25.433H1.106V2.764a1.659 1.659 0 0 1 1.659-1.659h14.374A1.659 1.659 0 0 1 18.8 2.764z"
          fill="currentColor"
        />
        <path
          className="b"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1.5px"
          d="M4.051 26.329l6.955-6.955M9.952 13.819l5.477-5.5M6.635 17.133l1.648-1.655M12.717 17.686l1.648-1.655"
        />
        <path
          d="M7.95 2.49l3.228-.006"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
        />
        <circle
          cx="1.106"
          cy="1.106"
          r="1.106"
          transform="translate(8.846 31.514)"
          fill="#db0011"
        />
      </g>
    </symbol>
    <symbol
      xmlns="http://www.w3.org/2000/svg"
      id="information-filled"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="inner-path"
        d="M15,8a1.125,1.125,0,1,1-1.125,1.125A1.125,1.125,0,0,1,15,8Zm3,10.406H15.844v-6H12.75v1.688h1.406v4.313H12v1.688h6Z"
        transform="translate(-3 -2)"
        fill="none"
      />
      <path
        id="Path_5958"
        data-name="Path 5958"
        d="M12.5,2A10.5,10.5,0,1,0,23,12.5,10.5,10.5,0,0,0,12.5,2Zm0,4.5a1.125,1.125,0,1,1-1.125,1.125A1.125,1.125,0,0,1,12.5,6.5Zm3,12.094h-6V16.906h2.156V12.594H10.25V10.906h3.094v6H15.5Z"
        transform="translate(-0.5 -0.5)"
        fill="#fff"
      />
      <rect
        id="_Transparent_Rectangle_"
        data-name="&lt;Transparent Rectangle&gt;"
        width="24"
        height="24"
        fill="none"
      />
    </symbol>
    <symbol id="icn-phone-new-retail" viewBox="0 0 21.144 21.144">
      <g className="a" transform="translate(0 -5.999)">
        <g transform="translate(0 5.999)">
          <path
            className="b"
            fill="#DB0011"
            d="M17.441,3.881c5.173,0,7.489,3.761,7.489,7.489a.441.441,0,0,0,.881,0C25.81,7.2,23.223,3,17.441,3a.441.441,0,0,0,0,.881Z"
            transform="translate(-4.666 -3)"
          />
          <path
            className="b"
            fill="#DB0011"
            d="M17.441,8.881a2.764,2.764,0,0,1,3.084,3.084.441.441,0,0,0,.881,0A3.609,3.609,0,0,0,17.441,8a.441.441,0,0,0,0,.881Z"
            transform="translate(-4.666 -3.595)"
          />
          <path
            className="c"
            fill="currentColor"
            d="M22.6,17.1a15.441,15.441,0,0,1-4.239-.8,1.5,1.5,0,0,0-1.522.322l-2.424,1.724a13.394,13.394,0,0,1-6.035-6.014l2.09-2.167a1.553,1.553,0,0,0,.382-1.573,13.54,13.54,0,0,1-.806-4.046A1.543,1.543,0,0,0,8.506,3H4.542A1.543,1.543,0,0,0,3,4.542a19.865,19.865,0,0,0,19.6,19.6A1.543,1.543,0,0,0,24.144,22.6V18.638A1.543,1.543,0,0,0,22.6,17.1Zm.661,5.506a.662.662,0,0,1-.661.661A18.972,18.972,0,0,1,3.881,4.542a.662.662,0,0,1,.661-.661H8.505a.662.662,0,0,1,.661.661,14.353,14.353,0,0,0,.849,4.317.666.666,0,0,1-.173.685l-2.315,2.4a.44.44,0,0,0-.075.506,14.337,14.337,0,0,0,6.8,6.8.439.439,0,0,0,.456-.033l2.7-1.928a.659.659,0,0,1,.674-.158,16.09,16.09,0,0,0,4.521.846.662.662,0,0,1,.661.661S23.263,22.6,23.263,22.6Z"
            transform="translate(-3 -3)"
          />
        </g>
      </g>
    </symbol>

    <symbol
      id="icn-home-new-retail"
      viewBox="0 0 39.205 35.419"
      fill="currentColor"
    >
      <path d="M39.177 14.278a2.265 2.265 0 0 0-.967-1.52L20.984.458a2.482 2.482 0 0 0-1.382-.461 2.174 2.174 0 0 0-1.382.461l-3.362 2.4v-.691A1.848 1.848 0 0 0 13.016.325H9.838a1.848 1.848 0 0 0-1.842 1.842V7.74l-7 5.02a2.374 2.374 0 0 0-.967 1.52 2.336 2.336 0 0 0 .415 1.75 2.465 2.465 0 0 0 1.934 1.013 2.174 2.174 0 0 0 1.382-.461l.138-.092v18.1a.97.97 0 0 0 .23.6.876.876 0 0 0 .6.23h29.8a.97.97 0 0 0 .6-.23.876.876 0 0 0 .23-.6v-18.1l.138.092a2.482 2.482 0 0 0 1.382.461 2.34 2.34 0 0 0 1.934-1.013 2.591 2.591 0 0 0 .365-1.752zM9.654 2.165a.218.218 0 0 1 .23-.23h3.176a.218.218 0 0 1 .23.23v1.842L9.7 6.586V2.165zM23.06 33.807h-6.912V23.029a.218.218 0 0 1 .23-.23h6.448a.218.218 0 0 1 .23.23zm10.639 0h-9.03V23.029a1.848 1.848 0 0 0-1.842-1.842h-6.449a1.848 1.848 0 0 0-1.842 1.842v10.778H5.509v-18.47L19.602 5.3l14.094 10.037zm3.731-18.7a.787.787 0 0 1-.6.322.743.743 0 0 1-.415-.138L19.602 3.316 2.791 15.291a.743.743 0 0 1-.415.138.671.671 0 0 1-.6-.322.736.736 0 0 1 .184-1.013L19.188 1.842a.691.691 0 0 1 .829 0l17.226 12.206a.793.793 0 0 1 .184 1.059z" />
      <g
        stroke="#db0011"
        strokeWidth="2px"
        fill="none"
        transform="translate(16.237 10.733)"
      >
        <circle fill="none" stroke="none" cx="3.179" cy="3.179" r="3.179" />
        <circle fill="none" cx="3.179" cy="3.179" r="2.179" />
      </g>
      <g fill="none" transform="translate(17.11 27.642)">
        <circle stroke="none" fill="#db0011" cx="1.194" cy="1.194" r="1.194" />
        <circle
          stroke="#db0011"
          fill="#db0011"
          cx="1.194"
          cy="1.194"
          r=".194"
        />
      </g>
    </symbol>

    <symbol
      id="icn-arrows-new-retail"
      viewBox="0 0 34.227 29.049"
      fill="none"
      strokeLinecap="round"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path stroke="#db0011" d="M16.42 7.395l15.573-.356" />
      <path d="M17.806 21.654l-15.573.356" />
      <path stroke="#db0011" d="M26.732 1l6.074 6.169-6.074 5.88" />
      <path d="M7.494 28.049L1.42 21.88 7.494 16" />
      <path strokeWidth="1px" d="M12.033 14.317h5.383M20.033 14.317h2.863" />
    </symbol>
    <symbol
      id="quick-add-new-retail"
      viewBox="0 0 18.775 18.775"
      fill="currentColor"
    >
      <g transform="translate(0 0)">
        <path
          className="a"
          d="M8.214,0a.587.587,0,0,0-.587.587V2.668a6.994,6.994,0,0,0-1.744.727L4.41,1.921a.587.587,0,0,0-.83,0L1.921,3.58a.587.587,0,0,0,0,.83L3.39,5.879a6.992,6.992,0,0,0-.722,1.749H.587A.587.587,0,0,0,0,8.214v2.347a.587.587,0,0,0,.587.587H2.666a7,7,0,0,0,.727,1.747L1.921,14.366a.587.587,0,0,0,0,.83L3.58,16.855a.587.587,0,0,0,.83,0l1.467-1.467a7,7,0,0,0,1.751.722v2.079a.587.587,0,0,0,.587.587h2.347a.587.587,0,0,0,.587-.587V16.11c.171-.046.6-.209.6-.209l0-1.144a10.91,10.91,0,0,1-1.288.4.587.587,0,0,0-.479.575V17.6H8.8V15.73a.587.587,0,0,0-.481-.575,5.867,5.867,0,0,1-2.258-.933.586.586,0,0,0-.747.069l-1.32,1.32-.83-.83L4.49,13.456a.587.587,0,0,0,.069-.747,5.87,5.87,0,0,1-.937-2.255.587.587,0,0,0-.578-.479H1.173V8.8H3.046a.587.587,0,0,0,.578-.479,5.872,5.872,0,0,1,.931-2.26.587.587,0,0,0-.069-.747l-1.32-1.32.83-.83L5.32,4.49a.587.587,0,0,0,.747.069,5.87,5.87,0,0,1,2.255-.937A.587.587,0,0,0,8.8,3.044V1.173H9.975V3.046a.587.587,0,0,0,.481.578,5.866,5.866,0,0,1,2.258.933.587.587,0,0,0,.747-.069l1.32-1.32.83.83L14.286,5.322a.587.587,0,0,0-.069.749,5.862,5.862,0,0,1,.938,2.253.587.587,0,0,0,.578.479H17.6V9.977H15.73a.587.587,0,0,0-.578.481c-.035.19-.193.667-.193.667l1.057.319s.068-.193.094-.293h2.079a.587.587,0,0,0,.587-.587V8.217a.587.587,0,0,0-.587-.587H16.11a7,7,0,0,0-.727-1.746l1.471-1.471a.587.587,0,0,0,0-.83L15.2,1.923a.587.587,0,0,0-.83,0L12.9,3.392a7,7,0,0,0-1.749-.722V.589A.587.587,0,0,0,10.561,0ZM9.388,4.694a4.694,4.694,0,1,0,4.694,4.694A4.7,4.7,0,0,0,9.388,4.694Zm0,1.173a3.52,3.52,0,1,1-3.52,3.52A3.512,3.512,0,0,1,9.388,5.867Z"
        />
        <path
          className="b"
          d="M16.479,13.334v4.673"
          transform="translate(-1.211 -0.98)"
          stroke="#db0011"
          fill="none"
        />
        <path
          className="b"
          d="M13.957,15.856h4.69"
          transform="translate(-1.026 -1.166)"
          stroke="#db0011"
          fill="none"
        />
      </g>
    </symbol>
    <symbol
      id="icn-warning-red-retail"
      viewBox="0 0 2 15.726"
      fill="currentColor"
    >
      <g transform="translate(-1704.5 -128.5)">
        <path
          d="M1705.566,128.849v8.92"
          transform="translate(-0.066 0.651)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          d="M1705.566,142.5v.726"
          transform="translate(-0.066 0.002)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="2"
        />
      </g>
    </symbol>
    <symbol
      id="icn-notfoundfine"
      viewBox="0 0 14.635 19.513"
      fill="currentColor"
    >
      <g id="noun_order_1591470" transform="translate(-20.5 11)">
        <path
          id="Path_1187"
          data-name="Path 1187"
          d="M32.67,8H18.965a.466.466,0,0,0-.465.465V26.7a.519.519,0,0,0,.232.418.475.475,0,0,0,.465-.023l3-1.928,3.252,1.278a.453.453,0,0,0,.348,0l.756-.313,1.544-.639,4.39,1.975a.547.547,0,0,0,.186.046.468.468,0,0,0,.256-.07.456.456,0,0,0,.209-.395V8.465A.452.452,0,0,0,32.67,8Zm-.186,18.7-4.2-1.84a.547.547,0,0,0-.186-.046.279.279,0,0,0-.186.046l-2.269.975-3.364-1.319a.445.445,0,0,0-.418.046L19.2,26.131l-.04-17.392H32.478Z"
          transform="translate(2 -19)"
        />
        <path
          id="Path_1188"
          data-name="Path 1188"
          d="M24.25,13.025h8.067"
          transform="translate(-0.389 -20.504)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          id="Path_1189"
          data-name="Path 1189"
          d="M24.25,13.025h8.067"
          transform="translate(-0.389 -17.581)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          id="Path_1190"
          data-name="Path 1190"
          d="M24.25,13.025h8.067"
          transform="translate(-0.389 -14.075)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          id="Path_1191"
          data-name="Path 1191"
          d="M24.25,13.228h4.033"
          transform="translate(-0.389 -10.771)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
    </symbol>
    <symbol id="icn-invest" viewBox="0 0 74.341 74.341" fill="currentColor">
      <g transform="translate(0 0)">
        <path
          d="M68.285,959.374a.874.874,0,0,0-.487.27L55.71,972.609a.913.913,0,0,0,.622,1.458c2.837-.018,3.846,0,6.058,0v23.309a.865.865,0,1,0,1.731,0V973.2a.9.9,0,0,0-.865-.865c-2.193,0-3.413,0-4.976,0l10.168-10.857,10.141,10.857c-1.53.006-2.743.016-4.949,0a.9.9,0,0,0-.865.864v58.772H64.12v-8.724a.865.865,0,1,0-1.731,0v9.588a.9.9,0,0,0,.865.864H73.64a.9.9,0,0,0,.865-.864V974.066c2.239.014,3.267.014,6.058,0a.912.912,0,0,0,.622-1.458L69.069,959.644a.884.884,0,0,0-.784-.27ZM44.054,974.932a.87.87,0,0,0-.406.189L31.56,985.492a.912.912,0,0,0,.568,1.54c2.837-.014,3.822,0,6.031,0V989.6a.865.865,0,0,0,1.731.026v-3.457a.9.9,0,0,0-.865-.864h-4.6l9.79-8.373,9.817,8.373c-1.363,0-2.54.011-4.6,0a.9.9,0,0,0-.892.837V989.6a.865.865,0,0,0,1.731.026v-2.592c2.241.01,3.293.01,6.085,0a.913.913,0,0,0,.541-1.54L44.785,975.12a.879.879,0,0,0-.73-.189ZM19.8,987.9a.867.867,0,0,0-.379.189L7.3,998.457a.912.912,0,0,0,.568,1.54c2.839-.009,3.847,0,6.058,0v32.843a.9.9,0,0,0,.865.864H25.178a.9.9,0,0,0,.865-.864v-12.964a.865.865,0,1,0-1.731,0v12.1H15.659V999.132a.9.9,0,0,0-.865-.865H10.2l9.79-8.4,4.651,3.862a.865.865,0,1,0,1.082-1.323l-5.192-4.321a.88.88,0,0,0-.73-.189Zm24.42,6.914a15.557,15.557,0,1,0,15.577,15.557A15.58,15.58,0,0,0,44.217,994.811Zm0,1.728a13.829,13.829,0,1,1-13.846,13.829A13.824,13.824,0,0,1,44.217,996.539Zm-5.3,33.681a.9.9,0,0,0-.757.891v1.729a.9.9,0,0,0,.865.864H49.409a.9.9,0,0,0,.865-.864v-1.729a.865.865,0,1,0-1.731,0v.864H39.89v-.864A.9.9,0,0,0,38.916,1030.219Z"
          transform="translate(-7.039 -959.362)"
          fill="currentColor"
        />
        <path
          d="M2.394-5a3.032,3.032,0,0,1,1.582-2.73V-4.9h.938V-8.064a3.2,3.2,0,0,1,.63-.056,3.243,3.243,0,0,1,.644.056V-4.9h.938V-7.728A3.153,3.153,0,0,1,8.708-4.9H10.64A5.057,5.057,0,0,0,7.126-9.758V-11.2H6.188v1.246A4.816,4.816,0,0,0,5.544-10a4.762,4.762,0,0,0-.63.042V-11.2H3.976v1.442A4.991,4.991,0,0,0,.462-5a3.975,3.975,0,0,0,1.5,3.29H.756V0h9.492V-1.89h-4.7A3.084,3.084,0,0,1,2.394-5Z"
          transform="translate(31.512 55.476)"
          fill="#db0011"
        />
      </g>
    </symbol>
    <symbol id="icn-done" viewBox="0 0 15.84 12.116" fill="currentColor">
      <path
        d="M0,3.375,4.121,7.26,12.1-1.058"
        transform="translate(1.816 3.067) rotate(-1)"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="2.5"
      />
    </symbol>
    <symbol id="icn-open-loan" viewBox="0 0 61.233 63.956" fill="currentColor">
      <g transform="translate(-783.767 -769)">
        <g transform="translate(379.767 244.919)">
          <g
            transform="translate(404 531)"
            fill="none"
            stroke="#242424"
            strokeWidth="1.5"
          >
            <rect width="53.615" height="57.037" rx="4" stroke="none" />
            <rect
              x="0.75"
              y="0.75"
              width="52.115"
              height="55.537"
              rx="3.25"
              fill="none"
            />
          </g>
          <path
            d="M10365.945,1879.406h38.277"
            transform="translate(-9955.161 -1335.395)"
            fill="none"
            stroke="#242424"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <path
            d="M10365.945,1879.406h38.277"
            transform="translate(-9955.161 -1326.269)"
            fill="none"
            stroke="#242424"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <path
            d="M10365.945,1879.417h17.6"
            transform="translate(-9955.163 -1317.153)"
            fill="none"
            stroke="#242424"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <path
            d="M10365.945,1879.406h13.223"
            transform="translate(-9955.161 -1308.017)"
            fill="none"
            stroke="#242424"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <path
            d="M10365.945,1879.406h17.6"
            transform="translate(-9955.161 -1298.891)"
            fill="none"
            stroke="#242424"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <text
            transform="translate(433.233 580.081)"
            fill="#db0011"
            fontSize="29"
            fontFamily="SegoeUI, Segoe UI"
          >
            <tspan x="0" y="0">
              %
            </tspan>
          </text>
        </g>
        <g transform="translate(-18 19.213)">
          <g
            transform="translate(843 749.787)"
            fill="#eff1f4"
            stroke="#db0011"
            strokeWidth="1"
          >
            <circle cx="10" cy="10" r="10" stroke="none" />
            <circle cx="10" cy="10" r="9.5" fill="none" />
          </g>
          <path
            d="M1500.5,3226.609v8.45"
            transform="translate(-647.632 -2471.104)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <path
            d="M0,0V8.45"
            transform="translate(857.093 759.73) rotate(90)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
        </g>
        <path
          d="M1461.527,822.876s-.663,5.14-3.689,7.13-9.743.51-9.743.51,6.562-.473,8.75-3.442a10.893,10.893,0,0,0,2.039-6.245,33.139,33.139,0,0,0,0-4.971l1.912,3.059Z"
          transform="translate(-617 -43)"
          fill="rgba(219,0,17,0.24)"
        />
      </g>
    </symbol>
    <symbol id="icn-home-phone" viewBox="0 0 28.288 28.238" fill="currentColor">
      <g transform="matrix(0.995, 0.105, -0.105, 0.995, -37.593, -50.258)">
        <g transform="translate(45.311 45.772)">
          <path
            d="M65.163,71.46h0a13.292,13.292,0,0,1-4.836-1.052A24.925,24.925,0,0,1,52.1,64.72c-5.291-5.291-7.235-9.226-6.709-13.582a6.989,6.989,0,0,1,2.482-4.583,2.634,2.634,0,0,1,1.873-.782,2.49,2.49,0,0,1,1.775.728l3.789,3.789a2.585,2.585,0,0,1-.051,3.647l-1.084,1.083a.915.915,0,0,0-.141,1.11A16.572,16.572,0,0,0,60.7,62.8a.914.914,0,0,0,1.1-.143l1.09-1.089a2.632,2.632,0,0,1,1.871-.78,2.5,2.5,0,0,1,1.774.726l3.79,3.79a2.59,2.59,0,0,1-.05,3.649l-.005.005a7.053,7.053,0,0,1-4.584,2.479h-.007A5,5,0,0,1,65.163,71.46ZM49.749,46.994a1.419,1.419,0,0,0-1.008.423c-1.35,1.358-1.945,2.195-2.134,3.863-.476,3.941,1.367,7.583,6.359,12.576,5.922,5.922,10.832,6.382,12.2,6.382h0c.225,0,.355-.012.386-.015a5.873,5.873,0,0,0,3.866-2.135,1.366,1.366,0,0,0,.048-1.92l-3.788-3.788a1.28,1.28,0,0,0-.911-.369,1.418,1.418,0,0,0-1.007.422l-1.091,1.089a2.136,2.136,0,0,1-2.583.335,19.062,19.062,0,0,1-4.066-3.046,18.66,18.66,0,0,1-3.034-4.064,2.137,2.137,0,0,1,.332-2.593L54.4,53.071a1.362,1.362,0,0,0,.05-1.919L50.66,47.364A1.276,1.276,0,0,0,49.749,46.994Z"
            transform="translate(-45.311 -45.772)"
            fill="#242424"
          />
        </g>
      </g>
    </symbol>
    <symbol id="icn-at" viewBox="0 0 27.767 27.767" fill="currentColor">
      <g transform="translate(-27 -27)">
        <path
          d="M40.883,27a13.883,13.883,0,1,0,7.062,25.835.937.937,0,0,0,.3-1.268.886.886,0,0,0-1.268-.3,11.879,11.879,0,0,1-6.1,1.69,12.073,12.073,0,1,1,0-24.145A11.809,11.809,0,0,1,52.956,40.883c0,5.433-2.052,5.433-3.018,5.433A3.179,3.179,0,0,1,46.92,43V35.149a.905.905,0,1,0-1.811,0V36.6a5.981,5.981,0,0,0-4.225-1.751,6.036,6.036,0,1,0,0,12.073,5.793,5.793,0,0,0,4.527-2.113,4.923,4.923,0,0,0,4.527,3.32c3.26,0,4.829-2.354,4.829-7.244A13.587,13.587,0,0,0,40.883,27Zm0,18.109a4.225,4.225,0,1,1,4.225-4.225A4.2,4.2,0,0,1,40.883,45.109Z"
          transform="translate(0 0)"
          fill="#242424"
        />
      </g>
    </symbol>
    <symbol id="icn-add-pluse" viewBox="0 0 19.371 19.657" fill="currentColor">
      <g transform="translate(-1484.281 -653.45)">
        <path
          d="M13343.281,567.458h17.371"
          transform="translate(-11858 95.36)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          d="M0,0H17.657"
          transform="translate(1493.967 654.45) rotate(90)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="2"
        />
      </g>
    </symbol>
    <symbol id="icn-depositpay" viewBox="0 0 67.254 66.406" fill="currentColor">
      <g transform="translate(0.5)">
        <path
          d="M1,32.191s-2.67,7.53,3.183,18.776,5.358,7.375,7.365,10.884,1.283,9.041,1.283,9.041H25.99V64.626H36.516v6.266l13.407-.752V63s.246.125,7.015-8.772a19.894,19.894,0,0,0,2.991-4.58c.737-1.158,1.2-4.506,1.2-4.506H66.26l.328-10.713s.627-3.007-2.756-2.882-.378-2.757-6.894-9.273.057-9.522-.945-12.78-4.278-3.194-9.411,0L45.208,10.58l-2.56,2.447-.086.035L35.29,11.6"
          transform="translate(-0.393 -4.986)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <g
          transform="translate(4.042 10.951)"
          fill="none"
          stroke="#242424"
          strokeWidth="0.5"
        >
          <ellipse cx="9.126" cy="9.126" rx="9.126" ry="9.126" stroke="none" />
          <ellipse cx="9.126" cy="9.126" rx="8.876" ry="8.876" fill="none" />
        </g>
        <g
          transform="translate(18.648)"
          fill="none"
          stroke="#242424"
          strokeWidth="0.5"
        >
          <ellipse cx="5.475" cy="5.476" rx="5.475" ry="5.476" stroke="none" />
          <ellipse cx="5.475" cy="5.476" rx="5.225" ry="5.226" fill="none" />
        </g>
        <path
          d="M2579.253,564.906V585.7"
          transform="translate(-2542.879 -542.334)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          d="M2577.536,567.789l7.451,6.926,7.544-6.926"
          transform="translate(-2548.727 -530.443)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </g>
    </symbol>

    <symbol
      id="icn-deposit-no-content"
      viewBox="0 0 67.254 66.406"
      fill="currentColor"
    >
      <g transform="translate(0.5)">
        <path
          d="M1,32.191s-2.67,7.53,3.183,18.776,5.358,7.375,7.365,10.884,1.283,9.041,1.283,9.041H25.99V64.626H36.516v6.266l13.407-.752V63s.246.125,7.015-8.772a19.894,19.894,0,0,0,2.991-4.58c.737-1.158,1.2-4.506,1.2-4.506H66.26l.328-10.713s.627-3.007-2.756-2.882-.378-2.757-6.894-9.273.057-9.522-.945-12.78-4.278-3.194-9.411,0L45.208,10.58l-2.56,2.447-.086.035L35.29,11.6"
          transform="translate(-0.393 -4.986)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <g
          transform="translate(4.042 10.951)"
          fill="none"
          stroke="#242424"
          strokeWidth="0.5"
        >
          <ellipse cx="9.126" cy="9.126" rx="9.126" ry="9.126" stroke="none" />
          <ellipse cx="9.126" cy="9.126" rx="8.876" ry="8.876" fill="none" />
        </g>
        <g
          transform="translate(18.648)"
          fill="none"
          stroke="#242424"
          strokeWidth="0.5"
        >
          <ellipse cx="5.475" cy="5.476" rx="5.475" ry="5.476" stroke="none" />
          <ellipse cx="5.475" cy="5.476" rx="5.225" ry="5.226" fill="none" />
        </g>
      </g>
    </symbol>

    <symbol
      id="icn-depositauto"
      viewBox="0 0 68.079 67.227"
      fill="currentColor"
    >
      <g transform="translate(0.5)">
        <g transform="translate(0 0)">
          <path
            d="M1.008,32.5s-2.7,7.623,3.223,19.01,5.424,7.467,7.456,11.019,1.3,9.153,1.3,9.153H26.308V65.343H36.966v6.344l13.574-.761V63.693s.249.127,7.1-8.881a20.141,20.141,0,0,0,3.028-4.637c.746-1.172,1.213-4.562,1.213-4.562h5.2l.332-10.847s.635-3.045-2.79-2.918-.383-2.791-6.98-9.389.058-9.64-.956-12.939-4.331-3.234-9.528,0l-1.392,1.1L43.174,13.1l-.087.035-7.362-1.479"
            transform="translate(-0.393 -4.96)"
            fill="none"
            stroke="#242424"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <g
            transform="translate(4.092 11.088)"
            fill="none"
            stroke="#242424"
            strokeWidth="0.5"
          >
            <ellipse cx="9.239" cy="9.24" rx="9.239" ry="9.24" stroke="none" />
            <ellipse cx="9.239" cy="9.24" rx="8.989" ry="8.99" fill="none" />
          </g>
          <g
            transform="translate(18.88)"
            fill="none"
            stroke="#242424"
            strokeWidth="0.5"
          >
            <ellipse
              cx="5.544"
              cy="5.544"
              rx="5.544"
              ry="5.544"
              stroke="none"
            />
            <ellipse cx="5.544" cy="5.544" rx="5.294" ry="5.294" fill="none" />
          </g>
        </g>
        <path
          d="M2986.713,566.572v19.154"
          transform="translate(-2950.746 -542.295)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          d="M0,0V19.154"
          transform="translate(45.543 33.853) rotate(90)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
    </symbol>
    <symbol id="icn-depositaccount" viewBox="0 0 133 83" fill="currentColor">
      <g transform="translate(-800 -281)">
        <g
          transform="translate(800 281)"
          fill="#fffbfb"
          stroke="#ebebeb"
          strokeWidth="1"
        >
          <rect width="133" height="83" rx="4" stroke="none" />
          <rect x="0.5" y="0.5" width="132" height="82" rx="3.5" fill="none" />
        </g>
        <path
          d="M525.662,244.944l.055,56.166s-.677,1.915-2.216,2.161-35.109,0-35.109,0,25.556-5.564,29.422-29.953S521.5,226,522.361,223.237s3.3,1.176,3.3,1.176Z"
          transform="translate(406.303 59.733)"
          fill="#141414"
          opacity="0.02"
        />
        <g transform="translate(847.866 305.223)">
          <path
            d="M.714,20.327S-.7,24.3,2.393,30.234s2.827,3.892,3.886,5.743a9.061,9.061,0,0,1,.677,4.771H13.9V37.442h5.555v3.306l7.074-.4V36.582s.13.066,3.7-4.629a10.5,10.5,0,0,0,1.578-2.417,8.858,8.858,0,0,0,.632-2.378h2.709l.173-5.653s.331-1.587-1.454-1.521-.2-1.455-3.638-4.893.03-5.024-.5-6.743-2.257-1.685-4.966,0l-.726.575L22.69,10.214l-.045.018-3.837-.771"
            transform="translate(-0.393 -5.971)"
            fill="none"
            stroke="#242424"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.5"
          />
          <g
            transform="translate(2.133 5.779)"
            fill="none"
            stroke="#db0011"
            strokeWidth="0.5"
          >
            <ellipse
              cx="4.815"
              cy="4.816"
              rx="4.815"
              ry="4.816"
              stroke="none"
            />
            <ellipse cx="4.815" cy="4.816" rx="4.565" ry="4.566" fill="none" />
          </g>
          <g
            transform="translate(9.84)"
            fill="none"
            stroke="#db0011"
            strokeWidth="0.5"
          >
            <ellipse
              cx="2.889"
              cy="2.889"
              rx="2.889"
              ry="2.889"
              stroke="none"
            />
            <ellipse cx="2.889" cy="2.889" rx="2.639" ry="2.639" fill="none" />
          </g>
        </g>
        <path
          d="M2840.1,341.92a2.489,2.489,0,0,1,1.275,2.47c0,1.959.331,3.925-1.377,4.227s-2.748,1.66-4.456.555,2.22-.975,3.854-2.63S2840.1,341.92,2840.1,341.92Z"
          transform="translate(-1982.342 -29.195)"
          fill="rgba(219,0,17,0.39)"
        />
        <path
          d="M2837.991,341.92a1.464,1.464,0,0,1,.734,1.45c0,1.151.191,2.305-.792,2.482s-1.582.975-2.566.326,1.278-.573,2.22-1.544S2837.991,341.92,2837.991,341.92Z"
          transform="translate(-1975.668 -35.544)"
          fill="rgba(219,0,17,0.39)"
        />
        <path
          d="M2858.929,345.118v.621l.575,1.379,2.594,1.213.284,6.178-2.628.426s-2.627,5.61-4.758,7.669-1.136,5.042-1.491,5.255-6.675.568-6.675.568-.355-3.763,3.906-7.882,5.894-4.828,6.249-10.3-.458-6.423.11-7.186S2858.929,345.118,2858.929,345.118Z"
          transform="translate(-1979.617 -28.555)"
          fill="#8a8a8a"
          opacity="0.04"
        />
      </g>
    </symbol>
    <symbol id="icn-saving-deposit" viewBox="0 0 66 63.001" fill="currentColor">
      <g transform="translate(-344 -771)">
        <g transform="translate(343.5 782.338)">
          <g
            transform="translate(0.5 0.5)"
            fill="none"
            stroke="#242424"
            strokeWidth="1"
          >
            <rect width="55.815" height="46.512" rx="2" stroke="none" />
            <rect
              x="0.5"
              y="0.5"
              width="54.815"
              height="45.512"
              rx="1.5"
              fill="none"
            />
          </g>
          <path
            d="M-7816.729,576.81a1.148,1.148,0,0,1-.873-.386,1.374,1.374,0,0,1-.4-1.056V544.263a1.361,1.361,0,0,1,.4-1.054,1.348,1.348,0,0,1,.967-.4h39.7a1.348,1.348,0,0,1,.967.4,1.369,1.369,0,0,1,.4,1.053v6.4h1.467a1.248,1.248,0,0,1,1.162,1.163,1.252,1.252,0,0,1-1.162,1.163h-1.467v14.247h1.453a1.245,1.245,0,0,1,1.162,1.163,1.25,1.25,0,0,1-1.162,1.163h-1.453v5.814a1.4,1.4,0,0,1-.4,1.051,1.362,1.362,0,0,1-.973.405h-.076l-39.635-.016Z"
            transform="translate(7824.315 -536.484)"
            fill="none"
            stroke="#262630"
            strokeWidth="1"
          />
          <g transform="translate(7.479 45.925)" fill="none">
            <path
              d="M10.625,5.737H1a1,1,0,0,1-1-1V0H11.626V4.737A1,1,0,0,1,10.625,5.737Z"
              stroke="none"
            />
            <path
              d="M 10.62620067596436 4.736700057983398 L 10.62620067596436 0.9973000288009644 L 0.9974691867828369 0.9973000288009644 L 0.9981003999710083 4.736599922180176 L 10.62540054321289 4.736599922180176 L 10.62620067596436 4.736700057983398 M 10.62540054321289 5.736599922180176 L 0.9981003999710083 5.736599922180176 C 0.4462604224681854 5.736599922180176 -0.00269958795979619 5.288050174713135 -0.00269958795979619 4.736700057983398 L -0.00269958795979619 -0.002699964912608266 L 11.62620067596436 -0.002699964912608266 L 11.62620067596436 4.736700057983398 C 11.62620067596436 5.288050174713135 11.1772403717041 5.736599922180176 10.62540054321289 5.736599922180176 Z"
              stroke="none"
              fill="#242424"
            />
          </g>
          <g transform="translate(37.712 45.925)" fill="none">
            <path
              d="M10.625,5.738H1a1,1,0,0,1-1-1V0H11.626V4.739A1,1,0,0,1,10.625,5.738Z"
              stroke="none"
            />
            <path
              d="M 10.62620067596436 4.738500118255615 L 10.62620067596436 1.002699971199036 L 0.9974693655967712 1.002699971199036 L 0.9981003999710083 4.738399982452393 L 10.62540054321289 4.738399982452393 L 10.62620067596436 4.738500118255615 M 10.62540054321289 5.738399982452393 L 0.9981003999710083 5.738399982452393 C 0.4462604224681854 5.738399982452393 -0.00269958795979619 5.289849758148193 -0.00269958795979619 4.738500118255615 L -0.00269958795979619 0.002699917182326317 L 11.62620067596436 0.002699917182326317 L 11.62620067596436 4.738500118255615 C 11.62620067596436 5.289849758148193 11.1772403717041 5.738399982452393 10.62540054321289 5.738399982452393 Z"
              stroke="none"
              fill="#242424"
            />
          </g>
          <g
            transform="translate(9.802 19.105)"
            fill="none"
            stroke="#db0011"
            strokeWidth="1"
          >
            <circle cx="3.488" cy="3.488" r="3.488" stroke="none" />
            <circle cx="3.488" cy="3.488" r="2.988" fill="none" />
          </g>
          <path
            d="M1756.156,72.191v2.544"
            transform="translate(-1742.865 -46.437)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="1"
          />
        </g>
        <g transform="translate(-453 21.213)">
          <g
            transform="translate(843 749.787)"
            fill="#eff1f4"
            stroke="#db0011"
            strokeWidth="1"
          >
            <circle cx="10" cy="10" r="10" stroke="none" />
            <circle cx="10" cy="10" r="9.5" fill="none" />
          </g>
          <path
            d="M1500.5,3226.609v8.45"
            transform="translate(-647.632 -2471.104)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <path
            d="M0,0V8.45"
            transform="translate(857.093 759.73) rotate(90)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <path
            d="M1461.527,822.876s-.663,5.14-3.689,7.13-9.743.51-9.743.51,6.562-.473,8.75-3.442a10.893,10.893,0,0,0,2.039-6.245,33.139,33.139,0,0,0,0-4.971l1.912,3.059Z"
            transform="translate(-599 -62.213)"
            fill="rgba(219,0,17,0.24)"
          />
        </g>
      </g>
    </symbol>
    <symbol
      id="icn-terms-deposit"
      viewBox="0 0 60.429 71.773"
      fill="currentColor"
    >
      <g transform="translate(-784.571 -769)">
        <g transform="translate(436.934 716.284)">
          <path
            d="M15145.4,527h2.959"
            transform="translate(-14788.23 -440.293)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="1"
          />
          <path
            d="M15145.4,527h2.959"
            transform="translate(-14788.23 -431.421)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="1"
          />
          <path
            d="M15145.4,527h2.959"
            transform="translate(-14788.23 -422.549)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="1"
          />
          <path
            d="M15145.4,527h2.959"
            transform="translate(-14776.277 -440.293)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="1"
          />
          <path
            d="M15145.4,527h2.959"
            transform="translate(-14776.277 -431.421)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="1"
          />
          <path
            d="M15145.4,527h2.959"
            transform="translate(-14764.447 -440.293)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="1"
          />
          <g transform="translate(347.638 62.216)">
            <g
              transform="translate(0 4.982)"
              fill="none"
              stroke="#242424"
              strokeWidth="1"
            >
              <rect width="52.308" height="49.819" rx="2" stroke="none" />
              <rect
                x="0.5"
                y="0.5"
                width="51.308"
                height="48.819"
                rx="1.5"
                fill="none"
              />
            </g>
            <path
              d="M15169.976,567.965h50.24"
              transform="translate(-15168.965 -550.616)"
              fill="none"
              stroke="#242424"
              strokeWidth="1"
            />
            <g
              transform="translate(12.456)"
              fill="none"
              stroke="#242424"
              strokeWidth="1"
            >
              <rect width="7.473" height="12.455" rx="2" stroke="none" />
              <rect
                x="0.5"
                y="0.5"
                width="6.473"
                height="11.455"
                rx="1.5"
                fill="none"
              />
            </g>
            <g
              transform="translate(32.381)"
              fill="none"
              stroke="#242424"
              strokeWidth="1"
            >
              <rect width="7.473" height="12.455" rx="2" stroke="none" />
              <rect
                x="0.5"
                y="0.5"
                width="6.473"
                height="11.455"
                rx="1.5"
                fill="none"
              />
            </g>
            <g transform="translate(29.888 32.382)" fill="#fff">
              <path
                d="M 14.94524002075195 29.39113616943359 C 11.08677959442139 29.39113616943359 7.459259986877441 27.88853454589844 4.73091983795166 25.16012573242188 C 2.002569913864136 22.43172454833984 0.5 18.80411529541016 0.5 14.94556522369385 C 0.5 11.08701515197754 2.002569913864136 7.459415435791016 4.73091983795166 4.731005191802979 C 7.459259986877441 2.002605199813843 11.08677959442139 0.5000052452087402 14.94524002075195 0.5000052452087402 C 18.8036994934082 0.5000052452087402 22.43121910095215 2.002605199813843 25.15955924987793 4.731005191802979 C 27.88791084289551 7.459415435791016 29.39048004150391 11.08701515197754 29.39048004150391 14.94556522369385 C 29.39048004150391 18.80411529541016 27.88791084289551 22.43172454833984 25.15955924987793 25.16012573242188 C 22.43121910095215 27.88853454589844 18.8036994934082 29.39113616943359 14.94524002075195 29.39113616943359 Z"
                stroke="none"
              />
              <path
                d="M 14.94524002075195 0.9999942779541016 C 11.22032928466797 0.9999942779541016 7.718379974365234 2.450584411621094 5.084470748901367 5.084554672241211 C 2.450559616088867 7.718524932861328 1 11.22056579589844 1 14.94556522369385 C 1 18.67056655883789 2.450559616088867 22.17260551452637 5.084470748901367 24.80657577514648 C 7.718379974365234 27.4405345916748 11.22032928466797 28.8911247253418 14.94524002075195 28.8911247253418 C 18.67015075683594 28.8911247253418 22.17210006713867 27.4405345916748 24.80601119995117 24.80657577514648 C 27.43992042541504 22.17260551452637 28.89048004150391 18.67056655883789 28.89048004150391 14.94556522369385 C 28.89048004150391 11.22056579589844 27.43992042541504 7.718524932861328 24.80601119995117 5.084554672241211 C 22.17210006713867 2.450584411621094 18.67015075683594 0.9999942779541016 14.94524002075195 0.9999942779541016 M 14.94524002075195 -5.7220458984375e-06 C 23.19927024841309 -5.7220458984375e-06 29.89048004150391 6.691354751586914 29.89048004150391 14.94556522369385 C 29.89048004150391 23.19977569580078 23.19927024841309 29.8911247253418 14.94524002075195 29.8911247253418 C 6.69120979309082 29.8911247253418 0 23.19977569580078 0 14.94556522369385 C 0 6.691354751586914 6.69120979309082 -5.7220458984375e-06 14.94524002075195 -5.7220458984375e-06 Z"
                stroke="none"
                fill="#242424"
              />
            </g>
            <path
              d="M3.2-6.045A2.291,2.291,0,0,0,5.565-8.37,2.309,2.309,0,0,0,3.2-10.7,2.318,2.318,0,0,0,.825-8.37,2.309,2.309,0,0,0,3.2-6.045Zm0-1.095A1.183,1.183,0,0,1,2-8.37,1.179,1.179,0,0,1,3.2-9.585a1.17,1.17,0,0,1,1.2,1.215A1.182,1.182,0,0,1,3.2-7.14Zm5.31-2.145L1.53-1.485l.72.42L9.24-8.88ZM7.725.18A2.309,2.309,0,0,0,10.1-2.145,2.309,2.309,0,0,0,7.725-4.47a2.309,2.309,0,0,0-2.37,2.325A2.309,2.309,0,0,0,7.725.18Zm0-1.11a1.17,1.17,0,0,1-1.2-1.215,1.17,1.17,0,0,1,1.2-1.215,1.179,1.179,0,0,1,1.2,1.215A1.179,1.179,0,0,1,7.725-.93Z"
              transform="translate(39.428 52.5)"
              fill="#db0011"
            />
          </g>
        </g>
        <g transform="translate(-18 19.213)">
          <g
            transform="translate(843 749.787)"
            fill="#eff1f4"
            stroke="#db0011"
            strokeWidth="1"
          >
            <circle cx="10" cy="10" r="10" stroke="none" />
            <circle cx="10" cy="10" r="9.5" fill="none" />
          </g>
          <path
            d="M1500.5,3226.609v8.45"
            transform="translate(-647.632 -2471.104)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <path
            d="M0,0V8.45"
            transform="translate(857.093 759.73) rotate(90)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
        </g>
        <path
          d="M1461.527,822.876s-.663,5.14-3.689,7.13-9.743.51-9.743.51,6.562-.473,8.75-3.442a10.893,10.893,0,0,0,2.039-6.245,33.139,33.139,0,0,0,0-4.971l1.912,3.059Z"
          transform="translate(-617 -43)"
          fill="rgba(219,0,17,0.24)"
        />
      </g>
    </symbol>
    <symbol id="icn-home-phone" viewBox="0 0 28.288 28.238" fill="currentColor">
      <g transform="matrix(0.995, 0.105, -0.105, 0.995, -37.593, -50.258)">
        <g transform="translate(45.311 45.772)">
          <path
            d="M65.163,71.46h0a13.292,13.292,0,0,1-4.836-1.052A24.925,24.925,0,0,1,52.1,64.72c-5.291-5.291-7.235-9.226-6.709-13.582a6.989,6.989,0,0,1,2.482-4.583,2.634,2.634,0,0,1,1.873-.782,2.49,2.49,0,0,1,1.775.728l3.789,3.789a2.585,2.585,0,0,1-.051,3.647l-1.084,1.083a.915.915,0,0,0-.141,1.11A16.572,16.572,0,0,0,60.7,62.8a.914.914,0,0,0,1.1-.143l1.09-1.089a2.632,2.632,0,0,1,1.871-.78,2.5,2.5,0,0,1,1.774.726l3.79,3.79a2.59,2.59,0,0,1-.05,3.649l-.005.005a7.053,7.053,0,0,1-4.584,2.479h-.007A5,5,0,0,1,65.163,71.46ZM49.749,46.994a1.419,1.419,0,0,0-1.008.423c-1.35,1.358-1.945,2.195-2.134,3.863-.476,3.941,1.367,7.583,6.359,12.576,5.922,5.922,10.832,6.382,12.2,6.382h0c.225,0,.355-.012.386-.015a5.873,5.873,0,0,0,3.866-2.135,1.366,1.366,0,0,0,.048-1.92l-3.788-3.788a1.28,1.28,0,0,0-.911-.369,1.418,1.418,0,0,0-1.007.422l-1.091,1.089a2.136,2.136,0,0,1-2.583.335,19.062,19.062,0,0,1-4.066-3.046,18.66,18.66,0,0,1-3.034-4.064,2.137,2.137,0,0,1,.332-2.593L54.4,53.071a1.362,1.362,0,0,0,.05-1.919L50.66,47.364A1.276,1.276,0,0,0,49.749,46.994Z"
            transform="translate(-45.311 -45.772)"
            fill="#242424"
          />
        </g>
      </g>
    </symbol>
    <symbol id="icn-at" viewBox="0 0 27.767 27.767" fill="currentColor">
      <g transform="translate(-27 -27)">
        <path
          d="M40.883,27a13.883,13.883,0,1,0,7.062,25.835.937.937,0,0,0,.3-1.268.886.886,0,0,0-1.268-.3,11.879,11.879,0,0,1-6.1,1.69,12.073,12.073,0,1,1,0-24.145A11.809,11.809,0,0,1,52.956,40.883c0,5.433-2.052,5.433-3.018,5.433A3.179,3.179,0,0,1,46.92,43V35.149a.905.905,0,1,0-1.811,0V36.6a5.981,5.981,0,0,0-4.225-1.751,6.036,6.036,0,1,0,0,12.073,5.793,5.793,0,0,0,4.527-2.113,4.923,4.923,0,0,0,4.527,3.32c3.26,0,4.829-2.354,4.829-7.244A13.587,13.587,0,0,0,40.883,27Zm0,18.109a4.225,4.225,0,1,1,4.225-4.225A4.2,4.2,0,0,1,40.883,45.109Z"
          transform="translate(0 0)"
          fill="#242424"
        />
      </g>
    </symbol>
    <symbol id="icn-view" viewBox="0 0 11.987 8.151" fill="currentColor">
      <g transform="translate(-56 -120)">
        <g transform="translate(56 120)">
          <g transform="translate(0 0)">
            <path
              d="M61.993,128.151a6.945,6.945,0,0,1-4.219-1.611A4.3,4.3,0,0,1,56,124.076a4.3,4.3,0,0,1,1.775-2.464,6.329,6.329,0,0,1,8.438,0,4.3,4.3,0,0,1,1.775,2.464,4.3,4.3,0,0,1-1.775,2.464A6.945,6.945,0,0,1,61.993,128.151Zm0-7.672a6.466,6.466,0,0,0-3.918,1.505,6.6,6.6,0,0,0-1.189,1.227,1.682,1.682,0,0,0-.407.864,4.044,4.044,0,0,0,1.6,2.091,5.852,5.852,0,0,0,7.836,0,6.6,6.6,0,0,0,1.189-1.227,1.682,1.682,0,0,0,.407-.864,4.044,4.044,0,0,0-1.6-2.091A6.466,6.466,0,0,0,61.993,120.479Z"
              transform="translate(-56 -120)"
              fill="currentColor"
            />
          </g>
        </g>
        <g transform="translate(59.836 121.918)">
          <g transform="translate(0 0)">
            <path
              d="M186.158,188.315a2.158,2.158,0,1,1,2.158-2.158A2.16,2.16,0,0,1,186.158,188.315Zm0-3.836a1.678,1.678,0,1,0,1.678,1.678A1.68,1.68,0,0,0,186.158,184.479Z"
              transform="translate(-184 -184)"
              fill="currentColor"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="icn-chat" viewBox="0 0 27 19.017" fill="currentColor">
      <g id="chat" transform="translate(-11101 820)">
        <g
          id="Path_2212"
          data-name="Path 2212"
          transform="translate(11101 -820)"
          fill="#fff"
        >
          <path
            d="M 19 15.5 L 8 15.5 C 3.864490032196045 15.5 0.5 12.13551044464111 0.5 8 C 0.5 3.864490032196045 3.864490032196045 0.5 8 0.5 L 19 0.5 C 23.1355094909668 0.5 26.5 3.864490032196045 26.5 8 C 26.5 12.13551044464111 23.1355094909668 15.5 19 15.5 Z"
            stroke="none"
          />
          <path
            d="M 8 1 C 4.140190124511719 1 1 4.140190124511719 1 8 C 1 11.85980987548828 4.140190124511719 15 8 15 L 19 15 C 22.85980987548828 15 26 11.85980987548828 26 8 C 26 4.140190124511719 22.85980987548828 1 19 1 L 8 1 M 8 0 L 19 0 C 23.41827964782715 0 27 3.581720352172852 27 8 C 27 12.41827964782715 23.41827964782715 16 19 16 L 8 16 C 3.581720352172852 16 0 12.41827964782715 0 8 C 0 3.581720352172852 3.581720352172852 0 8 0 Z"
            stroke="none"
            fill="#8d8f93"
          />
        </g>
        <circle
          id="Ellipse_107"
          data-name="Ellipse 107"
          cx="2"
          cy="2"
          r="2"
          transform="translate(11107 -814)"
          fill="#8d8f93"
        />
        <circle
          id="Ellipse_108"
          data-name="Ellipse 108"
          cx="2"
          cy="2"
          r="2"
          transform="translate(11113 -814)"
          fill="#8d8f93"
        />
        <circle
          id="Ellipse_109"
          data-name="Ellipse 109"
          cx="2"
          cy="2"
          r="2"
          transform="translate(11119 -814)"
          fill="#8d8f93"
        />
        <path
          id="Path_2210"
          data-name="Path 2210"
          d="M11108.585-808.581l3.386,2.978,4.8-2.978"
          transform="translate(0 4)"
          fill="none"
          stroke="#8d8f93"
          strokeWidth="1"
        />
      </g>
    </symbol>
    <symbol id="icn-warr-notif" viewBox="0 0 37.238 34.421" fill="currentColor">
      <g
        id="Group_2169"
        data-name="Group 2169"
        transform="translate(-12390.717 -4715.228)"
      >
        <path
          id="Path_2213"
          data-name="Path 2213"
          d="M12411.46,4722.191l-17.818,32.421h35.239Z"
          transform="translate(-1.926 -5.963)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_2214"
          data-name="Path 2214"
          d="M12409.487,4732.688v7.809"
          transform="translate(0 2.313)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          id="Path_2215"
          data-name="Path 2215"
          d="M12409.487,4732.688v1.234"
          transform="translate(0 -3)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeWidth="2"
        />
      </g>
    </symbol>
    <symbol id="icn-owncard" viewBox="0 0 53 39" fill="currentColor">
      <g
        id="Group_2303"
        data-name="Group 2303"
        transform="translate(-809 -348.008)"
      >
        <g
          id="Rectangle_874"
          data-name="Rectangle 874"
          transform="translate(809 360.008)"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <rect width="40" height="27" rx="3" stroke="none" />
          <rect
            x="0.75"
            y="0.75"
            width="38.5"
            height="25.5"
            rx="2.25"
            fill="none"
          />
        </g>
        <g
          id="Path_5850"
          data-name="Path 5850"
          transform="translate(822 348.008)"
          fill="none"
        >
          <path
            d="M3,0H37a3,3,0,0,1,3,3V24a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z"
            stroke="none"
          />
          <path
            d="M 3 1.5 C 2.172901153564453 1.5 1.5 2.17289924621582 1.5 3 L 1.5 24 C 1.5 24.82710075378418 2.172901153564453 25.5 3 25.5 L 37 25.5 C 37.82709884643555 25.5 38.5 24.82710075378418 38.5 24 L 38.5 3 C 38.5 2.17289924621582 37.82709884643555 1.5 37 1.5 L 3 1.5 M 3 0 L 37 0 C 38.6568489074707 0 40 1.3431396484375 40 3 L 40 24 C 40 25.65685081481934 38.6568489074707 27 37 27 L 3 27 C 1.343151092529297 27 0 25.65685081481934 0 24 L 0 3 C 0 1.3431396484375 1.343151092529297 0 3 0 Z"
            stroke="none"
            fill="currentColor"
          />
        </g>
        <path
          id="Path_5843"
          data-name="Path 5843"
          d="M2842.181,371.751h12.133"
          transform="translate(-2032.314 -2.935)"
          fill="none"
          stroke="currentColor"
          strokeWidth="1"
        />
        <path
          id="Path_5848"
          data-name="Path 5848"
          d="M2842.181,371.751h38.057"
          transform="translate(-2019.203 -16.935)"
          fill="none"
          stroke="currentColor"
          strokeWidth="1"
        />
        <path
          id="Path_5844"
          data-name="Path 5844"
          d="M2842.181,371.751h5.567"
          transform="translate(-2004.217 10.069)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          id="Path_5845"
          data-name="Path 5845"
          d="M2842.181,371.751h.751"
          transform="translate(-2028.474 3.317)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          id="Path_5846"
          data-name="Path 5846"
          d="M2881.856,371.751h14.153"
          transform="translate(-2041.061 -4.436)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1.5"
        />
        <path
          id="Path_5847"
          data-name="Path 5847"
          d="M2895.566,367.526l3.32,3.155-3.32,3.32"
          transform="translate(-2043.129 -3.381)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          id="Path_5849"
          data-name="Path 5849"
          d="M2895.566,367.526l3.32,3.155-3.32,3.32"
          transform="translate(3739.324 738.145) rotate(180)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </symbol>

    <symbol id="icn-owncard-new" viewBox="0 0 55 42" fill="currentColor">
      <g id="p2p" transform="translate(63 -333.935)">
        <g
          id="Rectangle_912"
          data-name="Rectangle 912"
          transform="translate(-58 333.935)"
          fill="none"
          stroke="#242424"
          strokeWidth="1.5"
        >
          <rect width="46" height="37" rx="4" stroke="none" />
          <rect
            x="0.75"
            y="0.75"
            width="44.5"
            height="35.5"
            rx="3.25"
            fill="none"
          />
        </g>
        <g
          id="Rectangle_913"
          data-name="Rectangle 913"
          transform="translate(-34 344.935)"
          fill="#f4f4f8"
          stroke="#242424"
          strokeWidth="1.5"
        >
          <rect width="26" height="15" rx="2" stroke="none" />
          <rect
            x="0.75"
            y="0.75"
            width="24.5"
            height="13.5"
            rx="1.25"
            fill="none"
          />
        </g>
        <g
          id="Ellipse_91"
          data-name="Ellipse 91"
          transform="translate(-28 348.935)"
          fill="none"
          stroke="#db0011"
          strokeWidth="1.5"
        >
          <circle cx="3.5" cy="3.5" r="3.5" stroke="none" />
          <circle cx="3.5" cy="3.5" r="2.75" fill="none" />
        </g>
        <g
          id="Path_5962"
          data-name="Path 5962"
          transform="translate(-63 357.702)"
          fill="#f4f4f8"
        >
          <path
            d="M 9.1162109375 17.732421875 C 4.36522102355957 17.732421875 0.5000009536743164 13.86720085144043 0.5000009536743164 9.1162109375 C 0.5000009536743164 4.36522102355957 4.36522102355957 0.5000009536743164 9.1162109375 0.5000009536743164 C 13.86720085144043 0.5000009536743164 17.732421875 4.36522102355957 17.732421875 9.1162109375 C 17.732421875 13.86720085144043 13.86720085144043 17.732421875 9.1162109375 17.732421875 Z"
            stroke="none"
          />
          <path
            d="M 9.1162109375 1 C 4.640920639038086 1 1 4.640920639038086 1 9.1162109375 C 1 13.59150123596191 4.640920639038086 17.232421875 9.1162109375 17.232421875 C 13.59150123596191 17.232421875 17.232421875 13.59150123596191 17.232421875 9.1162109375 C 17.232421875 4.640920639038086 13.59150123596191 1 9.1162109375 1 M 9.1162109375 0 C 14.15096092224121 0 18.232421875 4.081470489501953 18.232421875 9.1162109375 C 18.232421875 14.15096092224121 14.15096092224121 18.232421875 9.1162109375 18.232421875 C 4.081470489501953 18.232421875 0 14.15096092224121 0 9.1162109375 C 0 4.081470489501953 4.081470489501953 0 9.1162109375 0 Z"
            stroke="none"
            fill="#db0011"
          />
        </g>
        <path
          id="Path_782"
          data-name="Path 782"
          d="M10.322,3.894l-1.375.79A3.859,3.859,0,0,1,9.484,6.66,3.952,3.952,0,1,1,5.3,2.709v.9c0,.348.253.49.553.316l.854-.49L7.793,2.8l.854-.49a.334.334,0,0,0,0-.632l-.854-.49L6.7.559,5.849.085C5.548-.089,5.3.037,5.3.369v.759a5.535,5.535,0,1,0,5.77,5.532A5.486,5.486,0,0,0,10.322,3.894Z"
          transform="translate(-59.236 360.66)"
          fill="#242424"
        />
      </g>
    </symbol>

    <symbol id="icn-to-other" viewBox="0 0 42.066 41" fill="currentColor">
      <g id="other" transform="translate(585.433 855.604)">
        <g
          id="Rectangle_911"
          data-name="Rectangle 911"
          transform="translate(-576.433 -855.604)"
          fill="none"
          stroke="#242424"
          strokeWidth="1.5"
        >
          <rect width="33" height="25" rx="2" stroke="none" />
          <rect
            x="0.75"
            y="0.75"
            width="31.5"
            height="23.5"
            rx="1.25"
            fill="none"
          />
        </g>
        <path
          id="Path_5960"
          data-name="Path 5960"
          d="M-564.532-842.321v4.476"
          transform="translate(14.605 9.268)"
          fill="none"
          stroke="#f4f4f8"
          strokeWidth="1"
        />
        <path
          id="Path_5961"
          data-name="Path 5961"
          d="M0,0V4.476"
          transform="matrix(-0.017, 1, -1, -0.017, -573.274, -842.715)"
          fill="none"
          stroke="#f4f4f8"
          strokeWidth="1.5"
        />
        <path
          id="Path_5957"
          data-name="Path 5957"
          d="M-586-826.618h32.528"
          transform="translate(10.105 -20.327)"
          fill="none"
          stroke="#242424"
          strokeWidth="1.5"
        />
        <g
          id="Rectangle_910"
          data-name="Rectangle 910"
          transform="translate(-585.433 -842.604)"
          fill="#f4f4f8"
          stroke="#242424"
          strokeWidth="1.5"
        >
          <rect width="35" height="28" rx="2" stroke="none" />
          <rect
            x="0.75"
            y="0.75"
            width="33.5"
            height="26.5"
            rx="1.25"
            fill="none"
          />
        </g>
        <path
          id="Path_5956"
          data-name="Path 5956"
          d="M-586-826.618h33.458"
          transform="translate(1.468 -6.832)"
          fill="#fff"
          stroke="#242424"
          strokeWidth="1.5"
        />
        <path
          id="Path_5958"
          data-name="Path 5958"
          d="M-545.883-826.618h8.548"
          transform="translate(-18.707 1.127)"
          fill="#fff"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          id="Path_5959"
          data-name="Path 5959"
          d="M-545.883-826.618h4.274"
          transform="translate(-18.707 4.1)"
          fill="#fff"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
    </symbol>

    <symbol
      id="icn-with-mobile"
      viewBox="0 0 24.169 42.968"
      fill="currentColor"
    >
      <g id="withmobail" transform="translate(54 -332.942)">
        <g
          id="Group_3166"
          data-name="Group 3166"
          transform="translate(-54 332.942)"
        >
          <g id="noun_Phone_1628280" transform="translate(0 0)">
            <g id="Group_1860" data-name="Group 1860">
              <path
                id="Path_734"
                data-name="Path 734"
                d="M34.813,0H17.357A3.357,3.357,0,0,0,14,3.357V39.611a3.357,3.357,0,0,0,3.357,3.357H34.813a3.357,3.357,0,0,0,3.357-3.357V3.357A3.357,3.357,0,0,0,34.813,0Zm2.014,39.611a2.014,2.014,0,0,1-2.014,2.014H17.357a2.014,2.014,0,0,1-2.014-2.014V37.6H36.827Zm0-3.357H15.343V6.714H36.827Zm0-30.883H15.343V3.357a2.014,2.014,0,0,1,2.014-2.014H34.813a2.014,2.014,0,0,1,2.014,2.014Z"
                transform="translate(-14 0)"
                fill="#242424"
              />
              <path
                id="Path_739"
                data-name="Path 739"
                d="M0,1.992,2.011,0"
                transform="translate(12.15 1.593) rotate(45)"
                fill="none"
                stroke="#db0011"
                strokeLinecap="round"
                strokeWidth="1"
              />
              <circle
                id="Ellipse_1"
                data-name="Ellipse 1"
                cx="1.343"
                cy="1.343"
                r="1.343"
                transform="translate(10.742 38.268)"
                fill="#db0011"
              />
            </g>
          </g>
        </g>
        <g
          id="Group_3167"
          data-name="Group 3167"
          transform="translate(-50.197 349.612)"
        >
          <path
            id="Path_819"
            data-name="Path 819"
            d="M0,30.269l8.72-.2"
            transform="translate(7.128 -26.688)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="1"
          />
          <path
            id="Path_956"
            data-name="Path 956"
            d="M0,.2,8.72,0"
            transform="translate(9.175 6.682) rotate(180)"
            fill="none"
            stroke="#242424"
            strokeLinecap="round"
            strokeWidth="1"
          />
          <path
            id="Path_820"
            data-name="Path 820"
            d="M10.312,24.031l3.4,3.453-3.4,3.294"
            transform="translate(2.59 -24.031)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="1"
          />
          <path
            id="Path_957"
            data-name="Path 957"
            d="M0,0,3.4,3.453,0,6.747"
            transform="translate(3.401 10.063) rotate(180)"
            fill="none"
            stroke="#242424"
            strokeLinecap="round"
            strokeWidth="1"
          />
        </g>
      </g>
    </symbol>

    <symbol id="icn-cardnumber" viewBox="0 0 61.742 36" fill="currentColor">
      <g
        id="Group_2302"
        data-name="Group 2302"
        transform="translate(-809 -360)"
      >
        <g
          id="Path_5851"
          data-name="Path 5851"
          transform="translate(809 360)"
          fill="none"
        >
          <path
            d="M3,0H50a3,3,0,0,1,3,3V33a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z"
            stroke="none"
          />
          <path
            d="M 3 1.5 C 2.172901153564453 1.5 1.5 2.172901153564453 1.5 3 L 1.5 33 C 1.5 33.82709884643555 2.172901153564453 34.5 3 34.5 L 50 34.5 C 50.82709884643555 34.5 51.5 33.82709884643555 51.5 33 L 51.5 3 C 51.5 2.172901153564453 50.82709884643555 1.5 50 1.5 L 3 1.5 M 3 0 L 50 0 C 51.6568489074707 0 53 1.343151092529297 53 3 L 53 33 C 53 34.6568489074707 51.6568489074707 36 50 36 L 3 36 C 1.343151092529297 36 0 34.6568489074707 0 33 L 0 3 C 0 1.343151092529297 1.343151092529297 0 3 0 Z"
            stroke="none"
            fill="currentColor"
          />
        </g>
        <path
          id="Path_5843"
          data-name="Path 5843"
          d="M2842.181,371.751h51.094"
          transform="translate(-2032.247)"
          fill="none"
          stroke="currentColor"
          strokeWidth="1"
        />
        <path
          id="Path_5844"
          data-name="Path 5844"
          d="M2842.181,371.751h7.42"
          transform="translate(-1994.573 16)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          id="Path_5845"
          data-name="Path 5845"
          d="M2842.181,371.751h3.073"
          transform="translate(-2025.573 7)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          id="Path_5846"
          data-name="Path 5846"
          d="M2881.856,371.751h18.056"
          transform="translate(-2031 -6)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1.5"
        />
        <path
          id="Path_5847"
          data-name="Path 5847"
          d="M2895.566,367.526l4.425,4.205-4.425,4.425"
          transform="translate(-2030 -6)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </symbol>

    <symbol
      id="icn-mobilenumber"
      viewBox="0 0 36.664 45.189"
      fill="currentColor"
    >
      <path
        id="XMLID_17_"
        d="M9.344,2.1h3.908a.263.263,0,0,1,.244.244v.611a.263.263,0,0,1-.244.244H9.344A.263.263,0,0,1,9.1,2.955V2.344A.263.263,0,0,1,9.344,2.1Z"
        transform="translate(2.014 0.465)"
        fill="#2a2a2a"
      />
      <path
        id="XMLID_14_"
        d="M9.1,33.8a2.2,2.2,0,1,0,2.2-2.2h0a2.189,2.189,0,0,0-2.2,2.2Zm3.664,0A1.466,1.466,0,1,1,11.3,32.333h0A1.411,1.411,0,0,1,12.764,33.8Z"
        transform="translate(2.014 6.993)"
        fill="#2a2a2a"
      />
      <path
        id="XMLID_9_"
        d="M22.1,10.1a5.378,5.378,0,0,0-1.954.244h-.366a9.579,9.579,0,0,0-4.03.855,8.91,8.91,0,0,0-7.939,9.77,9.08,9.08,0,0,0,7.939,7.939,9.2,9.2,0,0,0,4.03.855h.366a9.892,9.892,0,0,0,3.786-19.419A4.747,4.747,0,0,0,22.1,10.1ZM11.106,19.993a8.622,8.622,0,0,1,4.885-7.816A10.023,10.023,0,0,0,14.281,26.1a11.317,11.317,0,0,0,1.71,1.71A8.841,8.841,0,0,1,11.106,19.993Zm-2.2,0a7.909,7.909,0,0,1,4.03-6.839,9.656,9.656,0,0,0,0,13.679,7.666,7.666,0,0,1-4.03-6.839ZM22.1,28.42a8.549,8.549,0,1,1,8.549-8.671A8.574,8.574,0,0,1,22.1,28.42Z"
        transform="translate(4.718 2.235)"
        fill="#2a2a2a"
      />
      <path
        id="XMLID_8_"
        d="M22.563,9.762V5.61a1.67,1.67,0,0,0-1.71-1.71H4.61A1.67,1.67,0,0,0,2.9,5.61V35.288A1.67,1.67,0,0,0,4.61,37H20.853a1.67,1.67,0,0,0,1.71-1.71v-2.2c-.489,0-.977-.122-1.466-.122V35.41a.263.263,0,0,1-.244.244H4.61a.263.263,0,0,1-.244-.244V5.61c-.122-.122,0-.244.244-.366H20.853a.263.263,0,0,1,.244.244V9.762A5.885,5.885,0,0,0,22.563,9.762Z"
        transform="translate(0.642 0.863)"
        fill="#2a2a2a"
      />
      <g id="XMLID_3_">
        <path
          id="XMLID_7_"
          d="M25.159,41.709a2.067,2.067,0,0,1-2.2,2.136H3.664a2.319,2.319,0,0,1-2.32-2.32V3.664a2.381,2.381,0,0,1,2.32-2.2h19.3a2.319,2.319,0,0,1,2.32,2.32v6.961a6.13,6.13,0,0,1,1.466.244V3.664A3.674,3.674,0,0,0,23.083,0H3.664A3.757,3.757,0,0,0,0,3.664V41.525a3.674,3.674,0,0,0,3.664,3.664h19.3a3.674,3.674,0,0,0,3.664-3.664V33.708a6.13,6.13,0,0,1-1.466.244v7.757Z"
          fill="#2a2a2a"
        />
        <g id="XMLID_4_" transform="translate(22.175 15.022)">
          <path
            id="XMLID_5_"
            d="M20.707,23.658h4.4v.977H16.066v-.977H18.02a6.712,6.712,0,0,1-1.1-.855,8.571,8.571,0,0,1-.733-1.1c-.122-.366-.244-.733-.366-1.221a5.01,5.01,0,0,1-.122-1.343,6.964,6.964,0,0,1,.122-1.588,5.286,5.286,0,0,1,.611-1.466,3.464,3.464,0,0,1,1.1-1.221,6.58,6.58,0,0,1,1.588-.855V12.3h1.1v1.466H21.2V12.3h1.1v1.71a6.58,6.58,0,0,1,1.588.855,9.916,9.916,0,0,1,1.1,1.221,7.471,7.471,0,0,1,.611,1.466,6.964,6.964,0,0,1,.122,1.588H24.371a4.81,4.81,0,0,0-.611-2.443,2.675,2.675,0,0,0-1.588-1.466v4.03h-1.1V14.987H20.1v4.275H19v-4.03A3.712,3.712,0,0,0,17.41,16.7a5.347,5.347,0,0,0-.489,2.565,9.428,9.428,0,0,0,.244,1.832,2.911,2.911,0,0,0,.733,1.343,6.712,6.712,0,0,0,1.1.855,4.31,4.31,0,0,0,1.71.366Z"
            transform="translate(-15.7 -12.3)"
            fill="#db0000"
          />
        </g>
      </g>
    </symbol>
    <symbol id="icn-unlock" viewBox="0 0 12 17.999" fill="currentColor">
      <g
        id="Group_3155"
        data-name="Group 3155"
        transform="translate(-886 -684.001)"
      >
        <g
          id="Union_1"
          data-name="Union 1"
          transform="translate(6354.458 1752.541)"
          fill="none"
        >
          <path
            d="M-5468.458-1056.541a5.984,5.984,0,0,1,1.847-4.33,4.865,4.865,0,0,1-.847-2.669,5.175,5.175,0,0,1,5-5,5,5,0,0,1,5,5,4.975,4.975,0,0,1-.8,2.714,5.982,5.982,0,0,1,1.8,4.285,6,6,0,0,1-6,6A6,6,0,0,1-5468.458-1056.541Z"
            stroke="none"
          />
          <path
            d="M -5462.4580078125 -1051.540893554688 C -5459.701171875 -1051.540893554688 -5457.4580078125 -1053.783935546875 -5457.4580078125 -1056.541015625 C -5457.4580078125 -1057.8955078125 -5457.9912109375 -1059.163696289062 -5458.95849609375 -1060.112060546875 L -5459.54248046875 -1060.68408203125 L -5459.09814453125 -1061.369995117188 C -5458.6796875 -1062.015991210938 -5458.45849609375 -1062.766479492188 -5458.45849609375 -1063.540283203125 C -5458.45849609375 -1065.745727539062 -5460.25244140625 -1067.539916992188 -5462.4580078125 -1067.539916992188 C -5463.49169921875 -1067.539916992188 -5464.4921875 -1067.093627929688 -5465.27392578125 -1066.283325195312 C -5466.0263671875 -1065.50390625 -5466.4580078125 -1064.504028320312 -5466.4580078125 -1063.540283203125 C -5466.4580078125 -1062.834106445312 -5466.216796875 -1062.082885742188 -5465.77880859375 -1061.425170898438 L -5465.3154296875 -1060.728759765625 L -5465.9189453125 -1060.1494140625 C -5466.91162109375 -1059.19677734375 -5467.45849609375 -1057.915283203125 -5467.45849609375 -1056.541015625 C -5467.45849609375 -1053.783935546875 -5465.21533203125 -1051.540893554688 -5462.4580078125 -1051.540893554688 M -5462.4580078125 -1050.540893554688 C -5465.77099609375 -1050.540893554688 -5468.45849609375 -1053.226684570312 -5468.45849609375 -1056.541015625 C -5468.45849609375 -1058.242431640625 -5467.74951171875 -1059.77880859375 -5466.611328125 -1060.870971679688 C -5467.14599609375 -1061.674072265625 -5467.4580078125 -1062.607421875 -5467.4580078125 -1063.540283203125 C -5467.4580078125 -1066.040771484375 -5465.2197265625 -1068.539916992188 -5462.4580078125 -1068.539916992188 C -5459.69677734375 -1068.539916992188 -5457.45849609375 -1066.301513671875 -5457.45849609375 -1063.540283203125 C -5457.45849609375 -1062.539672851562 -5457.75244140625 -1061.608032226562 -5458.2587890625 -1060.826293945312 C -5457.1474609375 -1059.737182617188 -5456.4580078125 -1058.219360351562 -5456.4580078125 -1056.541015625 C -5456.4580078125 -1053.226684570312 -5459.14404296875 -1050.540893554688 -5462.4580078125 -1050.540893554688 Z"
            stroke="none"
            fill="currentColor"
          />
        </g>
        <path
          id="Path_1137"
          data-name="Path 1137"
          d="M234.868,108.028l3.987.632-1.141,3.878-2.031.891Z"
          transform="translate(651.458 578.541)"
          fill="#f8f8f8"
        />
        <g
          id="Ellipse_90"
          data-name="Ellipse 90"
          transform="translate(890 694)"
          fill="none"
          stroke="currentColor"
          strokeWidth="1"
        >
          <circle cx="2" cy="2" r="2" stroke="none" />
          <circle cx="2" cy="2" r="1.5" fill="none" />
        </g>
      </g>
    </symbol>
    <symbol id="icn-notifarrow" viewBox="0 0 5.317 3.908" fill="currentColor">
      <path
        d="M3037.814,1472.743l-3.675,3.292-1.241-3.292"
        transform="translate(-3032.664 -1472.557)"
        fill="none"
        stroke="#242424"
        strokeWidth="0.5"
      />
    </symbol>
    <symbol id="icn-warning-redin" viewBox="0 0 34 34">
      <path
        d="M-1515.975,6632.6l.124,6.776"
        transform="translate(1532.302 -6622.115)"
        fill="none"
        stroke="#db0011"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path
        d="M-1515.881,6639.854v.943"
        transform="translate(1532.332 -6618.248)"
        fill="none"
        stroke="#db0011"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <g fill="none" stroke="currentColor" strokeWidth="1">
        <circle cx="17" cy="17" r="17" stroke="none" />
        <circle cx="17" cy="17" r="16.5" fill="none" />
      </g>
    </symbol>
    <symbol id="moneybox-edit" viewBox="0 0 23.118 22.499" fill="currentColor">
      <g transform="translate(0.503)">
        <path
          d="M.6,15.456S-.3,17.97,1.658,21.724s1.788,2.462,2.458,3.633a5.732,5.732,0,0,1,.428,3.018H8.937V26.283h3.514v2.091l4.475-.251V25.739a23.056,23.056,0,0,0,2.342-2.928,6.64,6.64,0,0,0,1-1.529,5.6,5.6,0,0,0,.4-1.5h1.713l.109-3.576s.209-1-.92-.962-.126-.92-2.3-3.1.019-3.178-.315-4.266-1.428-1.066-3.141,0l-.459.364L14.5,9.06l-.029.012-2.427-.488"
          transform="translate(-0.394 -6.375)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <g
          transform="translate(1.349 3.656)"
          fill="none"
          stroke="#db0011"
          strokeWidth="1"
        >
          <ellipse cx="3.046" cy="3.046" rx="3.046" ry="3.046" stroke="none" />
          <ellipse cx="3.046" cy="3.046" rx="2.546" ry="2.546" fill="none" />
        </g>
        <g
          transform="translate(6.224)"
          fill="none"
          stroke="#db0011"
          strokeWidth="1"
        >
          <ellipse cx="1.828" cy="1.828" rx="1.828" ry="1.828" stroke="none" />
          <ellipse cx="1.828" cy="1.828" rx="1.328" ry="1.328" fill="none" />
        </g>
      </g>
    </symbol>
    <symbol
      id="moneybox-cancel"
      viewBox="0 0 23.118 25.499"
      fill="currentColor"
    >
      <g transform="translate(0.503 3)">
        <path
          d="M.6,15.456S-.3,17.97,1.658,21.724s1.788,2.462,2.458,3.633a5.732,5.732,0,0,1,.428,3.018H8.937V26.283h3.514v2.091l4.475-.251V25.739a23.056,23.056,0,0,0,2.342-2.928,6.64,6.64,0,0,0,1-1.529,5.6,5.6,0,0,0,.4-1.5h1.713l.109-3.576s.209-1-.92-.962-.126-.92-2.3-3.1.019-3.178-.315-4.266-1.428-1.066-3.141,0l-.459.364L14.5,9.06l-.029.012-2.427-.488"
          transform="translate(-0.394 -6.375)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <g
          transform="translate(0.349 0.656)"
          fill="none"
          stroke="#db0011"
          strokeWidth="1"
        >
          <ellipse cx="3.046" cy="3.046" rx="3.046" ry="3.046" stroke="none" />
          <ellipse cx="3.046" cy="3.046" rx="2.546" ry="2.546" fill="none" />
        </g>
        <g
          transform="translate(5.224 -3)"
          fill="none"
          stroke="#db0011"
          strokeWidth="1"
        >
          <ellipse cx="1.828" cy="1.828" rx="1.828" ry="1.828" stroke="none" />
          <ellipse cx="1.828" cy="1.828" rx="1.328" ry="1.328" fill="none" />
        </g>
        <g
          transform="translate(3.488 4.832)"
          fill="none"
          stroke="#242424"
          strokeWidth="1"
        >
          <circle cx="7" cy="7" r="7" stroke="none" />
          <circle cx="7" cy="7" r="6.5" fill="none" />
        </g>
        <path
          d="M0,0,7.19,4.149"
          transform="matrix(0.966, 0.259, -0.259, 0.966, 7.352, 9.082)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          d="M0,0,6.95,3.99"
          transform="matrix(-0.259, 0.966, -0.966, -0.259, 13.005, 9.146)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
      </g>
    </symbol>
    <symbol id="icn-cards" viewBox="0 0 34.562 22.723" fill="currentColor">
      <g
        id="Group_2219"
        data-name="Group 2219"
        transform="translate(-368 -594.823)"
      >
        <g
          id="Rectangle_759"
          data-name="Rectangle 759"
          transform="translate(368 594.823)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        >
          <rect width="34.562" height="22.723" rx="2" stroke="none" />
          <rect
            x="0.5"
            y="0.5"
            width="33.562"
            height="21.723"
            rx="1.5"
            fill="none"
          />
        </g>
        <path
          id="Path_1181"
          data-name="Path 1181"
          d="M377.612,593.972h3.276"
          transform="translate(-4.608 18.586)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          id="Path_1214"
          data-name="Path 1214"
          d="M377.612,593.972h1.719"
          transform="translate(1.754 18.586)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          id="Path_1213"
          data-name="Path 1213"
          d="M377.612,593.972h21.877"
          transform="translate(-4.803 8.381)"
          fill="none"
          stroke="#db0011"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <circle
          id="Ellipse_126"
          data-name="Ellipse 126"
          cx="2.5"
          cy="2.5"
          r="2.5"
          transform="translate(394.451 609.654)"
          fill="#db0011"
        />
        <circle
          id="Ellipse_127"
          data-name="Ellipse 127"
          cx="2.5"
          cy="2.5"
          r="2.5"
          transform="translate(391.451 609.654)"
          fill="#db0011"
        />
      </g>
    </symbol>

    <symbol id="icn-cardown" viewBox="0 0 28.004 18.016" fill="currentColor">
      <g
        id="Group_1680"
        data-name="Group 1680"
        transform="translate(2290 -2473)"
      >
        <g
          id="Path_635"
          data-name="Path 635"
          transform="translate(-2283.461 2478.902)"
          fill="none"
        >
          <path
            d="M.568.127,20.615,0a.85.85,0,0,1,.85.85V11.264a.85.85,0,0,1-.85.85H.85a.85.85,0,0,1-.85-.85V.85C0,.381.1.127.568.127Z"
            stroke="none"
          />
          <path
            d="M 20.46484375 1.000971794128418 L 1.000001907348633 1.124171257019043 L 1.000001907348633 11.11382293701172 L 20.46484375 11.11382293701172 L 20.46484375 1.000971794128418 M 20.61475372314453 3.814697265625e-06 C 21.08424377441406 3.814697265625e-06 21.46484375 0.3806037902832031 21.46484375 0.8500938415527344 L 21.46484375 11.26373291015625 C 21.46484375 11.73322296142578 21.08424377441406 12.11382293701172 20.61475372314453 12.11382293701172 L 0.8500919342041016 12.11382293701172 C 0.3806018829345703 12.11382293701172 1.9073486328125e-06 11.73322296142578 1.9073486328125e-06 11.26373291015625 L 1.9073486328125e-06 0.8500938415527344 C 1.9073486328125e-06 0.3806037902832031 0.09879302978515625 0.1268835067749023 0.5682830810546875 0.1268835067749023 L 20.61475372314453 3.814697265625e-06 Z"
            stroke="none"
            fill="currentColor"
          />
        </g>
        <path
          id="Path_748"
          data-name="Path 748"
          d="M0,0H12.656"
          transform="translate(-2274.758 2481.983)"
          fill="none"
          stroke="currentColor"
          strokeWidth="1"
        />
        <g
          id="Path_684"
          data-name="Path 684"
          transform="translate(-2290 2473)"
          fill="none"
        >
          <path
            d="M.815,0H20.65a.815.815,0,0,1,.815.815V11.3a.815.815,0,0,1-.815.815H.815A.815.815,0,0,1,0,11.3V.815A.815.815,0,0,1,.815,0Z"
            stroke="none"
          />
          <path
            d="M 1.000001907348633 1.000003814697266 L 1.000001907348633 11.11382293701172 L 20.46484375 11.11382293701172 L 20.46484375 1.000003814697266 L 1.000001907348633 1.000003814697266 M 0.8150119781494141 3.814697265625e-06 L 20.64983367919922 3.814697265625e-06 C 21.09995269775391 3.814697265625e-06 21.46484375 0.3648929595947266 21.46484375 0.8150129318237305 L 21.46484375 11.29881381988525 C 21.46484375 11.74893379211426 21.09995269775391 12.11382293701172 20.64983367919922 12.11382293701172 L 0.8150119781494141 12.11382293701172 C 0.3648929595947266 12.11382293701172 1.9073486328125e-06 11.74893379211426 1.9073486328125e-06 11.29881381988525 L 1.9073486328125e-06 0.8150129318237305 C 1.9073486328125e-06 0.3648929595947266 0.3648929595947266 3.814697265625e-06 0.8150119781494141 3.814697265625e-06 Z"
            stroke="none"
            fill="currentColor"
          />
        </g>
        <path
          id="Path_636"
          data-name="Path 636"
          d="M-1.053.146H20.295"
          transform="translate(-2288.947 2476.98)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"
        />
        <g
          id="Rectangle_449"
          data-name="Rectangle 449"
          transform="translate(-2267.522 2487.615)"
          fill="none"
          stroke="#db0000"
          strokeWidth="1"
        >
          <rect width="3.524" height="1.398" rx="0.699" stroke="none" />
          <rect
            x="0.5"
            y="0.5"
            width="2.524"
            height="0.398"
            rx="0.199"
            fill="none"
          />
        </g>
        <g
          id="noun_Arrow_197522"
          transform="translate(-2274.277 2483.275) rotate(180)"
        >
          <path
            id="Path_637"
            data-name="Path 637"
            d="M.03,1.359c0,.011,0,.011.011.022s.011.011.011.022.011.011.011.022l.032.032L1.173,2.534a.2.2,0,0,0,.14.054.213.213,0,0,0,.151-.065.208.208,0,0,0,0-.3L.752,1.51h3.8a.216.216,0,1,0,0-.431H.752L1.464.367a.208.208,0,0,0,0-.3.208.208,0,0,0-.3,0L.084,1.143l-.032.032A.038.038,0,0,0,.04,1.2c0,.011-.011.011-.011.022s0,.011-.011.022,0,.011-.011.022a.119.119,0,0,0,0,.086C.03,1.348.03,1.348.03,1.359Z"
            transform="translate(0 0)"
            fill="#db0000"
          />
        </g>
        <rect
          id="Rectangle_450"
          data-name="Rectangle 450"
          width="7.665"
          height="0.438"
          rx="0.219"
          transform="translate(-2284.795 2481.762)"
          fill="#db0000"
        />
      </g>
    </symbol>

    <symbol id="icn-cardother" viewBox="0 0 27.109 16.782" fill="currentColor">
      <g id="Blocks-2" transform="translate(0 0)">
        <g id="Blocks" transform="translate(0 0)">
          <g id="_8" data-name="8" transform="translate(0)">
            <g id="Group-12">
              <g id="Icon">
                <path
                  id="Combined-Shape"
                  d="M21.92,0V.806l0,.447h.925a.43.43,0,0,1,.43.43V12.517a.43.43,0,0,1-.43.43H1.677a.43.43,0,0,1-.43-.43V11.264H0v1.645A1.291,1.291,0,0,0,1.291,14.2H23.237a1.291,1.291,0,0,0,1.291-1.291V1.291A1.291,1.291,0,0,0,23.237,0Z"
                  transform="translate(24.528 14.2) rotate(180)"
                  fillRule="evenodd"
                />
                <path
                  id="Combined-Shape-2"
                  data-name="Combined-Shape"
                  d="M6,12.024H7.247V9.442H6V7.291A1.291,1.291,0,0,1,7.291,6H29.237a1.291,1.291,0,0,1,1.291,1.291V18.909A1.291,1.291,0,0,1,29.237,20.2H7.291A1.291,1.291,0,0,1,6,18.909ZM7.677,7.253a.43.43,0,0,0-.43.43V18.517a.43.43,0,0,0,.43.43H28.85a.43.43,0,0,0,.43-.43V7.683a.43.43,0,0,0-.43-.43Z"
                  transform="translate(-3.418 -3.418)"
                  fillRule="evenodd"
                />
                <path
                  id="Combined-Shape-3"
                  data-name="Combined-Shape"
                  d="M2.085,2.1V0h.834V2.937H0V2.1Z"
                  transform="translate(6.25 7.105) rotate(-45)"
                  fill="#da291c"
                  fillRule="evenodd"
                />
                <rect
                  id="Rectangle-Copy"
                  width="7.315"
                  height="0.861"
                  transform="translate(2.152 6.885)"
                  fill="#da291c"
                />
                <path
                  id="Combined-Shape-4"
                  data-name="Combined-Shape"
                  d="M44.8,23.378a1.721,1.721,0,1,1,0,2.687,1.721,1.721,0,1,1,0-2.687Zm0,.937a1.981,1.981,0,0,0-1.129-.454.863.863,0,0,0,0,1.721,1.981,1.981,0,0,0,1.129-.454,1.884,1.884,0,0,0,1.112.454.861.861,0,0,0,0-1.721A1.884,1.884,0,0,0,44.793,24.315Z"
                  transform="translate(-23.927 -13.103)"
                  fillRule="evenodd"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </symbol>

    <symbol id="icn-mobilenum" viewBox="0 0 21.857 29.339" fill="currentColor">
      <path
        id="XMLID_17_"
        d="M9.259,2.1H11.8a.171.171,0,0,1,.159.159v.4a.171.171,0,0,1-.159.159H9.259A.171.171,0,0,1,9.1,2.655v-.4A.171.171,0,0,1,9.259,2.1Z"
        transform="translate(-1.884 -0.435)"
        fill="currentColor"
      />
      <path
        id="XMLID_14_"
        d="M9.1,33.027A1.427,1.427,0,1,0,10.527,31.6h0A1.421,1.421,0,0,0,9.1,33.027Zm2.379,0a.952.952,0,1,1-.952-.952h0A.916.916,0,0,1,11.479,33.027Z"
        transform="translate(-1.884 -6.543)"
        fill="currentColor"
      />
      <path
        id="XMLID_9_"
        d="M17.07,10.1a3.492,3.492,0,0,0-1.269.159h-.238a6.219,6.219,0,0,0-2.617.555,5.785,5.785,0,0,0-5.154,6.344,5.9,5.9,0,0,0,5.154,5.154,5.975,5.975,0,0,0,2.617.555H15.8a6.423,6.423,0,0,0,2.458-12.608A3.082,3.082,0,0,0,17.07,10.1ZM9.933,16.523a5.6,5.6,0,0,1,3.172-5.075,6.507,6.507,0,0,0-1.11,9.04,7.348,7.348,0,0,0,1.11,1.11A5.74,5.74,0,0,1,9.933,16.523Zm-1.427,0a5.135,5.135,0,0,1,2.617-4.44,6.269,6.269,0,0,0,0,8.881,4.977,4.977,0,0,1-2.617-4.44Zm8.564,5.471a5.551,5.551,0,1,1,5.551-5.63A5.567,5.567,0,0,1,17.07,21.994Z"
        transform="translate(-1.607 -2.091)"
        fill="currentColor"
      />
      <path
        id="XMLID_8_"
        d="M15.666,7.706V5.01a1.084,1.084,0,0,0-1.11-1.11H4.01A1.084,1.084,0,0,0,2.9,5.01V24.279a1.084,1.084,0,0,0,1.11,1.11H14.556a1.084,1.084,0,0,0,1.11-1.11V22.851c-.317,0-.634-.079-.952-.079v1.586a.171.171,0,0,1-.159.159H4.01a.171.171,0,0,1-.159-.159V5.01c-.079-.079,0-.159.159-.238H14.556a.171.171,0,0,1,.159.159V7.706A3.821,3.821,0,0,0,15.666,7.706Z"
        transform="translate(-0.6 -0.808)"
        fill="currentColor"
      />
      <g id="XMLID_3_">
        <path
          id="XMLID_7_"
          d="M16.414,26.96a1.506,1.506,0,0,1-1.507,1.507H2.379A1.506,1.506,0,0,1,.872,26.96V2.379A1.546,1.546,0,0,1,2.379.952H14.907a1.506,1.506,0,0,1,1.507,1.507v4.52a3.98,3.98,0,0,1,.952.159V2.379A2.386,2.386,0,0,0,14.987,0H2.379A2.439,2.439,0,0,0,0,2.379V26.96a2.386,2.386,0,0,0,2.379,2.379H14.907a2.386,2.386,0,0,0,2.379-2.379V21.885a3.98,3.98,0,0,1-.952.159V26.96Z"
          fill="currentColor"
        />
        <g id="XMLID_4_" transform="translate(12.449 9.753)">
          <path
            id="XMLID_5_"
            d="M18.951,19.674h2.855v.634H15.938v-.634h1.269a4.358,4.358,0,0,1-.714-.555,5.565,5.565,0,0,1-.476-.714c-.079-.238-.159-.476-.238-.793a3.253,3.253,0,0,1-.079-.872,4.521,4.521,0,0,1,.079-1.031,3.432,3.432,0,0,1,.4-.952,2.249,2.249,0,0,1,.714-.793,4.272,4.272,0,0,1,1.031-.555V12.3h.714v.952h.634V12.3h.714v1.11a4.272,4.272,0,0,1,1.031.555,6.438,6.438,0,0,1,.714.793,4.85,4.85,0,0,1,.4.952A4.521,4.521,0,0,1,22.2,16.74H21.33a3.123,3.123,0,0,0-.4-1.586A1.736,1.736,0,0,0,19.9,14.2V16.82h-.714V14.044h-.634V16.82h-.714V14.2a2.41,2.41,0,0,0-1.031.952,3.472,3.472,0,0,0-.317,1.665,6.121,6.121,0,0,0,.159,1.189,1.89,1.89,0,0,0,.476.872,4.358,4.358,0,0,0,.714.555,2.8,2.8,0,0,0,1.11.238Z"
            transform="translate(-15.7 -12.3)"
            fill="#db0000"
          />
        </g>
      </g>
    </symbol>

    <symbol id="icn-smssend" viewBox="0 0 21.188 19.714" fill="currentColor">
      <g id="noun_Navigation_232524" transform="translate(0 0)">
        <path
          id="Path_1340"
          data-name="Path 1340"
          d="M8.456,20.6a9.479,9.479,0,0,1,2.139-9.84,9.468,9.468,0,0,1,13.24-.315V9.7a.462.462,0,0,1,.473-.473h0a.462.462,0,0,1,.473.473l.023,1.891a.462.462,0,0,1-.473.473l-1.891.023h0a.473.473,0,0,1,0-.946h.721a8.549,8.549,0,0,0-11.889.315,8.416,8.416,0,0,0-1.937,8.8.477.477,0,0,1-.293.608.383.383,0,0,1-.158.023A.431.431,0,0,1,8.456,20.6Zm16.956-6.1a.477.477,0,1,1,.9-.315,9.556,9.556,0,0,1,.36,5.157,9.426,9.426,0,0,1-2.5,4.684,9.552,9.552,0,0,1-6.665,2.86H17.4a9.464,9.464,0,0,1-6.463-2.545v.743a.462.462,0,0,1-.473.473h0a.462.462,0,0,1-.473-.473l-.045-1.891a.462.462,0,0,1,.473-.473l1.891-.023a.473.473,0,0,1,0,.946h-.721a8.324,8.324,0,0,0,5.877,2.252A8.532,8.532,0,0,0,25.412,14.5Z"
          transform="translate(-7.891 -7.898)"
          fill="currentColor"
        />
        <ellipse
          id="Ellipse_137"
          data-name="Ellipse 137"
          cx="5.5"
          cy="5"
          rx="5.5"
          ry="5"
          transform="translate(10.188 9.714)"
          fill="#db0011"
        />
        <g id="noun_Reply_1703099" transform="translate(11.792 11.359)">
          <g id="Group_2047" data-name="Group 2047" transform="translate(0 0)">
            <path
              id="Path_1109"
              data-name="Path 1109"
              d="M8.877,967.317a.263.263,0,0,0-.134.06l-2.63,2.192a.263.263,0,0,0,0,.4l2.63,2.192a.263.263,0,0,0,.43-.2v-.874a6.655,6.655,0,0,1,4.123,1.422.263.263,0,0,0,.422-.279c-.737-2.269-2.95-3.274-4.545-3.709v-.943a.263.263,0,0,0-.3-.263Zm-.23.822v.581a.263.263,0,0,0,.2.255,6.483,6.483,0,0,1,3.956,2.542,7.694,7.694,0,0,0-3.9-.956.263.263,0,0,0-.249.263v.578l-1.959-1.63Z"
              transform="translate(-6.019 -967.315)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </symbol>

    <symbol id="icn-mobile" viewBox="0 0 47.722 64.058" fill="currentColor">
      <path
        d="M9.446,2.1h5.54a.372.372,0,0,1,.346.346v.866a.372.372,0,0,1-.346.346H9.446A.372.372,0,0,1,9.1,3.312V2.446A.372.372,0,0,1,9.446,2.1Z"
        transform="translate(6.655 1.536)"
        fill="#e4e6ea"
      />
      <path
        d="M9.1,34.716A3.116,3.116,0,1,0,12.216,31.6h0A3.1,3.1,0,0,0,9.1,34.716Zm5.194,0a2,2,0,0,1-2.078,2.078,2.078,2.078,0,1,1,0-4.155h0A2,2,0,0,1,14.294,34.716Z"
        transform="translate(6.655 23.109)"
        fill="#e4e6ea"
      />
      <path
        d="M28.083,10.1a7.624,7.624,0,0,0-2.77.346h-.519a13.579,13.579,0,0,0-5.713,1.212A12.631,12.631,0,0,0,7.827,25.509,12.871,12.871,0,0,0,19.08,36.762a13.046,13.046,0,0,0,5.713,1.212h.519A14.023,14.023,0,1,0,30.68,10.446,6.73,6.73,0,0,0,28.083,10.1ZM12.5,24.124a12.223,12.223,0,0,1,6.925-11.08A14.208,14.208,0,0,0,17,32.78,16.043,16.043,0,0,0,19.427,35.2,12.533,12.533,0,0,1,12.5,24.124Zm-3.116,0a11.211,11.211,0,0,1,5.713-9.7,13.689,13.689,0,0,0,0,19.391,10.867,10.867,0,0,1-5.713-9.7Zm18.7,11.946A12.119,12.119,0,1,1,40.2,23.777,12.155,12.155,0,0,1,28.083,36.07Z"
        transform="translate(5.677 7.386)"
        fill="#e4e6ea"
      />
      <path
        d="M30.774,12.21V6.324A2.367,2.367,0,0,0,28.35,3.9H5.324A2.367,2.367,0,0,0,2.9,6.324V48.395a2.367,2.367,0,0,0,2.424,2.424H28.35a2.367,2.367,0,0,0,2.424-2.424V45.278c-.693,0-1.385-.173-2.078-.173v3.463a.372.372,0,0,1-.346.346H5.324a.372.372,0,0,1-.346-.346V6.324c-.173-.173,0-.346.346-.519H28.35a.372.372,0,0,1,.346.346v6.06A8.343,8.343,0,0,0,30.774,12.21Z"
        transform="translate(2.121 2.852)"
        fill="#e4e6ea"
      />
      <path
        d="M35.838,58.865a3.287,3.287,0,0,1-3.289,3.29H5.194A3.287,3.287,0,0,1,1.9,58.865V5.194A3.376,3.376,0,0,1,5.194,2.078H32.549a3.287,3.287,0,0,1,3.289,3.289v9.868a8.69,8.69,0,0,1,2.078.346V5.194A5.209,5.209,0,0,0,32.722,0H5.194A5.325,5.325,0,0,0,0,5.194V58.865a5.209,5.209,0,0,0,5.194,5.194H32.549a5.209,5.209,0,0,0,5.194-5.194V47.784a8.69,8.69,0,0,1-2.078.346V58.865Z"
        fill="#e4e6ea"
      />
      <g transform="translate(27.182 21.295)">
        <path
          d="M22.8,28.4h6.233v1.385H16.219V28.4h2.77a9.515,9.515,0,0,1-1.558-1.212,12.15,12.15,0,0,1-1.039-1.558c-.173-.519-.346-1.039-.519-1.731A7.1,7.1,0,0,1,15.7,22a9.872,9.872,0,0,1,.173-2.251,7.494,7.494,0,0,1,.866-2.078A4.911,4.911,0,0,1,18.3,15.936a9.327,9.327,0,0,1,2.251-1.212V12.3h1.558v2.078h1.385V12.3h1.558v2.424A9.327,9.327,0,0,1,27.3,15.936a14.056,14.056,0,0,1,1.558,1.731,10.59,10.59,0,0,1,.866,2.078A9.872,9.872,0,0,1,29.9,22h-1.9a6.819,6.819,0,0,0-.866-3.463,3.791,3.791,0,0,0-2.251-2.078v5.713H23.318v-6.06H21.933v6.06H20.375V16.455a5.262,5.262,0,0,0-2.251,2.078,7.58,7.58,0,0,0-.693,3.636,13.365,13.365,0,0,0,.346,2.6,4.127,4.127,0,0,0,1.039,1.9,9.515,9.515,0,0,0,1.558,1.212A6.11,6.11,0,0,0,22.8,28.4Z"
          transform="translate(-15.7 -12.3)"
          fill="#e4e6ea"
        />
      </g>
    </symbol>

    <symbol id="icn-mobile-red" viewBox="0 0 42.958 57.664" fill="currentColor">
      <path
        d="M9.412,2.1H14.4a.335.335,0,0,1,.312.312v.779A.335.335,0,0,1,14.4,3.5H9.412A.335.335,0,0,1,9.1,3.191V2.412A.335.335,0,0,1,9.412,2.1Z"
        transform="translate(5.082 1.173)"
        fill="#fff"
      />
      <path
        d="M9.1,34.405A2.805,2.805,0,1,0,11.905,31.6h0A2.794,2.794,0,0,0,9.1,34.405Zm4.675,0a1.8,1.8,0,0,1-1.87,1.87,1.87,1.87,0,0,1,0-3.74h0A1.8,1.8,0,0,1,13.775,34.405Z"
        transform="translate(5.082 17.648)"
        fill="#fff"
      />
      <path
        d="M26.055,10.1a6.863,6.863,0,0,0-2.494.312h-.468A12.223,12.223,0,0,0,17.951,11.5,11.37,11.37,0,0,0,7.821,23.97,11.586,11.586,0,0,0,17.951,34.1a11.744,11.744,0,0,0,5.143,1.091h.468a12.623,12.623,0,0,0,4.831-24.78A6.058,6.058,0,0,0,26.055,10.1ZM12.028,22.724a11,11,0,0,1,6.234-9.974,12.789,12.789,0,0,0-2.182,17.767A14.441,14.441,0,0,0,18.262,32.7,11.282,11.282,0,0,1,12.028,22.724Zm-2.805,0A10.092,10.092,0,0,1,14.366,14a12.322,12.322,0,0,0,0,17.455,9.782,9.782,0,0,1-5.143-8.727ZM26.055,33.477A10.909,10.909,0,1,1,36.964,22.412,10.941,10.941,0,0,1,26.055,33.477Z"
        transform="translate(4.336 5.641)"
        fill="#fff"
      />
      <path
        d="M27.991,11.381v-5.3A2.131,2.131,0,0,0,25.81,3.9H5.082A2.131,2.131,0,0,0,2.9,6.082V43.953a2.131,2.131,0,0,0,2.182,2.182H25.81a2.131,2.131,0,0,0,2.182-2.182V41.148c-.623,0-1.247-.156-1.87-.156v3.117a.335.335,0,0,1-.312.312H5.082a.335.335,0,0,1-.312-.312V6.082c-.156-.156,0-.312.312-.468H25.81a.335.335,0,0,1,.312.312v5.455A7.51,7.51,0,0,0,27.991,11.381Z"
        transform="translate(1.62 2.178)"
        fill="#fff"
      />
      <path
        d="M32.26,52.988A2.959,2.959,0,0,1,29.3,55.949H4.675a2.959,2.959,0,0,1-2.961-2.961V4.675A3.039,3.039,0,0,1,4.675,1.87H29.3A2.959,2.959,0,0,1,32.26,4.831v8.883a7.822,7.822,0,0,1,1.87.312V4.675A4.689,4.689,0,0,0,29.455,0H4.675A4.794,4.794,0,0,0,0,4.675V52.988a4.689,4.689,0,0,0,4.675,4.675H29.3a4.689,4.689,0,0,0,4.675-4.675V43.014a7.823,7.823,0,0,1-1.87.312v9.663Z"
        fill="#fff"
      />
      <g transform="translate(24.468 19.169)">
        <path
          d="M22.09,26.794H27.7v1.247H16.168V26.794h2.494a8.565,8.565,0,0,1-1.4-1.091,10.936,10.936,0,0,1-.935-1.4c-.156-.468-.312-.935-.468-1.558a6.393,6.393,0,0,1-.156-1.714A8.886,8.886,0,0,1,15.856,19a6.746,6.746,0,0,1,.779-1.87,4.42,4.42,0,0,1,1.4-1.558,8.4,8.4,0,0,1,2.026-1.091V12.3h1.4v1.87h1.247V12.3h1.4v2.182a8.4,8.4,0,0,1,2.026,1.091,12.654,12.654,0,0,1,1.4,1.558A9.533,9.533,0,0,1,28.324,19a8.886,8.886,0,0,1,.156,2.026H26.765a6.138,6.138,0,0,0-.779-3.117,3.413,3.413,0,0,0-2.026-1.87v5.143h-1.4V15.729H21.311v5.455h-1.4V16.04a4.737,4.737,0,0,0-2.026,1.87,6.824,6.824,0,0,0-.623,3.273,12.03,12.03,0,0,0,.312,2.338,3.715,3.715,0,0,0,.935,1.714,8.565,8.565,0,0,0,1.4,1.091,5.5,5.5,0,0,0,2.182.468Z"
          transform="translate(-15.7 -12.3)"
          fill="#db0000"
        />
      </g>
    </symbol>

    <symbol
      id="mouthpiece-icon"
      viewBox="0 0 76.966 76.966"
      fill="currentColor"
    >
      <rect
        id="rectangle"
        width="71.638"
        height="71.638"
        transform="translate(0 5.329)"
        fill="none"
      />
      <g id="outline-location_on-24px">
        <g id="Bounding_Boxes">
          <path
            id="Path_836"
            data-name="Path 836"
            d="M0,0H76.966V76.966H0Z"
            fill="none"
          />
        </g>
      </g>
      <path
        id="Path_2206"
        data-name="Path 2206"
        d="M.042,0S5.429,2.878,5.429,6.518A6.619,6.619,0,0,1,5.18,8.133c-.717,2.085-2.869,4.058-4.666,5.651.105-.044-.469.439-.469.439S0,10.918,0,7.278.042,0,.042,0Z"
        transform="translate(61.572 21.625) rotate(-14)"
        fill="#db0011"
      />
      <path
        id="Path_2205"
        data-name="Path 2205"
        d="M47.882,5.98a5.418,5.418,0,0,0-8.854-3.193L31.361,9.3a13.394,13.394,0,0,1-6.331,2.969L8.983,15.094A9.192,9.192,0,0,0,1.54,25.727L3.709,38.04a9.183,9.183,0,0,0,10.636,7.446l2.324-.41,1.58,8.965a6.756,6.756,0,1,0,13.306-2.346l-1.583-8.951.415-.072a13.408,13.408,0,0,1,6.967.628l9.438,3.489a5.42,5.42,0,0,0,7.219-6.018ZM25.52,56.268a3.481,3.481,0,0,1-4-2.8L19.937,44.5,26.7,43.308l1.58,8.965a3.442,3.442,0,0,1-2.761,4ZM50.016,43.3a2.059,2.059,0,0,1-2.072.357h0L38.505,40.17a16.743,16.743,0,0,0-8.694-.783L13.767,42.218a5.891,5.891,0,0,1-6.787-4.754L4.81,25.152a5.866,5.866,0,0,1,4.754-6.787l16.048-2.828a16.7,16.7,0,0,0,7.883-3.708L41.17,5.321A2.1,2.1,0,0,1,44.6,6.558l1.458,8.273V14.9c0,.025.022.042.025.066l3.187,17.954v.069c0,.022.019.044.025.069l1.458,8.267A2.064,2.064,0,0,1,50.016,43.3ZM52.21,30.539,49.678,16.181a96.469,96.469,0,0,0,2.532,14.36Z"
        transform="translate(5.765 9.78)"
        fill="none"
        stroke="#242424"
        strokeWidth="1"
      />
    </symbol>

    <symbol id="beauty-icon" viewBox="0 0 42 42" fill="currentColor">
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_18"
            data-name="Rectangle 18"
            width="42"
            height="42"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Group_70" data-name="Group 70" clipPath="url(#clip-path)">
        <g id="Group_69" data-name="Group 69" transform="translate(2.33 4.001)">
          <g id="Group_68" data-name="Group 68">
            <g
              id="Group_66"
              data-name="Group 66"
              transform="translate(20.348 14.886)"
            >
              <path
                id="Path_39"
                data-name="Path 39"
                d="M184.052,157.611a1,1,0,0,1,1.992,0v7.061a1,1,0,0,1-1,1,.985.985,0,0,1-.584-.19l-1.6-1.155-1.6,1.158a1,1,0,0,1-1.585-.809v-6.413a1,1,0,0,1,2,0v4.455l.582-.422a1,1,0,0,1,1.188-.011l.6.436Z"
                transform="translate(-176.599 -146.558)"
                fill="#eb293e"
                fillRule="evenodd"
              />
              <path
                id="Path_40"
                data-name="Path 40"
                d="M181.132,146.64l1.782.669,1.835-.657a1,1,0,0,1,1.264.572l.79,1.739,1.756.83a1,1,0,0,1,.508,1.254l-.687,1.828.657,1.833a1,1,0,0,1-.572,1.265l-1.739.789-.83,1.756a1,1,0,0,1-1.254.508l-1.828-.687-1.833.657a1,1,0,0,1-1.265-.572l-.789-1.739-1.756-.83a1,1,0,0,1-.508-1.254l.687-1.828-.657-1.833a1,1,0,0,1,.572-1.265l1.739-.789.83-1.756a1,1,0,0,1,1.3-.49Zm1.431,2.666-1.317-.495-.58,1.228a1,1,0,0,1-.507.515l-1.274.578.47,1.31a1.017,1.017,0,0,1-.008.688l-.493,1.313,1.226.58a.991.991,0,0,1,.515.507l.578,1.273,1.31-.469a1,1,0,0,1,.688.008l1.313.493.58-1.227a.993.993,0,0,1,.507-.514l1.273-.579-.469-1.309a1,1,0,0,1,.008-.688l.493-1.314-1.226-.579a.993.993,0,0,1-.515-.506l-.579-1.275-1.31.47v0A.988.988,0,0,1,182.563,149.306Z"
                transform="translate(-176.599 -146.558)"
                fill="#eb293e"
                fillRule="evenodd"
              />
            </g>
            <path
              id="Path_41"
              data-name="Path 41"
              d="M175.366,156.975a1,1,0,1,1,0,2H158.832a2.575,2.575,0,0,1-1.823-.758v0a2.569,2.569,0,0,1-.758-1.819V134.253a2.585,2.585,0,0,1,2.581-2.581h32.179a2.585,2.585,0,0,1,2.581,2.581v22.141a2.595,2.595,0,0,1-2.581,2.581H190.3a1,1,0,0,1,0-2h.708a.58.58,0,0,0,.581-.581V134.253a.584.584,0,0,0-.581-.581H158.832a.584.584,0,0,0-.581.581v22.141a.582.582,0,0,0,.17.411.594.594,0,0,0,.411.17Z"
              transform="translate(-156.251 -131.672)"
              fill="#545d64"
              fillRule="evenodd"
            />
            <g
              id="Group_67"
              data-name="Group 67"
              transform="translate(7.134 6.337)"
            >
              <path
                id="Path_42"
                data-name="Path 42"
                d="M164.385,140.009a1,1,0,0,1,0-2h21.073a1,1,0,0,1,0,2Z"
                transform="translate(-163.385 -138.009)"
                fill="#545d64"
                fillRule="evenodd"
              />
              <path
                id="Path_43"
                data-name="Path 43"
                d="M164.385,146.055a1,1,0,0,1,0-2h10.743a1,1,0,0,1,0,2Z"
                transform="translate(-163.385 -138.009)"
                fill="#545d64"
                fillRule="evenodd"
              />
              <path
                id="Path_44"
                data-name="Path 44"
                d="M164.385,152.1a1,1,0,0,1,0-2h4.123a1,1,0,0,1,0,2Z"
                transform="translate(-163.385 -138.009)"
                fill="#545d64"
                fillRule="evenodd"
              />
              <path
                id="Path_45"
                data-name="Path 45"
                d="M171.553,152.1a1,1,0,1,0-1-1A1,1,0,0,0,171.553,152.1Z"
                transform="translate(-163.385 -138.009)"
                fill="#545d64"
                fillRule="evenodd"
              />
            </g>
          </g>
        </g>
      </g>
    </symbol>

    <symbol id="pharmacy-icon" viewBox="0 0 42 42" fill="currentColor">
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_17"
            data-name="Rectangle 17"
            width="42"
            height="42"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Group_64" data-name="Group 64" clipPath="url(#clip-path)">
        <g
          id="Group_63"
          data-name="Group 63"
          transform="translate(7.265 4.001)"
        >
          <g id="Group_62" data-name="Group 62">
            <path
              id="Path_33"
              data-name="Path 33"
              d="M365.7,164.353a1,1,0,0,1-2,0v-6.175a10.507,10.507,0,0,1,21.014,0v6.175a1,1,0,0,1-2,0v-6.175a8.507,8.507,0,1,0-17.013,0Z"
              transform="translate(-360.592 -131.672)"
              fill="#545d64"
              fillRule="evenodd"
            />
            <path
              id="Path_34"
              data-name="Path 34"
              d="M381.557,143.44a1,1,0,1,1,1.719,1.008,10.608,10.608,0,0,1-3.851,3.821,10.465,10.465,0,0,1-5.217,1.4v0h-.023a10.5,10.5,0,0,1-10.479-10.484h0v-6.2a1,1,0,1,1,2,0v6.2h0a8.5,8.5,0,0,0,8.487,8.484h.023v0a8.486,8.486,0,0,0,4.225-1.133A8.611,8.611,0,0,0,381.557,143.44Z"
              transform="translate(-360.592 -131.672)"
              fill="#545d64"
              fillRule="evenodd"
            />
            <path
              id="Path_35"
              data-name="Path 35"
              d="M382.715,132.99a1,1,0,1,1,2,0v6.174a1,1,0,0,1-2,0Z"
              transform="translate(-360.592 -131.672)"
              fill="#545d64"
              fillRule="evenodd"
            />
            <path
              id="Path_36"
              data-name="Path 36"
              d="M375.439,154.735a1,1,0,0,1,.672-1.876,5.63,5.63,0,0,1,3.728,5.3v3.887a1,1,0,1,1-2,0v-3.887a3.635,3.635,0,0,0-2.4-3.422Z"
              transform="translate(-360.592 -131.672)"
              fill="#eb293e"
              fillRule="evenodd"
            />
            <circle
              id="Ellipse_1"
              data-name="Ellipse 1"
              cx="1.214"
              cy="1.214"
              r="1.214"
              transform="translate(10.323 21.132)"
              fill="#eb293e"
            />
            <path
              id="Path_37"
              data-name="Path 37"
              d="M361.593,165.671a1,1,0,0,1,0-2H387.06a1,1,0,0,1,0,2Z"
              transform="translate(-360.592 -131.672)"
              fill="#545d64"
              fillRule="evenodd"
            />
            <path
              id="Path_38"
              data-name="Path 38"
              d="M361.592,133.672a1,1,0,0,1,0-2h25.47a1,1,0,0,1,0,2Z"
              transform="translate(-360.592 -131.672)"
              fill="#545d64"
              fillRule="evenodd"
            />
          </g>
        </g>
      </g>
    </symbol>

    <symbol id="home-icn" viewBox="0 0 42 42" fill="currentColor">
      <defs>
        <clipPath id="a">
          <rect
            width="42"
            height="42"
            transform="translate(353.327 198.632)"
            fill="none"
          />
        </clipPath>
      </defs>
      <g transform="translate(-353.327 -198.632)" clipPath="url(#a)">
        <path
          d="M386.828,218.861a1,1,0,0,1,2,0v15.5a1.558,1.558,0,0,1-.557,1.184,1.765,1.765,0,0,1-1.149.426h-5.182a1,1,0,0,1,0-2h4.887V218.861Zm-28.9-.727,16.395-12.589,16.394,12.589a1,1,0,1,0,1.211-1.586l-16.983-13.041a1,1,0,0,0-1.228-.013l-17,13.054a1,1,0,0,0,1.211,1.586Zm8.78,15.841a1,1,0,0,1,0,2H361.53a1.77,1.77,0,0,1-1.146-.422,1.561,1.561,0,0,1-.56-1.188v-15.5a1,1,0,0,1,2,0v15.114Z"
          fill="#545d64"
          fillRule="evenodd"
        />
        <path
          d="M370.711,223.061h7.231a1,1,0,0,1,1,1v10.914a1,1,0,0,1-1,1h-7.231a1,1,0,0,1-1-1V224.061a1,1,0,0,1,1-1Zm-2.376-5.543a1.918,1.918,0,0,1-.031-.373,4.13,4.13,0,0,1,1.543-2.686,7.767,7.767,0,0,1,3.123-1.732,5.182,5.182,0,0,1,1.368-.175,5.377,5.377,0,0,1,1.288.18,7.972,7.972,0,0,1,3.172,1.74,4.029,4.029,0,0,1,1.552,2.722,1.856,1.856,0,0,1-.058.444,1,1,0,0,1-.965.747v0h-10a1,1,0,0,1-.992-.87Zm2.848-1.582a5.74,5.74,0,0,0-.448.451h7.171a5.982,5.982,0,0,0-.437-.431,5.89,5.89,0,0,0-2.343-1.294,3.41,3.41,0,0,0-.811-.118,3.245,3.245,0,0,0-.845.113,5.706,5.706,0,0,0-2.287,1.279Zm5.759,9.125h-5.231v8.914h5.231Z"
          fill="#eb293e"
          fillRule="evenodd"
        />
      </g>
    </symbol>
    <symbol
      id="icn-prioritychange"
      viewBox="0 0 24.141 21.126"
      fill="currentColor"
    >
      <g id="prior" transform="translate(-750.481 -488.5)">
        <path
          id="Path_111"
          data-name="Path 111"
          d="M-5.037-9.342a3.62,3.62,0,0,1,.961.4,3.094,3.094,0,0,1,.777.662,3.366,3.366,0,0,1,.543.911A3.74,3.74,0,0,1-2.5-6.219H-3.956a2.191,2.191,0,0,0-.316-1.128,1.9,1.9,0,0,0-.764-.685v1.862h-.777V-8.251q-.085-.01-.164-.015t-.164,0l-.124,0-.115.007v2.091h-.777v-1.9a1.733,1.733,0,0,0-.51.339,1.946,1.946,0,0,0-.361.476,2.272,2.272,0,0,0-.217.588A3.069,3.069,0,0,0-8.319-6a3.068,3.068,0,0,0,.169,1.053,2.238,2.238,0,0,0,.481.792,2.092,2.092,0,0,0,.747.5,2.6,2.6,0,0,0,.974.174h2.485v1.265h-6.21V-3.475h1.21a3.009,3.009,0,0,1-.5-.471,3.3,3.3,0,0,1-.413-.613,3.559,3.559,0,0,1-.281-.717,2.931,2.931,0,0,1-.1-.779,3.4,3.4,0,0,1,.184-1.123,3.29,3.29,0,0,1,.523-.961,3.285,3.285,0,0,1,.822-.739,3.628,3.628,0,0,1,1.076-.458v-.921h.777v.8l.147-.007.152,0,.134,0,.134.007v-.8h.777Z"
          transform="translate(760.244 505.653)"
          fill="#db0011"
        />
        <path
          id="Path_112"
          data-name="Path 112"
          d="M-1.579-4.066a1.992,1.992,0,0,1-.587,1.494A2.571,2.571,0,0,1-3.7-1.884v.923h-.7v-.912a3,3,0,0,1-1.51-.493,2.375,2.375,0,0,1-.9-1.164l1.248-.724A1.407,1.407,0,0,0-4.4-3.3V-5.114h-.01l-.021-.01q-.367-.136-.6-.241a4.369,4.369,0,0,1-.54-.3,2.008,2.008,0,0,1-.482-.414,2.084,2.084,0,0,1-.3-.551,2,2,0,0,1-.131-.734,1.915,1.915,0,0,1,.6-1.479A2.47,2.47,0,0,1-4.4-9.488V-10.4h.7v.933A2.378,2.378,0,0,1-1.684-7.988L-2.9-7.275a1.159,1.159,0,0,0-.8-.766v1.751a7.652,7.652,0,0,1,1.311.619A1.861,1.861,0,0,1-1.579-4.066ZM-5.05-7.359a.6.6,0,0,0,.147.4,1.61,1.61,0,0,0,.5.351V-8.072a.844.844,0,0,0-.482.252A.67.67,0,0,0-5.05-7.359ZM-3.7-3.321q.671-.147.671-.734a.629.629,0,0,0-.163-.44A1.56,1.56,0,0,0-3.7-4.831Z"
          transform="translate(776.201 505.681)"
          fill="#db0011"
        />
        <path
          id="Path_1099"
          data-name="Path 1099"
          d="M808.477,480.953v4.183"
          transform="translate(-45.054 8.317)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          id="Path_1102"
          data-name="Path 1102"
          d="M0,0V11.3"
          transform="translate(763.289 508.827) rotate(180)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeWidth="1"
        />
        <path
          id="Path_1100"
          data-name="Path 1100"
          d="M803.142,483.01l2.672-2.591,2.591,2.591"
          transform="translate(-42.417 8.581)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Path_1101"
          data-name="Path 1101"
          d="M0,2.872,2.672,0,5.263,2.872"
          transform="translate(765.988 509.126) rotate(180)"
          fill="none"
          stroke="#242424"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </g>
    </symbol>
    <symbol id="blocked-creditcard" viewBox="0 0 30 23" fill="currentColor">
      <g
        id="noun_blocked_credit_card_584320"
        data-name="noun_blocked credit card_584320"
        transform="translate(-0.186 -1.651)"
      >
        <g
          id="Path_5914"
          data-name="Path 5914"
          transform="translate(0.186 1.651)"
          fill="none"
        >
          <path
            d="M2,0H22a2,2,0,0,1,2,2V14a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
            stroke="none"
          />
          <path
            d="M 2 1 C 1.448600769042969 1 1 1.448599815368652 1 2 L 1 14 C 1 14.55140018463135 1.448600769042969 15 2 15 L 22 15 C 22.55139923095703 15 23 14.55140018463135 23 14 L 23 2 C 23 1.448599815368652 22.55139923095703 1 22 1 L 2 1 M 2 0 L 22 0 C 23.10457038879395 0 24 0.8954296112060547 24 2 L 24 14 C 24 15.10457038879395 23.10457038879395 16 22 16 L 2 16 C 0.8954296112060547 16 0 15.10457038879395 0 14 L 0 2 C 0 0.8954296112060547 0.8954296112060547 0 2 0 Z"
            stroke="none"
            fill="#242424"
          />
        </g>
        <g
          id="Path_5918"
          data-name="Path 5918"
          transform="translate(3.186 6.651)"
          fill="#fff"
        >
          <path
            d="M 22 15.5 L 2 15.5 C 1.172899961471558 15.5 0.5 14.82709980010986 0.5 14 L 0.5 2 C 0.5 1.172899961471558 1.172899961471558 0.5 2 0.5 L 22 0.5 C 22.82710075378418 0.5 23.5 1.172899961471558 23.5 2 L 23.5 14 C 23.5 14.82709980010986 22.82710075378418 15.5 22 15.5 Z"
            stroke="none"
          />
          <path
            d="M 2 1 C 1.448600769042969 1 1 1.448599815368652 1 2 L 1 14 C 1 14.55140018463135 1.448600769042969 15 2 15 L 22 15 C 22.55139923095703 15 23 14.55140018463135 23 14 L 23 2 C 23 1.448599815368652 22.55139923095703 1 22 1 L 2 1 M 2 0 L 22 0 C 23.10457038879395 0 24 0.8954296112060547 24 2 L 24 14 C 24 15.10457038879395 23.10457038879395 16 22 16 L 2 16 C 0.8954296112060547 16 0 15.10457038879395 0 14 L 0 2 C 0 0.8954296112060547 0.8954296112060547 0 2 0 Z"
            stroke="none"
            fill="#242424"
          />
        </g>
        <path
          id="Path_5917"
          data-name="Path 5917"
          d="M1.353,4.723H23.885"
          transform="translate(2.439 7)"
          fill="none"
          stroke="#242424"
          strokeWidth="1"
        />
        <g
          id="Ellipse_157"
          data-name="Ellipse 157"
          transform="translate(21.186 15.651)"
          fill="#fff"
          stroke="#242424"
          strokeWidth="1"
        >
          <circle cx="4.5" cy="4.5" r="4.5" stroke="none" />
          <circle cx="4.5" cy="4.5" r="4" fill="none" />
        </g>
        <g
          id="Group_3165"
          data-name="Group 3165"
          transform="translate(16.768 12.5)"
        >
          <path
            id="Path_5915"
            data-name="Path 5915"
            d="M0,0,3.713,2.142"
            transform="matrix(0.966, 0.259, -0.259, 0.966, 7.402, 6.151)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="1"
          />
          <path
            id="Path_5916"
            data-name="Path 5916"
            d="M0,0,3.589,2.06"
            transform="matrix(-0.259, 0.966, -0.966, -0.259, 10.321, 6.184)"
            fill="none"
            stroke="#db0011"
            strokeLinecap="round"
            strokeWidth="1"
          />
        </g>
      </g>{' '}
    </symbol>

    <symbol id="icn-refresh" viewBox="0 0 19.286 19.286" fill="currentColor">
      <g id="noun_update_370571" transform="translate(-6.6 -6.6)">
        <g
          id="Group_2123"
          data-name="Group 2123"
          transform="translate(6.6 6.6)"
        >
          <path
            id="Path_2196"
            data-name="Path 2196"
            d="M24.864,24.775a1.034,1.034,0,0,1-1.022-1.022V22.176A9.631,9.631,0,0,1,6.689,17.443l-.067-.489H8.666l.044.378a7.61,7.61,0,0,0,14.065,2.8H20.22a1.022,1.022,0,1,1,0-2.044h4.666a.96.96,0,0,1,1,1.022v4.644A1.034,1.034,0,0,1,24.864,24.775ZM23.82,15.532l-.044-.378a7.61,7.61,0,0,0-14.065-2.8h2.533a1.022,1.022,0,1,1,0,2.044H7.622A1.013,1.013,0,0,1,6.6,13.377V8.733a1.022,1.022,0,1,1,2.044,0v1.578A9.631,9.631,0,0,1,25.8,15.043l.067.489Z"
            transform="translate(-6.6 -6.6)"
            fill="currentColor"
            fillRule="evenodd"
          />
        </g>
      </g>
    </symbol>
    <symbol id="icn-refresh" viewBox="0 0 19.286 19.286" fill="currentColor">
      <g id="noun_update_370571" transform="translate(-6.6 -6.6)">
        <g
          id="Group_2123"
          data-name="Group 2123"
          transform="translate(6.6 6.6)"
        >
          <path
            id="Path_2196"
            data-name="Path 2196"
            d="M24.864,24.775a1.034,1.034,0,0,1-1.022-1.022V22.176A9.631,9.631,0,0,1,6.689,17.443l-.067-.489H8.666l.044.378a7.61,7.61,0,0,0,14.065,2.8H20.22a1.022,1.022,0,1,1,0-2.044h4.666a.96.96,0,0,1,1,1.022v4.644A1.034,1.034,0,0,1,24.864,24.775ZM23.82,15.532l-.044-.378a7.61,7.61,0,0,0-14.065-2.8h2.533a1.022,1.022,0,1,1,0,2.044H7.622A1.013,1.013,0,0,1,6.6,13.377V8.733a1.022,1.022,0,1,1,2.044,0v1.578A9.631,9.631,0,0,1,25.8,15.043l.067.489Z"
            transform="translate(-6.6 -6.6)"
            fill="currentColor"
            fillRule="evenodd"
          />
        </g>
      </g>
    </symbol>
    <symbol id="info-filled" viewBox="0 0 18 18" fill="currentColor">
      <g
        id="საკრედიტო-ბარათი"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="საკრედიტო-ბარათი-14"
          transform="translate(-348.000000, -951.000000)"
        >
          <g id="content" transform="translate(300.000000, 199.000000)">
            <g id="Group-3173" transform="translate(32.000000, 402.000000)">
              <g
                id="Group_2228-Copy"
                transform="translate(0.000000, 334.745000)"
              >
                <g
                  id="Enterprise-/-Commerce-/-currency--won-/-20"
                  transform="translate(15.000000, 14.255000)"
                >
                  <path
                    d="M10,1.25 C5.16750844,1.25 1.25,5.16750844 1.25,10 C1.25,14.8324916 5.16750844,18.75 10,18.75 C14.8324916,18.75 18.75,14.8324916 18.75,10 C18.75,7.67935571 17.8281276,5.45375898 16.1871843,3.81281566 C14.546241,2.17187235 12.3206443,1.25 10,1.25 Z M10,5 C10.517767,5 10.9375,5.41973305 10.9375,5.9375 C10.9375,6.45526695 10.517767,6.875 10,6.875 C9.48223305,6.875 9.0625,6.45526695 9.0625,5.9375 C9.0625,5.41973305 9.48223305,5 10,5 Z M12.5,15.078125 L7.5,15.078125 L7.5,13.671875 L9.296875,13.671875 L9.296875,10.078125 L8.125,10.078125 L8.125,8.671875 L10.703125,8.671875 L10.703125,13.671875 L12.5,13.671875 L12.5,15.078125 Z"
                    id="Fill"
                    fill="#161616"
                  ></path>
                  <path
                    d="M10,5 C10.517767,5 10.9375,5.41973305 10.9375,5.9375 C10.9375,6.45526695 10.517767,6.875 10,6.875 C9.48223305,6.875 9.0625,6.45526695 9.0625,5.9375 C9.0625,5.41973305 9.48223305,5 10,5 Z M12.5,13.671875 L10.703125,13.671875 L10.703125,8.671875 L8.125,8.671875 L8.125,10.078125 L9.296875,10.078125 L9.296875,13.671875 L7.5,13.671875 L7.5,15.078125 L12.5,15.078125 L12.5,13.671875 Z"
                    id="_inner-path_"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="information" viewBox="0 0 16 16" fill="currentColor">
      <path d="M14.5,18V14h-2v1h1v3H12v1h4V18Z" transform="translate(-6 -7)" />
      <path
        d="M15.25,8a.75.75,0,1,0,.75.75A.75.75,0,0,0,15.25,8Z"
        transform="translate(-7.25 -4)"
      />
      <path
        d="M9,16a7,7,0,1,1,7-7,7,7,0,0,1-7,7ZM9,3a6,6,0,1,0,6,6A6,6,0,0,0,9,3Z"
        transform="translate(-1 -1)"
      />
      <rect width="16" height="16" fill="none" />
    </symbol>
    <symbol id="information-new" viewBox="0 0 16 16" fill="currentColor">
      <path
        id="Path_5765"
        data-name="Path 5765"
        d="M14.5,18V14h-2v1h1v3H12v1h4V18Z"
        transform="translate(-6 -7)"
        fill="currentColor"
      />
      <path
        id="Path_5766"
        data-name="Path 5766"
        d="M15.25,8a.75.75,0,1,0,.75.75A.75.75,0,0,0,15.25,8Z"
        transform="translate(-7.25 -4)"
        fill="currentColor"
      />
      <path
        id="Path_5767"
        data-name="Path 5767"
        d="M9,16a7,7,0,1,1,7-7,7,7,0,0,1-7,7ZM9,3a6,6,0,1,0,6,6A6,6,0,0,0,9,3Z"
        transform="translate(-1 -1)"
        fill="currentColor"
      />
      <rect
        id="_Transparent_Rectangle_"
        data-name="&lt;Transparent Rectangle&gt;"
        width="16"
        height="16"
        fill="none"
      />
    </symbol>
    <symbol id="mobile-check" viewBox="0 0 40 40" fill="currentColor">
      <path
        d="M32.648,12.161c-.647-.22-1.078-.586-1.078-1.026v-.293a5.476,5.476,0,0,0,1.365-3.663,3.143,3.143,0,0,0-3.377-3.37,3.179,3.179,0,0,0-3.377,3.37,5.618,5.618,0,0,0,1.365,3.663v.22c0,.366-.431.806-1.078,1.026a3.575,3.575,0,0,0-2.659,3.223v1.1a.686.686,0,0,0,.719.733h9.988a.686.686,0,0,0,.719-.733v-1.1A3.27,3.27,0,0,0,32.648,12.161ZM29.63,5.275a1.734,1.734,0,0,1,1.94,1.9c0,1.538-1.006,3.15-1.94,3.15s-1.94-1.612-1.94-3.15A1.772,1.772,0,0,1,29.63,5.275Zm4.239,10.4H25.318v-.366c0-.733.647-1.465,1.725-1.832a2.975,2.975,0,0,0,1.94-1.758,2.891,2.891,0,0,0,1.293,0,2.669,2.669,0,0,0,1.94,1.758c1.006.366,1.725,1.1,1.725,1.832v.366Z"
        transform="translate(0 -0.31)"
        fill="#db0011"
      />
      <path d="M37.5,0H21.667a2.455,2.455,0,0,0-2.5,2.5V4.917A10.256,10.256,0,0,0,15.5,4.25c-5.333,0-8.583,3.25-8.583,8.5A14.177,14.177,0,0,0,11,22.667v1.25C11,25.583,9.417,27.25,7.083,28,2.75,29.5,0,32.667,0,36.083v3.083A.787.787,0,0,0,.833,40H30.167A.787.787,0,0,0,31,39.167V36.083c0-3.417-2.75-6.583-7-8-2.417-.833-3.917-2.417-3.917-4.083V22.75a12.117,12.117,0,0,0,1.583-1.917H27V23.5a.179.179,0,0,1-.167.167h-3a.833.833,0,0,0,0,1.667h3A1.85,1.85,0,0,0,28.667,23.5V20.833H37.5a2.455,2.455,0,0,0,2.5-2.5V2.5A2.455,2.455,0,0,0,37.5,0ZM23.417,29.667c3.583,1.167,5.917,3.75,5.917,6.417v2.25H1.667v-2.25c0-2.75,2.333-5.25,5.917-6.417,3.167-1.083,5.083-3.25,5.083-5.667h0a5.727,5.727,0,0,0,5.667,0h0C18.333,26.417,20.333,28.667,23.417,29.667Zm-4.75-7.917a4.476,4.476,0,0,1-6.333,0,12.42,12.42,0,0,1-3.75-9c0-4.25,2.583-6.833,6.917-6.833a8.208,8.208,0,0,1,3.667.833V18.333A2.713,2.713,0,0,0,20,20.25,7.787,7.787,0,0,1,18.667,21.75Zm19.667-3.417a.787.787,0,0,1-.833.833H21.667a.787.787,0,0,1-.833-.833V2.5a.787.787,0,0,1,.833-.833H37.5a.787.787,0,0,1,.833.833Z" />
      <path d="M3.167,8A.787.787,0,0,0,4,7.167v-3A.179.179,0,0,1,4.167,4h3A.787.787,0,0,0,8,3.167a.787.787,0,0,0-.833-.833H4.25A1.85,1.85,0,0,0,2.417,4.167v3A.766.766,0,0,0,3.167,8Z" />
      <path d="M4.25,25.417h3a.833.833,0,1,0,0-1.667h-3a.179.179,0,0,1-.167-.167V20.667a.787.787,0,0,0-.833-.833.787.787,0,0,0-.833.833v2.917A1.749,1.749,0,0,0,4.25,25.417Z" />
    </symbol>
    <symbol id="pincode" viewBox="0 0 27.361 12.568" fill="currentColor">
      <g id="Group_3382" data-name="Group 3382" transform="translate(0.4 0.4)">
        <path
          id="Path_5974"
          data-name="Path 5974"
          d="M4.241,3.845a.216.216,0,0,0-.168,0l-.588.4a.216.216,0,0,0-.06.312h0l.552.8H3.04a.24.24,0,0,0-.24.24h0v.7a.24.24,0,0,0,.24.24h.973l-.54.817a.228.228,0,0,0,.06.324h0l.588.4a.228.228,0,0,0,.312-.06h0l.672-1,.672,1a.24.24,0,0,0,.324.072l.54-.36a.228.228,0,0,0,0-.324h0L6.1,6.583h.973A.216.216,0,0,0,7.3,6.355h0V5.646a.228.228,0,0,0-.216-.24H6.2l.54-.8a.228.228,0,0,0-.1-.324l-.588-.4a.228.228,0,0,0-.324,0h0l-.672,1-.672-1A.264.264,0,0,0,4.241,3.845Z"
          transform="translate(-0.314 -0.111)"
          fill="#db0011"
        />
        <path
          id="Path_5975"
          data-name="Path 5975"
          d="M8.989,3.85a.2.2,0,0,0-.168,0l-.588.4a.216.216,0,0,0-.072.312h0l.54.8H7.74a.24.24,0,0,0-.24.228h0v.7a.216.216,0,0,0,.216.24H8.7l-.54.817a.228.228,0,0,0,0,.324h0l.588.4A.228.228,0,0,0,9.061,8h0l.684-1,.672,1a.24.24,0,0,0,.324.072l.588-.4a.228.228,0,0,0,.06-.324h0l-.54-.817h.973a.216.216,0,0,0,.228-.228h0v-.66a.228.228,0,0,0-.216-.24H10.85l.54-.8a.24.24,0,0,0-.06-.324l-.588-.4a.228.228,0,0,0-.324,0h0l-.672,1-.684-1a.2.2,0,0,0-.144-.1Z"
          transform="translate(0.629 -0.116)"
          fill="#db0011"
        />
        <path
          id="Path_5976"
          data-name="Path 5976"
          d="M13.709,3.85a.24.24,0,0,0-.18,0l-.588.4a.228.228,0,0,0-.06.312h0l.552.8h-.985a.24.24,0,0,0-.228.228h0v.7a.24.24,0,0,0,.228.24h.985l-.552.817a.24.24,0,0,0,.06.324h0l.588.4A.24.24,0,0,0,13.853,8h0l.672-1,.684,1a.24.24,0,0,0,.348.12l.576-.4a.24.24,0,0,0,.072-.324l-.552-.817h.973a.228.228,0,0,0,.24-.228h0V5.651a.252.252,0,0,0-.228-.24h-.985l.552-.8a.24.24,0,0,0-.072-.324l-.576-.4a.228.228,0,0,0-.324,0l-.684,1-.672-1a.24.24,0,0,0-.144-.1Z"
          transform="translate(1.577 -0.116)"
          fill="#db0011"
        />
        <rect
          id="Rectangle_568"
          data-name="Rectangle 568"
          width="4.623"
          height="0.901"
          transform="translate(19.465 7.133)"
          fill="#db0011"
        />
        <rect
          id="Rectangle_569"
          data-name="Rectangle 569"
          width="26.561"
          height="11.768"
          rx="3"
          fill="none"
          stroke="#242424"
          strokeMiterlimit="10"
          strokeWidth="0.8"
        />
      </g>
    </symbol>
    <symbol id="pincode-card" viewBox="0 0 27.361 12.568" fill="currentColor">
      <g id="Group_3382" data-name="Group 3382" transform="translate(0.4 0.4)">
        <path
          id="Path_5974"
          data-name="Path 5974"
          d="M4.241,3.845a.216.216,0,0,0-.168,0l-.588.4a.216.216,0,0,0-.06.312h0l.552.8H3.04a.24.24,0,0,0-.24.24h0v.7a.24.24,0,0,0,.24.24h.973l-.54.817a.228.228,0,0,0,.06.324h0l.588.4a.228.228,0,0,0,.312-.06h0l.672-1,.672,1a.24.24,0,0,0,.324.072l.54-.36a.228.228,0,0,0,0-.324h0L6.1,6.583h.973A.216.216,0,0,0,7.3,6.355h0V5.646a.228.228,0,0,0-.216-.24H6.2l.54-.8a.228.228,0,0,0-.1-.324l-.588-.4a.228.228,0,0,0-.324,0h0l-.672,1-.672-1A.264.264,0,0,0,4.241,3.845Z"
          transform="translate(-0.314 -0.111)"
          fill="currentColor"
        />
        <path
          id="Path_5975"
          data-name="Path 5975"
          d="M8.989,3.85a.2.2,0,0,0-.168,0l-.588.4a.216.216,0,0,0-.072.312h0l.54.8H7.74a.24.24,0,0,0-.24.228h0v.7a.216.216,0,0,0,.216.24H8.7l-.54.817a.228.228,0,0,0,0,.324h0l.588.4A.228.228,0,0,0,9.061,8h0l.684-1,.672,1a.24.24,0,0,0,.324.072l.588-.4a.228.228,0,0,0,.06-.324h0l-.54-.817h.973a.216.216,0,0,0,.228-.228h0v-.66a.228.228,0,0,0-.216-.24H10.85l.54-.8a.24.24,0,0,0-.06-.324l-.588-.4a.228.228,0,0,0-.324,0h0l-.672,1-.684-1a.2.2,0,0,0-.144-.1Z"
          transform="translate(0.629 -0.116)"
          fill="currentColor"
        />
        <path
          id="Path_5976"
          data-name="Path 5976"
          d="M13.709,3.85a.24.24,0,0,0-.18,0l-.588.4a.228.228,0,0,0-.06.312h0l.552.8h-.985a.24.24,0,0,0-.228.228h0v.7a.24.24,0,0,0,.228.24h.985l-.552.817a.24.24,0,0,0,.06.324h0l.588.4A.24.24,0,0,0,13.853,8h0l.672-1,.684,1a.24.24,0,0,0,.348.12l.576-.4a.24.24,0,0,0,.072-.324l-.552-.817h.973a.228.228,0,0,0,.24-.228h0V5.651a.252.252,0,0,0-.228-.24h-.985l.552-.8a.24.24,0,0,0-.072-.324l-.576-.4a.228.228,0,0,0-.324,0l-.684,1-.672-1a.24.24,0,0,0-.144-.1Z"
          transform="translate(1.577 -0.116)"
          fill="currentColor"
        />
        <rect
          id="Rectangle_568"
          data-name="Rectangle 568"
          width="4.623"
          height="0.901"
          transform="translate(19.465 7.133)"
          fill="currentColor"
        />
        <rect
          id="Rectangle_569"
          data-name="Rectangle 569"
          width="26.561"
          height="11.768"
          rx="3"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="0.8"
        />
      </g>
    </symbol>
    <symbol id="attachment" viewBox="0 0 24 24" fill="currentColor">
      <path
        d="M21.88,23.7H10.515A1.517,1.517,0,0,1,9,22.184V17.638h1.515v4.546H21.88V5.515H15.061V4H21.88A1.517,1.517,0,0,1,23.4,5.515V22.184A1.517,1.517,0,0,1,21.88,23.7Z"
        transform="translate(-2.181 -0.969)"
        fill="currentColor"
      />
      <rect
        width="5"
        height="1.5"
        transform="translate(13 8)"
        fill="currentColor"
      />
      <rect
        width="6"
        height="1.5"
        transform="translate(12 11)"
        fill="currentColor"
      />
      <rect
        width="7"
        height="1.5"
        transform="translate(11 14)"
        fill="currentColor"
      />
      <path
        d="M7.788,14.88A3.793,3.793,0,0,1,4,11.092V2.758H5.515v8.334a2.273,2.273,0,0,0,4.546,0V4.273a.758.758,0,0,0-1.515,0V11.85H7.031V4.273a2.273,2.273,0,0,1,4.546,0v6.819A3.793,3.793,0,0,1,7.788,14.88Z"
        transform="translate(-0.969 -0.485)"
        fill="currentColor"
      />
      <rect width="24" height="24" fill="none" />
    </symbol>
    <symbol id="printer" viewBox="0 0 24 24" fill="currentColor">
      <path
        d="M20.571,7.154H18.429V3H5.571V7.154H3.429A1.407,1.407,0,0,0,2,8.538v6.923a1.407,1.407,0,0,0,1.429,1.385H5.571V21H18.429V16.846h2.143A1.407,1.407,0,0,0,22,15.462V8.538A1.407,1.407,0,0,0,20.571,7.154ZM7,4.385H17V7.154H7ZM17,19.615H7V12.692H17Zm3.571-4.154H18.429V11.308H5.571v4.154H3.429V8.538H20.571Z"
        fill="currentColor"
      />
      <rect width="24" height="24" fill="none" />
    </symbol>
    <symbol id="icn-new-info" viewBox="0 0 16 16" fill="currentColor">
      <g id="information">
        <path
          id="Path_5950"
          data-name="Path 5950"
          d="M14.506,18.01V14H12.5v1h1V18.01H12v1h4.01v-1Z"
          transform="translate(-5.984 -6.657)"
          fill="currentColor"
        />
        <path
          id="Path_5951"
          data-name="Path 5951"
          d="M15.252,8A.752.752,0,1,0,16,8.752.752.752,0,0,0,15.252,8Z"
          transform="translate(-7.231 -3.665)"
          fill="currentColor"
        />
        <path
          id="Path_5952"
          data-name="Path 5952"
          d="M9.018,16.036a7.018,7.018,0,1,1,7.018-7.018,7.018,7.018,0,0,1-7.018,7.018ZM9.018,3a6.016,6.016,0,1,0,6.016,6.016A6.016,6.016,0,0,0,9.018,3Z"
          transform="translate(-0.997 -0.673)"
          fill="currentColor"
        />
        <rect
          id="_Transparent_Rectangle_"
          data-name="&lt;Transparent Rectangle&gt;"
          width="16"
          height="16"
          fill="none"
        />
      </g>
    </symbol>
    <symbol id="icn-new-warning" viewBox="0 0 20 20" fill="currentColor">
      <g id="Group_5299" data-name="Group 5299" transform="translate(-24 -19)">
        <g id="warning--filled" transform="translate(24 19)">
          <rect id="Transparent_Rectangle" width="20" height="20" fill="none" />
          <path
            id="Compound_Path"
            d="M10.7,2a8.7,8.7,0,1,0,8.7,8.7A8.721,8.721,0,0,0,10.7,2Zm-.683,3.726h1.366v6.832H10.012ZM10.7,16.285a.932.932,0,1,1,.932-.932A.955.955,0,0,1,10.7,16.285Z"
            transform="translate(-0.798 -0.758)"
            fill="#f5b403"
          />
          <path
            id="inner-path"
            d="M16.363,17.627a.932.932,0,1,1-.932-.932A.955.955,0,0,1,16.363,17.627ZM16.115,8H14.748v6.832h1.366Z"
            transform="translate(-5.535 -3.031)"
            fill="#db0011"
            opacity="0"
          />
        </g>
      </g>
    </symbol>
    <symbol id="workflow-automation" viewBox="0 0 16 16" fill="currentColor">
      <path
        id="Path_1359"
        data-name="Path 1359"
        d="M9.919,23.453a5.435,5.435,0,0,1-4.538-2.466H7.946V20H4v3.946h.987V22.121A6.37,6.37,0,0,0,9.919,24.44Z"
        transform="translate(-2.027 -10.134)"
      />
      <path
        id="Path_1360"
        data-name="Path 1360"
        d="M23.906,18.946V17.96H22.87a3.3,3.3,0,0,0-.345-.888l.74-.74-.691-.691-.74.74a2.388,2.388,0,0,0-.888-.345V15H19.96v1.036a3.3,3.3,0,0,0-.888.345l-.74-.74-.691.691.74.74a2.388,2.388,0,0,0-.345.888H17v.987h1.036a3.3,3.3,0,0,0,.345.888l-.74.74.691.691.74-.74a2.388,2.388,0,0,0,.888.345v1.036h.987V20.87a3.3,3.3,0,0,0,.888-.345l.74.74.691-.691-.74-.74a2.388,2.388,0,0,0,.345-.888Zm-3.453.987a1.48,1.48,0,1,1,1.48-1.48A1.453,1.453,0,0,1,20.453,19.933Z"
        transform="translate(-8.614 -7.601)"
      />
      <path
        id="Path_1361"
        data-name="Path 1361"
        d="M11.386,6.453h2.565a5.424,5.424,0,0,0-9.964,2.96H3A6.411,6.411,0,0,1,14.346,5.318V3.493h.987V7.44H11.386Z"
        transform="translate(-1.52 -1.52)"
      />
      <rect
        id="_x3C_Transparent_Rectangle_x3E__589_"
        width="16"
        height="16"
        fill="none"
      />
    </symbol>
    <symbol id="rotate-360" viewBox="0 0 16 16" fill="currentColor">
      <path
        id="Path_1358"
        data-name="Path 1358"
        d="M14.766,5.384l0,0c-.047-.056-.1-.106-.15-.16-.094-.105-.188-.21-.289-.309-.071-.07-.146-.134-.22-.2-.094-.084-.187-.168-.286-.247-.082-.066-.166-.126-.251-.188s-.2-.142-.3-.208S13.091,3.956,13,3.9s-.212-.119-.321-.175-.19-.095-.287-.138c-.114-.051-.23-.1-.348-.143-.1-.037-.194-.075-.293-.107-.126-.042-.255-.077-.385-.111-.095-.025-.188-.053-.285-.073-.149-.033-.3-.055-.453-.077-.082-.012-.161-.028-.244-.037A6.63,6.63,0,0,0,4.538,5.411v-1.9H3.513v4.1h4.1V6.588H4.954A5.619,5.619,0,0,1,9.665,4.025a5.7,5.7,0,0,1,.61.034c.07.007.137.022.206.032.129.019.257.038.383.065.082.018.161.041.242.062.109.029.218.058.325.093.084.028.167.06.249.091.1.038.2.077.292.12s.164.077.244.118.181.1.27.147.156.092.232.141.17.115.252.175.144.1.214.16.162.137.241.208c.063.056.127.111.187.17.086.084.165.173.245.262A5.636,5.636,0,1,1,4.025,9.664H3A6.665,6.665,0,1,0,14.766,5.384Z"
        transform="translate(-1.462 -1.462)"
      />
      <rect
        id="_Transparent_Rectangle_"
        data-name="&lt;Transparent Rectangle&gt;"
        width="16"
        height="16"
        fill="none"
      />
    </symbol>
    <symbol id="document-add" viewBox="0 0 16 16" fill="currentColor">
      <path
        id="Path_1349"
        data-name="Path 1349"
        d="M25,22H23V20H22v2H20v1h2v2h1V23h2Z"
        transform="translate(-10 -10)"
      />
      <path
        id="Path_1350"
        data-name="Path 1350"
        d="M11,15H7V3h4V6a1,1,0,0,0,1,1h3V9h1V6a.455.455,0,0,0-.15-.35l-3.5-3.5A.454.454,0,0,0,12,2H7A1,1,0,0,0,6,3V15a1,1,0,0,0,1,1h4ZM12,3.2,14.8,6H12Z"
        transform="translate(-3 -1)"
      />
      <rect
        id="_Transparent_Rectangle_"
        data-name="&lt;Transparent Rectangle&gt;"
        width="16"
        height="16"
        fill="none"
      />
    </symbol>

    <symbol id="attach-new" viewBox="0 0 24 24" fill="currentColor">
      <g
        id="Group_6813"
        data-name="Group 6813"
        transform="translate(-1674 -788)"
      >
        <rect
          id="Rectangle_1568"
          data-name="Rectangle 1568"
          width="24"
          height="24"
          transform="translate(1674 788)"
          fill="none"
        />
        <g id="noun_attach_275572" transform="translate(1675.985 791.196)">
          <path
            id="Path_1200"
            data-name="Path 1200"
            d="M20.133,5.927a3.758,3.758,0,0,0-5.1.314l-2.714,2.6-1.569,1.5L5.576,15.286a1.777,1.777,0,0,0-.011,2.586,1.98,1.98,0,0,0,2.7-.01l6.4-6.124a.445.445,0,0,0,0-.649.5.5,0,0,0-.679,0l-6.4,6.124a.985.985,0,0,1-1.347.01.884.884,0,0,1,.011-1.288l5.174-4.948L13,9.486l2.714-2.6a3.2,3.2,0,0,1,2-.9,2.275,2.275,0,0,1,1.742.582,2.063,2.063,0,0,1,.608,1.666,2.942,2.942,0,0,1-.937,1.913l-3.011,2.88-1.272,1.217L8.269,20.539a2.985,2.985,0,0,1-4.072,0L2.8,19.2a2.679,2.679,0,0,1,0-3.894L13.327,5.238a.444.444,0,0,0,0-.648h0a.5.5,0,0,0-.678,0L2.119,14.657a3.569,3.569,0,0,0,0,5.192l1.4,1.338a3.976,3.976,0,0,0,5.429,0L15.521,14.9l1.272-1.217L19.8,10.8A3.374,3.374,0,0,0,20.133,5.927Z"
            transform="translate(-0.999 -4.455)"
            stroke="#000"
            strokeWidth="0.4"
          />
        </g>
      </g>
    </symbol>
    <symbol id="trash-new" viewBox="0 0 24 24" fill="currentColor">
      <g
        id="Group_6812"
        data-name="Group 6812"
        transform="translate(-1710 -788)"
      >
        <rect
          id="Rectangle_1567"
          data-name="Rectangle 1567"
          width="24"
          height="24"
          transform="translate(1710 788)"
          fill="none"
        />
        <g id="trash-can" transform="translate(1711 789)">
          <rect
            id="Rectangle_815"
            data-name="Rectangle 815"
            width="1.362"
            height="8.175"
            transform="translate(8.104 8.175)"
          />
          <rect
            id="Rectangle_816"
            data-name="Rectangle 816"
            width="1.362"
            height="8.175"
            transform="translate(12.191 8.175)"
          />
          <path
            id="Path_7186"
            data-name="Path 7186"
            d="M4,6V7.362H5.362V20.987A1.362,1.362,0,0,0,6.725,22.35h10.9a1.362,1.362,0,0,0,1.362-1.362V7.362H20.35V6ZM6.725,20.987V7.362h10.9V20.987Z"
            transform="translate(-1.346 -1.913)"
          />
          <rect
            id="Rectangle_817"
            data-name="Rectangle 817"
            width="5.45"
            height="1.362"
            transform="translate(8.104 1.362)"
          />
          <rect
            id="_Transparent_Rectangle_"
            data-name="&lt;Transparent Rectangle&gt;"
            width="21"
            height="22"
            transform="translate(0)"
            fill="none"
          />
        </g>
      </g>
    </symbol>
    <symbol
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <g
        id="info-black"
        data-name="Group 6684"
        transform="translate(-1.25 18.75)"
      >
        <g
          id="Group_6685"
          data-name="Group 6685"
          transform="translate(1.25 -18.75)"
        >
          <path
            id="Path_5956"
            data-name="Path 5956"
            d="M10.25-18.75a9,9,0,0,0-9,9,9,9,0,0,0,9,9,9,9,0,0,0,9-9,9,9,0,0,0-2.636-6.364A9,9,0,0,0,10.25-18.75Zm0,3.857a.964.964,0,0,1,.964.964.964.964,0,0,1-.964.964.964.964,0,0,1-.964-.964A.964.964,0,0,1,10.25-14.893ZM12.821-4.527H7.679V-5.973H9.527v-3.7H8.321v-1.446h2.652v5.143h1.848Z"
            transform="translate(-1.25 18.75)"
            fill="#161616"
            fillRule="evenodd"
          />
        </g>
      </g>
    </symbol>

    <symbol id="trust-green" viewBox="0 0 20 20" fill="currentColor">
      <g
        id="Group_7904"
        data-name="Group 7904"
        transform="translate(-1846 -800)"
      >
        <rect
          id="Rectangle_2054"
          data-name="Rectangle 2054"
          width="20"
          height="20"
          transform="translate(1846 800)"
          fill="none"
        />
        <g id="Symbols" transform="translate(1848.5 801.25)">
          <g
            id="Icons-_-24-_-Trusted-filled"
            data-name="Icons-/-24-/-Trusted-filled"
            transform="translate(0)"
          >
            <path
              id="Combined-Shape"
              d="M10.5,19,6.64,16.942A6.864,6.864,0,0,1,3,10.875V2.75A1.251,1.251,0,0,1,4.25,1.5h12.5A1.251,1.251,0,0,1,18,2.75v8.125a6.864,6.864,0,0,1-3.64,6.067ZM13.007,6.724a.747.747,0,0,1,1.032-.18.726.726,0,0,1,.231.94l-.049.078-4.01,5.521L7.275,9.8A.725.725,0,0,1,7.35,8.772a.748.748,0,0,1,.98.009l.065.066,1.692,1.86Z"
              transform="translate(-3 -1.5)"
              fill="#34ac34"
              fillRule="evenodd"
            />
          </g>
        </g>
      </g>
    </symbol>

    <symbol id="trust-yellow" viewBox="0 0 20 20" fill="currentColor">
      <g
        id="Group_7899"
        data-name="Group 7899"
        transform="translate(-1846 -800)"
      >
        <rect
          id="Rectangle_2054"
          data-name="Rectangle 2054"
          width="20"
          height="20"
          transform="translate(1846 800)"
          fill="none"
        />
        <g id="Symbols" transform="translate(1848.5 801.25)">
          <g
            id="Icons-_-24-_-Trusted-filled"
            data-name="Icons-/-24-/-Trusted-filled"
            transform="translate(0)"
          >
            <path
              id="Combined-Shape"
              d="M10.5,19,6.64,16.942A6.864,6.864,0,0,1,3,10.875V2.75A1.251,1.251,0,0,1,4.25,1.5h12.5A1.251,1.251,0,0,1,18,2.75v8.125a6.864,6.864,0,0,1-3.64,6.067ZM13.007,6.724a.747.747,0,0,1,1.032-.18.726.726,0,0,1,.231.94l-.049.078-4.01,5.521L7.275,9.8A.725.725,0,0,1,7.35,8.772a.748.748,0,0,1,.98.009l.065.066,1.692,1.86Z"
              transform="translate(-3 -1.5)"
              fill="#efb734"
              fillRule="evenodd"
            />
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="radio-black-circle" viewBox="0 0 18.004 18.004">
      <g id="radio-black-circle" transform="translate(0 0)">
        <g id="Group-13">
          <g id="Group-8">
            <g id="Group">
              <g id="radio-button--checked">
                <path
                  id="Shape"
                  d="M9,0a9,9,0,1,0,6.365,2.637A9,9,0,0,0,9,0ZM9,16.718a7.716,7.716,0,1,1,5.456-2.26A7.716,7.716,0,0,1,9,16.718Z"
                  transform="translate(0 0)"
                  fill="#212126"
                />
                <path
                  id="Path"
                  d="M8.99,4a4.99,4.99,0,1,0,4.99,4.99A4.99,4.99,0,0,0,8.99,4Z"
                  transform="translate(0.012 0.012)"
                  fill="#212126"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="Icons_radiobutton_1" viewBox="0 0 18.004 18.004">
      <g id="Icons_radiobutton_1" data-name="Icons/radiobutton 1">
        <g id="radio-button">
          <rect
            id="_Transparent_Rectangle_"
            width="20"
            height="20"
            fill="none"
          />
          <g
            id="radiobutton_2"
            data-name="radiobutton 2"
            transform="translate(2 2.001)"
          >
            <g id="radio-button--checked">
              <path
                id="Shape"
                d="M8,16a8,8,0,1,1,8-8A8.009,8.009,0,0,1,8,16ZM4.394,7.333,3.335,8.393l3.333,3.333,6-6L11.606,4.666,6.667,9.606Z"
              />
              <path
                id="inner-path"
                d="M3.333,7.06,0,3.727,1.061,2.667,3.333,4.939,8.273,0,9.336,1.057l-6,6Z"
                transform="translate(3.334 4.666)"
                fill="none"
              />
            </g>
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="printer" viewBox="0 0 20 20" fill="currentColor">
      <path
        id="Path_1351"
        data-name="Path 1351"
        d="M18.163,6.73H16.3V3H5.108V6.73H3.243A1.243,1.243,0,0,0,2,7.973V14.19a1.243,1.243,0,0,0,1.243,1.243H5.108v3.73H16.3v-3.73h1.865a1.243,1.243,0,0,0,1.243-1.243V7.973A1.243,1.243,0,0,0,18.163,6.73ZM6.352,4.243h8.7V6.73h-8.7Zm8.7,13.677h-8.7V11.7h8.7Zm3.108-3.73H16.3V10.46H5.108v3.73H3.243V7.973h14.92Z"
        transform="translate(-0.757 -1.135)"
        fill="#242424"
      />
      <rect
        id="_Transparent_Rectangle_"
        data-name="&lt;Transparent Rectangle&gt;"
        width="20"
        height="20"
        fill="none"
      />
    </symbol>
    <symbol id="spliit-money" viewBox="0 0 20 20" fill="currentColor">
      <g id="Page-1" transform="translate(4.5 1.5)">
        <g id="Artboard" transform="translate(-4.5 -1.5)">
          <g id="Group" transform="translate(0 0)">
            <rect id="Rectangle" width="20" height="20" fill="none" />
            <g
              id="Actions-_-Controls-_-center-to-fit-_-24"
              data-name="Actions-/-Controls-/-center-to-fit-/-24"
              transform="translate(2.083 1.25)"
            >
              <path
                id="Fill"
                d="M11.25,0h-10A1.251,1.251,0,0,0,0,1.25V16.875a.625.625,0,0,0,.625.625H1.25a.625.625,0,0,0,.5-.25l1.125-1.833L4,17.25a.647.647,0,0,0,1,0l.875-1.833L7.25,17.25a.647.647,0,0,0,1,0l1.125-1.833L10.75,17.25a.625.625,0,0,0,.5.25h.625a.625.625,0,0,0,.625-.625V1.25A1.251,1.251,0,0,0,11.25,0Zm0,15.833L9.875,14a.647.647,0,0,0-1,0L7.75,15.833,6.375,14a.647.647,0,0,0-1,0L4.5,15.833,3.375,14a.647.647,0,0,0-1,0L1.25,15.833V1.25h10Z"
                transform="translate(1.667)"
                fillRule="evenodd"
              />
              <rect
                id="Rectangle_2312"
                data-name="Rectangle 2312"
                width="13.333"
                height="5"
                transform="translate(1.25 6.25)"
                fill="#eaeaeb"
              />
              <g
                id="Group_8573"
                data-name="Group 8573"
                transform="translate(0 8.159)"
              >
                <rect
                  id="Rectangle_2313"
                  data-name="Rectangle 2313"
                  width="3.333"
                  height="1.182"
                />
                <rect
                  id="Rectangle_2314"
                  data-name="Rectangle 2314"
                  width="3.333"
                  height="1.182"
                  transform="translate(4.167)"
                />
                <rect
                  id="Rectangle_2315"
                  data-name="Rectangle 2315"
                  width="3.333"
                  height="1.182"
                  transform="translate(8.333)"
                />
                <rect
                  id="Rectangle_2316"
                  data-name="Rectangle 2316"
                  width="3.333"
                  height="1.182"
                  transform="translate(12.5)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </symbol>
    <symbol
      id="launch"
      viewBox="0 0 24 24"
      fill="currentColor"
      style={{ background: '#FFFFFF' }}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect fill="#FFFFFF" opacity="0" x="0" y="0" width="24" height="24" />
        <path
          d="M19.5,21 L4.5,21 C3.67203537,20.9988845 3.00111549,20.3279646 3,19.5 L3,4.5 C3.00111549,3.67203537 3.67203537,3.00111549 4.5,3 L12,3 L12,4.5 L4.5,4.5 L4.5,19.5 L19.5,19.5 L19.5,12 L21,12 L21,19.5 C20.9988845,20.3279646 20.3279646,20.9988845 19.5,21 Z M15,1.5 L15,3 L19.9395,3 L13.5,9.4395 L14.5605,10.5 L21,4.0605 L21,9 L22.5,9 L22.5,1.5 L15,1.5 L15,1.5 Z"
          id="Fill"
          fill="#151519"
        />
      </g>
    </symbol>
    <symbol id="telegram" viewBox="0 0 24 24">
      <g data-name="Group 9051" transform="translate(0 -0.198)">
        <g
          id="Rectangle_2516"
          data-name="Rectangle 2516"
          transform="translate(0 0.198)"
          fill="#fff"
          stroke="#e6e6e6"
          strokeWidth="0.5"
        >
          <rect width="24" height="24" rx="12" stroke="none" />
          <rect
            x="0.25"
            y="0.25"
            width="23.5"
            height="23.5"
            rx="11.75"
            fill="none"
          />
        </g>
        <path
          id="Path_7881"
          data-name="Path 7881"
          d="M27.829,24.111a.509.509,0,0,0-.491-.078L16.479,28a.709.709,0,0,0-.483.726.731.731,0,0,0,.613.635l2.814.516V32.8a.8.8,0,0,0,.536.742.9.9,0,0,0,.938-.187l1.357-1.313L24.406,33.8a.887.887,0,0,0,.563.2.931.931,0,0,0,.268-.04.816.816,0,0,0,.572-.582l2.175-8.829a.433.433,0,0,0-.155-.441Zm-3.276,1.8-4.8,3.208-2.658-.487ZM20.28,32.8V30.428l1.328,1.087Zm4.69.4-4.43-3.625,6.376-4.265Z"
          transform="translate(-9.993 -17.002)"
        />
      </g>
    </symbol>
    <symbol id="whatsApp" viewBox="0 0 24 24">
      <g id="Group_9052" data-name="Group 9052" transform="translate(0 -0.198)">
        <g
          id="Rectangle_2516"
          data-name="Rectangle 2516"
          transform="translate(0 0.198)"
          fill="#fff"
          stroke="#e6e6e6"
          strokeWidth="0.5"
        >
          <rect width="24" height="24" rx="12" stroke="none" />
          <rect
            x="0.25"
            y="0.25"
            width="23.5"
            height="23.5"
            rx="11.75"
            fill="none"
          />
        </g>
        <path
          id="Vector"
          d="M11.159,1.233C10.845.944,9.575.023,6.744.01c0,0-3.338-.2-4.963,1.292A5.407,5.407,0,0,0,.523,5.176C.488,6.819.446,9.9,3.413,10.733h0l0,1.275s-.02.516.321.62c.41.129.652-.264,1.045-.687.215-.232.511-.573.736-.833a11.481,11.481,0,0,0,3.768-.277,3.71,3.71,0,0,0,3.106-3.508C12.779,4.146,12.2,2.14,11.159,1.233ZM11.5,7.091A2.944,2.944,0,0,1,8.957,9.935a10.622,10.622,0,0,1-3.241.277S4.431,11.76,4.031,12.163c-.131.131-.274.119-.272-.141,0-.17.01-2.117.01-2.117h0C1.254,9.208,1.4,6.587,1.43,5.216A4.505,4.505,0,0,1,2.482,1.965C3.858.717,6.692.9,6.692.9a6.033,6.033,0,0,1,3.807.973C11.381,2.632,11.831,4.44,11.5,7.091Zm-3.434-2a.16.16,0,1,1-.319.015.764.764,0,0,0-.805-.838.16.16,0,0,1,.017-.319A1.074,1.074,0,0,1,8.068,5.095Zm.5.279A1.846,1.846,0,0,0,6.7,3.415.16.16,0,0,1,6.719,3.1,2.164,2.164,0,0,1,8.888,5.381.159.159,0,0,1,8.57,5.374Zm1.161.331a.159.159,0,1,1-.319,0A2.913,2.913,0,0,0,6.428,2.585a.159.159,0,0,1,0-.319A3.232,3.232,0,0,1,9.731,5.705ZM9.451,8.129v0c-.267.469-.766.988-1.28.823l0-.007a9.495,9.495,0,0,1-2.525-1.4A6.457,6.457,0,0,1,4.594,6.506a8.015,8.015,0,0,1-.761-1.151,7.382,7.382,0,0,1-.642-1.376c-.166-.514.351-1.013.823-1.28h0a.45.45,0,0,1,.59.1s.306.366.437.546.289.437.376.588a.516.516,0,0,1-.091.657l-.3.237a.435.435,0,0,0-.131.346A3.093,3.093,0,0,0,6.986,7.252a.435.435,0,0,0,.346-.131l.237-.3a.516.516,0,0,1,.657-.091,6.4,6.4,0,0,1,1.132.813A.441.441,0,0,1,9.451,8.129Z"
          transform="translate(5.487 5.673)"
        />
      </g>
    </symbol>
    <symbol
      id="social-discount-money"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <g
        id="icn-greenPercentage"
        data-name="Group 7944"
        transform="translate(-861 -447)"
      >
        <path
          id="Path_7534"
          data-name="Path 7534"
          d="M32.864,22.977a3.692,3.692,0,0,1-.734-.93,3.531,3.531,0,0,1-.122-1.12,3.122,3.122,0,0,0-.643-2.291,3.122,3.122,0,0,0-2.291-.643,3.531,3.531,0,0,1-1.12-.122,3.706,3.706,0,0,1-.93-.734A3.086,3.086,0,0,0,25,16a3.088,3.088,0,0,0-2.023,1.136,3.692,3.692,0,0,1-.93.734,3.525,3.525,0,0,1-1.12.122,3.122,3.122,0,0,0-2.291.643,3.139,3.139,0,0,0-.643,2.291,3.531,3.531,0,0,1-.122,1.12,3.706,3.706,0,0,1-.734.93A3.086,3.086,0,0,0,16,25a3.088,3.088,0,0,0,1.136,2.023,3.692,3.692,0,0,1,.734.93,3.531,3.531,0,0,1,.122,1.12,3.122,3.122,0,0,0,.643,2.291,3.122,3.122,0,0,0,2.291.643,3.531,3.531,0,0,1,1.12.122,3.706,3.706,0,0,1,.93.734A3.086,3.086,0,0,0,25,34a3.088,3.088,0,0,0,2.023-1.136,3.692,3.692,0,0,1,.93-.734,3.531,3.531,0,0,1,1.12-.122,3.122,3.122,0,0,0,2.291-.643,3.122,3.122,0,0,0,.643-2.291,3.531,3.531,0,0,1,.122-1.12,3.706,3.706,0,0,1,.734-.93A3.086,3.086,0,0,0,34,25,3.088,3.088,0,0,0,32.864,22.977Zm-4.195.55-4.5,4.5a.643.643,0,0,1-.91,0L21.331,26.1a.643.643,0,0,1,.91-.91l1.474,1.475,4.045-4.046a.643.643,0,1,1,.91.91Z"
          transform="translate(845 431)"
          fill="#34ac34"
        />
        <rect
          id="Rectangle_2066"
          data-name="Rectangle 2066"
          width="9"
          height="8.1"
          transform="translate(866 452)"
          fill="#34ac34"
        />
        <path
          id="Path_7535"
          data-name="Path 7535"
          d="M43.611,37.249l-6.34,6.339a.529.529,0,0,1-.748-.748l6.34-6.339a.529.529,0,0,1,.748.748ZM36.533,39a1.761,1.761,0,1,1,1.245.516A1.761,1.761,0,0,1,36.533,39Zm.541-1.244a.7.7,0,1,0,.206-.5A.7.7,0,0,0,37.074,37.757Zm7.044,4.578A1.761,1.761,0,1,1,43.6,41.09,1.761,1.761,0,0,1,44.118,42.335Zm-1.057,0a.7.7,0,0,0-.206-.5h0a.7.7,0,1,0,.206.5Z"
          transform="translate(829.932 415.954)"
          fill="#fff"
          stroke="#fff"
          strokeWidth="0.2"
        />
      </g>
    </symbol>
    <symbol
      id="equivalent"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g
        id="Enterprise-_-Commerce-_-currency--exchange-_-20"
        data-name="Enterprise-/-Commerce-/-currency--exchange-/-20"
      >
        <rect
          id="Rectangle_2384"
          data-name="Rectangle 2384"
          width="20"
          height="20"
          fill="#fff"
          opacity="0"
        />
        <g id="Group">
          <rect id="Rectangle" width="20" height="20" fill="none" />
          <path
            id="Combined-Shape"
            d="M15.338,4.625v1.8a4.931,4.931,0,0,1,3.285,1.843l-.885.706A3.856,3.856,0,0,0,14.573,7.5c-1.221,0-2.646.478-2.646,1.824,0,1.6,1.065,1.828,2.947,2.087,1.727.237,3.876.533,3.876,3.129,0,1.751-1.293,2.889-3.412,3.06v1.775H14.2v-1.77a4.816,4.816,0,0,1-3.854-1.877l.885-.706A3.891,3.891,0,0,0,14.77,16.5c1.062,0,2.843-.255,2.843-1.96,0-1.542-1.046-1.761-2.9-2.015-1.75-.24-3.928-.54-3.928-3.2,0-1.665,1.356-2.813,3.412-2.936V4.625ZM6.478,1.25V2.784a5.7,5.7,0,0,1,1.484,0V1.25h.99V2.978A5.924,5.924,0,0,1,11.9,4.925a3.772,3.772,0,0,0-.932.4A5.749,5.749,0,0,0,8.952,4.143v3.2h-.99V3.884a5.7,5.7,0,0,0-1.484,0V7.34h-.99v-3.2A4.624,4.624,0,0,0,2.4,8.493,4.742,4.742,0,0,0,7.22,13.15H9.847c0,.323-.005.693,0,1.1H1.563V13.2H4.021A5.207,5.207,0,0,1,1.25,8.493,5.805,5.805,0,0,1,5.488,2.978V1.25Z"
            fill="#fff"
            stroke="#fff"
            strokeWidth="0.3"
            fillRule="evenodd"
          />
        </g>
      </g>
    </symbol>

    <symbol id="transport" viewBox="0 0 32 32" fill="currentColor">
      <g id="Group_8370" data-name="Group 8370" transform="translate(-35 -29)">
        <rect
          id="Rectangle_2282"
          data-name="Rectangle 2282"
          width="32"
          height="32"
          rx="16"
          transform="translate(35 29)"
          fill="#eae1f8"
        />
        <g id="Group_8043" data-name="Group 8043" transform="translate(42 36)">
          <g id="Page-1">
            <g id="Google-Pixel-3">
              <g id="Group-2">
                <g
                  id="Enterprise-_-Commerce-_-purchase-_-24"
                  data-name="Enterprise-/-Commerce-/-purchase-/-24"
                  transform="translate(1.135 1.135)"
                >
                  <path
                    id="Fill"
                    d="M6.608,12.284h3.405v1.135H6.608Zm7.518-7.378L15.1,8.311h2.293V7.176H15.955l-.738-2.582a1.139,1.139,0,0,0-1.092-.824H13.36l-.414-1.447A1.139,1.139,0,0,0,11.855,1.5H4.766a1.14,1.14,0,0,0-1.091.823L2.937,4.905H1.5V6.04H3.793l.973-3.405h7.089L12.18,3.77H7.036a1.14,1.14,0,0,0-1.091.823L5.369,6.608H4.743a1.134,1.134,0,0,0-1.074.767l-.71,2.071H1.5v1.135H2.635v3.973A1.137,1.137,0,0,0,3.77,15.689v1.7H4.905v-1.7h6.811v1.7h1.135v-1.7a1.137,1.137,0,0,0,1.135-1.135V10.581h1.135V9.446H13.662l-.71-2.07a1.134,1.134,0,0,0-1.074-.768H6.55l.487-1.7Zm-1.274,6.243v1.135H11.716v1.135h1.135v1.135H3.77V13.419H4.905V12.284H3.77V11.148Zm-.195-1.135H3.965l.778-2.27h7.135Z"
                    transform="translate(-1.5 -1.5)"
                    fill="#8953db"
                    fillRule="evenodd"
                  />
                </g>
                <rect id="Rectangle" width="18" height="18" fill="none" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="spliit-money" viewBox="0 0 20 20" fill="currentColor">
      <g id="Page-1" transform="translate(4.5 1.5)">
        <g id="Artboard" transform="translate(-4.5 -1.5)">
          <g id="Group" transform="translate(0 0)">
            <rect id="Rectangle" width="20" height="20" fill="none" />
            <g
              id="Actions-_-Controls-_-center-to-fit-_-24"
              data-name="Actions-/-Controls-/-center-to-fit-/-24"
              transform="translate(2.083 1.25)"
            >
              <path
                id="Fill"
                d="M11.25,0h-10A1.251,1.251,0,0,0,0,1.25V16.875a.625.625,0,0,0,.625.625H1.25a.625.625,0,0,0,.5-.25l1.125-1.833L4,17.25a.647.647,0,0,0,1,0l.875-1.833L7.25,17.25a.647.647,0,0,0,1,0l1.125-1.833L10.75,17.25a.625.625,0,0,0,.5.25h.625a.625.625,0,0,0,.625-.625V1.25A1.251,1.251,0,0,0,11.25,0Zm0,15.833L9.875,14a.647.647,0,0,0-1,0L7.75,15.833,6.375,14a.647.647,0,0,0-1,0L4.5,15.833,3.375,14a.647.647,0,0,0-1,0L1.25,15.833V1.25h10Z"
                transform="translate(1.667)"
                fillRule="evenodd"
              />
              <rect
                id="Rectangle_2312"
                data-name="Rectangle 2312"
                width="13.333"
                height="5"
                transform="translate(1.25 6.25)"
                fill="#eaeaeb"
              />
              <g
                id="Group_8573"
                data-name="Group 8573"
                transform="translate(0 8.159)"
              >
                <rect
                  id="Rectangle_2313"
                  data-name="Rectangle 2313"
                  width="3.333"
                  height="1.182"
                />
                <rect
                  id="Rectangle_2314"
                  data-name="Rectangle 2314"
                  width="3.333"
                  height="1.182"
                  transform="translate(4.167)"
                />
                <rect
                  id="Rectangle_2315"
                  data-name="Rectangle 2315"
                  width="3.333"
                  height="1.182"
                  transform="translate(8.333)"
                />
                <rect
                  id="Rectangle_2316"
                  data-name="Rectangle 2316"
                  width="3.333"
                  height="1.182"
                  transform="translate(12.5)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </symbol>
    <symbol id="changelimit" viewBox="0 0 21.677 18" fill="currentColor">
      <g
        id="Group_9056"
        data-name="Group 9056"
        transform="translate(-25 -4371)"
      >
        <path
          id="Path_7912"
          data-name="Path 7912"
          d="M34.692,54.124h3.989a3.459,3.459,0,0,0,6.78,0h9.524a.692.692,0,1,0,0-1.384H45.461a3.459,3.459,0,0,0-6.78,0H34.692a.692.692,0,1,0,0,1.384Zm7.379-2.767A2.075,2.075,0,1,1,40,53.432,2.075,2.075,0,0,1,42.071,51.357ZM54.985,63.81H52.84a3.459,3.459,0,0,0-6.78,0H34.692a.692.692,0,1,0,0,1.384H46.061a3.459,3.459,0,0,0,6.78,0h2.145a.692.692,0,0,0,0-1.384ZM49.45,66.577A2.075,2.075,0,1,1,51.526,64.5,2.075,2.075,0,0,1,49.45,66.577Z"
          transform="translate(-9 4321.03)"
        />
        <g
          id="Rectangle_2517"
          data-name="Rectangle 2517"
          transform="translate(29.6 4371)"
          fill="#fff"
          stroke="#da0110"
          strokeWidth="1"
        >
          <rect width="7" height="7" rx="3.5" stroke="none" />
          <rect x="0.5" y="0.5" width="6" height="6" rx="3" fill="none" />
        </g>
        <g
          id="Rectangle_2518"
          data-name="Rectangle 2518"
          transform="translate(37 4382)"
          fill="#fff"
          stroke="#da0110"
          strokeWidth="1"
        >
          <rect width="7" height="7" rx="3.5" stroke="none" />
          <rect x="0.5" y="0.5" width="6" height="6" rx="3" fill="none" />
        </g>
      </g>
    </symbol>
    <symbol id="Card" viewBox="0 0 23.9 15.694" fill="currentColor">
      <g
        id="Rectangle_2447"
        data-name="Rectangle 2447"
        fill="none"
        stroke="#242424"
        strokeWidth="1.2"
      >
        <rect width="23.9" height="15.694" rx="2" stroke="none" />
        <rect
          x="0.6"
          y="0.6"
          width="22.7"
          height="14.494"
          rx="1.4"
          fill="none"
        />
      </g>
      <line
        id="Line_153"
        data-name="Line 153"
        x1="23"
        transform="translate(0 5.063)"
        fill="none"
        stroke="#242424"
        strokeWidth="1.2"
      />
      <path
        id="Path_7896"
        data-name="Path 7896"
        d="M9.957,18.49H5.2a.6.6,0,1,1,0-1.19H9.957a.6.6,0,1,1,0,1.19Z"
        transform="translate(-1.862 -6.123)"
        fill="#db0011"
      />
    </symbol>

    <symbol id="icn-edit" viewBox="0 0 20 20" fill="currentColor">
      <g id="edit" transform="translate(0 0.093)">
        <rect
          id="Rectangle_2513"
          data-name="Rectangle 2513"
          width="18"
          height="1"
          transform="translate(1 15.907)"
        />
        <path
          id="Path_7524"
          data-name="Path 7524"
          d="M17.313,6.355a1.2,1.2,0,0,0,0-1.742h0l-2.24-2.24a1.2,1.2,0,0,0-1.742,0h0L4,11.7v3.981H7.981ZM14.2,3.244l2.24,2.24L14.575,7.35l-2.24-2.24Zm-8.958,11.2V12.2l6.221-6.221,2.24,2.24L7.484,14.442Z"
          transform="translate(-1.512 -0.756)"
        />
        <rect
          id="_Transparent_Rectangle_"
          width="20"
          height="20"
          transform="translate(0 -0.093)"
          fill="none"
        />
      </g>
    </symbol>
    <symbol id="calendar-new" viewBox="0 0 24 24" fill="currentColor">
      <path
        id="Path_7461"
        data-name="Path 7461"
        d="M18.667,3.385H16V2H14.667V3.385H9.333V2H8V3.385H5.333A1.364,1.364,0,0,0,4,4.769V18.615A1.364,1.364,0,0,0,5.333,20H18.667A1.364,1.364,0,0,0,20,18.615V4.769A1.364,1.364,0,0,0,18.667,3.385Zm0,15.231H5.333V8.923H18.667Zm0-11.077H5.333V4.769H8V6.154H9.333V4.769h5.333V6.154H16V4.769h2.667Z"
        fill="#a7a7a7"
      />
      <rect id="_Transparent_Rectangle_" width="24" height="24" fill="none" />
    </symbol>
    <symbol id="hint" viewBox="0 0 30 30" fill="currentColor">
      <path
        id="Path_7890"
        data-name="Path 7890"
        d="M39,24A15,15,0,1,0,54,39,15,15,0,0,0,39,24Zm0,27.692A12.692,12.692,0,1,1,51.692,39,12.692,12.692,0,0,1,39,51.692ZM37.846,40.154V32.077a1.154,1.154,0,0,1,2.308,0v8.077a1.154,1.154,0,0,1-2.308,0Zm2.885,5.192A1.731,1.731,0,1,1,39,43.615,1.731,1.731,0,0,1,40.731,45.346Z"
        transform="translate(-24 -24)"
        fill="currentColor"
      />
    </symbol>

    <symbol id="download-icn" viewBox="0 0 32 32" fill="currentColor">
      <rect
        id="Rectangle_2408"
        data-name="Rectangle 2408"
        width="32"
        height="32"
        rx="16"
        fill="#f1f1f4"
      />
      <g id="launch" transform="translate(8 8)">
        <path
          id="Path_7886"
          data-name="Path 7886"
          d="M14.853,15.84H4.987A.988.988,0,0,1,4,14.853V4.987A.988.988,0,0,1,4.987,4H9.92v.987H4.987v9.867h9.867V9.92h.987v4.933A.988.988,0,0,1,14.853,15.84Z"
          transform="translate(-2.025 -2.025)"
          fill="#585858"
        />
        <path
          id="Path_7887"
          data-name="Path 7887"
          d="M18.987,2v.987h3.249L18,7.222l.7.7,4.236-4.236V6.933h.987V2Z"
          transform="translate(-9.118 -1.012)"
          fill="#585858"
        />
        <rect
          id="_Transparent_Rectangle_"
          data-name="&lt;Transparent Rectangle&gt;"
          width="16"
          height="16"
          fill="none"
        />
      </g>
    </symbol>

    <symbol id="download-icn-new" viewBox="0 0 32 32" fill="currentColor">
      <path d="M26,24v4H6V24H4v4H4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2h0V24Z" />
      <polygon points="26 14 24.59 12.59 17 20.17 17 2 15 2 15 20.17 7.41 12.59 6 14 16 24 26 14" />
      <g id="_Transparent_Rectangle_" data-name="&lt;Transparent Rectangle&gt;">
        <rect  width="32" height="32" />
      </g>
    </symbol>
  </svg>
)

export default SvgIcons
